const case1_data = [
	{
		"city": "Catron",
		"area": "Catron",
		"latitude": 34.344371,
		"longitude": -108.496444,
		"children": 63,
		"centers": 1
	},
	{
		"city": "Pie Town",
		"area": "Catron",
		"latitude": 34.299876,
		"longitude": -108.136028,
		"children": 72,
		"centers": 1
	},
	{
		"city": "Datil",
		"area": "Catron",
		"latitude": 34.144210,
		"longitude": -107.843756,
		"children": 73,
		"centers": 1
	},
	{
		"city": "Lincoln",
		"area": "Lincoln",
		"latitude": 33.647337,
		"longitude": -105.884642,
		"children": 288,
		"centers": 6
	},
	{
		"city": "Quay",
		"area": "Quay",
		"latitude": 35.362679,
		"longitude": -103.448836,
		"children": 8,
		"centers": 1
	},
	{
		"city": "Roosevelt",
		"area": "Roosevelt",
		"latitude": 33.946139,
		"longitude": -103.655059,
		"children": 190,
		"centers": 6
	},
	{
		"city": "Dora",
		"area": "Roosevelt",
		"latitude": 33.938126,
		"longitude": -103.328412,
		"children": 75,
		"centers": 1
	},
	{
		"city": "Portales",
		"area": "Roosevelt",
		"latitude": 34.184592,
		"longitude": -103.341888,
		"children": 68,
		"centers": 1
	},
	{
		"city": "Floyd",
		"area": "Roosevelt",
		"latitude": 34.227926,
		"longitude": -103.530932,
		"children": 22,
		"centers": 1
	},
	{
		"city": "Chaves",
		"area": "Chaves",
		"latitude": 33.399434,
		"longitude": -104.531479,
		"children": 17,
		"centers": 1
	},
	{
		"city": "Hagerman",
		"area": "Chaves",
		"latitude": 33.115359,
		"longitude": -104.329597,
		"children": 63,
		"centers": 1
	},
	{
		"city": "Carlsbad",
		"area": "Eddy",
		"latitude": 32.399852,
		"longitude": -104.231541,
		"children": 443,
		"centers": 4
	},
	{
		"city": "Eddy",
		"area": "Eddy",
		"latitude": 32.595402,
		"longitude": -104.424589,
		"children": 252,
		"centers": 3
	},
	{
		"city": "Avalon",
		"area": "Eddy",
		"latitude": 32.498340,
		"longitude": -104.237218,
		"children": 180,
		"centers": 3
	},
	{
		"city": "Loving",
		"area": "Eddy",
		"latitude": 32.287974,
		"longitude": -104.096723,
		"children": 152,
		"centers": 1
	},
	{
		"city": "Malaga",
		"area": "Eddy",
		"latitude": 32.224689,
		"longitude": -104.073790,
		"children": 43,
		"centers": 2
	},
	{
		"city": "Whites City",
		"area": "Eddy",
		"latitude": 32.176470,
		"longitude": -104.374468,
		"children": 24,
		"centers": 1
	}
];

const case1_spec = {
	"artboard": {
		"name": "new-mexico-personnel-desktop",
		"artboard_width": 1000,
		"artboard_height": 1000,
		"screen_type": "Desktop-Landscape",
		"device_width": 1440,
		"device_height": 900,
		"ppi": 227
	},
	"original_artboard": {
		"name": "new-mexico-personnel-desktop",
		"artboard_width": 1000,
		"artboard_height": 1000,
		"screen_type": "Desktop-Landscape",
		"device_width": 1440,
		"device_height": 900,
		"ppi": 227
	},
	"fronto": {
		"data": [],
		"datatype": {},
		"name": "",
		"layout": {
			"width": 1000,
			"height": 1000,
			"composition": "projection",
			"projection": {
				"type": "albersUsa",
				"level": "us-county",
				"center": [
					14,
					0
				],
				"customMap": "nm-map.json"
			},
			"column": [
				{
					"field": "longitude",
					"type": "quantitative"
				}
			],
			"row": [
				{
					"field": "latitude",
					"type": "quantitative"
				}
			]
		},
		"layer": [
			{
				"mark": {
					"type": "geoshape",
					"feature": "state",
					"fill": {
						"value": "rgba(241,241,241,1)"
					},
					"stroke": {
						"value": "rgba(241,241,241,1)"
					}
				},
				"name": "geolayer1"
			},
			{
				"mark": {
					"type": "geoshape",
					"fill": {
						"value": "rgba(205,205,205,1)"
					},
					"stroke": {
						"value": "rgba(205,205,205,1)"
					},
					"feature": "urban_areas"
				},
				"name": "geolayer0"
			},
			{
				"mark": {
					"type": "geoshape",
					"feature": "roads",
					"fill": {
						"value": "rgba(255,255,255,0)"
					},
					"stroke": {
						"value": "rgba(255,255,255,1)"
					},
					"strokeWidth": {
						"value": 2
					}
				},
				"name": "geolayer2"
			},
			{
				"name": "layer_0",
				"mark": {
					"type": "circle",
					"size": {
						"field": "children",
						"scale": {
							"domain": [
								"20",
								"440"
							],
							"range": [
								500,
								5000
							]
						}
					},
					"fill": {
						"value": "rgba(51, 139, 255,1)"
					},
					"stroke": {
						"value": "rgba(51, 139, 255,1)"
					},
					"strokeWidth": {
						"value": 1.5
					},
					"fillOpacity": {
						"value": 0.4
					}
				},
				"text": [
					{
						"type": "on-mark",
						"items": [
							{
								"index": 0,
								"fontWeight": "700",
								"fontSize": 16,
								"textAlign": "left",
								"width": 160,
								"lineHeight": 130,
								"fontStroke": "rgba(255,255,255,1)",
								"expression": "(datum.area) + ' Region'"
							},
							{
								"index": 1,
								"fontSize": 16,
								"content": "",
								"textAlign": "left",
								"width": 160,
								"lineHeight": 130,
								"fontStroke": "rgba(255,255,255,1)",
								"expression": "sum(\"children\", \"area\") + ' personnel <br/>in ' + sum(\"centers\", \"area\") + ' centers'"
							}
						],
						"field": "city",
						"name": "label_0",
						"orient": "middle-right",
						"values": [
							"Catron"
						],
						"anchorAlign": "start",
						"dx": 3,
						"dy": -71
					},
					{
						"type": "on-mark",
						"items": [
							{
								"index": 0,
								"fontWeight": "700",
								"fontSize": 16,
								"textAlign": "left",
								"width": 160,
								"lineHeight": 130,
								"fontStroke": "rgba(255,255,255,1)",
								"expression": "(datum.area) + ' Region'"
							},
							{
								"index": 1,
								"fontSize": 16,
								"content": "",
								"textAlign": "left",
								"width": 160,
								"lineHeight": 130,
								"fontStroke": "rgba(255,255,255,1)",
								"expression": "sum(\"children\", \"area\") + ' personnel <br/>in ' + sum(\"centers\", \"area\") + ' centers'"
							}
						],
						"field": "city",
						"name": "label_1",
						"orient": "middle-right",
						"values": [
							"Lincoln"
						],
						"anchorAlign": "start",
						"dx": 10,
						"dy": -26
					},
					{
						"type": "on-mark",
						"items": [
							{
								"index": 0,
								"fontWeight": "700",
								"fontSize": 16,
								"textAlign": "right",
								"width": 160,
								"lineHeight": 130,
								"fontStroke": "rgba(255,255,255,1)",
								"expression": "(datum.area) + ' Region'"
							},
							{
								"index": 1,
								"fontSize": 16,
								"content": "",
								"textAlign": "right",
								"width": 160,
								"lineHeight": 130,
								"fontStroke": "rgba(255,255,255,1)",
								"expression": "sum(\"children\", \"area\") + ' personnel <br/>in ' + sum(\"centers\", \"area\") + ' centers'"
							}
						],
						"field": "city",
						"name": "label_2",
						"orient": "middle-left",
						"values": [
							"Quay"
						],
						"anchorAlign": "end",
						"dx": -18,
						"dy": -26
					},
					{
						"type": "on-mark",
						"items": [
							{
								"index": 0,
								"fontWeight": "700",
								"fontSize": 16,
								"textAlign": "left",
								"width": 160,
								"lineHeight": 130,
								"fontStroke": "rgba(255,255,255,1)",
								"expression": "(datum.area) + ' Region'"
							},
							{
								"index": 1,
								"fontSize": 16,
								"content": "",
								"textAlign": "left",
								"width": 160,
								"lineHeight": 130,
								"fontStroke": "rgba(255,255,255,1)",
								"expression": "sum(\"children\", \"area\") + ' personnel <br/>in ' + sum(\"centers\", \"area\") + ' centers'"
							}
						],
						"field": "city",
						"name": "label_3",
						"orient": "middle-right",
						"values": [
							"Roosevelt"
						],
						"anchorAlign": "start",
						"dx": -2,
						"dy": -124
					},
					{
						"type": "on-mark",
						"items": [
							{
								"index": 0,
								"fontWeight": "700",
								"fontSize": 16,
								"textAlign": "left",
								"width": 160,
								"lineHeight": 130,
								"fontStroke": "rgba(255,255,255,1)",
								"expression": "(datum.area) + ' Region'"
							},
							{
								"index": 1,
								"fontSize": 16,
								"content": "",
								"textAlign": "left",
								"width": 160,
								"lineHeight": 130,
								"fontStroke": "rgba(255,255,255,1)",
								"expression": "sum(\"children\", \"area\") + ' personnel <br/>in ' + sum(\"centers\", \"area\") + ' centers'"
							}
						],
						"field": "city",
						"name": "label_4",
						"orient": "middle-right",
						"values": [
							"Chaves"
						],
						"anchorAlign": "start",
						"dx": 10,
						"dy": -26
					},
					{
						"type": "on-mark",
						"items": [
							{
								"index": 0,
								"fontWeight": "700",
								"fontSize": 16,
								"textAlign": "left",
								"width": 160,
								"lineHeight": 130,
								"fontStroke": "rgba(255,255,255,1)",
								"expression": "(datum.city) + ' Region'"
							},
							{
								"index": 1,
								"fontSize": 16,
								"content": "",
								"textAlign": "left",
								"width": 160,
								"lineHeight": 130,
								"fontStroke": "rgba(255,255,255,1)",
								"expression": "sum(\"children\", \"area\") + ' personnel <br/>in ' + sum(\"centers\", \"area\") + ' centers'"
							}
						],
						"field": "city",
						"name": "label_5",
						"orient": "middle-right",
						"values": [
							"Eddy"
						],
						"anchorAlign": "start",
						"dx": 45,
						"dy": -10
					},
					{
						"type": "legend",
						"field": "children",
						"channel": "size",
						"items": [
							{
								"index": 0,
								"fontSize": 16,
								"custom": {
									"20": "Fewer than 20",
									"440": "At least 440"
								},
								"width": 60
							}
						],
						"values": [
							20,
							440
						],
						"orient": "bottom-left",
						"dx": null,
						"dy": null,
						"direction": "horizontal",
						"name": "legend_0",
						"title": {
							"value": "Personnel in New Mexico<br/>centers by city",
							"fontSize": 16,
							"fontWeight": "400"
						}
					}
				]
			}
		],
		"annotation": {
			"items": [
				{
					"type": "text",
					"text": [
						{
							"text": "As of January, at least <strong>2,025 personnels for specialized areas</strong> employed by 35 centers across New Mexico.",
							"align": "left",
							"index": "0",
							"fontSize": 18,
							"lineHeight": 130
						}
					],
					"name": "annotation_0",
					"x": "56.8%",
					"y": "11.6%",
					"width": 230
				}
			]
		}
	}
};

const case2_spec = {
	"artboard": {
		"name": "ky-order-desktop",
		"artboard_width": 1000,
		"artboard_height": 300,
		"screen_type": "Desktop-Landscape",
		"device_width": 1440,
		"device_height": 900,
		"ppi": 227
	},
	"original_artboard": {
		"name": "ky-order-desktop",
		"artboard_width": 1000,
		"artboard_height": 300,
		"screen_type": "Desktop-Landscape",
		"device_width": 1440,
		"device_height": 900,
		"ppi": 227
	},
	"fronto": {
		"data": [],
		"datatype": {},
		"name": "",
		"layout": {
			"width": 1000,
			"height": 300,
			"composition": "repeated",
			"split": {
				"field": "county",
				"nColumns": 1,
				"label": {
					"align": "left",
					"anchor": "start",
					"items": [{
						"fontSize": 16,
						"expression": "(datum.title)",
						"fontWeight": "700"
					}, {
						"fontSize": 14,
						"expression": "round(argmax(\"date\", \"cases_7day_mean_per_100k\"),1) + (datum.county == \"Oldham\" ? '<br/>cases per 100k<br/>in last 7 days' : '' )",
						"fontWeight": "300"
					}]
				},
				"values": [
					"Oldham", //"San Francisco",
					"Grayson", //"Tuolumne",
					"Lincoln", //"Glenn",
					"Greenup", //"Imperial",
					"Laurel", //"San Mateo",
					"Jefferson", //"Los Angeles",
					"Clark", // "Yolo",
					"Mercer",//"Inyo",
					"Daviess", //"Alameda",
					"Muhlenberg", //"Kings"
				]
			},
			"column": [
				{
					"field": "date",
					"type": "temporal"
				}
			],
			"row": [
				{
					"field": "cases_7day_mean_per_100k",
					"type": "quantitative"
				}
			],
			"nColumns": 5
		},
		"layer": [
			{
				"name": "layer_0",
				"mark": {
					"type": "line",
					"interpolate": "monotone",
					"stroke": {
						"value": "rgba(142,84,204,1)"
					}
				},
				"text": [
					{
						"type": "on-axis",
						"field": "date",
						"items": [
							{
								"index": 0,
								"align": "left",
								"fontSize": 13,
								"color": "rgba(136,136,136,1)",
								"expression": "timeFormat((datum.value), '%b. %-d')"
							}
						],
						"values": [
							"2022-03-01",
							"2022-11-08"
						],
						"anchor": "middle"
					}
				]
			}
		],
		"title": {
			"items": [
				{
					"name": "title_0",
					"text": "Kentucky counties ordered by per-100K cases",
					"fontWeight": 700,
					"fontSize": 16,
					"offset": 35
				}
			]
		}
	}
}

const case2_data = [
	{
		"date": "2022-03-01",
		"county": "Daviess",
		"title": "9. Daviess",
		"cases_7day_mean_per_100k": 11.8886194813
	},
	{
		"date": "2022-03-02",
		"county": "Daviess",
		"title": "9. Daviess",
		"cases_7day_mean_per_100k": 11.2361435725
	},
	{
		"date": "2022-03-03",
		"county": "Daviess",
		"title": "9. Daviess",
		"cases_7day_mean_per_100k": 10.8548264829
	},
	{
		"date": "2022-03-04",
		"county": "Daviess",
		"title": "9. Daviess",
		"cases_7day_mean_per_100k": 10.1260871562
	},
	{
		"date": "2022-03-05",
		"county": "Daviess",
		"title": "9. Daviess",
		"cases_7day_mean_per_100k": 9.9057706156
	},
	{
		"date": "2022-03-06",
		"county": "Daviess",
		"title": "9. Daviess",
		"cases_7day_mean_per_100k": 9.9650866073
	},
	{
		"date": "2022-03-07",
		"county": "Daviess",
		"title": "9. Daviess",
		"cases_7day_mean_per_100k": 9.2278735675
	},
	{
		"date": "2022-03-08",
		"county": "Daviess",
		"title": "9. Daviess",
		"cases_7day_mean_per_100k": 9.0499255923
	},
	{
		"date": "2022-03-09",
		"county": "Daviess",
		"title": "9. Daviess",
		"cases_7day_mean_per_100k": 8.939767322
	},
	{
		"date": "2022-03-10",
		"county": "Daviess",
		"title": "9. Daviess",
		"cases_7day_mean_per_100k": 8.4737131014
	},
	{
		"date": "2022-03-11",
		"county": "Daviess",
		"title": "9. Daviess",
		"cases_7day_mean_per_100k": 8.4059233966
	},
	{
		"date": "2022-03-12",
		"county": "Daviess",
		"title": "9. Daviess",
		"cases_7day_mean_per_100k": 8.1432382905
	},
	{
		"date": "2022-03-13",
		"county": "Daviess",
		"title": "9. Daviess",
		"cases_7day_mean_per_100k": 7.7365000616
	},
	{
		"date": "2022-03-14",
		"county": "Daviess",
		"title": "9. Daviess",
		"cases_7day_mean_per_100k": 7.1941824231
	},
	{
		"date": "2022-03-15",
		"county": "Daviess",
		"title": "9. Daviess",
		"cases_7day_mean_per_100k": 6.4061271047
	},
	{
		"date": "2022-03-16",
		"county": "Daviess",
		"title": "9. Daviess",
		"cases_7day_mean_per_100k": 6.2112317033
	},
	{
		"date": "2022-03-17",
		"county": "Daviess",
		"title": "9. Daviess",
		"cases_7day_mean_per_100k": 6.0078625889
	},
	{
		"date": "2022-03-18",
		"county": "Daviess",
		"title": "9. Daviess",
		"cases_7day_mean_per_100k": 5.8977043186
	},
	{
		"date": "2022-03-19",
		"county": "Daviess",
		"title": "9. Daviess",
		"cases_7day_mean_per_100k": 5.8553357531
	},
	{
		"date": "2022-03-20",
		"county": "Daviess",
		"title": "9. Daviess",
		"cases_7day_mean_per_100k": 5.9231254579
	},
	{
		"date": "2022-03-21",
		"county": "Daviess",
		"title": "9. Daviess",
		"cases_7day_mean_per_100k": 6.0248100151
	},
	{
		"date": "2022-03-22",
		"county": "Daviess",
		"title": "9. Daviess",
		"cases_7day_mean_per_100k": 7.0247081611
	},
	{
		"date": "2022-03-23",
		"county": "Daviess",
		"title": "9. Daviess",
		"cases_7day_mean_per_100k": 6.9399710301
	},
	{
		"date": "2022-03-24",
		"county": "Daviess",
		"title": "9. Daviess",
		"cases_7day_mean_per_100k": 7.2450247017
	},
	{
		"date": "2022-03-25",
		"county": "Daviess",
		"title": "9. Daviess",
		"cases_7day_mean_per_100k": 7.4060252506
	},
	{
		"date": "2022-03-26",
		"county": "Daviess",
		"title": "9. Daviess",
		"cases_7day_mean_per_100k": 7.4399201031
	},
	{
		"date": "2022-03-27",
		"county": "Daviess",
		"title": "9. Daviess",
		"cases_7day_mean_per_100k": 7.4738149555
	},
	{
		"date": "2022-03-28",
		"county": "Daviess",
		"title": "9. Daviess",
		"cases_7day_mean_per_100k": 7.9059743236
	},
	{
		"date": "2022-03-29",
		"county": "Daviess",
		"title": "9. Daviess",
		"cases_7day_mean_per_100k": 7.270445841
	},
	{
		"date": "2022-03-30",
		"county": "Daviess",
		"title": "9. Daviess",
		"cases_7day_mean_per_100k": 7.2958669803
	},
	{
		"date": "2022-03-31",
		"county": "Daviess",
		"title": "9. Daviess",
		"cases_7day_mean_per_100k": 7.2789195541
	},
	{
		"date": "2022-04-01",
		"county": "Daviess",
		"title": "9. Daviess",
		"cases_7day_mean_per_100k": 7.7873423402
	},
	{
		"date": "2022-04-02",
		"county": "Daviess",
		"title": "9. Daviess",
		"cases_7day_mean_per_100k": 8.2279754215
	},
	{
		"date": "2022-04-03",
		"county": "Daviess",
		"title": "9. Daviess",
		"cases_7day_mean_per_100k": 8.4143971097
	},
	{
		"date": "2022-04-04",
		"county": "Daviess",
		"title": "9. Daviess",
		"cases_7day_mean_per_100k": 8.9821358875
	},
	{
		"date": "2022-04-05",
		"county": "Daviess",
		"title": "9. Daviess",
		"cases_7day_mean_per_100k": 9.6346117963
	},
	{
		"date": "2022-04-06",
		"county": "Daviess",
		"title": "9. Daviess",
		"cases_7day_mean_per_100k": 10.3718248361
	},
	{
		"date": "2022-04-07",
		"county": "Daviess",
		"title": "9. Daviess",
		"cases_7day_mean_per_100k": 10.8124579174
	},
	{
		"date": "2022-04-08",
		"county": "Daviess",
		"title": "9. Daviess",
		"cases_7day_mean_per_100k": 10.9565110401
	},
	{
		"date": "2022-04-09",
		"county": "Daviess",
		"title": "9. Daviess",
		"cases_7day_mean_per_100k": 11.3208807035
	},
	{
		"date": "2022-04-10",
		"county": "Daviess",
		"title": "9. Daviess",
		"cases_7day_mean_per_100k": 11.947935473
	},
	{
		"date": "2022-04-11",
		"county": "Daviess",
		"title": "9. Daviess",
		"cases_7day_mean_per_100k": 12.617358808
	},
	{
		"date": "2022-04-12",
		"county": "Daviess",
		"title": "9. Daviess",
		"cases_7day_mean_per_100k": 13.1427290203
	},
	{
		"date": "2022-04-13",
		"county": "Daviess",
		"title": "9. Daviess",
		"cases_7day_mean_per_100k": 13.4138878396
	},
	{
		"date": "2022-04-14",
		"county": "Daviess",
		"title": "9. Daviess",
		"cases_7day_mean_per_100k": 13.9816266174
	},
	{
		"date": "2022-04-15",
		"county": "Daviess",
		"title": "9. Daviess",
		"cases_7day_mean_per_100k": 14.5832602476
	},
	{
		"date": "2022-04-16",
		"county": "Daviess",
		"title": "9. Daviess",
		"cases_7day_mean_per_100k": 14.7781556489
	},
	{
		"date": "2022-04-17",
		"county": "Daviess",
		"title": "9. Daviess",
		"cases_7day_mean_per_100k": 14.5747865345
	},
	{
		"date": "2022-04-18",
		"county": "Daviess",
		"title": "9. Daviess",
		"cases_7day_mean_per_100k": 15.0747356074
	},
	{
		"date": "2022-04-19",
		"county": "Daviess",
		"title": "9. Daviess",
		"cases_7day_mean_per_100k": 15.8458434997
	},
	{
		"date": "2022-04-20",
		"county": "Daviess",
		"title": "9. Daviess",
		"cases_7day_mean_per_100k": 16.8372679325
	},
	{
		"date": "2022-04-21",
		"county": "Daviess",
		"title": "9. Daviess",
		"cases_7day_mean_per_100k": 17.7778500868
	},
	{
		"date": "2022-04-22",
		"county": "Daviess",
		"title": "9. Daviess",
		"cases_7day_mean_per_100k": 18.5659054052
	},
	{
		"date": "2022-04-23",
		"county": "Daviess",
		"title": "9. Daviess",
		"cases_7day_mean_per_100k": 19.0065384865
	},
	{
		"date": "2022-04-24",
		"county": "Daviess",
		"title": "9. Daviess",
		"cases_7day_mean_per_100k": 19.7861200918
	},
	{
		"date": "2022-04-25",
		"county": "Daviess",
		"title": "9. Daviess",
		"cases_7day_mean_per_100k": 21.3961255811
	},
	{
		"date": "2022-04-26",
		"county": "Daviess",
		"title": "9. Daviess",
		"cases_7day_mean_per_100k": 22.472287145
	},
	{
		"date": "2022-04-27",
		"county": "Daviess",
		"title": "9. Daviess",
		"cases_7day_mean_per_100k": 23.8026601019
	},
	{
		"date": "2022-04-28",
		"county": "Daviess",
		"title": "9. Daviess",
		"cases_7day_mean_per_100k": 24.8025582479
	},
	{
		"date": "2022-04-29",
		"county": "Daviess",
		"title": "9. Daviess",
		"cases_7day_mean_per_100k": 25.480455296
	},
	{
		"date": "2022-04-30",
		"county": "Daviess",
		"title": "9. Daviess",
		"cases_7day_mean_per_100k": 26.149878631
	},
	{
		"date": "2022-05-01",
		"county": "Daviess",
		"title": "9. Daviess",
		"cases_7day_mean_per_100k": 27.4802515879
	},
	{
		"date": "2022-05-02",
		"county": "Daviess",
		"title": "9. Daviess",
		"cases_7day_mean_per_100k": 28.4970971601
	},
	{
		"date": "2022-05-03",
		"county": "Daviess",
		"title": "9. Daviess",
		"cases_7day_mean_per_100k": 29.5224164454
	},
	{
		"date": "2022-05-04",
		"county": "Daviess",
		"title": "9. Daviess",
		"cases_7day_mean_per_100k": 30.3443666162
	},
	{
		"date": "2022-05-05",
		"county": "Daviess",
		"title": "9. Daviess",
		"cases_7day_mean_per_100k": 31.8781086876
	},
	{
		"date": "2022-05-06",
		"county": "Daviess",
		"title": "9. Daviess",
		"cases_7day_mean_per_100k": 33.1406919397
	},
	{
		"date": "2022-05-07",
		"county": "Daviess",
		"title": "9. Daviess",
		"cases_7day_mean_per_100k": 33.7423255699
	},
	{
		"date": "2022-05-08",
		"county": "Daviess",
		"title": "9. Daviess",
		"cases_7day_mean_per_100k": 33.5304827424
	},
	{
		"date": "2022-05-09",
		"county": "Daviess",
		"title": "9. Daviess",
		"cases_7day_mean_per_100k": 35.1489619447
	},
	{
		"date": "2022-05-10",
		"county": "Daviess",
		"title": "9. Daviess",
		"cases_7day_mean_per_100k": 36.3352817789
	},
	{
		"date": "2022-05-11",
		"county": "Daviess",
		"title": "9. Daviess",
		"cases_7day_mean_per_100k": 37.7164970145
	},
	{
		"date": "2022-05-12",
		"county": "Daviess",
		"title": "9. Daviess",
		"cases_7day_mean_per_100k": 38.1401826695
	},
	{
		"date": "2022-05-13",
		"county": "Daviess",
		"title": "9. Daviess",
		"cases_7day_mean_per_100k": 39.4790293396
	},
	{
		"date": "2022-05-14",
		"county": "Daviess",
		"title": "9. Daviess",
		"cases_7day_mean_per_100k": 40.2755583711
	},
	{
		"date": "2022-05-15",
		"county": "Daviess",
		"title": "9. Daviess",
		"cases_7day_mean_per_100k": 40.6568754607
	},
	{
		"date": "2022-05-16",
		"county": "Daviess",
		"title": "9. Daviess",
		"cases_7day_mean_per_100k": 42.1651963927
	},
	{
		"date": "2022-05-17",
		"county": "Daviess",
		"title": "9. Daviess",
		"cases_7day_mean_per_100k": 44.1480452584
	},
	{
		"date": "2022-05-18",
		"county": "Daviess",
		"title": "9. Daviess",
		"cases_7day_mean_per_100k": 44.6056257659
	},
	{
		"date": "2022-05-19",
		"county": "Daviess",
		"title": "9. Daviess",
		"cases_7day_mean_per_100k": 45.7495770346
	},
	{
		"date": "2022-05-20",
		"county": "Daviess",
		"title": "9. Daviess",
		"cases_7day_mean_per_100k": 46.4359477958
	},
	{
		"date": "2022-05-21",
		"county": "Daviess",
		"title": "9. Daviess",
		"cases_7day_mean_per_100k": 46.9697917212
	},
	{
		"date": "2022-05-22",
		"county": "Daviess",
		"title": "9. Daviess",
		"cases_7day_mean_per_100k": 47.3087402453
	},
	{
		"date": "2022-05-23",
		"county": "Daviess",
		"title": "9. Daviess",
		"cases_7day_mean_per_100k": 47.452793368
	},
	{
		"date": "2022-05-24",
		"county": "Daviess",
		"title": "9. Daviess",
		"cases_7day_mean_per_100k": 46.8765808771
	},
	{
		"date": "2022-05-25",
		"county": "Daviess",
		"title": "9. Daviess",
		"cases_7day_mean_per_100k": 47.2578979667
	},
	{
		"date": "2022-05-26",
		"county": "Daviess",
		"title": "9. Daviess",
		"cases_7day_mean_per_100k": 47.707004761
	},
	{
		"date": "2022-05-27",
		"county": "Daviess",
		"title": "9. Daviess",
		"cases_7day_mean_per_100k": 47.9019001624
	},
	{
		"date": "2022-05-28",
		"county": "Daviess",
		"title": "9. Daviess",
		"cases_7day_mean_per_100k": 47.3341613846
	},
	{
		"date": "2022-05-29",
		"county": "Daviess",
		"title": "9. Daviess",
		"cases_7day_mean_per_100k": 46.5969483448
	},
	{
		"date": "2022-05-30",
		"county": "Daviess",
		"title": "9. Daviess",
		"cases_7day_mean_per_100k": 41.4449307791
	},
	{
		"date": "2022-05-31",
		"county": "Daviess",
		"title": "9. Daviess",
		"cases_7day_mean_per_100k": 45.1309959782
	},
	{
		"date": "2022-06-01",
		"county": "Daviess",
		"title": "9. Daviess",
		"cases_7day_mean_per_100k": 47.0630025653
	},
	{
		"date": "2022-06-02",
		"county": "Daviess",
		"title": "9. Daviess",
		"cases_7day_mean_per_100k": 47.9357950148
	},
	{
		"date": "2022-06-03",
		"county": "Daviess",
		"title": "9. Daviess",
		"cases_7day_mean_per_100k": 48.3425332436
	},
	{
		"date": "2022-06-04",
		"county": "Daviess",
		"title": "9. Daviess",
		"cases_7day_mean_per_100k": 48.8509560297
	},
	{
		"date": "2022-06-05",
		"county": "Daviess",
		"title": "9. Daviess",
		"cases_7day_mean_per_100k": 49.9271175936
	},
	{
		"date": "2022-06-06",
		"county": "Daviess",
		"title": "9. Daviess",
		"cases_7day_mean_per_100k": 54.7571340614
	},
	{
		"date": "2022-06-07",
		"county": "Daviess",
		"title": "9. Daviess",
		"cases_7day_mean_per_100k": 50.5965409286
	},
	{
		"date": "2022-06-08",
		"county": "Daviess",
		"title": "9. Daviess",
		"cases_7day_mean_per_100k": 48.1052692768
	},
	{
		"date": "2022-06-09",
		"county": "Daviess",
		"title": "9. Daviess",
		"cases_7day_mean_per_100k": 46.0715781325
	},
	{
		"date": "2022-06-10",
		"county": "Daviess",
		"title": "9. Daviess",
		"cases_7day_mean_per_100k": 46.1732626897
	},
	{
		"date": "2022-06-11",
		"county": "Daviess",
		"title": "9. Daviess",
		"cases_7day_mean_per_100k": 45.6478924774
	},
	{
		"date": "2022-06-12",
		"county": "Daviess",
		"title": "9. Daviess",
		"cases_7day_mean_per_100k": 44.9191531507
	},
	{
		"date": "2022-06-13",
		"county": "Daviess",
		"title": "9. Daviess",
		"cases_7day_mean_per_100k": 42.9701991373
	},
	{
		"date": "2022-06-14",
		"county": "Daviess",
		"title": "9. Daviess",
		"cases_7day_mean_per_100k": 42.4787237775
	},
	{
		"date": "2022-06-15",
		"county": "Daviess",
		"title": "9. Daviess",
		"cases_7day_mean_per_100k": 41.4957730577
	},
	{
		"date": "2022-06-16",
		"county": "Daviess",
		"title": "9. Daviess",
		"cases_7day_mean_per_100k": 41.6652473197
	},
	{
		"date": "2022-06-17",
		"county": "Daviess",
		"title": "9. Daviess",
		"cases_7day_mean_per_100k": 40.5806120427
	},
	{
		"date": "2022-06-18",
		"county": "Daviess",
		"title": "9. Daviess",
		"cases_7day_mean_per_100k": 40.5636646165
	},
	{
		"date": "2022-06-19",
		"county": "Daviess",
		"title": "9. Daviess",
		"cases_7day_mean_per_100k": 40.9958239847
	},
	{
		"date": "2022-06-20",
		"county": "Daviess",
		"title": "9. Daviess",
		"cases_7day_mean_per_100k": 41.9025112866
	},
	{
		"date": "2022-06-21",
		"county": "Daviess",
		"title": "9. Daviess",
		"cases_7day_mean_per_100k": 42.5465134823
	},
	{
		"date": "2022-06-22",
		"county": "Daviess",
		"title": "9. Daviess",
		"cases_7day_mean_per_100k": 43.4277796448
	},
	{
		"date": "2022-06-23",
		"county": "Daviess",
		"title": "9. Daviess",
		"cases_7day_mean_per_100k": 43.7836755951
	},
	{
		"date": "2022-06-24",
		"county": "Daviess",
		"title": "9. Daviess",
		"cases_7day_mean_per_100k": 44.0717818405
	},
	{
		"date": "2022-06-25",
		"county": "Daviess",
		"title": "9. Daviess",
		"cases_7day_mean_per_100k": 44.94457429
	},
	{
		"date": "2022-06-26",
		"county": "Daviess",
		"title": "9. Daviess",
		"cases_7day_mean_per_100k": 44.9615217162
	},
	{
		"date": "2022-06-27",
		"county": "Daviess",
		"title": "9. Daviess",
		"cases_7day_mean_per_100k": 46.2410523945
	},
	{
		"date": "2022-06-28",
		"county": "Daviess",
		"title": "9. Daviess",
		"cases_7day_mean_per_100k": 46.5291586399
	},
	{
		"date": "2022-06-29",
		"county": "Daviess",
		"title": "9. Daviess",
		"cases_7day_mean_per_100k": 46.8850545902
	},
	{
		"date": "2022-06-30",
		"county": "Daviess",
		"title": "9. Daviess",
		"cases_7day_mean_per_100k": 46.6647380496
	},
	{
		"date": "2022-07-01",
		"county": "Daviess",
		"title": "9. Daviess",
		"cases_7day_mean_per_100k": 46.7410014675
	},
	{
		"date": "2022-07-02",
		"county": "Daviess",
		"title": "9. Daviess",
		"cases_7day_mean_per_100k": 45.9868410015
	},
	{
		"date": "2022-07-03",
		"county": "Daviess",
		"title": "9. Daviess",
		"cases_7day_mean_per_100k": 45.2326805354
	},
	{
		"date": "2022-07-04",
		"county": "Daviess",
		"title": "9. Daviess",
		"cases_7day_mean_per_100k": 40.8263497227
	},
	{
		"date": "2022-07-05",
		"county": "Daviess",
		"title": "9. Daviess",
		"cases_7day_mean_per_100k": 42.6736191788
	},
	{
		"date": "2022-07-06",
		"county": "Daviess",
		"title": "9. Daviess",
		"cases_7day_mean_per_100k": 43.9192550047
	},
	{
		"date": "2022-07-07",
		"county": "Daviess",
		"title": "9. Daviess",
		"cases_7day_mean_per_100k": 44.2243086764
	},
	{
		"date": "2022-07-08",
		"county": "Daviess",
		"title": "9. Daviess",
		"cases_7day_mean_per_100k": 44.0717818405
	},
	{
		"date": "2022-07-09",
		"county": "Daviess",
		"title": "9. Daviess",
		"cases_7day_mean_per_100k": 44.4107303646
	},
	{
		"date": "2022-07-10",
		"county": "Daviess",
		"title": "9. Daviess",
		"cases_7day_mean_per_100k": 45.3258913795
	},
	{
		"date": "2022-07-11",
		"county": "Daviess",
		"title": "9. Daviess",
		"cases_7day_mean_per_100k": 49.0543251442
	},
	{
		"date": "2022-07-12",
		"county": "Daviess",
		"title": "9. Daviess",
		"cases_7day_mean_per_100k": 47.0460551391
	},
	{
		"date": "2022-07-13",
		"county": "Daviess",
		"title": "9. Daviess",
		"cases_7day_mean_per_100k": 45.2326805354
	},
	{
		"date": "2022-07-14",
		"county": "Daviess",
		"title": "9. Daviess",
		"cases_7day_mean_per_100k": 44.0802555536
	},
	{
		"date": "2022-07-15",
		"county": "Daviess",
		"title": "9. Daviess",
		"cases_7day_mean_per_100k": 43.690464751
	},
	{
		"date": "2022-07-16",
		"county": "Daviess",
		"title": "9. Daviess",
		"cases_7day_mean_per_100k": 43.1650945387
	},
	{
		"date": "2022-07-17",
		"county": "Daviess",
		"title": "9. Daviess",
		"cases_7day_mean_per_100k": 42.5634609085
	},
	{
		"date": "2022-07-18",
		"county": "Daviess",
		"title": "9. Daviess",
		"cases_7day_mean_per_100k": 41.7330370245
	},
	{
		"date": "2022-07-19",
		"county": "Daviess",
		"title": "9. Daviess",
		"cases_7day_mean_per_100k": 40.2501372318
	},
	{
		"date": "2022-07-20",
		"county": "Daviess",
		"title": "9. Daviess",
		"cases_7day_mean_per_100k": 39.4027659216
	},
	{
		"date": "2022-07-21",
		"county": "Daviess",
		"title": "9. Daviess",
		"cases_7day_mean_per_100k": 39.2332916596
	},
	{
		"date": "2022-07-22",
		"county": "Daviess",
		"title": "9. Daviess",
		"cases_7day_mean_per_100k": 38.5299734722
	},
	{
		"date": "2022-07-23",
		"county": "Daviess",
		"title": "9. Daviess",
		"cases_7day_mean_per_100k": 38.0893403909
	},
	{
		"date": "2022-07-24",
		"county": "Daviess",
		"title": "9. Daviess",
		"cases_7day_mean_per_100k": 38.0893403909
	},
	{
		"date": "2022-07-25",
		"county": "Daviess",
		"title": "9. Daviess",
		"cases_7day_mean_per_100k": 37.2928113594
	},
	{
		"date": "2022-07-26",
		"county": "Daviess",
		"title": "9. Daviess",
		"cases_7day_mean_per_100k": 37.2419690808
	},
	{
		"date": "2022-07-27",
		"county": "Daviess",
		"title": "9. Daviess",
		"cases_7day_mean_per_100k": 36.9199679829
	},
	{
		"date": "2022-07-28",
		"county": "Daviess",
		"title": "9. Daviess",
		"cases_7day_mean_per_100k": 35.6319635915
	},
	{
		"date": "2022-07-29",
		"county": "Daviess",
		"title": "9. Daviess",
		"cases_7day_mean_per_100k": 33.9965369629
	},
	{
		"date": "2022-07-30",
		"county": "Daviess",
		"title": "9. Daviess",
		"cases_7day_mean_per_100k": 33.6152198734
	},
	{
		"date": "2022-07-31",
		"county": "Daviess",
		"title": "9. Daviess",
		"cases_7day_mean_per_100k": 32.9542702515
	},
	{
		"date": "2022-08-01",
		"county": "Daviess",
		"title": "9. Daviess",
		"cases_7day_mean_per_100k": 32.3526366213
	},
	{
		"date": "2022-08-02",
		"county": "Daviess",
		"title": "9. Daviess",
		"cases_7day_mean_per_100k": 31.7171081386
	},
	{
		"date": "2022-08-03",
		"county": "Daviess",
		"title": "9. Daviess",
		"cases_7day_mean_per_100k": 30.8951579678
	},
	{
		"date": "2022-08-04",
		"county": "Daviess",
		"title": "9. Daviess",
		"cases_7day_mean_per_100k": 30.742631132
	},
	{
		"date": "2022-08-05",
		"county": "Daviess",
		"title": "9. Daviess",
		"cases_7day_mean_per_100k": 30.5562094437
	},
	{
		"date": "2022-08-06",
		"county": "Daviess",
		"title": "9. Daviess",
		"cases_7day_mean_per_100k": 30.073207797
	},
	{
		"date": "2022-08-07",
		"county": "Daviess",
		"title": "9. Daviess",
		"cases_7day_mean_per_100k": 29.2682050523
	},
	{
		"date": "2022-08-08",
		"county": "Daviess",
		"title": "9. Daviess",
		"cases_7day_mean_per_100k": 27.7683578334
	},
	{
		"date": "2022-08-09",
		"county": "Daviess",
		"title": "9. Daviess",
		"cases_7day_mean_per_100k": 26.0651415
	},
	{
		"date": "2022-08-10",
		"county": "Daviess",
		"title": "9. Daviess",
		"cases_7day_mean_per_100k": 25.0906644933
	},
	{
		"date": "2022-08-11",
		"county": "Daviess",
		"title": "9. Daviess",
		"cases_7day_mean_per_100k": 24.1331349129
	},
	{
		"date": "2022-08-12",
		"county": "Daviess",
		"title": "9. Daviess",
		"cases_7day_mean_per_100k": 22.9468150787
	},
	{
		"date": "2022-08-13",
		"county": "Daviess",
		"title": "9. Daviess",
		"cases_7day_mean_per_100k": 22.4383922926
	},
	{
		"date": "2022-08-14",
		"county": "Daviess",
		"title": "9. Daviess",
		"cases_7day_mean_per_100k": 22.4977082843
	},
	{
		"date": "2022-08-15",
		"county": "Daviess",
		"title": "9. Daviess",
		"cases_7day_mean_per_100k": 21.6503369741
	},
	{
		"date": "2022-08-16",
		"county": "Daviess",
		"title": "9. Daviess",
		"cases_7day_mean_per_100k": 21.0232822046
	},
	{
		"date": "2022-08-17",
		"county": "Daviess",
		"title": "9. Daviess",
		"cases_7day_mean_per_100k": 20.5572279841
	},
	{
		"date": "2022-08-18",
		"county": "Daviess",
		"title": "9. Daviess",
		"cases_7day_mean_per_100k": 20.0318577718
	},
	{
		"date": "2022-08-19",
		"county": "Daviess",
		"title": "9. Daviess",
		"cases_7day_mean_per_100k": 19.8115412311
	},
	{
		"date": "2022-08-20",
		"county": "Daviess",
		"title": "9. Daviess",
		"cases_7day_mean_per_100k": 19.4895401333
	},
	{
		"date": "2022-08-21",
		"county": "Daviess",
		"title": "9. Daviess",
		"cases_7day_mean_per_100k": 19.1590653223
	},
	{
		"date": "2022-08-22",
		"county": "Daviess",
		"title": "9. Daviess",
		"cases_7day_mean_per_100k": 18.9048539293
	},
	{
		"date": "2022-08-23",
		"county": "Daviess",
		"title": "9. Daviess",
		"cases_7day_mean_per_100k": 18.7353796673
	},
	{
		"date": "2022-08-24",
		"county": "Daviess",
		"title": "9. Daviess",
		"cases_7day_mean_per_100k": 18.3032202991
	},
	{
		"date": "2022-08-25",
		"county": "Daviess",
		"title": "9. Daviess",
		"cases_7day_mean_per_100k": 18.0998511847
	},
	{
		"date": "2022-08-26",
		"county": "Daviess",
		"title": "9. Daviess",
		"cases_7day_mean_per_100k": 18.0574826191
	},
	{
		"date": "2022-08-27",
		"county": "Daviess",
		"title": "9. Daviess",
		"cases_7day_mean_per_100k": 17.6931129558
	},
	{
		"date": "2022-08-28",
		"county": "Daviess",
		"title": "9. Daviess",
		"cases_7day_mean_per_100k": 17.4897438413
	},
	{
		"date": "2022-08-29",
		"county": "Daviess",
		"title": "9. Daviess",
		"cases_7day_mean_per_100k": 16.6000039657
	},
	{
		"date": "2022-08-30",
		"county": "Daviess",
		"title": "9. Daviess",
		"cases_7day_mean_per_100k": 16.2610554416
	},
	{
		"date": "2022-08-31",
		"county": "Daviess",
		"title": "9. Daviess",
		"cases_7day_mean_per_100k": 15.6594218114
	},
	{
		"date": "2022-09-01",
		"county": "Daviess",
		"title": "9. Daviess",
		"cases_7day_mean_per_100k": 14.9984721895
	},
	{
		"date": "2022-09-02",
		"county": "Daviess",
		"title": "9. Daviess",
		"cases_7day_mean_per_100k": 14.4731019772
	},
	{
		"date": "2022-09-03",
		"county": "Daviess",
		"title": "9. Daviess",
		"cases_7day_mean_per_100k": 14.1680483056
	},
	{
		"date": "2022-09-04",
		"county": "Daviess",
		"title": "9. Daviess",
		"cases_7day_mean_per_100k": 13.6342043802
	},
	{
		"date": "2022-09-05",
		"county": "Daviess",
		"title": "9. Daviess",
		"cases_7day_mean_per_100k": 12.0750411695
	},
	{
		"date": "2022-09-06",
		"county": "Daviess",
		"title": "9. Daviess",
		"cases_7day_mean_per_100k": 11.8038823503
	},
	{
		"date": "2022-09-07",
		"county": "Daviess",
		"title": "9. Daviess",
		"cases_7day_mean_per_100k": 11.9564091861
	},
	{
		"date": "2022-09-08",
		"county": "Daviess",
		"title": "9. Daviess",
		"cases_7day_mean_per_100k": 12.0750411695
	},
	{
		"date": "2022-09-09",
		"county": "Daviess",
		"title": "9. Daviess",
		"cases_7day_mean_per_100k": 12.0241988909
	},
	{
		"date": "2022-09-10",
		"county": "Daviess",
		"title": "9. Daviess",
		"cases_7day_mean_per_100k": 12.4139896936
	},
	{
		"date": "2022-09-11",
		"county": "Daviess",
		"title": "9. Daviess",
		"cases_7day_mean_per_100k": 12.532621677
	},
	{
		"date": "2022-09-12",
		"county": "Daviess",
		"title": "9. Daviess",
		"cases_7day_mean_per_100k": 13.5918358147
	},
	{
		"date": "2022-09-13",
		"county": "Daviess",
		"title": "9. Daviess",
		"cases_7day_mean_per_100k": 12.9817284714
	},
	{
		"date": "2022-09-14",
		"county": "Daviess",
		"title": "9. Daviess",
		"cases_7day_mean_per_100k": 12.363147415
	},
	{
		"date": "2022-09-15",
		"county": "Daviess",
		"title": "9. Daviess",
		"cases_7day_mean_per_100k": 11.8123560634
	},
	{
		"date": "2022-09-16",
		"county": "Daviess",
		"title": "9. Daviess",
		"cases_7day_mean_per_100k": 11.3971441214
	},
	{
		"date": "2022-09-17",
		"county": "Daviess",
		"title": "9. Daviess",
		"cases_7day_mean_per_100k": 11.0327744581
	},
	{
		"date": "2022-09-18",
		"county": "Daviess",
		"title": "9. Daviess",
		"cases_7day_mean_per_100k": 10.8717739091
	},
	{
		"date": "2022-09-19",
		"county": "Daviess",
		"title": "9. Daviess",
		"cases_7day_mean_per_100k": 10.3548774099
	},
	{
		"date": "2022-09-20",
		"county": "Daviess",
		"title": "9. Daviess",
		"cases_7day_mean_per_100k": 9.9311917549
	},
	{
		"date": "2022-09-21",
		"county": "Daviess",
		"title": "9. Daviess",
		"cases_7day_mean_per_100k": 9.6007169439
	},
	{
		"date": "2022-09-22",
		"county": "Daviess",
		"title": "9. Daviess",
		"cases_7day_mean_per_100k": 9.4905586736
	},
	{
		"date": "2022-09-23",
		"county": "Daviess",
		"title": "9. Daviess",
		"cases_7day_mean_per_100k": 9.4312426819
	},
	{
		"date": "2022-09-24",
		"county": "Daviess",
		"title": "9. Daviess",
		"cases_7day_mean_per_100k": 9.4905586736
	},
	{
		"date": "2022-09-25",
		"county": "Daviess",
		"title": "9. Daviess",
		"cases_7day_mean_per_100k": 9.4312426819
	},
	{
		"date": "2022-09-26",
		"county": "Daviess",
		"title": "9. Daviess",
		"cases_7day_mean_per_100k": 9.5329272391
	},
	{
		"date": "2022-09-27",
		"county": "Daviess",
		"title": "9. Daviess",
		"cases_7day_mean_per_100k": 9.7024015011
	},
	{
		"date": "2022-09-28",
		"county": "Daviess",
		"title": "9. Daviess",
		"cases_7day_mean_per_100k": 9.8040860584
	},
	{
		"date": "2022-09-29",
		"county": "Daviess",
		"title": "9. Daviess",
		"cases_7day_mean_per_100k": 9.7362963535
	},
	{
		"date": "2022-09-30",
		"county": "Daviess",
		"title": "9. Daviess",
		"cases_7day_mean_per_100k": 9.7108752142
	},
	{
		"date": "2022-10-01",
		"county": "Daviess",
		"title": "9. Daviess",
		"cases_7day_mean_per_100k": 9.4820849605
	},
	{
		"date": "2022-10-02",
		"county": "Daviess",
		"title": "9. Daviess",
		"cases_7day_mean_per_100k": 9.4905586736
	},
	{
		"date": "2022-10-03",
		"county": "Daviess",
		"title": "9. Daviess",
		"cases_7day_mean_per_100k": 9.3719266902
	},
	{
		"date": "2022-10-04",
		"county": "Daviess",
		"title": "9. Daviess",
		"cases_7day_mean_per_100k": 9.3041369854
	},
	{
		"date": "2022-10-05",
		"county": "Daviess",
		"title": "9. Daviess",
		"cases_7day_mean_per_100k": 9.0753467316
	},
	{
		"date": "2022-10-06",
		"county": "Daviess",
		"title": "9. Daviess",
		"cases_7day_mean_per_100k": 9.0668730185
	},
	{
		"date": "2022-10-07",
		"county": "Daviess",
		"title": "9. Daviess",
		"cases_7day_mean_per_100k": 8.8211353386
	},
	{
		"date": "2022-10-08",
		"county": "Daviess",
		"title": "9. Daviess",
		"cases_7day_mean_per_100k": 8.8635039041
	},
	{
		"date": "2022-10-09",
		"county": "Daviess",
		"title": "9. Daviess",
		"cases_7day_mean_per_100k": 8.6431873635
	},
	{
		"date": "2022-10-10",
		"county": "Daviess",
		"title": "9. Daviess",
		"cases_7day_mean_per_100k": 8.2364491346
	},
	{
		"date": "2022-10-11",
		"county": "Daviess",
		"title": "9. Daviess",
		"cases_7day_mean_per_100k": 7.9229217498
	},
	{
		"date": "2022-10-12",
		"county": "Daviess",
		"title": "9. Daviess",
		"cases_7day_mean_per_100k": 8.100869725
	},
	{
		"date": "2022-10-13",
		"county": "Daviess",
		"title": "9. Daviess",
		"cases_7day_mean_per_100k": 7.770394914
	},
	{
		"date": "2022-10-14",
		"county": "Daviess",
		"title": "9. Daviess",
		"cases_7day_mean_per_100k": 7.8042897664
	},
	{
		"date": "2022-10-15",
		"county": "Daviess",
		"title": "9. Daviess",
		"cases_7day_mean_per_100k": 7.43144639
	},
	{
		"date": "2022-10-16",
		"county": "Daviess",
		"title": "9. Daviess",
		"cases_7day_mean_per_100k": 7.5077098079
	},
	{
		"date": "2022-10-17",
		"county": "Daviess",
		"title": "9. Daviess",
		"cases_7day_mean_per_100k": 7.5754995127
	},
	{
		"date": "2022-10-18",
		"county": "Daviess",
		"title": "9. Daviess",
		"cases_7day_mean_per_100k": 7.6093943651
	},
	{
		"date": "2022-10-19",
		"county": "Daviess",
		"title": "9. Daviess",
		"cases_7day_mean_per_100k": 7.3128144065
	},
	{
		"date": "2022-10-20",
		"county": "Daviess",
		"title": "9. Daviess",
		"cases_7day_mean_per_100k": 7.4399201031
	},
	{
		"date": "2022-10-21",
		"county": "Daviess",
		"title": "9. Daviess",
		"cases_7day_mean_per_100k": 7.4229726769
	},
	{
		"date": "2022-10-22",
		"county": "Daviess",
		"title": "9. Daviess",
		"cases_7day_mean_per_100k": 7.4653412424
	},
	{
		"date": "2022-10-23",
		"county": "Daviess",
		"title": "9. Daviess",
		"cases_7day_mean_per_100k": 7.4907623817
	},
	{
		"date": "2022-10-24",
		"county": "Daviess",
		"title": "9. Daviess",
		"cases_7day_mean_per_100k": 7.770394914
	},
	{
		"date": "2022-10-25",
		"county": "Daviess",
		"title": "9. Daviess",
		"cases_7day_mean_per_100k": 7.8212371926
	},
	{
		"date": "2022-10-26",
		"county": "Daviess",
		"title": "9. Daviess",
		"cases_7day_mean_per_100k": 7.9991851677
	},
	{
		"date": "2022-10-27",
		"county": "Daviess",
		"title": "9. Daviess",
		"cases_7day_mean_per_100k": 8.2364491346
	},
	{
		"date": "2022-10-28",
		"county": "Daviess",
		"title": "9. Daviess",
		"cases_7day_mean_per_100k": 8.1347645774
	},
	{
		"date": "2022-10-29",
		"county": "Daviess",
		"title": "9. Daviess",
		"cases_7day_mean_per_100k": 8.1940805691
	},
	{
		"date": "2022-10-30",
		"county": "Daviess",
		"title": "9. Daviess",
		"cases_7day_mean_per_100k": 8.2195017084
	},
	{
		"date": "2022-10-31",
		"county": "Daviess",
		"title": "9. Daviess",
		"cases_7day_mean_per_100k": 8.2449228477
	},
	{
		"date": "2022-11-01",
		"county": "Daviess",
		"title": "9. Daviess",
		"cases_7day_mean_per_100k": 8.5923450848
	},
	{
		"date": "2022-11-02",
		"county": "Daviess",
		"title": "9. Daviess",
		"cases_7day_mean_per_100k": 8.8889250434
	},
	{
		"date": "2022-11-03",
		"county": "Daviess",
		"title": "9. Daviess",
		"cases_7day_mean_per_100k": 8.8465564779
	},
	{
		"date": "2022-11-04",
		"county": "Daviess",
		"title": "9. Daviess",
		"cases_7day_mean_per_100k": 9.0414518792
	},
	{
		"date": "2022-11-05",
		"county": "Daviess",
		"title": "9. Daviess",
		"cases_7day_mean_per_100k": 9.0329781661
	},
	{
		"date": "2022-11-06",
		"county": "Daviess",
		"title": "9. Daviess",
		"cases_7day_mean_per_100k": 8.6770822159
	},
	{
		"date": "2022-11-07",
		"county": "Daviess",
		"title": "9. Daviess",
		"cases_7day_mean_per_100k": 7.0077607349
	},
	{
		"date": "2022-11-08",
		"county": "Daviess",
		"title": "9. Daviess",
		"cases_7day_mean_per_100k": 5.3553866801
	},
	{
		"date": "2022-03-01",
		"county": "Lincoln",
		"title": "3. Lincoln",
		"cases_7day_mean_per_100k": 8.2750832376
	},
	{
		"date": "2022-03-02",
		"county": "Lincoln",
		"title": "3. Lincoln",
		"cases_7day_mean_per_100k": 8.7618528398
	},
	{
		"date": "2022-03-03",
		"county": "Lincoln",
		"title": "3. Lincoln",
		"cases_7day_mean_per_100k": 7.3015440332
	},
	{
		"date": "2022-03-04",
		"county": "Lincoln",
		"title": "3. Lincoln",
		"cases_7day_mean_per_100k": 7.7883136354
	},
	{
		"date": "2022-03-05",
		"county": "Lincoln",
		"title": "3. Lincoln",
		"cases_7day_mean_per_100k": 7.3015440332
	},
	{
		"date": "2022-03-06",
		"county": "Lincoln",
		"title": "3. Lincoln",
		"cases_7day_mean_per_100k": 8.2750832376
	},
	{
		"date": "2022-03-07",
		"county": "Lincoln",
		"title": "3. Lincoln",
		"cases_7day_mean_per_100k": 8.7618528398
	},
	{
		"date": "2022-03-08",
		"county": "Lincoln",
		"title": "3. Lincoln",
		"cases_7day_mean_per_100k": 8.2750832376
	},
	{
		"date": "2022-03-09",
		"county": "Lincoln",
		"title": "3. Lincoln",
		"cases_7day_mean_per_100k": 8.2750832376
	},
	{
		"date": "2022-03-10",
		"county": "Lincoln",
		"title": "3. Lincoln",
		"cases_7day_mean_per_100k": 8.2750832376
	},
	{
		"date": "2022-03-11",
		"county": "Lincoln",
		"title": "3. Lincoln",
		"cases_7day_mean_per_100k": 8.2750832376
	},
	{
		"date": "2022-03-12",
		"county": "Lincoln",
		"title": "3. Lincoln",
		"cases_7day_mean_per_100k": 7.7883136354
	},
	{
		"date": "2022-03-13",
		"county": "Lincoln",
		"title": "3. Lincoln",
		"cases_7day_mean_per_100k": 5.8412352265
	},
	{
		"date": "2022-03-14",
		"county": "Lincoln",
		"title": "3. Lincoln",
		"cases_7day_mean_per_100k": 5.8412352265
	},
	{
		"date": "2022-03-15",
		"county": "Lincoln",
		"title": "3. Lincoln",
		"cases_7day_mean_per_100k": 5.3544656243
	},
	{
		"date": "2022-03-16",
		"county": "Lincoln",
		"title": "3. Lincoln",
		"cases_7day_mean_per_100k": 5.3544656243
	},
	{
		"date": "2022-03-17",
		"county": "Lincoln",
		"title": "3. Lincoln",
		"cases_7day_mean_per_100k": 5.3544656243
	},
	{
		"date": "2022-03-18",
		"county": "Lincoln",
		"title": "3. Lincoln",
		"cases_7day_mean_per_100k": 3.8941568177
	},
	{
		"date": "2022-03-19",
		"county": "Lincoln",
		"title": "3. Lincoln",
		"cases_7day_mean_per_100k": 4.3809264199
	},
	{
		"date": "2022-03-20",
		"county": "Lincoln",
		"title": "3. Lincoln",
		"cases_7day_mean_per_100k": 4.3809264199
	},
	{
		"date": "2022-03-21",
		"county": "Lincoln",
		"title": "3. Lincoln",
		"cases_7day_mean_per_100k": 3.4073872155
	},
	{
		"date": "2022-03-22",
		"county": "Lincoln",
		"title": "3. Lincoln",
		"cases_7day_mean_per_100k": 3.4073872155
	},
	{
		"date": "2022-03-23",
		"county": "Lincoln",
		"title": "3. Lincoln",
		"cases_7day_mean_per_100k": 3.4073872155
	},
	{
		"date": "2022-03-24",
		"county": "Lincoln",
		"title": "3. Lincoln",
		"cases_7day_mean_per_100k": 2.9206176133
	},
	{
		"date": "2022-03-25",
		"county": "Lincoln",
		"title": "3. Lincoln",
		"cases_7day_mean_per_100k": 3.4073872155
	},
	{
		"date": "2022-03-26",
		"county": "Lincoln",
		"title": "3. Lincoln",
		"cases_7day_mean_per_100k": 2.9206176133
	},
	{
		"date": "2022-03-27",
		"county": "Lincoln",
		"title": "3. Lincoln",
		"cases_7day_mean_per_100k": 3.4073872155
	},
	{
		"date": "2022-03-28",
		"county": "Lincoln",
		"title": "3. Lincoln",
		"cases_7day_mean_per_100k": 3.8941568177
	},
	{
		"date": "2022-03-29",
		"county": "Lincoln",
		"title": "3. Lincoln",
		"cases_7day_mean_per_100k": 3.4073872155
	},
	{
		"date": "2022-03-30",
		"county": "Lincoln",
		"title": "3. Lincoln",
		"cases_7day_mean_per_100k": 2.4338480111
	},
	{
		"date": "2022-03-31",
		"county": "Lincoln",
		"title": "3. Lincoln",
		"cases_7day_mean_per_100k": 2.9206176133
	},
	{
		"date": "2022-04-01",
		"county": "Lincoln",
		"title": "3. Lincoln",
		"cases_7day_mean_per_100k": 2.9206176133
	},
	{
		"date": "2022-04-02",
		"county": "Lincoln",
		"title": "3. Lincoln",
		"cases_7day_mean_per_100k": 2.9206176133
	},
	{
		"date": "2022-04-03",
		"county": "Lincoln",
		"title": "3. Lincoln",
		"cases_7day_mean_per_100k": 2.4338480111
	},
	{
		"date": "2022-04-04",
		"county": "Lincoln",
		"title": "3. Lincoln",
		"cases_7day_mean_per_100k": 1.4603088066
	},
	{
		"date": "2022-04-05",
		"county": "Lincoln",
		"title": "3. Lincoln",
		"cases_7day_mean_per_100k": 1.4603088066
	},
	{
		"date": "2022-04-06",
		"county": "Lincoln",
		"title": "3. Lincoln",
		"cases_7day_mean_per_100k": 1.4603088066
	},
	{
		"date": "2022-04-07",
		"county": "Lincoln",
		"title": "3. Lincoln",
		"cases_7day_mean_per_100k": 0.9735392044
	},
	{
		"date": "2022-04-08",
		"county": "Lincoln",
		"title": "3. Lincoln",
		"cases_7day_mean_per_100k": 0.9735392044
	},
	{
		"date": "2022-04-09",
		"county": "Lincoln",
		"title": "3. Lincoln",
		"cases_7day_mean_per_100k": 0.9735392044
	},
	{
		"date": "2022-04-10",
		"county": "Lincoln",
		"title": "3. Lincoln",
		"cases_7day_mean_per_100k": 0.9735392044
	},
	{
		"date": "2022-04-11",
		"county": "Lincoln",
		"title": "3. Lincoln",
		"cases_7day_mean_per_100k": 0.9735392044
	},
	{
		"date": "2022-04-12",
		"county": "Lincoln",
		"title": "3. Lincoln",
		"cases_7day_mean_per_100k": 0.9735392044
	},
	{
		"date": "2022-04-13",
		"county": "Lincoln",
		"title": "3. Lincoln",
		"cases_7day_mean_per_100k": 0.9735392044
	},
	{
		"date": "2022-04-14",
		"county": "Lincoln",
		"title": "3. Lincoln",
		"cases_7day_mean_per_100k": 1.9470784088
	},
	{
		"date": "2022-04-15",
		"county": "Lincoln",
		"title": "3. Lincoln",
		"cases_7day_mean_per_100k": 1.4603088066
	},
	{
		"date": "2022-04-16",
		"county": "Lincoln",
		"title": "3. Lincoln",
		"cases_7day_mean_per_100k": 1.9470784088
	},
	{
		"date": "2022-04-17",
		"county": "Lincoln",
		"title": "3. Lincoln",
		"cases_7day_mean_per_100k": 1.9470784088
	},
	{
		"date": "2022-04-18",
		"county": "Lincoln",
		"title": "3. Lincoln",
		"cases_7day_mean_per_100k": 1.9470784088
	},
	{
		"date": "2022-04-19",
		"county": "Lincoln",
		"title": "3. Lincoln",
		"cases_7day_mean_per_100k": 1.4603088066
	},
	{
		"date": "2022-04-20",
		"county": "Lincoln",
		"title": "3. Lincoln",
		"cases_7day_mean_per_100k": 1.9470784088
	},
	{
		"date": "2022-04-21",
		"county": "Lincoln",
		"title": "3. Lincoln",
		"cases_7day_mean_per_100k": 1.4603088066
	},
	{
		"date": "2022-04-22",
		"county": "Lincoln",
		"title": "3. Lincoln",
		"cases_7day_mean_per_100k": 1.4603088066
	},
	{
		"date": "2022-04-23",
		"county": "Lincoln",
		"title": "3. Lincoln",
		"cases_7day_mean_per_100k": 1.9470784088
	},
	{
		"date": "2022-04-24",
		"county": "Lincoln",
		"title": "3. Lincoln",
		"cases_7day_mean_per_100k": 1.9470784088
	},
	{
		"date": "2022-04-25",
		"county": "Lincoln",
		"title": "3. Lincoln",
		"cases_7day_mean_per_100k": 1.9470784088
	},
	{
		"date": "2022-04-26",
		"county": "Lincoln",
		"title": "3. Lincoln",
		"cases_7day_mean_per_100k": 1.9470784088
	},
	{
		"date": "2022-04-27",
		"county": "Lincoln",
		"title": "3. Lincoln",
		"cases_7day_mean_per_100k": 1.4603088066
	},
	{
		"date": "2022-04-28",
		"county": "Lincoln",
		"title": "3. Lincoln",
		"cases_7day_mean_per_100k": 0.9735392044
	},
	{
		"date": "2022-04-29",
		"county": "Lincoln",
		"title": "3. Lincoln",
		"cases_7day_mean_per_100k": 2.4338480111
	},
	{
		"date": "2022-04-30",
		"county": "Lincoln",
		"title": "3. Lincoln",
		"cases_7day_mean_per_100k": 1.4603088066
	},
	{
		"date": "2022-05-01",
		"county": "Lincoln",
		"title": "3. Lincoln",
		"cases_7day_mean_per_100k": 1.9470784088
	},
	{
		"date": "2022-05-02",
		"county": "Lincoln",
		"title": "3. Lincoln",
		"cases_7day_mean_per_100k": 1.9470784088
	},
	{
		"date": "2022-05-03",
		"county": "Lincoln",
		"title": "3. Lincoln",
		"cases_7day_mean_per_100k": 2.9206176133
	},
	{
		"date": "2022-05-04",
		"county": "Lincoln",
		"title": "3. Lincoln",
		"cases_7day_mean_per_100k": 3.4073872155
	},
	{
		"date": "2022-05-05",
		"county": "Lincoln",
		"title": "3. Lincoln",
		"cases_7day_mean_per_100k": 4.3809264199
	},
	{
		"date": "2022-05-06",
		"county": "Lincoln",
		"title": "3. Lincoln",
		"cases_7day_mean_per_100k": 2.9206176133
	},
	{
		"date": "2022-05-07",
		"county": "Lincoln",
		"title": "3. Lincoln",
		"cases_7day_mean_per_100k": 2.9206176133
	},
	{
		"date": "2022-05-08",
		"county": "Lincoln",
		"title": "3. Lincoln",
		"cases_7day_mean_per_100k": 2.9206176133
	},
	{
		"date": "2022-05-09",
		"county": "Lincoln",
		"title": "3. Lincoln",
		"cases_7day_mean_per_100k": 3.8941568177
	},
	{
		"date": "2022-05-10",
		"county": "Lincoln",
		"title": "3. Lincoln",
		"cases_7day_mean_per_100k": 3.8941568177
	},
	{
		"date": "2022-05-11",
		"county": "Lincoln",
		"title": "3. Lincoln",
		"cases_7day_mean_per_100k": 4.8676960221
	},
	{
		"date": "2022-05-12",
		"county": "Lincoln",
		"title": "3. Lincoln",
		"cases_7day_mean_per_100k": 3.8941568177
	},
	{
		"date": "2022-05-13",
		"county": "Lincoln",
		"title": "3. Lincoln",
		"cases_7day_mean_per_100k": 5.8412352265
	},
	{
		"date": "2022-05-14",
		"county": "Lincoln",
		"title": "3. Lincoln",
		"cases_7day_mean_per_100k": 6.814774431
	},
	{
		"date": "2022-05-15",
		"county": "Lincoln",
		"title": "3. Lincoln",
		"cases_7day_mean_per_100k": 6.814774431
	},
	{
		"date": "2022-05-16",
		"county": "Lincoln",
		"title": "3. Lincoln",
		"cases_7day_mean_per_100k": 7.3015440332
	},
	{
		"date": "2022-05-17",
		"county": "Lincoln",
		"title": "3. Lincoln",
		"cases_7day_mean_per_100k": 8.2750832376
	},
	{
		"date": "2022-05-18",
		"county": "Lincoln",
		"title": "3. Lincoln",
		"cases_7day_mean_per_100k": 8.2750832376
	},
	{
		"date": "2022-05-19",
		"county": "Lincoln",
		"title": "3. Lincoln",
		"cases_7day_mean_per_100k": 8.7618528398
	},
	{
		"date": "2022-05-20",
		"county": "Lincoln",
		"title": "3. Lincoln",
		"cases_7day_mean_per_100k": 7.3015440332
	},
	{
		"date": "2022-05-21",
		"county": "Lincoln",
		"title": "3. Lincoln",
		"cases_7day_mean_per_100k": 7.7883136354
	},
	{
		"date": "2022-05-22",
		"county": "Lincoln",
		"title": "3. Lincoln",
		"cases_7day_mean_per_100k": 9.248622442
	},
	{
		"date": "2022-05-23",
		"county": "Lincoln",
		"title": "3. Lincoln",
		"cases_7day_mean_per_100k": 12.6560096575
	},
	{
		"date": "2022-05-24",
		"county": "Lincoln",
		"title": "3. Lincoln",
		"cases_7day_mean_per_100k": 12.6560096575
	},
	{
		"date": "2022-05-25",
		"county": "Lincoln",
		"title": "3. Lincoln",
		"cases_7day_mean_per_100k": 12.1692400553
	},
	{
		"date": "2022-05-26",
		"county": "Lincoln",
		"title": "3. Lincoln",
		"cases_7day_mean_per_100k": 14.1163184641
	},
	{
		"date": "2022-05-27",
		"county": "Lincoln",
		"title": "3. Lincoln",
		"cases_7day_mean_per_100k": 16.5501664752
	},
	{
		"date": "2022-05-28",
		"county": "Lincoln",
		"title": "3. Lincoln",
		"cases_7day_mean_per_100k": 16.063396873
	},
	{
		"date": "2022-05-29",
		"county": "Lincoln",
		"title": "3. Lincoln",
		"cases_7day_mean_per_100k": 15.5766272708
	},
	{
		"date": "2022-05-30",
		"county": "Lincoln",
		"title": "3. Lincoln",
		"cases_7day_mean_per_100k": 13.1427792597
	},
	{
		"date": "2022-05-31",
		"county": "Lincoln",
		"title": "3. Lincoln",
		"cases_7day_mean_per_100k": 13.6295488619
	},
	{
		"date": "2022-06-01",
		"county": "Lincoln",
		"title": "3. Lincoln",
		"cases_7day_mean_per_100k": 16.5501664752
	},
	{
		"date": "2022-06-02",
		"county": "Lincoln",
		"title": "3. Lincoln",
		"cases_7day_mean_per_100k": 16.5501664752
	},
	{
		"date": "2022-06-03",
		"county": "Lincoln",
		"title": "3. Lincoln",
		"cases_7day_mean_per_100k": 16.5501664752
	},
	{
		"date": "2022-06-04",
		"county": "Lincoln",
		"title": "3. Lincoln",
		"cases_7day_mean_per_100k": 18.4972448841
	},
	{
		"date": "2022-06-05",
		"county": "Lincoln",
		"title": "3. Lincoln",
		"cases_7day_mean_per_100k": 18.9840144863
	},
	{
		"date": "2022-06-06",
		"county": "Lincoln",
		"title": "3. Lincoln",
		"cases_7day_mean_per_100k": 19.9575536907
	},
	{
		"date": "2022-06-07",
		"county": "Lincoln",
		"title": "3. Lincoln",
		"cases_7day_mean_per_100k": 21.4178624973
	},
	{
		"date": "2022-06-08",
		"county": "Lincoln",
		"title": "3. Lincoln",
		"cases_7day_mean_per_100k": 20.9310928951
	},
	{
		"date": "2022-06-09",
		"county": "Lincoln",
		"title": "3. Lincoln",
		"cases_7day_mean_per_100k": 20.4443232929
	},
	{
		"date": "2022-06-10",
		"county": "Lincoln",
		"title": "3. Lincoln",
		"cases_7day_mean_per_100k": 20.4443232929
	},
	{
		"date": "2022-06-11",
		"county": "Lincoln",
		"title": "3. Lincoln",
		"cases_7day_mean_per_100k": 18.4972448841
	},
	{
		"date": "2022-06-12",
		"county": "Lincoln",
		"title": "3. Lincoln",
		"cases_7day_mean_per_100k": 17.5237056796
	},
	{
		"date": "2022-06-13",
		"county": "Lincoln",
		"title": "3. Lincoln",
		"cases_7day_mean_per_100k": 15.5766272708
	},
	{
		"date": "2022-06-14",
		"county": "Lincoln",
		"title": "3. Lincoln",
		"cases_7day_mean_per_100k": 13.6295488619
	},
	{
		"date": "2022-06-15",
		"county": "Lincoln",
		"title": "3. Lincoln",
		"cases_7day_mean_per_100k": 14.6030880664
	},
	{
		"date": "2022-06-16",
		"county": "Lincoln",
		"title": "3. Lincoln",
		"cases_7day_mean_per_100k": 15.0898576686
	},
	{
		"date": "2022-06-17",
		"county": "Lincoln",
		"title": "3. Lincoln",
		"cases_7day_mean_per_100k": 16.5501664752
	},
	{
		"date": "2022-06-18",
		"county": "Lincoln",
		"title": "3. Lincoln",
		"cases_7day_mean_per_100k": 16.063396873
	},
	{
		"date": "2022-06-19",
		"county": "Lincoln",
		"title": "3. Lincoln",
		"cases_7day_mean_per_100k": 16.5501664752
	},
	{
		"date": "2022-06-20",
		"county": "Lincoln",
		"title": "3. Lincoln",
		"cases_7day_mean_per_100k": 19.4707840885
	},
	{
		"date": "2022-06-21",
		"county": "Lincoln",
		"title": "3. Lincoln",
		"cases_7day_mean_per_100k": 19.9575536907
	},
	{
		"date": "2022-06-22",
		"county": "Lincoln",
		"title": "3. Lincoln",
		"cases_7day_mean_per_100k": 18.9840144863
	},
	{
		"date": "2022-06-23",
		"county": "Lincoln",
		"title": "3. Lincoln",
		"cases_7day_mean_per_100k": 17.5237056796
	},
	{
		"date": "2022-06-24",
		"county": "Lincoln",
		"title": "3. Lincoln",
		"cases_7day_mean_per_100k": 14.6030880664
	},
	{
		"date": "2022-06-25",
		"county": "Lincoln",
		"title": "3. Lincoln",
		"cases_7day_mean_per_100k": 15.0898576686
	},
	{
		"date": "2022-06-26",
		"county": "Lincoln",
		"title": "3. Lincoln",
		"cases_7day_mean_per_100k": 16.063396873
	},
	{
		"date": "2022-06-27",
		"county": "Lincoln",
		"title": "3. Lincoln",
		"cases_7day_mean_per_100k": 14.1163184641
	},
	{
		"date": "2022-06-28",
		"county": "Lincoln",
		"title": "3. Lincoln",
		"cases_7day_mean_per_100k": 14.6030880664
	},
	{
		"date": "2022-06-29",
		"county": "Lincoln",
		"title": "3. Lincoln",
		"cases_7day_mean_per_100k": 15.0898576686
	},
	{
		"date": "2022-06-30",
		"county": "Lincoln",
		"title": "3. Lincoln",
		"cases_7day_mean_per_100k": 14.6030880664
	},
	{
		"date": "2022-07-01",
		"county": "Lincoln",
		"title": "3. Lincoln",
		"cases_7day_mean_per_100k": 14.6030880664
	},
	{
		"date": "2022-07-02",
		"county": "Lincoln",
		"title": "3. Lincoln",
		"cases_7day_mean_per_100k": 13.6295488619
	},
	{
		"date": "2022-07-03",
		"county": "Lincoln",
		"title": "3. Lincoln",
		"cases_7day_mean_per_100k": 13.6295488619
	},
	{
		"date": "2022-07-04",
		"county": "Lincoln",
		"title": "3. Lincoln",
		"cases_7day_mean_per_100k": 11.6824704531
	},
	{
		"date": "2022-07-05",
		"county": "Lincoln",
		"title": "3. Lincoln",
		"cases_7day_mean_per_100k": 12.6560096575
	},
	{
		"date": "2022-07-06",
		"county": "Lincoln",
		"title": "3. Lincoln",
		"cases_7day_mean_per_100k": 13.1427792597
	},
	{
		"date": "2022-07-07",
		"county": "Lincoln",
		"title": "3. Lincoln",
		"cases_7day_mean_per_100k": 15.0898576686
	},
	{
		"date": "2022-07-08",
		"county": "Lincoln",
		"title": "3. Lincoln",
		"cases_7day_mean_per_100k": 16.5501664752
	},
	{
		"date": "2022-07-09",
		"county": "Lincoln",
		"title": "3. Lincoln",
		"cases_7day_mean_per_100k": 18.9840144863
	},
	{
		"date": "2022-07-10",
		"county": "Lincoln",
		"title": "3. Lincoln",
		"cases_7day_mean_per_100k": 19.9575536907
	},
	{
		"date": "2022-07-11",
		"county": "Lincoln",
		"title": "3. Lincoln",
		"cases_7day_mean_per_100k": 21.9046320995
	},
	{
		"date": "2022-07-12",
		"county": "Lincoln",
		"title": "3. Lincoln",
		"cases_7day_mean_per_100k": 19.4707840885
	},
	{
		"date": "2022-07-13",
		"county": "Lincoln",
		"title": "3. Lincoln",
		"cases_7day_mean_per_100k": 17.0369360774
	},
	{
		"date": "2022-07-14",
		"county": "Lincoln",
		"title": "3. Lincoln",
		"cases_7day_mean_per_100k": 16.5501664752
	},
	{
		"date": "2022-07-15",
		"county": "Lincoln",
		"title": "3. Lincoln",
		"cases_7day_mean_per_100k": 18.0104752818
	},
	{
		"date": "2022-07-16",
		"county": "Lincoln",
		"title": "3. Lincoln",
		"cases_7day_mean_per_100k": 17.0369360774
	},
	{
		"date": "2022-07-17",
		"county": "Lincoln",
		"title": "3. Lincoln",
		"cases_7day_mean_per_100k": 16.063396873
	},
	{
		"date": "2022-07-18",
		"county": "Lincoln",
		"title": "3. Lincoln",
		"cases_7day_mean_per_100k": 16.5501664752
	},
	{
		"date": "2022-07-19",
		"county": "Lincoln",
		"title": "3. Lincoln",
		"cases_7day_mean_per_100k": 16.063396873
	},
	{
		"date": "2022-07-20",
		"county": "Lincoln",
		"title": "3. Lincoln",
		"cases_7day_mean_per_100k": 17.5237056796
	},
	{
		"date": "2022-07-21",
		"county": "Lincoln",
		"title": "3. Lincoln",
		"cases_7day_mean_per_100k": 17.5237056796
	},
	{
		"date": "2022-07-22",
		"county": "Lincoln",
		"title": "3. Lincoln",
		"cases_7day_mean_per_100k": 16.063396873
	},
	{
		"date": "2022-07-23",
		"county": "Lincoln",
		"title": "3. Lincoln",
		"cases_7day_mean_per_100k": 17.0369360774
	},
	{
		"date": "2022-07-24",
		"county": "Lincoln",
		"title": "3. Lincoln",
		"cases_7day_mean_per_100k": 15.5766272708
	},
	{
		"date": "2022-07-25",
		"county": "Lincoln",
		"title": "3. Lincoln",
		"cases_7day_mean_per_100k": 15.5766272708
	},
	{
		"date": "2022-07-26",
		"county": "Lincoln",
		"title": "3. Lincoln",
		"cases_7day_mean_per_100k": 18.4972448841
	},
	{
		"date": "2022-07-27",
		"county": "Lincoln",
		"title": "3. Lincoln",
		"cases_7day_mean_per_100k": 16.5501664752
	},
	{
		"date": "2022-07-28",
		"county": "Lincoln",
		"title": "3. Lincoln",
		"cases_7day_mean_per_100k": 16.5501664752
	},
	{
		"date": "2022-07-29",
		"county": "Lincoln",
		"title": "3. Lincoln",
		"cases_7day_mean_per_100k": 14.6030880664
	},
	{
		"date": "2022-07-30",
		"county": "Lincoln",
		"title": "3. Lincoln",
		"cases_7day_mean_per_100k": 13.6295488619
	},
	{
		"date": "2022-07-31",
		"county": "Lincoln",
		"title": "3. Lincoln",
		"cases_7day_mean_per_100k": 15.0898576686
	},
	{
		"date": "2022-08-01",
		"county": "Lincoln",
		"title": "3. Lincoln",
		"cases_7day_mean_per_100k": 13.6295488619
	},
	{
		"date": "2022-08-02",
		"county": "Lincoln",
		"title": "3. Lincoln",
		"cases_7day_mean_per_100k": 13.1427792597
	},
	{
		"date": "2022-08-03",
		"county": "Lincoln",
		"title": "3. Lincoln",
		"cases_7day_mean_per_100k": 13.6295488619
	},
	{
		"date": "2022-08-04",
		"county": "Lincoln",
		"title": "3. Lincoln",
		"cases_7day_mean_per_100k": 12.6560096575
	},
	{
		"date": "2022-08-05",
		"county": "Lincoln",
		"title": "3. Lincoln",
		"cases_7day_mean_per_100k": 14.1163184641
	},
	{
		"date": "2022-08-06",
		"county": "Lincoln",
		"title": "3. Lincoln",
		"cases_7day_mean_per_100k": 13.1427792597
	},
	{
		"date": "2022-08-07",
		"county": "Lincoln",
		"title": "3. Lincoln",
		"cases_7day_mean_per_100k": 10.7089312487
	},
	{
		"date": "2022-08-08",
		"county": "Lincoln",
		"title": "3. Lincoln",
		"cases_7day_mean_per_100k": 10.2221616464
	},
	{
		"date": "2022-08-09",
		"county": "Lincoln",
		"title": "3. Lincoln",
		"cases_7day_mean_per_100k": 9.7353920442
	},
	{
		"date": "2022-08-10",
		"county": "Lincoln",
		"title": "3. Lincoln",
		"cases_7day_mean_per_100k": 8.7618528398
	},
	{
		"date": "2022-08-11",
		"county": "Lincoln",
		"title": "3. Lincoln",
		"cases_7day_mean_per_100k": 8.7618528398
	},
	{
		"date": "2022-08-12",
		"county": "Lincoln",
		"title": "3. Lincoln",
		"cases_7day_mean_per_100k": 7.3015440332
	},
	{
		"date": "2022-08-13",
		"county": "Lincoln",
		"title": "3. Lincoln",
		"cases_7day_mean_per_100k": 6.814774431
	},
	{
		"date": "2022-08-14",
		"county": "Lincoln",
		"title": "3. Lincoln",
		"cases_7day_mean_per_100k": 6.814774431
	},
	{
		"date": "2022-08-15",
		"county": "Lincoln",
		"title": "3. Lincoln",
		"cases_7day_mean_per_100k": 7.7883136354
	},
	{
		"date": "2022-08-16",
		"county": "Lincoln",
		"title": "3. Lincoln",
		"cases_7day_mean_per_100k": 8.7618528398
	},
	{
		"date": "2022-08-17",
		"county": "Lincoln",
		"title": "3. Lincoln",
		"cases_7day_mean_per_100k": 8.2750832376
	},
	{
		"date": "2022-08-18",
		"county": "Lincoln",
		"title": "3. Lincoln",
		"cases_7day_mean_per_100k": 7.7883136354
	},
	{
		"date": "2022-08-19",
		"county": "Lincoln",
		"title": "3. Lincoln",
		"cases_7day_mean_per_100k": 9.248622442
	},
	{
		"date": "2022-08-20",
		"county": "Lincoln",
		"title": "3. Lincoln",
		"cases_7day_mean_per_100k": 9.7353920442
	},
	{
		"date": "2022-08-21",
		"county": "Lincoln",
		"title": "3. Lincoln",
		"cases_7day_mean_per_100k": 11.1957008509
	},
	{
		"date": "2022-08-22",
		"county": "Lincoln",
		"title": "3. Lincoln",
		"cases_7day_mean_per_100k": 11.1957008509
	},
	{
		"date": "2022-08-23",
		"county": "Lincoln",
		"title": "3. Lincoln",
		"cases_7day_mean_per_100k": 7.7883136354
	},
	{
		"date": "2022-08-24",
		"county": "Lincoln",
		"title": "3. Lincoln",
		"cases_7day_mean_per_100k": 10.7089312487
	},
	{
		"date": "2022-08-25",
		"county": "Lincoln",
		"title": "3. Lincoln",
		"cases_7day_mean_per_100k": 11.1957008509
	},
	{
		"date": "2022-08-26",
		"county": "Lincoln",
		"title": "3. Lincoln",
		"cases_7day_mean_per_100k": 11.1957008509
	},
	{
		"date": "2022-08-27",
		"county": "Lincoln",
		"title": "3. Lincoln",
		"cases_7day_mean_per_100k": 12.1692400553
	},
	{
		"date": "2022-08-28",
		"county": "Lincoln",
		"title": "3. Lincoln",
		"cases_7day_mean_per_100k": 11.6824704531
	},
	{
		"date": "2022-08-29",
		"county": "Lincoln",
		"title": "3. Lincoln",
		"cases_7day_mean_per_100k": 11.1957008509
	},
	{
		"date": "2022-08-30",
		"county": "Lincoln",
		"title": "3. Lincoln",
		"cases_7day_mean_per_100k": 11.6824704531
	},
	{
		"date": "2022-08-31",
		"county": "Lincoln",
		"title": "3. Lincoln",
		"cases_7day_mean_per_100k": 8.2750832376
	},
	{
		"date": "2022-09-01",
		"county": "Lincoln",
		"title": "3. Lincoln",
		"cases_7day_mean_per_100k": 7.7883136354
	},
	{
		"date": "2022-09-02",
		"county": "Lincoln",
		"title": "3. Lincoln",
		"cases_7day_mean_per_100k": 6.3280048288
	},
	{
		"date": "2022-09-03",
		"county": "Lincoln",
		"title": "3. Lincoln",
		"cases_7day_mean_per_100k": 6.814774431
	},
	{
		"date": "2022-09-04",
		"county": "Lincoln",
		"title": "3. Lincoln",
		"cases_7day_mean_per_100k": 6.3280048288
	},
	{
		"date": "2022-09-05",
		"county": "Lincoln",
		"title": "3. Lincoln",
		"cases_7day_mean_per_100k": 5.3544656243
	},
	{
		"date": "2022-09-06",
		"county": "Lincoln",
		"title": "3. Lincoln",
		"cases_7day_mean_per_100k": 5.8412352265
	},
	{
		"date": "2022-09-07",
		"county": "Lincoln",
		"title": "3. Lincoln",
		"cases_7day_mean_per_100k": 6.814774431
	},
	{
		"date": "2022-09-08",
		"county": "Lincoln",
		"title": "3. Lincoln",
		"cases_7day_mean_per_100k": 7.3015440332
	},
	{
		"date": "2022-09-09",
		"county": "Lincoln",
		"title": "3. Lincoln",
		"cases_7day_mean_per_100k": 6.3280048288
	},
	{
		"date": "2022-09-10",
		"county": "Lincoln",
		"title": "3. Lincoln",
		"cases_7day_mean_per_100k": 5.3544656243
	},
	{
		"date": "2022-09-11",
		"county": "Lincoln",
		"title": "3. Lincoln",
		"cases_7day_mean_per_100k": 6.3280048288
	},
	{
		"date": "2022-09-12",
		"county": "Lincoln",
		"title": "3. Lincoln",
		"cases_7day_mean_per_100k": 7.3015440332
	},
	{
		"date": "2022-09-13",
		"county": "Lincoln",
		"title": "3. Lincoln",
		"cases_7day_mean_per_100k": 7.7883136354
	},
	{
		"date": "2022-09-14",
		"county": "Lincoln",
		"title": "3. Lincoln",
		"cases_7day_mean_per_100k": 7.3015440332
	},
	{
		"date": "2022-09-15",
		"county": "Lincoln",
		"title": "3. Lincoln",
		"cases_7day_mean_per_100k": 6.3280048288
	},
	{
		"date": "2022-09-16",
		"county": "Lincoln",
		"title": "3. Lincoln",
		"cases_7day_mean_per_100k": 6.3280048288
	},
	{
		"date": "2022-09-17",
		"county": "Lincoln",
		"title": "3. Lincoln",
		"cases_7day_mean_per_100k": 5.3544656243
	},
	{
		"date": "2022-09-18",
		"county": "Lincoln",
		"title": "3. Lincoln",
		"cases_7day_mean_per_100k": 5.8412352265
	},
	{
		"date": "2022-09-19",
		"county": "Lincoln",
		"title": "3. Lincoln",
		"cases_7day_mean_per_100k": 6.814774431
	},
	{
		"date": "2022-09-20",
		"county": "Lincoln",
		"title": "3. Lincoln",
		"cases_7day_mean_per_100k": 5.3544656243
	},
	{
		"date": "2022-09-21",
		"county": "Lincoln",
		"title": "3. Lincoln",
		"cases_7day_mean_per_100k": 5.3544656243
	},
	{
		"date": "2022-09-22",
		"county": "Lincoln",
		"title": "3. Lincoln",
		"cases_7day_mean_per_100k": 5.8412352265
	},
	{
		"date": "2022-09-23",
		"county": "Lincoln",
		"title": "3. Lincoln",
		"cases_7day_mean_per_100k": 6.3280048288
	},
	{
		"date": "2022-09-24",
		"county": "Lincoln",
		"title": "3. Lincoln",
		"cases_7day_mean_per_100k": 7.3015440332
	},
	{
		"date": "2022-09-25",
		"county": "Lincoln",
		"title": "3. Lincoln",
		"cases_7day_mean_per_100k": 5.8412352265
	},
	{
		"date": "2022-09-26",
		"county": "Lincoln",
		"title": "3. Lincoln",
		"cases_7day_mean_per_100k": 3.4073872155
	},
	{
		"date": "2022-09-27",
		"county": "Lincoln",
		"title": "3. Lincoln",
		"cases_7day_mean_per_100k": 2.9206176133
	},
	{
		"date": "2022-09-28",
		"county": "Lincoln",
		"title": "3. Lincoln",
		"cases_7day_mean_per_100k": 2.9206176133
	},
	{
		"date": "2022-09-29",
		"county": "Lincoln",
		"title": "3. Lincoln",
		"cases_7day_mean_per_100k": 2.4338480111
	},
	{
		"date": "2022-09-30",
		"county": "Lincoln",
		"title": "3. Lincoln",
		"cases_7day_mean_per_100k": 1.9470784088
	},
	{
		"date": "2022-10-01",
		"county": "Lincoln",
		"title": "3. Lincoln",
		"cases_7day_mean_per_100k": 1.4603088066
	},
	{
		"date": "2022-10-02",
		"county": "Lincoln",
		"title": "3. Lincoln",
		"cases_7day_mean_per_100k": 1.4603088066
	},
	{
		"date": "2022-10-03",
		"county": "Lincoln",
		"title": "3. Lincoln",
		"cases_7day_mean_per_100k": 2.9206176133
	},
	{
		"date": "2022-10-04",
		"county": "Lincoln",
		"title": "3. Lincoln",
		"cases_7day_mean_per_100k": 2.9206176133
	},
	{
		"date": "2022-10-05",
		"county": "Lincoln",
		"title": "3. Lincoln",
		"cases_7day_mean_per_100k": 2.9206176133
	},
	{
		"date": "2022-10-06",
		"county": "Lincoln",
		"title": "3. Lincoln",
		"cases_7day_mean_per_100k": 2.9206176133
	},
	{
		"date": "2022-10-07",
		"county": "Lincoln",
		"title": "3. Lincoln",
		"cases_7day_mean_per_100k": 3.4073872155
	},
	{
		"date": "2022-10-08",
		"county": "Lincoln",
		"title": "3. Lincoln",
		"cases_7day_mean_per_100k": 3.4073872155
	},
	{
		"date": "2022-10-09",
		"county": "Lincoln",
		"title": "3. Lincoln",
		"cases_7day_mean_per_100k": 3.4073872155
	},
	{
		"date": "2022-10-10",
		"county": "Lincoln",
		"title": "3. Lincoln",
		"cases_7day_mean_per_100k": 3.4073872155
	},
	{
		"date": "2022-10-11",
		"county": "Lincoln",
		"title": "3. Lincoln",
		"cases_7day_mean_per_100k": 3.8941568177
	},
	{
		"date": "2022-10-12",
		"county": "Lincoln",
		"title": "3. Lincoln",
		"cases_7day_mean_per_100k": 3.8941568177
	},
	{
		"date": "2022-10-13",
		"county": "Lincoln",
		"title": "3. Lincoln",
		"cases_7day_mean_per_100k": 4.3809264199
	},
	{
		"date": "2022-10-14",
		"county": "Lincoln",
		"title": "3. Lincoln",
		"cases_7day_mean_per_100k": 3.8941568177
	},
	{
		"date": "2022-10-15",
		"county": "Lincoln",
		"title": "3. Lincoln",
		"cases_7day_mean_per_100k": 3.4073872155
	},
	{
		"date": "2022-10-16",
		"county": "Lincoln",
		"title": "3. Lincoln",
		"cases_7day_mean_per_100k": 3.4073872155
	},
	{
		"date": "2022-10-17",
		"county": "Lincoln",
		"title": "3. Lincoln",
		"cases_7day_mean_per_100k": 2.4338480111
	},
	{
		"date": "2022-10-18",
		"county": "Lincoln",
		"title": "3. Lincoln",
		"cases_7day_mean_per_100k": 3.4073872155
	},
	{
		"date": "2022-10-19",
		"county": "Lincoln",
		"title": "3. Lincoln",
		"cases_7day_mean_per_100k": 2.9206176133
	},
	{
		"date": "2022-10-20",
		"county": "Lincoln",
		"title": "3. Lincoln",
		"cases_7day_mean_per_100k": 3.8941568177
	},
	{
		"date": "2022-10-21",
		"county": "Lincoln",
		"title": "3. Lincoln",
		"cases_7day_mean_per_100k": 3.8941568177
	},
	{
		"date": "2022-10-22",
		"county": "Lincoln",
		"title": "3. Lincoln",
		"cases_7day_mean_per_100k": 3.8941568177
	},
	{
		"date": "2022-10-23",
		"county": "Lincoln",
		"title": "3. Lincoln",
		"cases_7day_mean_per_100k": 3.8941568177
	},
	{
		"date": "2022-10-24",
		"county": "Lincoln",
		"title": "3. Lincoln",
		"cases_7day_mean_per_100k": 4.3809264199
	},
	{
		"date": "2022-10-25",
		"county": "Lincoln",
		"title": "3. Lincoln",
		"cases_7day_mean_per_100k": 3.4073872155
	},
	{
		"date": "2022-10-26",
		"county": "Lincoln",
		"title": "3. Lincoln",
		"cases_7day_mean_per_100k": 4.3809264199
	},
	{
		"date": "2022-10-27",
		"county": "Lincoln",
		"title": "3. Lincoln",
		"cases_7day_mean_per_100k": 2.9206176133
	},
	{
		"date": "2022-10-28",
		"county": "Lincoln",
		"title": "3. Lincoln",
		"cases_7day_mean_per_100k": 4.3809264199
	},
	{
		"date": "2022-10-29",
		"county": "Lincoln",
		"title": "3. Lincoln",
		"cases_7day_mean_per_100k": 4.8676960221
	},
	{
		"date": "2022-10-30",
		"county": "Lincoln",
		"title": "3. Lincoln",
		"cases_7day_mean_per_100k": 4.8676960221
	},
	{
		"date": "2022-10-31",
		"county": "Lincoln",
		"title": "3. Lincoln",
		"cases_7day_mean_per_100k": 7.7883136354
	},
	{
		"date": "2022-11-01",
		"county": "Lincoln",
		"title": "3. Lincoln",
		"cases_7day_mean_per_100k": 7.7883136354
	},
	{
		"date": "2022-11-02",
		"county": "Lincoln",
		"title": "3. Lincoln",
		"cases_7day_mean_per_100k": 7.3015440332
	},
	{
		"date": "2022-11-03",
		"county": "Lincoln",
		"title": "3. Lincoln",
		"cases_7day_mean_per_100k": 7.3015440332
	},
	{
		"date": "2022-11-04",
		"county": "Lincoln",
		"title": "3. Lincoln",
		"cases_7day_mean_per_100k": 6.814774431
	},
	{
		"date": "2022-11-05",
		"county": "Lincoln",
		"title": "3. Lincoln",
		"cases_7day_mean_per_100k": 6.3280048288
	},
	{
		"date": "2022-11-06",
		"county": "Lincoln",
		"title": "3. Lincoln",
		"cases_7day_mean_per_100k": 6.3280048288
	},
	{
		"date": "2022-11-07",
		"county": "Lincoln",
		"title": "3. Lincoln",
		"cases_7day_mean_per_100k": 2.4338480111
	},
	{
		"date": "2022-11-08",
		"county": "Lincoln",
		"title": "3. Lincoln",
		"cases_7day_mean_per_100k": 1.9470784088
	},
	{
		"date": "2022-03-01",
		"county": "Greenup",
		"title": "4. Greenup",
		"cases_7day_mean_per_100k": 17.218978445
	},
	{
		"date": "2022-03-02",
		"county": "Greenup",
		"title": "4. Greenup",
		"cases_7day_mean_per_100k": 16.1008629615
	},
	{
		"date": "2022-03-03",
		"county": "Greenup",
		"title": "4. Greenup",
		"cases_7day_mean_per_100k": 15.1318295425
	},
	{
		"date": "2022-03-04",
		"county": "Greenup",
		"title": "4. Greenup",
		"cases_7day_mean_per_100k": 13.4173858013
	},
	{
		"date": "2022-03-05",
		"county": "Greenup",
		"title": "4. Greenup",
		"cases_7day_mean_per_100k": 12.5974344468
	},
	{
		"date": "2022-03-06",
		"county": "Greenup",
		"title": "4. Greenup",
		"cases_7day_mean_per_100k": 11.3302368989
	},
	{
		"date": "2022-03-07",
		"county": "Greenup",
		"title": "4. Greenup",
		"cases_7day_mean_per_100k": 9.094005932
	},
	{
		"date": "2022-03-08",
		"county": "Greenup",
		"title": "4. Greenup",
		"cases_7day_mean_per_100k": 8.7213007708
	},
	{
		"date": "2022-03-09",
		"county": "Greenup",
		"title": "4. Greenup",
		"cases_7day_mean_per_100k": 8.5722187064
	},
	{
		"date": "2022-03-10",
		"county": "Greenup",
		"title": "4. Greenup",
		"cases_7day_mean_per_100k": 7.0068570296
	},
	{
		"date": "2022-03-11",
		"county": "Greenup",
		"title": "4. Greenup",
		"cases_7day_mean_per_100k": 6.4850698039
	},
	{
		"date": "2022-03-12",
		"county": "Greenup",
		"title": "4. Greenup",
		"cases_7day_mean_per_100k": 6.4105287717
	},
	{
		"date": "2022-03-13",
		"county": "Greenup",
		"title": "4. Greenup",
		"cases_7day_mean_per_100k": 6.0378236106
	},
	{
		"date": "2022-03-14",
		"county": "Greenup",
		"title": "4. Greenup",
		"cases_7day_mean_per_100k": 5.516036385
	},
	{
		"date": "2022-03-15",
		"county": "Greenup",
		"title": "4. Greenup",
		"cases_7day_mean_per_100k": 4.6960850304
	},
	{
		"date": "2022-03-16",
		"county": "Greenup",
		"title": "4. Greenup",
		"cases_7day_mean_per_100k": 4.3233798693
	},
	{
		"date": "2022-03-17",
		"county": "Greenup",
		"title": "4. Greenup",
		"cases_7day_mean_per_100k": 4.8451670949
	},
	{
		"date": "2022-03-18",
		"county": "Greenup",
		"title": "4. Greenup",
		"cases_7day_mean_per_100k": 4.9197081271
	},
	{
		"date": "2022-03-19",
		"county": "Greenup",
		"title": "4. Greenup",
		"cases_7day_mean_per_100k": 4.6215439982
	},
	{
		"date": "2022-03-20",
		"county": "Greenup",
		"title": "4. Greenup",
		"cases_7day_mean_per_100k": 4.3233798693
	},
	{
		"date": "2022-03-21",
		"county": "Greenup",
		"title": "4. Greenup",
		"cases_7day_mean_per_100k": 4.3233798693
	},
	{
		"date": "2022-03-22",
		"county": "Greenup",
		"title": "4. Greenup",
		"cases_7day_mean_per_100k": 4.4724619338
	},
	{
		"date": "2022-03-23",
		"county": "Greenup",
		"title": "4. Greenup",
		"cases_7day_mean_per_100k": 4.6215439982
	},
	{
		"date": "2022-03-24",
		"county": "Greenup",
		"title": "4. Greenup",
		"cases_7day_mean_per_100k": 4.1742978048
	},
	{
		"date": "2022-03-25",
		"county": "Greenup",
		"title": "4. Greenup",
		"cases_7day_mean_per_100k": 3.8761336759
	},
	{
		"date": "2022-03-26",
		"county": "Greenup",
		"title": "4. Greenup",
		"cases_7day_mean_per_100k": 4.0997567726
	},
	{
		"date": "2022-03-27",
		"county": "Greenup",
		"title": "4. Greenup",
		"cases_7day_mean_per_100k": 4.4724619338
	},
	{
		"date": "2022-03-28",
		"county": "Greenup",
		"title": "4. Greenup",
		"cases_7day_mean_per_100k": 4.6215439982
	},
	{
		"date": "2022-03-29",
		"county": "Greenup",
		"title": "4. Greenup",
		"cases_7day_mean_per_100k": 4.3979209015
	},
	{
		"date": "2022-03-30",
		"county": "Greenup",
		"title": "4. Greenup",
		"cases_7day_mean_per_100k": 4.547002966
	},
	{
		"date": "2022-03-31",
		"county": "Greenup",
		"title": "4. Greenup",
		"cases_7day_mean_per_100k": 4.3979209015
	},
	{
		"date": "2022-04-01",
		"county": "Greenup",
		"title": "4. Greenup",
		"cases_7day_mean_per_100k": 4.0997567726
	},
	{
		"date": "2022-04-02",
		"county": "Greenup",
		"title": "4. Greenup",
		"cases_7day_mean_per_100k": 3.8761336759
	},
	{
		"date": "2022-04-03",
		"county": "Greenup",
		"title": "4. Greenup",
		"cases_7day_mean_per_100k": 3.6525105792
	},
	{
		"date": "2022-04-04",
		"county": "Greenup",
		"title": "4. Greenup",
		"cases_7day_mean_per_100k": 2.8325592247
	},
	{
		"date": "2022-04-05",
		"county": "Greenup",
		"title": "4. Greenup",
		"cases_7day_mean_per_100k": 2.4598540636
	},
	{
		"date": "2022-04-06",
		"county": "Greenup",
		"title": "4. Greenup",
		"cases_7day_mean_per_100k": 1.5653616768
	},
	{
		"date": "2022-04-07",
		"county": "Greenup",
		"title": "4. Greenup",
		"cases_7day_mean_per_100k": 1.7144437413
	},
	{
		"date": "2022-04-08",
		"county": "Greenup",
		"title": "4. Greenup",
		"cases_7day_mean_per_100k": 1.639902709
	},
	{
		"date": "2022-04-09",
		"county": "Greenup",
		"title": "4. Greenup",
		"cases_7day_mean_per_100k": 1.7889847735
	},
	{
		"date": "2022-04-10",
		"county": "Greenup",
		"title": "4. Greenup",
		"cases_7day_mean_per_100k": 1.938066838
	},
	{
		"date": "2022-04-11",
		"county": "Greenup",
		"title": "4. Greenup",
		"cases_7day_mean_per_100k": 2.0871489024
	},
	{
		"date": "2022-04-12",
		"county": "Greenup",
		"title": "4. Greenup",
		"cases_7day_mean_per_100k": 2.0871489024
	},
	{
		"date": "2022-04-13",
		"county": "Greenup",
		"title": "4. Greenup",
		"cases_7day_mean_per_100k": 2.2362309669
	},
	{
		"date": "2022-04-14",
		"county": "Greenup",
		"title": "4. Greenup",
		"cases_7day_mean_per_100k": 2.7580181925
	},
	{
		"date": "2022-04-15",
		"county": "Greenup",
		"title": "4. Greenup",
		"cases_7day_mean_per_100k": 3.3543464503
	},
	{
		"date": "2022-04-16",
		"county": "Greenup",
		"title": "4. Greenup",
		"cases_7day_mean_per_100k": 3.2052643859
	},
	{
		"date": "2022-04-17",
		"county": "Greenup",
		"title": "4. Greenup",
		"cases_7day_mean_per_100k": 3.2798054181
	},
	{
		"date": "2022-04-18",
		"county": "Greenup",
		"title": "4. Greenup",
		"cases_7day_mean_per_100k": 3.6525105792
	},
	{
		"date": "2022-04-19",
		"county": "Greenup",
		"title": "4. Greenup",
		"cases_7day_mean_per_100k": 4.1742978048
	},
	{
		"date": "2022-04-20",
		"county": "Greenup",
		"title": "4. Greenup",
		"cases_7day_mean_per_100k": 4.3979209015
	},
	{
		"date": "2022-04-21",
		"county": "Greenup",
		"title": "4. Greenup",
		"cases_7day_mean_per_100k": 4.0252157404
	},
	{
		"date": "2022-04-22",
		"county": "Greenup",
		"title": "4. Greenup",
		"cases_7day_mean_per_100k": 3.9506747082
	},
	{
		"date": "2022-04-23",
		"county": "Greenup",
		"title": "4. Greenup",
		"cases_7day_mean_per_100k": 4.2488388371
	},
	{
		"date": "2022-04-24",
		"county": "Greenup",
		"title": "4. Greenup",
		"cases_7day_mean_per_100k": 4.6215439982
	},
	{
		"date": "2022-04-25",
		"county": "Greenup",
		"title": "4. Greenup",
		"cases_7day_mean_per_100k": 4.8451670949
	},
	{
		"date": "2022-04-26",
		"county": "Greenup",
		"title": "4. Greenup",
		"cases_7day_mean_per_100k": 5.3669543205
	},
	{
		"date": "2022-04-27",
		"county": "Greenup",
		"title": "4. Greenup",
		"cases_7day_mean_per_100k": 6.3359877395
	},
	{
		"date": "2022-04-28",
		"county": "Greenup",
		"title": "4. Greenup",
		"cases_7day_mean_per_100k": 7.0813980618
	},
	{
		"date": "2022-04-29",
		"county": "Greenup",
		"title": "4. Greenup",
		"cases_7day_mean_per_100k": 7.3050211585
	},
	{
		"date": "2022-04-30",
		"county": "Greenup",
		"title": "4. Greenup",
		"cases_7day_mean_per_100k": 8.0504314808
	},
	{
		"date": "2022-05-01",
		"county": "Greenup",
		"title": "4. Greenup",
		"cases_7day_mean_per_100k": 8.1995135452
	},
	{
		"date": "2022-05-02",
		"county": "Greenup",
		"title": "4. Greenup",
		"cases_7day_mean_per_100k": 9.094005932
	},
	{
		"date": "2022-05-03",
		"county": "Greenup",
		"title": "4. Greenup",
		"cases_7day_mean_per_100k": 8.6467597386
	},
	{
		"date": "2022-05-04",
		"county": "Greenup",
		"title": "4. Greenup",
		"cases_7day_mean_per_100k": 8.7213007708
	},
	{
		"date": "2022-05-05",
		"county": "Greenup",
		"title": "4. Greenup",
		"cases_7day_mean_per_100k": 9.094005932
	},
	{
		"date": "2022-05-06",
		"county": "Greenup",
		"title": "4. Greenup",
		"cases_7day_mean_per_100k": 8.7213007708
	},
	{
		"date": "2022-05-07",
		"county": "Greenup",
		"title": "4. Greenup",
		"cases_7day_mean_per_100k": 8.1995135452
	},
	{
		"date": "2022-05-08",
		"county": "Greenup",
		"title": "4. Greenup",
		"cases_7day_mean_per_100k": 8.9449238675
	},
	{
		"date": "2022-05-09",
		"county": "Greenup",
		"title": "4. Greenup",
		"cases_7day_mean_per_100k": 9.6903341898
	},
	{
		"date": "2022-05-10",
		"county": "Greenup",
		"title": "4. Greenup",
		"cases_7day_mean_per_100k": 11.1811548344
	},
	{
		"date": "2022-05-11",
		"county": "Greenup",
		"title": "4. Greenup",
		"cases_7day_mean_per_100k": 12.2247292856
	},
	{
		"date": "2022-05-12",
		"county": "Greenup",
		"title": "4. Greenup",
		"cases_7day_mean_per_100k": 12.4483523823
	},
	{
		"date": "2022-05-13",
		"county": "Greenup",
		"title": "4. Greenup",
		"cases_7day_mean_per_100k": 13.9391730269
	},
	{
		"date": "2022-05-14",
		"county": "Greenup",
		"title": "4. Greenup",
		"cases_7day_mean_per_100k": 14.6845833492
	},
	{
		"date": "2022-05-15",
		"county": "Greenup",
		"title": "4. Greenup",
		"cases_7day_mean_per_100k": 15.280911607
	},
	{
		"date": "2022-05-16",
		"county": "Greenup",
		"title": "4. Greenup",
		"cases_7day_mean_per_100k": 15.4299936715
	},
	{
		"date": "2022-05-17",
		"county": "Greenup",
		"title": "4. Greenup",
		"cases_7day_mean_per_100k": 17.7407656706
	},
	{
		"date": "2022-05-18",
		"county": "Greenup",
		"title": "4. Greenup",
		"cases_7day_mean_per_100k": 18.3370939284
	},
	{
		"date": "2022-05-19",
		"county": "Greenup",
		"title": "4. Greenup",
		"cases_7day_mean_per_100k": 21.0205710887
	},
	{
		"date": "2022-05-20",
		"county": "Greenup",
		"title": "4. Greenup",
		"cases_7day_mean_per_100k": 22.436850701
	},
	{
		"date": "2022-05-21",
		"county": "Greenup",
		"title": "4. Greenup",
		"cases_7day_mean_per_100k": 22.8095558622
	},
	{
		"date": "2022-05-22",
		"county": "Greenup",
		"title": "4. Greenup",
		"cases_7day_mean_per_100k": 23.0331789589
	},
	{
		"date": "2022-05-23",
		"county": "Greenup",
		"title": "4. Greenup",
		"cases_7day_mean_per_100k": 25.4184919902
	},
	{
		"date": "2022-05-24",
		"county": "Greenup",
		"title": "4. Greenup",
		"cases_7day_mean_per_100k": 23.9276713456
	},
	{
		"date": "2022-05-25",
		"county": "Greenup",
		"title": "4. Greenup",
		"cases_7day_mean_per_100k": 24.6730816679
	},
	{
		"date": "2022-05-26",
		"county": "Greenup",
		"title": "4. Greenup",
		"cases_7day_mean_per_100k": 24.3003765068
	},
	{
		"date": "2022-05-27",
		"county": "Greenup",
		"title": "4. Greenup",
		"cases_7day_mean_per_100k": 23.2568020555
	},
	{
		"date": "2022-05-28",
		"county": "Greenup",
		"title": "4. Greenup",
		"cases_7day_mean_per_100k": 27.7292639893
	},
	{
		"date": "2022-05-29",
		"county": "Greenup",
		"title": "4. Greenup",
		"cases_7day_mean_per_100k": 27.1329357315
	},
	{
		"date": "2022-05-30",
		"county": "Greenup",
		"title": "4. Greenup",
		"cases_7day_mean_per_100k": 24.8221637324
	},
	{
		"date": "2022-05-31",
		"county": "Greenup",
		"title": "4. Greenup",
		"cases_7day_mean_per_100k": 27.5801819248
	},
	{
		"date": "2022-06-01",
		"county": "Greenup",
		"title": "4. Greenup",
		"cases_7day_mean_per_100k": 28.4001332794
	},
	{
		"date": "2022-06-02",
		"county": "Greenup",
		"title": "4. Greenup",
		"cases_7day_mean_per_100k": 29.1455436017
	},
	{
		"date": "2022-06-03",
		"county": "Greenup",
		"title": "4. Greenup",
		"cases_7day_mean_per_100k": 31.1581514718
	},
	{
		"date": "2022-06-04",
		"county": "Greenup",
		"title": "4. Greenup",
		"cases_7day_mean_per_100k": 28.3255922471
	},
	{
		"date": "2022-06-05",
		"county": "Greenup",
		"title": "4. Greenup",
		"cases_7day_mean_per_100k": 30.1145770206
	},
	{
		"date": "2022-06-06",
		"county": "Greenup",
		"title": "4. Greenup",
		"cases_7day_mean_per_100k": 34.5124979222
	},
	{
		"date": "2022-06-07",
		"county": "Greenup",
		"title": "4. Greenup",
		"cases_7day_mean_per_100k": 33.9907106966
	},
	{
		"date": "2022-06-08",
		"county": "Greenup",
		"title": "4. Greenup",
		"cases_7day_mean_per_100k": 33.6180055354
	},
	{
		"date": "2022-06-09",
		"county": "Greenup",
		"title": "4. Greenup",
		"cases_7day_mean_per_100k": 34.2888748255
	},
	{
		"date": "2022-06-10",
		"county": "Greenup",
		"title": "4. Greenup",
		"cases_7day_mean_per_100k": 34.2143337933
	},
	{
		"date": "2022-06-11",
		"county": "Greenup",
		"title": "4. Greenup",
		"cases_7day_mean_per_100k": 34.2143337933
	},
	{
		"date": "2022-06-12",
		"county": "Greenup",
		"title": "4. Greenup",
		"cases_7day_mean_per_100k": 34.6615799866
	},
	{
		"date": "2022-06-13",
		"county": "Greenup",
		"title": "4. Greenup",
		"cases_7day_mean_per_100k": 33.2453003743
	},
	{
		"date": "2022-06-14",
		"county": "Greenup",
		"title": "4. Greenup",
		"cases_7day_mean_per_100k": 35.1833672122
	},
	{
		"date": "2022-06-15",
		"county": "Greenup",
		"title": "4. Greenup",
		"cases_7day_mean_per_100k": 36.3014826957
	},
	{
		"date": "2022-06-16",
		"county": "Greenup",
		"title": "4. Greenup",
		"cases_7day_mean_per_100k": 36.8232699213
	},
	{
		"date": "2022-06-17",
		"county": "Greenup",
		"title": "4. Greenup",
		"cases_7day_mean_per_100k": 39.8794522427
	},
	{
		"date": "2022-06-18",
		"county": "Greenup",
		"title": "4. Greenup",
		"cases_7day_mean_per_100k": 40.4012394683
	},
	{
		"date": "2022-06-19",
		"county": "Greenup",
		"title": "4. Greenup",
		"cases_7day_mean_per_100k": 41.4448139195
	},
	{
		"date": "2022-06-20",
		"county": "Greenup",
		"title": "4. Greenup",
		"cases_7day_mean_per_100k": 44.873701402
	},
	{
		"date": "2022-06-21",
		"county": "Greenup",
		"title": "4. Greenup",
		"cases_7day_mean_per_100k": 47.3335554656
	},
	{
		"date": "2022-06-22",
		"county": "Greenup",
		"title": "4. Greenup",
		"cases_7day_mean_per_100k": 48.8989171424
	},
	{
		"date": "2022-06-23",
		"county": "Greenup",
		"title": "4. Greenup",
		"cases_7day_mean_per_100k": 50.2406557226
	},
	{
		"date": "2022-06-24",
		"county": "Greenup",
		"title": "4. Greenup",
		"cases_7day_mean_per_100k": 48.3771299168
	},
	{
		"date": "2022-06-25",
		"county": "Greenup",
		"title": "4. Greenup",
		"cases_7day_mean_per_100k": 49.7934095292
	},
	{
		"date": "2022-06-26",
		"county": "Greenup",
		"title": "4. Greenup",
		"cases_7day_mean_per_100k": 50.6133608837
	},
	{
		"date": "2022-06-27",
		"county": "Greenup",
		"title": "4. Greenup",
		"cases_7day_mean_per_100k": 52.2532635927
	},
	{
		"date": "2022-06-28",
		"county": "Greenup",
		"title": "4. Greenup",
		"cases_7day_mean_per_100k": 52.7750508183
	},
	{
		"date": "2022-06-29",
		"county": "Greenup",
		"title": "4. Greenup",
		"cases_7day_mean_per_100k": 52.8495918506
	},
	{
		"date": "2022-06-30",
		"county": "Greenup",
		"title": "4. Greenup",
		"cases_7day_mean_per_100k": 54.1913304307
	},
	{
		"date": "2022-07-01",
		"county": "Greenup",
		"title": "4. Greenup",
		"cases_7day_mean_per_100k": 57.1729717199
	},
	{
		"date": "2022-07-02",
		"county": "Greenup",
		"title": "4. Greenup",
		"cases_7day_mean_per_100k": 57.4711358488
	},
	{
		"date": "2022-07-03",
		"county": "Greenup",
		"title": "4. Greenup",
		"cases_7day_mean_per_100k": 57.2475127521
	},
	{
		"date": "2022-07-04",
		"county": "Greenup",
		"title": "4. Greenup",
		"cases_7day_mean_per_100k": 52.0296404961
	},
	{
		"date": "2022-07-05",
		"county": "Greenup",
		"title": "4. Greenup",
		"cases_7day_mean_per_100k": 57.0984306876
	},
	{
		"date": "2022-07-06",
		"county": "Greenup",
		"title": "4. Greenup",
		"cases_7day_mean_per_100k": 60.452777138
	},
	{
		"date": "2022-07-07",
		"county": "Greenup",
		"title": "4. Greenup",
		"cases_7day_mean_per_100k": 66.4160597163
	},
	{
		"date": "2022-07-08",
		"county": "Greenup",
		"title": "4. Greenup",
		"cases_7day_mean_per_100k": 70.9630626823
	},
	{
		"date": "2022-07-09",
		"county": "Greenup",
		"title": "4. Greenup",
		"cases_7day_mean_per_100k": 71.9320961013
	},
	{
		"date": "2022-07-10",
		"county": "Greenup",
		"title": "4. Greenup",
		"cases_7day_mean_per_100k": 72.0066371335
	},
	{
		"date": "2022-07-11",
		"county": "Greenup",
		"title": "4. Greenup",
		"cases_7day_mean_per_100k": 83.1132509357
	},
	{
		"date": "2022-07-12",
		"county": "Greenup",
		"title": "4. Greenup",
		"cases_7day_mean_per_100k": 79.5352813887
	},
	{
		"date": "2022-07-13",
		"county": "Greenup",
		"title": "4. Greenup",
		"cases_7day_mean_per_100k": 82.1442175167
	},
	{
		"date": "2022-07-14",
		"county": "Greenup",
		"title": "4. Greenup",
		"cases_7day_mean_per_100k": 78.8644120986
	},
	{
		"date": "2022-07-15",
		"county": "Greenup",
		"title": "4. Greenup",
		"cases_7day_mean_per_100k": 79.1625762275
	},
	{
		"date": "2022-07-16",
		"county": "Greenup",
		"title": "4. Greenup",
		"cases_7day_mean_per_100k": 78.0444607441
	},
	{
		"date": "2022-07-17",
		"county": "Greenup",
		"title": "4. Greenup",
		"cases_7day_mean_per_100k": 78.4917069375
	},
	{
		"date": "2022-07-18",
		"county": "Greenup",
		"title": "4. Greenup",
		"cases_7day_mean_per_100k": 76.2554759706
	},
	{
		"date": "2022-07-19",
		"county": "Greenup",
		"title": "4. Greenup",
		"cases_7day_mean_per_100k": 76.6281811317
	},
	{
		"date": "2022-07-20",
		"county": "Greenup",
		"title": "4. Greenup",
		"cases_7day_mean_per_100k": 73.5719988103
	},
	{
		"date": "2022-07-21",
		"county": "Greenup",
		"title": "4. Greenup",
		"cases_7day_mean_per_100k": 72.7520474558
	},
	{
		"date": "2022-07-22",
		"county": "Greenup",
		"title": "4. Greenup",
		"cases_7day_mean_per_100k": 67.8323393287
	},
	{
		"date": "2022-07-23",
		"county": "Greenup",
		"title": "4. Greenup",
		"cases_7day_mean_per_100k": 69.0995368766
	},
	{
		"date": "2022-07-24",
		"county": "Greenup",
		"title": "4. Greenup",
		"cases_7day_mean_per_100k": 67.3105521031
	},
	{
		"date": "2022-07-25",
		"county": "Greenup",
		"title": "4. Greenup",
		"cases_7day_mean_per_100k": 64.9252390717
	},
	{
		"date": "2022-07-26",
		"county": "Greenup",
		"title": "4. Greenup",
		"cases_7day_mean_per_100k": 61.4963515892
	},
	{
		"date": "2022-07-27",
		"county": "Greenup",
		"title": "4. Greenup",
		"cases_7day_mean_per_100k": 60.452777138
	},
	{
		"date": "2022-07-28",
		"county": "Greenup",
		"title": "4. Greenup",
		"cases_7day_mean_per_100k": 56.0548562364
	},
	{
		"date": "2022-07-29",
		"county": "Greenup",
		"title": "4. Greenup",
		"cases_7day_mean_per_100k": 55.0112817852
	},
	{
		"date": "2022-07-30",
		"county": "Greenup",
		"title": "4. Greenup",
		"cases_7day_mean_per_100k": 52.7750508183
	},
	{
		"date": "2022-07-31",
		"county": "Greenup",
		"title": "4. Greenup",
		"cases_7day_mean_per_100k": 51.6569353349
	},
	{
		"date": "2022-08-01",
		"county": "Greenup",
		"title": "4. Greenup",
		"cases_7day_mean_per_100k": 47.4080964978
	},
	{
		"date": "2022-08-02",
		"county": "Greenup",
		"title": "4. Greenup",
		"cases_7day_mean_per_100k": 47.1099323689
	},
	{
		"date": "2022-08-03",
		"county": "Greenup",
		"title": "4. Greenup",
		"cases_7day_mean_per_100k": 44.202832112
	},
	{
		"date": "2022-08-04",
		"county": "Greenup",
		"title": "4. Greenup",
		"cases_7day_mean_per_100k": 43.6810448864
	},
	{
		"date": "2022-08-05",
		"county": "Greenup",
		"title": "4. Greenup",
		"cases_7day_mean_per_100k": 41.3702728873
	},
	{
		"date": "2022-08-06",
		"county": "Greenup",
		"title": "4. Greenup",
		"cases_7day_mean_per_100k": 42.4138473385
	},
	{
		"date": "2022-08-07",
		"county": "Greenup",
		"title": "4. Greenup",
		"cases_7day_mean_per_100k": 42.4883883707
	},
	{
		"date": "2022-08-08",
		"county": "Greenup",
		"title": "4. Greenup",
		"cases_7day_mean_per_100k": 40.7739446294
	},
	{
		"date": "2022-08-09",
		"county": "Greenup",
		"title": "4. Greenup",
		"cases_7day_mean_per_100k": 36.5996468246
	},
	{
		"date": "2022-08-10",
		"county": "Greenup",
		"title": "4. Greenup",
		"cases_7day_mean_per_100k": 35.1833672122
	},
	{
		"date": "2022-08-11",
		"county": "Greenup",
		"title": "4. Greenup",
		"cases_7day_mean_per_100k": 33.7670875999
	},
	{
		"date": "2022-08-12",
		"county": "Greenup",
		"title": "4. Greenup",
		"cases_7day_mean_per_100k": 32.2017259231
	},
	{
		"date": "2022-08-13",
		"county": "Greenup",
		"title": "4. Greenup",
		"cases_7day_mean_per_100k": 28.6237563761
	},
	{
		"date": "2022-08-14",
		"county": "Greenup",
		"title": "4. Greenup",
		"cases_7day_mean_per_100k": 28.1765101827
	},
	{
		"date": "2022-08-15",
		"county": "Greenup",
		"title": "4. Greenup",
		"cases_7day_mean_per_100k": 26.9093126348
	},
	{
		"date": "2022-08-16",
		"county": "Greenup",
		"title": "4. Greenup",
		"cases_7day_mean_per_100k": 26.014820248
	},
	{
		"date": "2022-08-17",
		"county": "Greenup",
		"title": "4. Greenup",
		"cases_7day_mean_per_100k": 25.045786829
	},
	{
		"date": "2022-08-18",
		"county": "Greenup",
		"title": "4. Greenup",
		"cases_7day_mean_per_100k": 23.7785892811
	},
	{
		"date": "2022-08-19",
		"county": "Greenup",
		"title": "4. Greenup",
		"cases_7day_mean_per_100k": 22.0641455399
	},
	{
		"date": "2022-08-20",
		"county": "Greenup",
		"title": "4. Greenup",
		"cases_7day_mean_per_100k": 22.1386865721
	},
	{
		"date": "2022-08-21",
		"county": "Greenup",
		"title": "4. Greenup",
		"cases_7day_mean_per_100k": 21.6914403787
	},
	{
		"date": "2022-08-22",
		"county": "Greenup",
		"title": "4. Greenup",
		"cases_7day_mean_per_100k": 21.2441941854
	},
	{
		"date": "2022-08-23",
		"county": "Greenup",
		"title": "4. Greenup",
		"cases_7day_mean_per_100k": 23.2568020555
	},
	{
		"date": "2022-08-24",
		"county": "Greenup",
		"title": "4. Greenup",
		"cases_7day_mean_per_100k": 22.6604737977
	},
	{
		"date": "2022-08-25",
		"county": "Greenup",
		"title": "4. Greenup",
		"cases_7day_mean_per_100k": 22.2132276043
	},
	{
		"date": "2022-08-26",
		"county": "Greenup",
		"title": "4. Greenup",
		"cases_7day_mean_per_100k": 23.4804251522
	},
	{
		"date": "2022-08-27",
		"county": "Greenup",
		"title": "4. Greenup",
		"cases_7day_mean_per_100k": 23.1077199911
	},
	{
		"date": "2022-08-28",
		"county": "Greenup",
		"title": "4. Greenup",
		"cases_7day_mean_per_100k": 22.2132276043
	},
	{
		"date": "2022-08-29",
		"county": "Greenup",
		"title": "4. Greenup",
		"cases_7day_mean_per_100k": 21.6914403787
	},
	{
		"date": "2022-08-30",
		"county": "Greenup",
		"title": "4. Greenup",
		"cases_7day_mean_per_100k": 19.3061273474
	},
	{
		"date": "2022-08-31",
		"county": "Greenup",
		"title": "4. Greenup",
		"cases_7day_mean_per_100k": 19.6042914763
	},
	{
		"date": "2022-09-01",
		"county": "Greenup",
		"title": "4. Greenup",
		"cases_7day_mean_per_100k": 19.1570452829
	},
	{
		"date": "2022-09-02",
		"county": "Greenup",
		"title": "4. Greenup",
		"cases_7day_mean_per_100k": 19.6042914763
	},
	{
		"date": "2022-09-03",
		"county": "Greenup",
		"title": "4. Greenup",
		"cases_7day_mean_per_100k": 19.4552094118
	},
	{
		"date": "2022-09-04",
		"county": "Greenup",
		"title": "4. Greenup",
		"cases_7day_mean_per_100k": 19.1570452829
	},
	{
		"date": "2022-09-05",
		"county": "Greenup",
		"title": "4. Greenup",
		"cases_7day_mean_per_100k": 17.2935194772
	},
	{
		"date": "2022-09-06",
		"county": "Greenup",
		"title": "4. Greenup",
		"cases_7day_mean_per_100k": 18.1134708317
	},
	{
		"date": "2022-09-07",
		"county": "Greenup",
		"title": "4. Greenup",
		"cases_7day_mean_per_100k": 18.4116349606
	},
	{
		"date": "2022-09-08",
		"county": "Greenup",
		"title": "4. Greenup",
		"cases_7day_mean_per_100k": 18.7843401218
	},
	{
		"date": "2022-09-09",
		"county": "Greenup",
		"title": "4. Greenup",
		"cases_7day_mean_per_100k": 17.5171425739
	},
	{
		"date": "2022-09-10",
		"county": "Greenup",
		"title": "4. Greenup",
		"cases_7day_mean_per_100k": 17.7407656706
	},
	{
		"date": "2022-09-11",
		"county": "Greenup",
		"title": "4. Greenup",
		"cases_7day_mean_per_100k": 17.9643887673
	},
	{
		"date": "2022-09-12",
		"county": "Greenup",
		"title": "4. Greenup",
		"cases_7day_mean_per_100k": 19.0825042507
	},
	{
		"date": "2022-09-13",
		"county": "Greenup",
		"title": "4. Greenup",
		"cases_7day_mean_per_100k": 16.8462732838
	},
	{
		"date": "2022-09-14",
		"county": "Greenup",
		"title": "4. Greenup",
		"cases_7day_mean_per_100k": 14.7591243814
	},
	{
		"date": "2022-09-15",
		"county": "Greenup",
		"title": "4. Greenup",
		"cases_7day_mean_per_100k": 14.0882550913
	},
	{
		"date": "2022-09-16",
		"county": "Greenup",
		"title": "4. Greenup",
		"cases_7day_mean_per_100k": 13.5664678657
	},
	{
		"date": "2022-09-17",
		"county": "Greenup",
		"title": "4. Greenup",
		"cases_7day_mean_per_100k": 12.7465165112
	},
	{
		"date": "2022-09-18",
		"county": "Greenup",
		"title": "4. Greenup",
		"cases_7day_mean_per_100k": 12.671975479
	},
	{
		"date": "2022-09-19",
		"county": "Greenup",
		"title": "4. Greenup",
		"cases_7day_mean_per_100k": 10.9575317377
	},
	{
		"date": "2022-09-20",
		"county": "Greenup",
		"title": "4. Greenup",
		"cases_7day_mean_per_100k": 10.5848265766
	},
	{
		"date": "2022-09-21",
		"county": "Greenup",
		"title": "4. Greenup",
		"cases_7day_mean_per_100k": 10.5848265766
	},
	{
		"date": "2022-09-22",
		"county": "Greenup",
		"title": "4. Greenup",
		"cases_7day_mean_per_100k": 9.8394162543
	},
	{
		"date": "2022-09-23",
		"county": "Greenup",
		"title": "4. Greenup",
		"cases_7day_mean_per_100k": 9.0194648997
	},
	{
		"date": "2022-09-24",
		"county": "Greenup",
		"title": "4. Greenup",
		"cases_7day_mean_per_100k": 8.7958418031
	},
	{
		"date": "2022-09-25",
		"county": "Greenup",
		"title": "4. Greenup",
		"cases_7day_mean_per_100k": 8.3485956097
	},
	{
		"date": "2022-09-26",
		"county": "Greenup",
		"title": "4. Greenup",
		"cases_7day_mean_per_100k": 8.3485956097
	},
	{
		"date": "2022-09-27",
		"county": "Greenup",
		"title": "4. Greenup",
		"cases_7day_mean_per_100k": 8.5722187064
	},
	{
		"date": "2022-09-28",
		"county": "Greenup",
		"title": "4. Greenup",
		"cases_7day_mean_per_100k": 8.5722187064
	},
	{
		"date": "2022-09-29",
		"county": "Greenup",
		"title": "4. Greenup",
		"cases_7day_mean_per_100k": 8.4976776741
	},
	{
		"date": "2022-09-30",
		"county": "Greenup",
		"title": "4. Greenup",
		"cases_7day_mean_per_100k": 9.094005932
	},
	{
		"date": "2022-10-01",
		"county": "Greenup",
		"title": "4. Greenup",
		"cases_7day_mean_per_100k": 9.094005932
	},
	{
		"date": "2022-10-02",
		"county": "Greenup",
		"title": "4. Greenup",
		"cases_7day_mean_per_100k": 9.2430879964
	},
	{
		"date": "2022-10-03",
		"county": "Greenup",
		"title": "4. Greenup",
		"cases_7day_mean_per_100k": 10.3612034799
	},
	{
		"date": "2022-10-04",
		"county": "Greenup",
		"title": "4. Greenup",
		"cases_7day_mean_per_100k": 10.063039351
	},
	{
		"date": "2022-10-05",
		"county": "Greenup",
		"title": "4. Greenup",
		"cases_7day_mean_per_100k": 10.8829907055
	},
	{
		"date": "2022-10-06",
		"county": "Greenup",
		"title": "4. Greenup",
		"cases_7day_mean_per_100k": 11.4793189633
	},
	{
		"date": "2022-10-07",
		"county": "Greenup",
		"title": "4. Greenup",
		"cases_7day_mean_per_100k": 11.70294206
	},
	{
		"date": "2022-10-08",
		"county": "Greenup",
		"title": "4. Greenup",
		"cases_7day_mean_per_100k": 11.8520241245
	},
	{
		"date": "2022-10-09",
		"county": "Greenup",
		"title": "4. Greenup",
		"cases_7day_mean_per_100k": 12.4483523823
	},
	{
		"date": "2022-10-10",
		"county": "Greenup",
		"title": "4. Greenup",
		"cases_7day_mean_per_100k": 12.1501882534
	},
	{
		"date": "2022-10-11",
		"county": "Greenup",
		"title": "4. Greenup",
		"cases_7day_mean_per_100k": 12.2247292856
	},
	{
		"date": "2022-10-12",
		"county": "Greenup",
		"title": "4. Greenup",
		"cases_7day_mean_per_100k": 10.733908641
	},
	{
		"date": "2022-10-13",
		"county": "Greenup",
		"title": "4. Greenup",
		"cases_7day_mean_per_100k": 10.5102855443
	},
	{
		"date": "2022-10-14",
		"county": "Greenup",
		"title": "4. Greenup",
		"cases_7day_mean_per_100k": 9.8394162543
	},
	{
		"date": "2022-10-15",
		"county": "Greenup",
		"title": "4. Greenup",
		"cases_7day_mean_per_100k": 9.6903341898
	},
	{
		"date": "2022-10-16",
		"county": "Greenup",
		"title": "4. Greenup",
		"cases_7day_mean_per_100k": 8.3485956097
	},
	{
		"date": "2022-10-17",
		"county": "Greenup",
		"title": "4. Greenup",
		"cases_7day_mean_per_100k": 8.4976776741
	},
	{
		"date": "2022-10-18",
		"county": "Greenup",
		"title": "4. Greenup",
		"cases_7day_mean_per_100k": 8.5722187064
	},
	{
		"date": "2022-10-19",
		"county": "Greenup",
		"title": "4. Greenup",
		"cases_7day_mean_per_100k": 9.094005932
	},
	{
		"date": "2022-10-20",
		"county": "Greenup",
		"title": "4. Greenup",
		"cases_7day_mean_per_100k": 8.7213007708
	},
	{
		"date": "2022-10-21",
		"county": "Greenup",
		"title": "4. Greenup",
		"cases_7day_mean_per_100k": 8.3485956097
	},
	{
		"date": "2022-10-22",
		"county": "Greenup",
		"title": "4. Greenup",
		"cases_7day_mean_per_100k": 7.9013494163
	},
	{
		"date": "2022-10-23",
		"county": "Greenup",
		"title": "4. Greenup",
		"cases_7day_mean_per_100k": 8.2740545775
	},
	{
		"date": "2022-10-24",
		"county": "Greenup",
		"title": "4. Greenup",
		"cases_7day_mean_per_100k": 6.8577749651
	},
	{
		"date": "2022-10-25",
		"county": "Greenup",
		"title": "4. Greenup",
		"cases_7day_mean_per_100k": 6.9323159973
	},
	{
		"date": "2022-10-26",
		"county": "Greenup",
		"title": "4. Greenup",
		"cases_7day_mean_per_100k": 7.0813980618
	},
	{
		"date": "2022-10-27",
		"county": "Greenup",
		"title": "4. Greenup",
		"cases_7day_mean_per_100k": 7.4541032229
	},
	{
		"date": "2022-10-28",
		"county": "Greenup",
		"title": "4. Greenup",
		"cases_7day_mean_per_100k": 7.7522673518
	},
	{
		"date": "2022-10-29",
		"county": "Greenup",
		"title": "4. Greenup",
		"cases_7day_mean_per_100k": 8.5722187064
	},
	{
		"date": "2022-10-30",
		"county": "Greenup",
		"title": "4. Greenup",
		"cases_7day_mean_per_100k": 8.4976776741
	},
	{
		"date": "2022-10-31",
		"county": "Greenup",
		"title": "4. Greenup",
		"cases_7day_mean_per_100k": 9.1685469642
	},
	{
		"date": "2022-11-01",
		"county": "Greenup",
		"title": "4. Greenup",
		"cases_7day_mean_per_100k": 10.2121214154
	},
	{
		"date": "2022-11-02",
		"county": "Greenup",
		"title": "4. Greenup",
		"cases_7day_mean_per_100k": 10.5848265766
	},
	{
		"date": "2022-11-03",
		"county": "Greenup",
		"title": "4. Greenup",
		"cases_7day_mean_per_100k": 11.2556958666
	},
	{
		"date": "2022-11-04",
		"county": "Greenup",
		"title": "4. Greenup",
		"cases_7day_mean_per_100k": 12.0756472211
	},
	{
		"date": "2022-11-05",
		"county": "Greenup",
		"title": "4. Greenup",
		"cases_7day_mean_per_100k": 11.3302368989
	},
	{
		"date": "2022-11-06",
		"county": "Greenup",
		"title": "4. Greenup",
		"cases_7day_mean_per_100k": 11.3302368989
	},
	{
		"date": "2022-11-07",
		"county": "Greenup",
		"title": "4. Greenup",
		"cases_7day_mean_per_100k": 9.6903341898
	},
	{
		"date": "2022-11-08",
		"county": "Greenup",
		"title": "4. Greenup",
		"cases_7day_mean_per_100k": 7.155939094
	},
	{
		"date": "2022-03-01",
		"county": "Mercer",
		"title": "8. Mercer",
		"cases_7day_mean_per_100k": 5.4191730342
	},
	{
		"date": "2022-03-02",
		"county": "Mercer",
		"title": "8. Mercer",
		"cases_7day_mean_per_100k": 6.9675081868
	},
	{
		"date": "2022-03-03",
		"county": "Mercer",
		"title": "8. Mercer",
		"cases_7day_mean_per_100k": 7.7416757631
	},
	{
		"date": "2022-03-04",
		"county": "Mercer",
		"title": "8. Mercer",
		"cases_7day_mean_per_100k": 7.7416757631
	},
	{
		"date": "2022-03-05",
		"county": "Mercer",
		"title": "8. Mercer",
		"cases_7day_mean_per_100k": 6.9675081868
	},
	{
		"date": "2022-03-06",
		"county": "Mercer",
		"title": "8. Mercer",
		"cases_7day_mean_per_100k": 6.9675081868
	},
	{
		"date": "2022-03-07",
		"county": "Mercer",
		"title": "8. Mercer",
		"cases_7day_mean_per_100k": 7.7416757631
	},
	{
		"date": "2022-03-08",
		"county": "Mercer",
		"title": "8. Mercer",
		"cases_7day_mean_per_100k": 9.2900109158
	},
	{
		"date": "2022-03-09",
		"county": "Mercer",
		"title": "8. Mercer",
		"cases_7day_mean_per_100k": 8.5158433394
	},
	{
		"date": "2022-03-10",
		"county": "Mercer",
		"title": "8. Mercer",
		"cases_7day_mean_per_100k": 6.9675081868
	},
	{
		"date": "2022-03-11",
		"county": "Mercer",
		"title": "8. Mercer",
		"cases_7day_mean_per_100k": 6.9675081868
	},
	{
		"date": "2022-03-12",
		"county": "Mercer",
		"title": "8. Mercer",
		"cases_7day_mean_per_100k": 6.9675081868
	},
	{
		"date": "2022-03-13",
		"county": "Mercer",
		"title": "8. Mercer",
		"cases_7day_mean_per_100k": 6.1933406105
	},
	{
		"date": "2022-03-14",
		"county": "Mercer",
		"title": "8. Mercer",
		"cases_7day_mean_per_100k": 4.6450054579
	},
	{
		"date": "2022-03-15",
		"county": "Mercer",
		"title": "8. Mercer",
		"cases_7day_mean_per_100k": 3.0966703053
	},
	{
		"date": "2022-03-16",
		"county": "Mercer",
		"title": "8. Mercer",
		"cases_7day_mean_per_100k": 0.7741675763
	},
	{
		"date": "2022-03-17",
		"county": "Mercer",
		"title": "8. Mercer",
		"cases_7day_mean_per_100k": 1.5483351526
	},
	{
		"date": "2022-03-18",
		"county": "Mercer",
		"title": "8. Mercer",
		"cases_7day_mean_per_100k": 0.7741675763
	},
	{
		"date": "2022-03-19",
		"county": "Mercer",
		"title": "8. Mercer",
		"cases_7day_mean_per_100k": 0.7741675763
	},
	{
		"date": "2022-03-20",
		"county": "Mercer",
		"title": "8. Mercer",
		"cases_7day_mean_per_100k": 0.7741675763
	},
	{
		"date": "2022-03-21",
		"county": "Mercer",
		"title": "8. Mercer",
		"cases_7day_mean_per_100k": 0.7741675763
	},
	{
		"date": "2022-03-22",
		"county": "Mercer",
		"title": "8. Mercer",
		"cases_7day_mean_per_100k": 1.5483351526
	},
	{
		"date": "2022-03-23",
		"county": "Mercer",
		"title": "8. Mercer",
		"cases_7day_mean_per_100k": 1.5483351526
	},
	{
		"date": "2022-03-24",
		"county": "Mercer",
		"title": "8. Mercer",
		"cases_7day_mean_per_100k": 0.7741675763
	},
	{
		"date": "2022-03-25",
		"county": "Mercer",
		"title": "8. Mercer",
		"cases_7day_mean_per_100k": 1.5483351526
	},
	{
		"date": "2022-03-26",
		"county": "Mercer",
		"title": "8. Mercer",
		"cases_7day_mean_per_100k": 2.3225027289
	},
	{
		"date": "2022-03-27",
		"county": "Mercer",
		"title": "8. Mercer",
		"cases_7day_mean_per_100k": 2.3225027289
	},
	{
		"date": "2022-03-28",
		"county": "Mercer",
		"title": "8. Mercer",
		"cases_7day_mean_per_100k": 3.0966703053
	},
	{
		"date": "2022-03-29",
		"county": "Mercer",
		"title": "8. Mercer",
		"cases_7day_mean_per_100k": 3.0966703053
	},
	{
		"date": "2022-03-30",
		"county": "Mercer",
		"title": "8. Mercer",
		"cases_7day_mean_per_100k": 4.6450054579
	},
	{
		"date": "2022-03-31",
		"county": "Mercer",
		"title": "8. Mercer",
		"cases_7day_mean_per_100k": 5.4191730342
	},
	{
		"date": "2022-04-01",
		"county": "Mercer",
		"title": "8. Mercer",
		"cases_7day_mean_per_100k": 5.4191730342
	},
	{
		"date": "2022-04-02",
		"county": "Mercer",
		"title": "8. Mercer",
		"cases_7day_mean_per_100k": 6.1933406105
	},
	{
		"date": "2022-04-03",
		"county": "Mercer",
		"title": "8. Mercer",
		"cases_7day_mean_per_100k": 6.1933406105
	},
	{
		"date": "2022-04-04",
		"county": "Mercer",
		"title": "8. Mercer",
		"cases_7day_mean_per_100k": 6.9675081868
	},
	{
		"date": "2022-04-05",
		"county": "Mercer",
		"title": "8. Mercer",
		"cases_7day_mean_per_100k": 6.1933406105
	},
	{
		"date": "2022-04-06",
		"county": "Mercer",
		"title": "8. Mercer",
		"cases_7day_mean_per_100k": 5.4191730342
	},
	{
		"date": "2022-04-07",
		"county": "Mercer",
		"title": "8. Mercer",
		"cases_7day_mean_per_100k": 5.4191730342
	},
	{
		"date": "2022-04-08",
		"county": "Mercer",
		"title": "8. Mercer",
		"cases_7day_mean_per_100k": 4.6450054579
	},
	{
		"date": "2022-04-09",
		"county": "Mercer",
		"title": "8. Mercer",
		"cases_7day_mean_per_100k": 4.6450054579
	},
	{
		"date": "2022-04-10",
		"county": "Mercer",
		"title": "8. Mercer",
		"cases_7day_mean_per_100k": 4.6450054579
	},
	{
		"date": "2022-04-11",
		"county": "Mercer",
		"title": "8. Mercer",
		"cases_7day_mean_per_100k": 3.0966703053
	},
	{
		"date": "2022-04-12",
		"county": "Mercer",
		"title": "8. Mercer",
		"cases_7day_mean_per_100k": 3.0966703053
	},
	{
		"date": "2022-04-13",
		"county": "Mercer",
		"title": "8. Mercer",
		"cases_7day_mean_per_100k": 2.3225027289
	},
	{
		"date": "2022-04-14",
		"county": "Mercer",
		"title": "8. Mercer",
		"cases_7day_mean_per_100k": 1.5483351526
	},
	{
		"date": "2022-04-15",
		"county": "Mercer",
		"title": "8. Mercer",
		"cases_7day_mean_per_100k": 1.5483351526
	},
	{
		"date": "2022-04-16",
		"county": "Mercer",
		"title": "8. Mercer",
		"cases_7day_mean_per_100k": 0
	},
	{
		"date": "2022-04-17",
		"county": "Mercer",
		"title": "8. Mercer",
		"cases_7day_mean_per_100k": 0
	},
	{
		"date": "2022-04-18",
		"county": "Mercer",
		"title": "8. Mercer",
		"cases_7day_mean_per_100k": 1.5483351526
	},
	{
		"date": "2022-04-19",
		"county": "Mercer",
		"title": "8. Mercer",
		"cases_7day_mean_per_100k": 1.5483351526
	},
	{
		"date": "2022-04-20",
		"county": "Mercer",
		"title": "8. Mercer",
		"cases_7day_mean_per_100k": 3.8708378816
	},
	{
		"date": "2022-04-21",
		"county": "Mercer",
		"title": "8. Mercer",
		"cases_7day_mean_per_100k": 3.8708378816
	},
	{
		"date": "2022-04-22",
		"county": "Mercer",
		"title": "8. Mercer",
		"cases_7day_mean_per_100k": 3.8708378816
	},
	{
		"date": "2022-04-23",
		"county": "Mercer",
		"title": "8. Mercer",
		"cases_7day_mean_per_100k": 3.8708378816
	},
	{
		"date": "2022-04-24",
		"county": "Mercer",
		"title": "8. Mercer",
		"cases_7day_mean_per_100k": 3.8708378816
	},
	{
		"date": "2022-04-25",
		"county": "Mercer",
		"title": "8. Mercer",
		"cases_7day_mean_per_100k": 5.4191730342
	},
	{
		"date": "2022-04-26",
		"county": "Mercer",
		"title": "8. Mercer",
		"cases_7day_mean_per_100k": 5.4191730342
	},
	{
		"date": "2022-04-27",
		"county": "Mercer",
		"title": "8. Mercer",
		"cases_7day_mean_per_100k": 3.0966703053
	},
	{
		"date": "2022-04-28",
		"county": "Mercer",
		"title": "8. Mercer",
		"cases_7day_mean_per_100k": 3.8708378816
	},
	{
		"date": "2022-04-29",
		"county": "Mercer",
		"title": "8. Mercer",
		"cases_7day_mean_per_100k": 3.8708378816
	},
	{
		"date": "2022-04-30",
		"county": "Mercer",
		"title": "8. Mercer",
		"cases_7day_mean_per_100k": 3.8708378816
	},
	{
		"date": "2022-05-01",
		"county": "Mercer",
		"title": "8. Mercer",
		"cases_7day_mean_per_100k": 3.8708378816
	},
	{
		"date": "2022-05-02",
		"county": "Mercer",
		"title": "8. Mercer",
		"cases_7day_mean_per_100k": 1.5483351526
	},
	{
		"date": "2022-05-03",
		"county": "Mercer",
		"title": "8. Mercer",
		"cases_7day_mean_per_100k": 2.3225027289
	},
	{
		"date": "2022-05-04",
		"county": "Mercer",
		"title": "8. Mercer",
		"cases_7day_mean_per_100k": 3.8708378816
	},
	{
		"date": "2022-05-05",
		"county": "Mercer",
		"title": "8. Mercer",
		"cases_7day_mean_per_100k": 3.0966703053
	},
	{
		"date": "2022-05-06",
		"county": "Mercer",
		"title": "8. Mercer",
		"cases_7day_mean_per_100k": 6.1933406105
	},
	{
		"date": "2022-05-07",
		"county": "Mercer",
		"title": "8. Mercer",
		"cases_7day_mean_per_100k": 13.1608487973
	},
	{
		"date": "2022-05-08",
		"county": "Mercer",
		"title": "8. Mercer",
		"cases_7day_mean_per_100k": 15.4833515263
	},
	{
		"date": "2022-05-09",
		"county": "Mercer",
		"title": "8. Mercer",
		"cases_7day_mean_per_100k": 20.1283569842
	},
	{
		"date": "2022-05-10",
		"county": "Mercer",
		"title": "8. Mercer",
		"cases_7day_mean_per_100k": 21.6766921368
	},
	{
		"date": "2022-05-11",
		"county": "Mercer",
		"title": "8. Mercer",
		"cases_7day_mean_per_100k": 21.6766921368
	},
	{
		"date": "2022-05-12",
		"county": "Mercer",
		"title": "8. Mercer",
		"cases_7day_mean_per_100k": 22.4508597131
	},
	{
		"date": "2022-05-13",
		"county": "Mercer",
		"title": "8. Mercer",
		"cases_7day_mean_per_100k": 22.4508597131
	},
	{
		"date": "2022-05-14",
		"county": "Mercer",
		"title": "8. Mercer",
		"cases_7day_mean_per_100k": 15.4833515263
	},
	{
		"date": "2022-05-15",
		"county": "Mercer",
		"title": "8. Mercer",
		"cases_7day_mean_per_100k": 17.0316866789
	},
	{
		"date": "2022-05-16",
		"county": "Mercer",
		"title": "8. Mercer",
		"cases_7day_mean_per_100k": 14.70918395
	},
	{
		"date": "2022-05-17",
		"county": "Mercer",
		"title": "8. Mercer",
		"cases_7day_mean_per_100k": 15.4833515263
	},
	{
		"date": "2022-05-18",
		"county": "Mercer",
		"title": "8. Mercer",
		"cases_7day_mean_per_100k": 15.4833515263
	},
	{
		"date": "2022-05-19",
		"county": "Mercer",
		"title": "8. Mercer",
		"cases_7day_mean_per_100k": 17.8058542552
	},
	{
		"date": "2022-05-20",
		"county": "Mercer",
		"title": "8. Mercer",
		"cases_7day_mean_per_100k": 17.8058542552
	},
	{
		"date": "2022-05-21",
		"county": "Mercer",
		"title": "8. Mercer",
		"cases_7day_mean_per_100k": 20.1283569842
	},
	{
		"date": "2022-05-22",
		"county": "Mercer",
		"title": "8. Mercer",
		"cases_7day_mean_per_100k": 17.8058542552
	},
	{
		"date": "2022-05-23",
		"county": "Mercer",
		"title": "8. Mercer",
		"cases_7day_mean_per_100k": 20.9025245605
	},
	{
		"date": "2022-05-24",
		"county": "Mercer",
		"title": "8. Mercer",
		"cases_7day_mean_per_100k": 20.1283569842
	},
	{
		"date": "2022-05-25",
		"county": "Mercer",
		"title": "8. Mercer",
		"cases_7day_mean_per_100k": 24.773362442
	},
	{
		"date": "2022-05-26",
		"county": "Mercer",
		"title": "8. Mercer",
		"cases_7day_mean_per_100k": 23.9991948657
	},
	{
		"date": "2022-05-27",
		"county": "Mercer",
		"title": "8. Mercer",
		"cases_7day_mean_per_100k": 21.6766921368
	},
	{
		"date": "2022-05-28",
		"county": "Mercer",
		"title": "8. Mercer",
		"cases_7day_mean_per_100k": 20.9025245605
	},
	{
		"date": "2022-05-29",
		"county": "Mercer",
		"title": "8. Mercer",
		"cases_7day_mean_per_100k": 19.3541894078
	},
	{
		"date": "2022-05-30",
		"county": "Mercer",
		"title": "8. Mercer",
		"cases_7day_mean_per_100k": 13.9350163736
	},
	{
		"date": "2022-05-31",
		"county": "Mercer",
		"title": "8. Mercer",
		"cases_7day_mean_per_100k": 15.4833515263
	},
	{
		"date": "2022-06-01",
		"county": "Mercer",
		"title": "8. Mercer",
		"cases_7day_mean_per_100k": 13.9350163736
	},
	{
		"date": "2022-06-02",
		"county": "Mercer",
		"title": "8. Mercer",
		"cases_7day_mean_per_100k": 14.70918395
	},
	{
		"date": "2022-06-03",
		"county": "Mercer",
		"title": "8. Mercer",
		"cases_7day_mean_per_100k": 13.9350163736
	},
	{
		"date": "2022-06-04",
		"county": "Mercer",
		"title": "8. Mercer",
		"cases_7day_mean_per_100k": 13.1608487973
	},
	{
		"date": "2022-06-05",
		"county": "Mercer",
		"title": "8. Mercer",
		"cases_7day_mean_per_100k": 13.1608487973
	},
	{
		"date": "2022-06-06",
		"county": "Mercer",
		"title": "8. Mercer",
		"cases_7day_mean_per_100k": 15.4833515263
	},
	{
		"date": "2022-06-07",
		"county": "Mercer",
		"title": "8. Mercer",
		"cases_7day_mean_per_100k": 14.70918395
	},
	{
		"date": "2022-06-08",
		"county": "Mercer",
		"title": "8. Mercer",
		"cases_7day_mean_per_100k": 10.8383460684
	},
	{
		"date": "2022-06-09",
		"county": "Mercer",
		"title": "8. Mercer",
		"cases_7day_mean_per_100k": 9.2900109158
	},
	{
		"date": "2022-06-10",
		"county": "Mercer",
		"title": "8. Mercer",
		"cases_7day_mean_per_100k": 11.6125136447
	},
	{
		"date": "2022-06-11",
		"county": "Mercer",
		"title": "8. Mercer",
		"cases_7day_mean_per_100k": 11.6125136447
	},
	{
		"date": "2022-06-12",
		"county": "Mercer",
		"title": "8. Mercer",
		"cases_7day_mean_per_100k": 11.6125136447
	},
	{
		"date": "2022-06-13",
		"county": "Mercer",
		"title": "8. Mercer",
		"cases_7day_mean_per_100k": 10.0641784921
	},
	{
		"date": "2022-06-14",
		"county": "Mercer",
		"title": "8. Mercer",
		"cases_7day_mean_per_100k": 10.0641784921
	},
	{
		"date": "2022-06-15",
		"county": "Mercer",
		"title": "8. Mercer",
		"cases_7day_mean_per_100k": 13.1608487973
	},
	{
		"date": "2022-06-16",
		"county": "Mercer",
		"title": "8. Mercer",
		"cases_7day_mean_per_100k": 13.1608487973
	},
	{
		"date": "2022-06-17",
		"county": "Mercer",
		"title": "8. Mercer",
		"cases_7day_mean_per_100k": 11.6125136447
	},
	{
		"date": "2022-06-18",
		"county": "Mercer",
		"title": "8. Mercer",
		"cases_7day_mean_per_100k": 13.9350163736
	},
	{
		"date": "2022-06-19",
		"county": "Mercer",
		"title": "8. Mercer",
		"cases_7day_mean_per_100k": 14.70918395
	},
	{
		"date": "2022-06-20",
		"county": "Mercer",
		"title": "8. Mercer",
		"cases_7day_mean_per_100k": 13.9350163736
	},
	{
		"date": "2022-06-21",
		"county": "Mercer",
		"title": "8. Mercer",
		"cases_7day_mean_per_100k": 13.9350163736
	},
	{
		"date": "2022-06-22",
		"county": "Mercer",
		"title": "8. Mercer",
		"cases_7day_mean_per_100k": 13.9350163736
	},
	{
		"date": "2022-06-23",
		"county": "Mercer",
		"title": "8. Mercer",
		"cases_7day_mean_per_100k": 16.2575191026
	},
	{
		"date": "2022-06-24",
		"county": "Mercer",
		"title": "8. Mercer",
		"cases_7day_mean_per_100k": 17.8058542552
	},
	{
		"date": "2022-06-25",
		"county": "Mercer",
		"title": "8. Mercer",
		"cases_7day_mean_per_100k": 16.2575191026
	},
	{
		"date": "2022-06-26",
		"county": "Mercer",
		"title": "8. Mercer",
		"cases_7day_mean_per_100k": 17.0316866789
	},
	{
		"date": "2022-06-27",
		"county": "Mercer",
		"title": "8. Mercer",
		"cases_7day_mean_per_100k": 24.773362442
	},
	{
		"date": "2022-06-28",
		"county": "Mercer",
		"title": "8. Mercer",
		"cases_7day_mean_per_100k": 29.4183678999
	},
	{
		"date": "2022-06-29",
		"county": "Mercer",
		"title": "8. Mercer",
		"cases_7day_mean_per_100k": 30.1925354762
	},
	{
		"date": "2022-06-30",
		"county": "Mercer",
		"title": "8. Mercer",
		"cases_7day_mean_per_100k": 29.4183678999
	},
	{
		"date": "2022-07-01",
		"county": "Mercer",
		"title": "8. Mercer",
		"cases_7day_mean_per_100k": 31.7408706289
	},
	{
		"date": "2022-07-02",
		"county": "Mercer",
		"title": "8. Mercer",
		"cases_7day_mean_per_100k": 35.6117085104
	},
	{
		"date": "2022-07-03",
		"county": "Mercer",
		"title": "8. Mercer",
		"cases_7day_mean_per_100k": 37.1600436631
	},
	{
		"date": "2022-07-04",
		"county": "Mercer",
		"title": "8. Mercer",
		"cases_7day_mean_per_100k": 31.7408706289
	},
	{
		"date": "2022-07-05",
		"county": "Mercer",
		"title": "8. Mercer",
		"cases_7day_mean_per_100k": 26.3216975947
	},
	{
		"date": "2022-07-06",
		"county": "Mercer",
		"title": "8. Mercer",
		"cases_7day_mean_per_100k": 32.5150382052
	},
	{
		"date": "2022-07-07",
		"county": "Mercer",
		"title": "8. Mercer",
		"cases_7day_mean_per_100k": 34.0633733578
	},
	{
		"date": "2022-07-08",
		"county": "Mercer",
		"title": "8. Mercer",
		"cases_7day_mean_per_100k": 31.7408706289
	},
	{
		"date": "2022-07-09",
		"county": "Mercer",
		"title": "8. Mercer",
		"cases_7day_mean_per_100k": 27.095865171
	},
	{
		"date": "2022-07-10",
		"county": "Mercer",
		"title": "8. Mercer",
		"cases_7day_mean_per_100k": 28.6442003236
	},
	{
		"date": "2022-07-11",
		"county": "Mercer",
		"title": "8. Mercer",
		"cases_7day_mean_per_100k": 29.4183678999
	},
	{
		"date": "2022-07-12",
		"county": "Mercer",
		"title": "8. Mercer",
		"cases_7day_mean_per_100k": 29.4183678999
	},
	{
		"date": "2022-07-13",
		"county": "Mercer",
		"title": "8. Mercer",
		"cases_7day_mean_per_100k": 24.773362442
	},
	{
		"date": "2022-07-14",
		"county": "Mercer",
		"title": "8. Mercer",
		"cases_7day_mean_per_100k": 20.9025245605
	},
	{
		"date": "2022-07-15",
		"county": "Mercer",
		"title": "8. Mercer",
		"cases_7day_mean_per_100k": 20.1283569842
	},
	{
		"date": "2022-07-16",
		"county": "Mercer",
		"title": "8. Mercer",
		"cases_7day_mean_per_100k": 23.2250272894
	},
	{
		"date": "2022-07-17",
		"county": "Mercer",
		"title": "8. Mercer",
		"cases_7day_mean_per_100k": 19.3541894078
	},
	{
		"date": "2022-07-18",
		"county": "Mercer",
		"title": "8. Mercer",
		"cases_7day_mean_per_100k": 23.2250272894
	},
	{
		"date": "2022-07-19",
		"county": "Mercer",
		"title": "8. Mercer",
		"cases_7day_mean_per_100k": 23.9991948657
	},
	{
		"date": "2022-07-20",
		"county": "Mercer",
		"title": "8. Mercer",
		"cases_7day_mean_per_100k": 19.3541894078
	},
	{
		"date": "2022-07-21",
		"county": "Mercer",
		"title": "8. Mercer",
		"cases_7day_mean_per_100k": 20.1283569842
	},
	{
		"date": "2022-07-22",
		"county": "Mercer",
		"title": "8. Mercer",
		"cases_7day_mean_per_100k": 21.6766921368
	},
	{
		"date": "2022-07-23",
		"county": "Mercer",
		"title": "8. Mercer",
		"cases_7day_mean_per_100k": 17.8058542552
	},
	{
		"date": "2022-07-24",
		"county": "Mercer",
		"title": "8. Mercer",
		"cases_7day_mean_per_100k": 18.5800218315
	},
	{
		"date": "2022-07-25",
		"county": "Mercer",
		"title": "8. Mercer",
		"cases_7day_mean_per_100k": 13.9350163736
	},
	{
		"date": "2022-07-26",
		"county": "Mercer",
		"title": "8. Mercer",
		"cases_7day_mean_per_100k": 12.386681221
	},
	{
		"date": "2022-07-27",
		"county": "Mercer",
		"title": "8. Mercer",
		"cases_7day_mean_per_100k": 13.1608487973
	},
	{
		"date": "2022-07-28",
		"county": "Mercer",
		"title": "8. Mercer",
		"cases_7day_mean_per_100k": 14.70918395
	},
	{
		"date": "2022-07-29",
		"county": "Mercer",
		"title": "8. Mercer",
		"cases_7day_mean_per_100k": 14.70918395
	},
	{
		"date": "2022-07-30",
		"county": "Mercer",
		"title": "8. Mercer",
		"cases_7day_mean_per_100k": 15.4833515263
	},
	{
		"date": "2022-07-31",
		"county": "Mercer",
		"title": "8. Mercer",
		"cases_7day_mean_per_100k": 14.70918395
	},
	{
		"date": "2022-08-01",
		"county": "Mercer",
		"title": "8. Mercer",
		"cases_7day_mean_per_100k": 15.4833515263
	},
	{
		"date": "2022-08-02",
		"county": "Mercer",
		"title": "8. Mercer",
		"cases_7day_mean_per_100k": 17.0316866789
	},
	{
		"date": "2022-08-03",
		"county": "Mercer",
		"title": "8. Mercer",
		"cases_7day_mean_per_100k": 17.0316866789
	},
	{
		"date": "2022-08-04",
		"county": "Mercer",
		"title": "8. Mercer",
		"cases_7day_mean_per_100k": 13.9350163736
	},
	{
		"date": "2022-08-05",
		"county": "Mercer",
		"title": "8. Mercer",
		"cases_7day_mean_per_100k": 11.6125136447
	},
	{
		"date": "2022-08-06",
		"county": "Mercer",
		"title": "8. Mercer",
		"cases_7day_mean_per_100k": 10.8383460684
	},
	{
		"date": "2022-08-07",
		"county": "Mercer",
		"title": "8. Mercer",
		"cases_7day_mean_per_100k": 10.0641784921
	},
	{
		"date": "2022-08-08",
		"county": "Mercer",
		"title": "8. Mercer",
		"cases_7day_mean_per_100k": 6.1933406105
	},
	{
		"date": "2022-08-09",
		"county": "Mercer",
		"title": "8. Mercer",
		"cases_7day_mean_per_100k": 3.8708378816
	},
	{
		"date": "2022-08-10",
		"county": "Mercer",
		"title": "8. Mercer",
		"cases_7day_mean_per_100k": 2.3225027289
	},
	{
		"date": "2022-08-11",
		"county": "Mercer",
		"title": "8. Mercer",
		"cases_7day_mean_per_100k": 2.3225027289
	},
	{
		"date": "2022-08-12",
		"county": "Mercer",
		"title": "8. Mercer",
		"cases_7day_mean_per_100k": 2.3225027289
	},
	{
		"date": "2022-08-13",
		"county": "Mercer",
		"title": "8. Mercer",
		"cases_7day_mean_per_100k": 3.0966703053
	},
	{
		"date": "2022-08-14",
		"county": "Mercer",
		"title": "8. Mercer",
		"cases_7day_mean_per_100k": 4.6450054579
	},
	{
		"date": "2022-08-15",
		"county": "Mercer",
		"title": "8. Mercer",
		"cases_7day_mean_per_100k": 10.0641784921
	},
	{
		"date": "2022-08-16",
		"county": "Mercer",
		"title": "8. Mercer",
		"cases_7day_mean_per_100k": 10.0641784921
	},
	{
		"date": "2022-08-17",
		"county": "Mercer",
		"title": "8. Mercer",
		"cases_7day_mean_per_100k": 12.386681221
	},
	{
		"date": "2022-08-18",
		"county": "Mercer",
		"title": "8. Mercer",
		"cases_7day_mean_per_100k": 13.9350163736
	},
	{
		"date": "2022-08-19",
		"county": "Mercer",
		"title": "8. Mercer",
		"cases_7day_mean_per_100k": 13.9350163736
	},
	{
		"date": "2022-08-20",
		"county": "Mercer",
		"title": "8. Mercer",
		"cases_7day_mean_per_100k": 13.1608487973
	},
	{
		"date": "2022-08-21",
		"county": "Mercer",
		"title": "8. Mercer",
		"cases_7day_mean_per_100k": 11.6125136447
	},
	{
		"date": "2022-08-22",
		"county": "Mercer",
		"title": "8. Mercer",
		"cases_7day_mean_per_100k": 6.1933406105
	},
	{
		"date": "2022-08-23",
		"county": "Mercer",
		"title": "8. Mercer",
		"cases_7day_mean_per_100k": 6.9675081868
	},
	{
		"date": "2022-08-24",
		"county": "Mercer",
		"title": "8. Mercer",
		"cases_7day_mean_per_100k": 4.6450054579
	},
	{
		"date": "2022-08-25",
		"county": "Mercer",
		"title": "8. Mercer",
		"cases_7day_mean_per_100k": 3.8708378816
	},
	{
		"date": "2022-08-26",
		"county": "Mercer",
		"title": "8. Mercer",
		"cases_7day_mean_per_100k": 3.0966703053
	},
	{
		"date": "2022-08-27",
		"county": "Mercer",
		"title": "8. Mercer",
		"cases_7day_mean_per_100k": 3.8708378816
	},
	{
		"date": "2022-08-28",
		"county": "Mercer",
		"title": "8. Mercer",
		"cases_7day_mean_per_100k": 4.6450054579
	},
	{
		"date": "2022-08-29",
		"county": "Mercer",
		"title": "8. Mercer",
		"cases_7day_mean_per_100k": 5.4191730342
	},
	{
		"date": "2022-08-30",
		"county": "Mercer",
		"title": "8. Mercer",
		"cases_7day_mean_per_100k": 4.6450054579
	},
	{
		"date": "2022-08-31",
		"county": "Mercer",
		"title": "8. Mercer",
		"cases_7day_mean_per_100k": 4.6450054579
	},
	{
		"date": "2022-09-01",
		"county": "Mercer",
		"title": "8. Mercer",
		"cases_7day_mean_per_100k": 5.4191730342
	},
	{
		"date": "2022-09-02",
		"county": "Mercer",
		"title": "8. Mercer",
		"cases_7day_mean_per_100k": 6.9675081868
	},
	{
		"date": "2022-09-03",
		"county": "Mercer",
		"title": "8. Mercer",
		"cases_7day_mean_per_100k": 8.5158433394
	},
	{
		"date": "2022-09-04",
		"county": "Mercer",
		"title": "8. Mercer",
		"cases_7day_mean_per_100k": 8.5158433394
	},
	{
		"date": "2022-09-05",
		"county": "Mercer",
		"title": "8. Mercer",
		"cases_7day_mean_per_100k": 9.2900109158
	},
	{
		"date": "2022-09-06",
		"county": "Mercer",
		"title": "8. Mercer",
		"cases_7day_mean_per_100k": 10.0641784921
	},
	{
		"date": "2022-09-07",
		"county": "Mercer",
		"title": "8. Mercer",
		"cases_7day_mean_per_100k": 10.8383460684
	},
	{
		"date": "2022-09-08",
		"county": "Mercer",
		"title": "8. Mercer",
		"cases_7day_mean_per_100k": 12.386681221
	},
	{
		"date": "2022-09-09",
		"county": "Mercer",
		"title": "8. Mercer",
		"cases_7day_mean_per_100k": 12.386681221
	},
	{
		"date": "2022-09-10",
		"county": "Mercer",
		"title": "8. Mercer",
		"cases_7day_mean_per_100k": 11.6125136447
	},
	{
		"date": "2022-09-11",
		"county": "Mercer",
		"title": "8. Mercer",
		"cases_7day_mean_per_100k": 10.8383460684
	},
	{
		"date": "2022-09-12",
		"county": "Mercer",
		"title": "8. Mercer",
		"cases_7day_mean_per_100k": 10.0641784921
	},
	{
		"date": "2022-09-13",
		"county": "Mercer",
		"title": "8. Mercer",
		"cases_7day_mean_per_100k": 10.0641784921
	},
	{
		"date": "2022-09-14",
		"county": "Mercer",
		"title": "8. Mercer",
		"cases_7day_mean_per_100k": 10.0641784921
	},
	{
		"date": "2022-09-15",
		"county": "Mercer",
		"title": "8. Mercer",
		"cases_7day_mean_per_100k": 8.5158433394
	},
	{
		"date": "2022-09-16",
		"county": "Mercer",
		"title": "8. Mercer",
		"cases_7day_mean_per_100k": 6.9675081868
	},
	{
		"date": "2022-09-17",
		"county": "Mercer",
		"title": "8. Mercer",
		"cases_7day_mean_per_100k": 5.4191730342
	},
	{
		"date": "2022-09-18",
		"county": "Mercer",
		"title": "8. Mercer",
		"cases_7day_mean_per_100k": 5.4191730342
	},
	{
		"date": "2022-09-19",
		"county": "Mercer",
		"title": "8. Mercer",
		"cases_7day_mean_per_100k": 6.1933406105
	},
	{
		"date": "2022-09-20",
		"county": "Mercer",
		"title": "8. Mercer",
		"cases_7day_mean_per_100k": 5.4191730342
	},
	{
		"date": "2022-09-21",
		"county": "Mercer",
		"title": "8. Mercer",
		"cases_7day_mean_per_100k": 4.6450054579
	},
	{
		"date": "2022-09-22",
		"county": "Mercer",
		"title": "8. Mercer",
		"cases_7day_mean_per_100k": 3.0966703053
	},
	{
		"date": "2022-09-23",
		"county": "Mercer",
		"title": "8. Mercer",
		"cases_7day_mean_per_100k": 3.0966703053
	},
	{
		"date": "2022-09-24",
		"county": "Mercer",
		"title": "8. Mercer",
		"cases_7day_mean_per_100k": 3.0966703053
	},
	{
		"date": "2022-09-25",
		"county": "Mercer",
		"title": "8. Mercer",
		"cases_7day_mean_per_100k": 3.0966703053
	},
	{
		"date": "2022-09-26",
		"county": "Mercer",
		"title": "8. Mercer",
		"cases_7day_mean_per_100k": 3.8708378816
	},
	{
		"date": "2022-09-27",
		"county": "Mercer",
		"title": "8. Mercer",
		"cases_7day_mean_per_100k": 3.0966703053
	},
	{
		"date": "2022-09-28",
		"county": "Mercer",
		"title": "8. Mercer",
		"cases_7day_mean_per_100k": 3.8708378816
	},
	{
		"date": "2022-09-29",
		"county": "Mercer",
		"title": "8. Mercer",
		"cases_7day_mean_per_100k": 5.4191730342
	},
	{
		"date": "2022-09-30",
		"county": "Mercer",
		"title": "8. Mercer",
		"cases_7day_mean_per_100k": 5.4191730342
	},
	{
		"date": "2022-10-01",
		"county": "Mercer",
		"title": "8. Mercer",
		"cases_7day_mean_per_100k": 6.1933406105
	},
	{
		"date": "2022-10-02",
		"county": "Mercer",
		"title": "8. Mercer",
		"cases_7day_mean_per_100k": 6.1933406105
	},
	{
		"date": "2022-10-03",
		"county": "Mercer",
		"title": "8. Mercer",
		"cases_7day_mean_per_100k": 3.8708378816
	},
	{
		"date": "2022-10-04",
		"county": "Mercer",
		"title": "8. Mercer",
		"cases_7day_mean_per_100k": 4.6450054579
	},
	{
		"date": "2022-10-05",
		"county": "Mercer",
		"title": "8. Mercer",
		"cases_7day_mean_per_100k": 3.8708378816
	},
	{
		"date": "2022-10-06",
		"county": "Mercer",
		"title": "8. Mercer",
		"cases_7day_mean_per_100k": 2.3225027289
	},
	{
		"date": "2022-10-07",
		"county": "Mercer",
		"title": "8. Mercer",
		"cases_7day_mean_per_100k": 2.3225027289
	},
	{
		"date": "2022-10-08",
		"county": "Mercer",
		"title": "8. Mercer",
		"cases_7day_mean_per_100k": 2.3225027289
	},
	{
		"date": "2022-10-09",
		"county": "Mercer",
		"title": "8. Mercer",
		"cases_7day_mean_per_100k": 2.3225027289
	},
	{
		"date": "2022-10-10",
		"county": "Mercer",
		"title": "8. Mercer",
		"cases_7day_mean_per_100k": 2.3225027289
	},
	{
		"date": "2022-10-11",
		"county": "Mercer",
		"title": "8. Mercer",
		"cases_7day_mean_per_100k": 2.3225027289
	},
	{
		"date": "2022-10-12",
		"county": "Mercer",
		"title": "8. Mercer",
		"cases_7day_mean_per_100k": 3.0966703053
	},
	{
		"date": "2022-10-13",
		"county": "Mercer",
		"title": "8. Mercer",
		"cases_7day_mean_per_100k": 3.8708378816
	},
	{
		"date": "2022-10-14",
		"county": "Mercer",
		"title": "8. Mercer",
		"cases_7day_mean_per_100k": 4.6450054579
	},
	{
		"date": "2022-10-15",
		"county": "Mercer",
		"title": "8. Mercer",
		"cases_7day_mean_per_100k": 3.8708378816
	},
	{
		"date": "2022-10-16",
		"county": "Mercer",
		"title": "8. Mercer",
		"cases_7day_mean_per_100k": 3.8708378816
	},
	{
		"date": "2022-10-17",
		"county": "Mercer",
		"title": "8. Mercer",
		"cases_7day_mean_per_100k": 3.8708378816
	},
	{
		"date": "2022-10-18",
		"county": "Mercer",
		"title": "8. Mercer",
		"cases_7day_mean_per_100k": 3.0966703053
	},
	{
		"date": "2022-10-19",
		"county": "Mercer",
		"title": "8. Mercer",
		"cases_7day_mean_per_100k": 1.5483351526
	},
	{
		"date": "2022-10-20",
		"county": "Mercer",
		"title": "8. Mercer",
		"cases_7day_mean_per_100k": 0.7741675763
	},
	{
		"date": "2022-10-21",
		"county": "Mercer",
		"title": "8. Mercer",
		"cases_7day_mean_per_100k": 2.3225027289
	},
	{
		"date": "2022-10-22",
		"county": "Mercer",
		"title": "8. Mercer",
		"cases_7day_mean_per_100k": 2.3225027289
	},
	{
		"date": "2022-10-23",
		"county": "Mercer",
		"title": "8. Mercer",
		"cases_7day_mean_per_100k": 3.0966703053
	},
	{
		"date": "2022-10-24",
		"county": "Mercer",
		"title": "8. Mercer",
		"cases_7day_mean_per_100k": 3.0966703053
	},
	{
		"date": "2022-10-25",
		"county": "Mercer",
		"title": "8. Mercer",
		"cases_7day_mean_per_100k": 3.8708378816
	},
	{
		"date": "2022-10-26",
		"county": "Mercer",
		"title": "8. Mercer",
		"cases_7day_mean_per_100k": 3.8708378816
	},
	{
		"date": "2022-10-27",
		"county": "Mercer",
		"title": "8. Mercer",
		"cases_7day_mean_per_100k": 4.6450054579
	},
	{
		"date": "2022-10-28",
		"county": "Mercer",
		"title": "8. Mercer",
		"cases_7day_mean_per_100k": 3.8708378816
	},
	{
		"date": "2022-10-29",
		"county": "Mercer",
		"title": "8. Mercer",
		"cases_7day_mean_per_100k": 6.1933406105
	},
	{
		"date": "2022-10-30",
		"county": "Mercer",
		"title": "8. Mercer",
		"cases_7day_mean_per_100k": 5.4191730342
	},
	{
		"date": "2022-10-31",
		"county": "Mercer",
		"title": "8. Mercer",
		"cases_7day_mean_per_100k": 5.4191730342
	},
	{
		"date": "2022-11-01",
		"county": "Mercer",
		"title": "8. Mercer",
		"cases_7day_mean_per_100k": 7.7416757631
	},
	{
		"date": "2022-11-02",
		"county": "Mercer",
		"title": "8. Mercer",
		"cases_7day_mean_per_100k": 10.0641784921
	},
	{
		"date": "2022-11-03",
		"county": "Mercer",
		"title": "8. Mercer",
		"cases_7day_mean_per_100k": 10.8383460684
	},
	{
		"date": "2022-11-04",
		"county": "Mercer",
		"title": "8. Mercer",
		"cases_7day_mean_per_100k": 9.2900109158
	},
	{
		"date": "2022-11-05",
		"county": "Mercer",
		"title": "8. Mercer",
		"cases_7day_mean_per_100k": 7.7416757631
	},
	{
		"date": "2022-11-06",
		"county": "Mercer",
		"title": "8. Mercer",
		"cases_7day_mean_per_100k": 8.5158433394
	},
	{
		"date": "2022-11-07",
		"county": "Mercer",
		"title": "8. Mercer",
		"cases_7day_mean_per_100k": 8.5158433394
	},
	{
		"date": "2022-11-08",
		"county": "Mercer",
		"title": "8. Mercer",
		"cases_7day_mean_per_100k": 5.4191730342
	},
	{
		"date": "2022-03-01",
		"county": "Muhlenberg",
		"title": "10. Muhlenberg",
		"cases_7day_mean_per_100k": 20.0893427863
	},
	{
		"date": "2022-03-02",
		"county": "Muhlenberg",
		"title": "10. Muhlenberg",
		"cases_7day_mean_per_100k": 16.436735007
	},
	{
		"date": "2022-03-03",
		"county": "Muhlenberg",
		"title": "10. Muhlenberg",
		"cases_7day_mean_per_100k": 15.7975286456
	},
	{
		"date": "2022-03-04",
		"county": "Muhlenberg",
		"title": "10. Muhlenberg",
		"cases_7day_mean_per_100k": 15.1583222842
	},
	{
		"date": "2022-03-05",
		"county": "Muhlenberg",
		"title": "10. Muhlenberg",
		"cases_7day_mean_per_100k": 15.0670070897
	},
	{
		"date": "2022-03-06",
		"county": "Muhlenberg",
		"title": "10. Muhlenberg",
		"cases_7day_mean_per_100k": 14.5191159228
	},
	{
		"date": "2022-03-07",
		"county": "Muhlenberg",
		"title": "10. Muhlenberg",
		"cases_7day_mean_per_100k": 18.3543540911
	},
	{
		"date": "2022-03-08",
		"county": "Muhlenberg",
		"title": "10. Muhlenberg",
		"cases_7day_mean_per_100k": 17.4412021463
	},
	{
		"date": "2022-03-09",
		"county": "Muhlenberg",
		"title": "10. Muhlenberg",
		"cases_7day_mean_per_100k": 19.2675060359
	},
	{
		"date": "2022-03-10",
		"county": "Muhlenberg",
		"title": "10. Muhlenberg",
		"cases_7day_mean_per_100k": 18.8109300635
	},
	{
		"date": "2022-03-11",
		"county": "Muhlenberg",
		"title": "10. Muhlenberg",
		"cases_7day_mean_per_100k": 19.3588212304
	},
	{
		"date": "2022-03-12",
		"county": "Muhlenberg",
		"title": "10. Muhlenberg",
		"cases_7day_mean_per_100k": 19.9980275918
	},
	{
		"date": "2022-03-13",
		"county": "Muhlenberg",
		"title": "10. Muhlenberg",
		"cases_7day_mean_per_100k": 19.9067123973
	},
	{
		"date": "2022-03-14",
		"county": "Muhlenberg",
		"title": "10. Muhlenberg",
		"cases_7day_mean_per_100k": 14.2451703394
	},
	{
		"date": "2022-03-15",
		"county": "Muhlenberg",
		"title": "10. Muhlenberg",
		"cases_7day_mean_per_100k": 13.1493880056
	},
	{
		"date": "2022-03-16",
		"county": "Muhlenberg",
		"title": "10. Muhlenberg",
		"cases_7day_mean_per_100k": 11.0491385325
	},
	{
		"date": "2022-03-17",
		"county": "Muhlenberg",
		"title": "10. Muhlenberg",
		"cases_7day_mean_per_100k": 10.5012473656
	},
	{
		"date": "2022-03-18",
		"county": "Muhlenberg",
		"title": "10. Muhlenberg",
		"cases_7day_mean_per_100k": 8.127052309
	},
	{
		"date": "2022-03-19",
		"county": "Muhlenberg",
		"title": "10. Muhlenberg",
		"cases_7day_mean_per_100k": 7.0312699752
	},
	{
		"date": "2022-03-20",
		"county": "Muhlenberg",
		"title": "10. Muhlenberg",
		"cases_7day_mean_per_100k": 6.9399547807
	},
	{
		"date": "2022-03-21",
		"county": "Muhlenberg",
		"title": "10. Muhlenberg",
		"cases_7day_mean_per_100k": 7.2139003642
	},
	{
		"date": "2022-03-22",
		"county": "Muhlenberg",
		"title": "10. Muhlenberg",
		"cases_7day_mean_per_100k": 6.8486395862
	},
	{
		"date": "2022-03-23",
		"county": "Muhlenberg",
		"title": "10. Muhlenberg",
		"cases_7day_mean_per_100k": 6.2094332249
	},
	{
		"date": "2022-03-24",
		"county": "Muhlenberg",
		"title": "10. Muhlenberg",
		"cases_7day_mean_per_100k": 5.8441724469
	},
	{
		"date": "2022-03-25",
		"county": "Muhlenberg",
		"title": "10. Muhlenberg",
		"cases_7day_mean_per_100k": 6.3920636138
	},
	{
		"date": "2022-03-26",
		"county": "Muhlenberg",
		"title": "10. Muhlenberg",
		"cases_7day_mean_per_100k": 5.7528572524
	},
	{
		"date": "2022-03-27",
		"county": "Muhlenberg",
		"title": "10. Muhlenberg",
		"cases_7day_mean_per_100k": 5.3875964745
	},
	{
		"date": "2022-03-28",
		"county": "Muhlenberg",
		"title": "10. Muhlenberg",
		"cases_7day_mean_per_100k": 5.2049660855
	},
	{
		"date": "2022-03-29",
		"county": "Muhlenberg",
		"title": "10. Muhlenberg",
		"cases_7day_mean_per_100k": 5.1136508911
	},
	{
		"date": "2022-03-30",
		"county": "Muhlenberg",
		"title": "10. Muhlenberg",
		"cases_7day_mean_per_100k": 4.6570749186
	},
	{
		"date": "2022-03-31",
		"county": "Muhlenberg",
		"title": "10. Muhlenberg",
		"cases_7day_mean_per_100k": 4.2004989462
	},
	{
		"date": "2022-04-01",
		"county": "Muhlenberg",
		"title": "10. Muhlenberg",
		"cases_7day_mean_per_100k": 4.2004989462
	},
	{
		"date": "2022-04-02",
		"county": "Muhlenberg",
		"title": "10. Muhlenberg",
		"cases_7day_mean_per_100k": 4.3831293352
	},
	{
		"date": "2022-04-03",
		"county": "Muhlenberg",
		"title": "10. Muhlenberg",
		"cases_7day_mean_per_100k": 4.5657597242
	},
	{
		"date": "2022-04-04",
		"county": "Muhlenberg",
		"title": "10. Muhlenberg",
		"cases_7day_mean_per_100k": 4.2918141407
	},
	{
		"date": "2022-04-05",
		"county": "Muhlenberg",
		"title": "10. Muhlenberg",
		"cases_7day_mean_per_100k": 3.6526077793
	},
	{
		"date": "2022-04-06",
		"county": "Muhlenberg",
		"title": "10. Muhlenberg",
		"cases_7day_mean_per_100k": 3.2873470014
	},
	{
		"date": "2022-04-07",
		"county": "Muhlenberg",
		"title": "10. Muhlenberg",
		"cases_7day_mean_per_100k": 2.830771029
	},
	{
		"date": "2022-04-08",
		"county": "Muhlenberg",
		"title": "10. Muhlenberg",
		"cases_7day_mean_per_100k": 2.7394558345
	},
	{
		"date": "2022-04-09",
		"county": "Muhlenberg",
		"title": "10. Muhlenberg",
		"cases_7day_mean_per_100k": 2.9220862235
	},
	{
		"date": "2022-04-10",
		"county": "Muhlenberg",
		"title": "10. Muhlenberg",
		"cases_7day_mean_per_100k": 3.1960318069
	},
	{
		"date": "2022-04-11",
		"county": "Muhlenberg",
		"title": "10. Muhlenberg",
		"cases_7day_mean_per_100k": 2.830771029
	},
	{
		"date": "2022-04-12",
		"county": "Muhlenberg",
		"title": "10. Muhlenberg",
		"cases_7day_mean_per_100k": 2.64814064
	},
	{
		"date": "2022-04-13",
		"county": "Muhlenberg",
		"title": "10. Muhlenberg",
		"cases_7day_mean_per_100k": 3.1047166124
	},
	{
		"date": "2022-04-14",
		"county": "Muhlenberg",
		"title": "10. Muhlenberg",
		"cases_7day_mean_per_100k": 3.5612925848
	},
	{
		"date": "2022-04-15",
		"county": "Muhlenberg",
		"title": "10. Muhlenberg",
		"cases_7day_mean_per_100k": 3.5612925848
	},
	{
		"date": "2022-04-16",
		"county": "Muhlenberg",
		"title": "10. Muhlenberg",
		"cases_7day_mean_per_100k": 3.4699773904
	},
	{
		"date": "2022-04-17",
		"county": "Muhlenberg",
		"title": "10. Muhlenberg",
		"cases_7day_mean_per_100k": 3.1960318069
	},
	{
		"date": "2022-04-18",
		"county": "Muhlenberg",
		"title": "10. Muhlenberg",
		"cases_7day_mean_per_100k": 4.0178685573
	},
	{
		"date": "2022-04-19",
		"county": "Muhlenberg",
		"title": "10. Muhlenberg",
		"cases_7day_mean_per_100k": 4.1091837517
	},
	{
		"date": "2022-04-20",
		"county": "Muhlenberg",
		"title": "10. Muhlenberg",
		"cases_7day_mean_per_100k": 4.6570749186
	},
	{
		"date": "2022-04-21",
		"county": "Muhlenberg",
		"title": "10. Muhlenberg",
		"cases_7day_mean_per_100k": 4.9310205021
	},
	{
		"date": "2022-04-22",
		"county": "Muhlenberg",
		"title": "10. Muhlenberg",
		"cases_7day_mean_per_100k": 4.9310205021
	},
	{
		"date": "2022-04-23",
		"county": "Muhlenberg",
		"title": "10. Muhlenberg",
		"cases_7day_mean_per_100k": 4.9310205021
	},
	{
		"date": "2022-04-24",
		"county": "Muhlenberg",
		"title": "10. Muhlenberg",
		"cases_7day_mean_per_100k": 5.1136508911
	},
	{
		"date": "2022-04-25",
		"county": "Muhlenberg",
		"title": "10. Muhlenberg",
		"cases_7day_mean_per_100k": 4.9310205021
	},
	{
		"date": "2022-04-26",
		"county": "Muhlenberg",
		"title": "10. Muhlenberg",
		"cases_7day_mean_per_100k": 5.29628128
	},
	{
		"date": "2022-04-27",
		"county": "Muhlenberg",
		"title": "10. Muhlenberg",
		"cases_7day_mean_per_100k": 4.5657597242
	},
	{
		"date": "2022-04-28",
		"county": "Muhlenberg",
		"title": "10. Muhlenberg",
		"cases_7day_mean_per_100k": 4.2004989462
	},
	{
		"date": "2022-04-29",
		"county": "Muhlenberg",
		"title": "10. Muhlenberg",
		"cases_7day_mean_per_100k": 4.0178685573
	},
	{
		"date": "2022-04-30",
		"county": "Muhlenberg",
		"title": "10. Muhlenberg",
		"cases_7day_mean_per_100k": 4.1091837517
	},
	{
		"date": "2022-05-01",
		"county": "Muhlenberg",
		"title": "10. Muhlenberg",
		"cases_7day_mean_per_100k": 4.2004989462
	},
	{
		"date": "2022-05-02",
		"county": "Muhlenberg",
		"title": "10. Muhlenberg",
		"cases_7day_mean_per_100k": 5.29628128
	},
	{
		"date": "2022-05-03",
		"county": "Muhlenberg",
		"title": "10. Muhlenberg",
		"cases_7day_mean_per_100k": 6.0268028359
	},
	{
		"date": "2022-05-04",
		"county": "Muhlenberg",
		"title": "10. Muhlenberg",
		"cases_7day_mean_per_100k": 6.5746940028
	},
	{
		"date": "2022-05-05",
		"county": "Muhlenberg",
		"title": "10. Muhlenberg",
		"cases_7day_mean_per_100k": 7.7617915311
	},
	{
		"date": "2022-05-06",
		"county": "Muhlenberg",
		"title": "10. Muhlenberg",
		"cases_7day_mean_per_100k": 7.94442192
	},
	{
		"date": "2022-05-07",
		"county": "Muhlenberg",
		"title": "10. Muhlenberg",
		"cases_7day_mean_per_100k": 8.2183675035
	},
	{
		"date": "2022-05-08",
		"county": "Muhlenberg",
		"title": "10. Muhlenberg",
		"cases_7day_mean_per_100k": 8.6749434759
	},
	{
		"date": "2022-05-09",
		"county": "Muhlenberg",
		"title": "10. Muhlenberg",
		"cases_7day_mean_per_100k": 8.309682698
	},
	{
		"date": "2022-05-10",
		"county": "Muhlenberg",
		"title": "10. Muhlenberg",
		"cases_7day_mean_per_100k": 9.5880954207
	},
	{
		"date": "2022-05-11",
		"county": "Muhlenberg",
		"title": "10. Muhlenberg",
		"cases_7day_mean_per_100k": 11.3230841159
	},
	{
		"date": "2022-05-12",
		"county": "Muhlenberg",
		"title": "10. Muhlenberg",
		"cases_7day_mean_per_100k": 12.2362360607
	},
	{
		"date": "2022-05-13",
		"county": "Muhlenberg",
		"title": "10. Muhlenberg",
		"cases_7day_mean_per_100k": 13.423333589
	},
	{
		"date": "2022-05-14",
		"county": "Muhlenberg",
		"title": "10. Muhlenberg",
		"cases_7day_mean_per_100k": 14.8843767007
	},
	{
		"date": "2022-05-15",
		"county": "Muhlenberg",
		"title": "10. Muhlenberg",
		"cases_7day_mean_per_100k": 16.3454198125
	},
	{
		"date": "2022-05-16",
		"county": "Muhlenberg",
		"title": "10. Muhlenberg",
		"cases_7day_mean_per_100k": 20.2719731752
	},
	{
		"date": "2022-05-17",
		"county": "Muhlenberg",
		"title": "10. Muhlenberg",
		"cases_7day_mean_per_100k": 22.0069618704
	},
	{
		"date": "2022-05-18",
		"county": "Muhlenberg",
		"title": "10. Muhlenberg",
		"cases_7day_mean_per_100k": 23.1027442042
	},
	{
		"date": "2022-05-19",
		"county": "Muhlenberg",
		"title": "10. Muhlenberg",
		"cases_7day_mean_per_100k": 23.1940593987
	},
	{
		"date": "2022-05-20",
		"county": "Muhlenberg",
		"title": "10. Muhlenberg",
		"cases_7day_mean_per_100k": 23.7419505656
	},
	{
		"date": "2022-05-21",
		"county": "Muhlenberg",
		"title": "10. Muhlenberg",
		"cases_7day_mean_per_100k": 22.9201138153
	},
	{
		"date": "2022-05-22",
		"county": "Muhlenberg",
		"title": "10. Muhlenberg",
		"cases_7day_mean_per_100k": 22.5548530373
	},
	{
		"date": "2022-05-23",
		"county": "Muhlenberg",
		"title": "10. Muhlenberg",
		"cases_7day_mean_per_100k": 22.7374834263
	},
	{
		"date": "2022-05-24",
		"county": "Muhlenberg",
		"title": "10. Muhlenberg",
		"cases_7day_mean_per_100k": 22.5548530373
	},
	{
		"date": "2022-05-25",
		"county": "Muhlenberg",
		"title": "10. Muhlenberg",
		"cases_7day_mean_per_100k": 24.6551025104
	},
	{
		"date": "2022-05-26",
		"county": "Muhlenberg",
		"title": "10. Muhlenberg",
		"cases_7day_mean_per_100k": 26.846667178
	},
	{
		"date": "2022-05-27",
		"county": "Muhlenberg",
		"title": "10. Muhlenberg",
		"cases_7day_mean_per_100k": 28.5816558732
	},
	{
		"date": "2022-05-28",
		"county": "Muhlenberg",
		"title": "10. Muhlenberg",
		"cases_7day_mean_per_100k": 29.7687534015
	},
	{
		"date": "2022-05-29",
		"county": "Muhlenberg",
		"title": "10. Muhlenberg",
		"cases_7day_mean_per_100k": 29.860068596
	},
	{
		"date": "2022-05-30",
		"county": "Muhlenberg",
		"title": "10. Muhlenberg",
		"cases_7day_mean_per_100k": 26.4814064001
	},
	{
		"date": "2022-05-31",
		"county": "Muhlenberg",
		"title": "10. Muhlenberg",
		"cases_7day_mean_per_100k": 30.8645357353
	},
	{
		"date": "2022-06-01",
		"county": "Muhlenberg",
		"title": "10. Muhlenberg",
		"cases_7day_mean_per_100k": 29.494807818
	},
	{
		"date": "2022-06-02",
		"county": "Muhlenberg",
		"title": "10. Muhlenberg",
		"cases_7day_mean_per_100k": 29.860068596
	},
	{
		"date": "2022-06-03",
		"county": "Muhlenberg",
		"title": "10. Muhlenberg",
		"cases_7day_mean_per_100k": 30.4992749574
	},
	{
		"date": "2022-06-04",
		"county": "Muhlenberg",
		"title": "10. Muhlenberg",
		"cases_7day_mean_per_100k": 30.1340141794
	},
	{
		"date": "2022-06-05",
		"county": "Muhlenberg",
		"title": "10. Muhlenberg",
		"cases_7day_mean_per_100k": 31.7776876801
	},
	{
		"date": "2022-06-06",
		"county": "Muhlenberg",
		"title": "10. Muhlenberg",
		"cases_7day_mean_per_100k": 36.3434474043
	},
	{
		"date": "2022-06-07",
		"county": "Muhlenberg",
		"title": "10. Muhlenberg",
		"cases_7day_mean_per_100k": 32.9647852084
	},
	{
		"date": "2022-06-08",
		"county": "Muhlenberg",
		"title": "10. Muhlenberg",
		"cases_7day_mean_per_100k": 33.6039915698
	},
	{
		"date": "2022-06-09",
		"county": "Muhlenberg",
		"title": "10. Muhlenberg",
		"cases_7day_mean_per_100k": 34.7910890981
	},
	{
		"date": "2022-06-10",
		"county": "Muhlenberg",
		"title": "10. Muhlenberg",
		"cases_7day_mean_per_100k": 33.6953067643
	},
	{
		"date": "2022-06-11",
		"county": "Muhlenberg",
		"title": "10. Muhlenberg",
		"cases_7day_mean_per_100k": 33.3300459863
	},
	{
		"date": "2022-06-12",
		"county": "Muhlenberg",
		"title": "10. Muhlenberg",
		"cases_7day_mean_per_100k": 32.4168940415
	},
	{
		"date": "2022-06-13",
		"county": "Muhlenberg",
		"title": "10. Muhlenberg",
		"cases_7day_mean_per_100k": 32.690839625
	},
	{
		"date": "2022-06-14",
		"county": "Muhlenberg",
		"title": "10. Muhlenberg",
		"cases_7day_mean_per_100k": 33.2387307918
	},
	{
		"date": "2022-06-15",
		"county": "Muhlenberg",
		"title": "10. Muhlenberg",
		"cases_7day_mean_per_100k": 34.3345131256
	},
	{
		"date": "2022-06-16",
		"county": "Muhlenberg",
		"title": "10. Muhlenberg",
		"cases_7day_mean_per_100k": 32.8734700139
	},
	{
		"date": "2022-06-17",
		"county": "Muhlenberg",
		"title": "10. Muhlenberg",
		"cases_7day_mean_per_100k": 35.2476650705
	},
	{
		"date": "2022-06-18",
		"county": "Muhlenberg",
		"title": "10. Muhlenberg",
		"cases_7day_mean_per_100k": 35.8868714319
	},
	{
		"date": "2022-06-19",
		"county": "Muhlenberg",
		"title": "10. Muhlenberg",
		"cases_7day_mean_per_100k": 36.2521322098
	},
	{
		"date": "2022-06-20",
		"county": "Muhlenberg",
		"title": "10. Muhlenberg",
		"cases_7day_mean_per_100k": 37.7131753215
	},
	{
		"date": "2022-06-21",
		"county": "Muhlenberg",
		"title": "10. Muhlenberg",
		"cases_7day_mean_per_100k": 39.1742184333
	},
	{
		"date": "2022-06-22",
		"county": "Muhlenberg",
		"title": "10. Muhlenberg",
		"cases_7day_mean_per_100k": 39.6307944057
	},
	{
		"date": "2022-06-23",
		"county": "Muhlenberg",
		"title": "10. Muhlenberg",
		"cases_7day_mean_per_100k": 40.5439463505
	},
	{
		"date": "2022-06-24",
		"county": "Muhlenberg",
		"title": "10. Muhlenberg",
		"cases_7day_mean_per_100k": 39.8134247946
	},
	{
		"date": "2022-06-25",
		"county": "Muhlenberg",
		"title": "10. Muhlenberg",
		"cases_7day_mean_per_100k": 41.3657831008
	},
	{
		"date": "2022-06-26",
		"county": "Muhlenberg",
		"title": "10. Muhlenberg",
		"cases_7day_mean_per_100k": 41.4570982953
	},
	{
		"date": "2022-06-27",
		"county": "Muhlenberg",
		"title": "10. Muhlenberg",
		"cases_7day_mean_per_100k": 42.7355110181
	},
	{
		"date": "2022-06-28",
		"county": "Muhlenberg",
		"title": "10. Muhlenberg",
		"cases_7day_mean_per_100k": 43.283402185
	},
	{
		"date": "2022-06-29",
		"county": "Muhlenberg",
		"title": "10. Muhlenberg",
		"cases_7day_mean_per_100k": 43.8312933519
	},
	{
		"date": "2022-06-30",
		"county": "Muhlenberg",
		"title": "10. Muhlenberg",
		"cases_7day_mean_per_100k": 46.2054884084
	},
	{
		"date": "2022-07-01",
		"county": "Muhlenberg",
		"title": "10. Muhlenberg",
		"cases_7day_mean_per_100k": 47.7578467147
	},
	{
		"date": "2022-07-02",
		"county": "Muhlenberg",
		"title": "10. Muhlenberg",
		"cases_7day_mean_per_100k": 46.7533795753
	},
	{
		"date": "2022-07-03",
		"county": "Muhlenberg",
		"title": "10. Muhlenberg",
		"cases_7day_mean_per_100k": 47.4839011312
	},
	{
		"date": "2022-07-04",
		"county": "Muhlenberg",
		"title": "10. Muhlenberg",
		"cases_7day_mean_per_100k": 39.9047399891
	},
	{
		"date": "2022-07-05",
		"county": "Muhlenberg",
		"title": "10. Muhlenberg",
		"cases_7day_mean_per_100k": 45.6575972416
	},
	{
		"date": "2022-07-06",
		"county": "Muhlenberg",
		"title": "10. Muhlenberg",
		"cases_7day_mean_per_100k": 50.0407265767
	},
	{
		"date": "2022-07-07",
		"county": "Muhlenberg",
		"title": "10. Muhlenberg",
		"cases_7day_mean_per_100k": 52.5062368278
	},
	{
		"date": "2022-07-08",
		"county": "Muhlenberg",
		"title": "10. Muhlenberg",
		"cases_7day_mean_per_100k": 52.5975520223
	},
	{
		"date": "2022-07-09",
		"county": "Muhlenberg",
		"title": "10. Muhlenberg",
		"cases_7day_mean_per_100k": 53.4193887726
	},
	{
		"date": "2022-07-10",
		"county": "Muhlenberg",
		"title": "10. Muhlenberg",
		"cases_7day_mean_per_100k": 52.8714976057
	},
	{
		"date": "2022-07-11",
		"county": "Muhlenberg",
		"title": "10. Muhlenberg",
		"cases_7day_mean_per_100k": 66.6600919727
	},
	{
		"date": "2022-07-12",
		"county": "Muhlenberg",
		"title": "10. Muhlenberg",
		"cases_7day_mean_per_100k": 66.4774615837
	},
	{
		"date": "2022-07-13",
		"county": "Muhlenberg",
		"title": "10. Muhlenberg",
		"cases_7day_mean_per_100k": 64.833788083
	},
	{
		"date": "2022-07-14",
		"county": "Muhlenberg",
		"title": "10. Muhlenberg",
		"cases_7day_mean_per_100k": 64.1945817216
	},
	{
		"date": "2022-07-15",
		"county": "Muhlenberg",
		"title": "10. Muhlenberg",
		"cases_7day_mean_per_100k": 65.8382552223
	},
	{
		"date": "2022-07-16",
		"county": "Muhlenberg",
		"title": "10. Muhlenberg",
		"cases_7day_mean_per_100k": 67.7558743065
	},
	{
		"date": "2022-07-17",
		"county": "Muhlenberg",
		"title": "10. Muhlenberg",
		"cases_7day_mean_per_100k": 67.9385046954
	},
	{
		"date": "2022-07-18",
		"county": "Muhlenberg",
		"title": "10. Muhlenberg",
		"cases_7day_mean_per_100k": 64.3772121106
	},
	{
		"date": "2022-07-19",
		"county": "Muhlenberg",
		"title": "10. Muhlenberg",
		"cases_7day_mean_per_100k": 60.6332891368
	},
	{
		"date": "2022-07-20",
		"county": "Muhlenberg",
		"title": "10. Muhlenberg",
		"cases_7day_mean_per_100k": 59.9027675809
	},
	{
		"date": "2022-07-21",
		"county": "Muhlenberg",
		"title": "10. Muhlenberg",
		"cases_7day_mean_per_100k": 57.6198877188
	},
	{
		"date": "2022-07-22",
		"county": "Muhlenberg",
		"title": "10. Muhlenberg",
		"cases_7day_mean_per_100k": 55.7022686347
	},
	{
		"date": "2022-07-23",
		"county": "Muhlenberg",
		"title": "10. Muhlenberg",
		"cases_7day_mean_per_100k": 53.2367583836
	},
	{
		"date": "2022-07-24",
		"county": "Muhlenberg",
		"title": "10. Muhlenberg",
		"cases_7day_mean_per_100k": 53.4193887726
	},
	{
		"date": "2022-07-25",
		"county": "Muhlenberg",
		"title": "10. Muhlenberg",
		"cases_7day_mean_per_100k": 52.3236064388
	},
	{
		"date": "2022-07-26",
		"county": "Muhlenberg",
		"title": "10. Muhlenberg",
		"cases_7day_mean_per_100k": 54.8804318843
	},
	{
		"date": "2022-07-27",
		"county": "Muhlenberg",
		"title": "10. Muhlenberg",
		"cases_7day_mean_per_100k": 55.9762142181
	},
	{
		"date": "2022-07-28",
		"county": "Muhlenberg",
		"title": "10. Muhlenberg",
		"cases_7day_mean_per_100k": 55.0630622733
	},
	{
		"date": "2022-07-29",
		"county": "Muhlenberg",
		"title": "10. Muhlenberg",
		"cases_7day_mean_per_100k": 57.6198877188
	},
	{
		"date": "2022-07-30",
		"county": "Muhlenberg",
		"title": "10. Muhlenberg",
		"cases_7day_mean_per_100k": 57.7112029133
	},
	{
		"date": "2022-07-31",
		"county": "Muhlenberg",
		"title": "10. Muhlenberg",
		"cases_7day_mean_per_100k": 56.7980509685
	},
	{
		"date": "2022-08-01",
		"county": "Muhlenberg",
		"title": "10. Muhlenberg",
		"cases_7day_mean_per_100k": 56.9806813575
	},
	{
		"date": "2022-08-02",
		"county": "Muhlenberg",
		"title": "10. Muhlenberg",
		"cases_7day_mean_per_100k": 53.0541279947
	},
	{
		"date": "2022-08-03",
		"county": "Muhlenberg",
		"title": "10. Muhlenberg",
		"cases_7day_mean_per_100k": 49.9494113823
	},
	{
		"date": "2022-08-04",
		"county": "Muhlenberg",
		"title": "10. Muhlenberg",
		"cases_7day_mean_per_100k": 48.9449442429
	},
	{
		"date": "2022-08-05",
		"county": "Muhlenberg",
		"title": "10. Muhlenberg",
		"cases_7day_mean_per_100k": 45.748912436
	},
	{
		"date": "2022-08-06",
		"county": "Muhlenberg",
		"title": "10. Muhlenberg",
		"cases_7day_mean_per_100k": 44.6531301022
	},
	{
		"date": "2022-08-07",
		"county": "Muhlenberg",
		"title": "10. Muhlenberg",
		"cases_7day_mean_per_100k": 45.2923364636
	},
	{
		"date": "2022-08-08",
		"county": "Muhlenberg",
		"title": "10. Muhlenberg",
		"cases_7day_mean_per_100k": 42.5528806291
	},
	{
		"date": "2022-08-09",
		"county": "Muhlenberg",
		"title": "10. Muhlenberg",
		"cases_7day_mean_per_100k": 39.6307944057
	},
	{
		"date": "2022-08-10",
		"county": "Muhlenberg",
		"title": "10. Muhlenberg",
		"cases_7day_mean_per_100k": 38.2610664884
	},
	{
		"date": "2022-08-11",
		"county": "Muhlenberg",
		"title": "10. Muhlenberg",
		"cases_7day_mean_per_100k": 36.7087081822
	},
	{
		"date": "2022-08-12",
		"county": "Muhlenberg",
		"title": "10. Muhlenberg",
		"cases_7day_mean_per_100k": 35.8868714319
	},
	{
		"date": "2022-08-13",
		"county": "Muhlenberg",
		"title": "10. Muhlenberg",
		"cases_7day_mean_per_100k": 35.4302954594
	},
	{
		"date": "2022-08-14",
		"county": "Muhlenberg",
		"title": "10. Muhlenberg",
		"cases_7day_mean_per_100k": 34.0605675422
	},
	{
		"date": "2022-08-15",
		"county": "Muhlenberg",
		"title": "10. Muhlenberg",
		"cases_7day_mean_per_100k": 30.3166445684
	},
	{
		"date": "2022-08-16",
		"county": "Muhlenberg",
		"title": "10. Muhlenberg",
		"cases_7day_mean_per_100k": 31.5950572912
	},
	{
		"date": "2022-08-17",
		"county": "Muhlenberg",
		"title": "10. Muhlenberg",
		"cases_7day_mean_per_100k": 29.7687534015
	},
	{
		"date": "2022-08-18",
		"county": "Muhlenberg",
		"title": "10. Muhlenberg",
		"cases_7day_mean_per_100k": 31.3211117077
	},
	{
		"date": "2022-08-19",
		"county": "Muhlenberg",
		"title": "10. Muhlenberg",
		"cases_7day_mean_per_100k": 30.1340141794
	},
	{
		"date": "2022-08-20",
		"county": "Muhlenberg",
		"title": "10. Muhlenberg",
		"cases_7day_mean_per_100k": 32.2342636525
	},
	{
		"date": "2022-08-21",
		"county": "Muhlenberg",
		"title": "10. Muhlenberg",
		"cases_7day_mean_per_100k": 32.4168940415
	},
	{
		"date": "2022-08-22",
		"county": "Muhlenberg",
		"title": "10. Muhlenberg",
		"cases_7day_mean_per_100k": 33.7866219587
	},
	{
		"date": "2022-08-23",
		"county": "Muhlenberg",
		"title": "10. Muhlenberg",
		"cases_7day_mean_per_100k": 31.7776876801
	},
	{
		"date": "2022-08-24",
		"county": "Muhlenberg",
		"title": "10. Muhlenberg",
		"cases_7day_mean_per_100k": 32.2342636525
	},
	{
		"date": "2022-08-25",
		"county": "Muhlenberg",
		"title": "10. Muhlenberg",
		"cases_7day_mean_per_100k": 31.2297965132
	},
	{
		"date": "2022-08-26",
		"county": "Muhlenberg",
		"title": "10. Muhlenberg",
		"cases_7day_mean_per_100k": 32.2342636525
	},
	{
		"date": "2022-08-27",
		"county": "Muhlenberg",
		"title": "10. Muhlenberg",
		"cases_7day_mean_per_100k": 29.5861230125
	},
	{
		"date": "2022-08-28",
		"county": "Muhlenberg",
		"title": "10. Muhlenberg",
		"cases_7day_mean_per_100k": 29.860068596
	},
	{
		"date": "2022-08-29",
		"county": "Muhlenberg",
		"title": "10. Muhlenberg",
		"cases_7day_mean_per_100k": 28.5816558732
	},
	{
		"date": "2022-08-30",
		"county": "Muhlenberg",
		"title": "10. Muhlenberg",
		"cases_7day_mean_per_100k": 30.2253293739
	},
	{
		"date": "2022-08-31",
		"county": "Muhlenberg",
		"title": "10. Muhlenberg",
		"cases_7day_mean_per_100k": 30.6819053463
	},
	{
		"date": "2022-09-01",
		"county": "Muhlenberg",
		"title": "10. Muhlenberg",
		"cases_7day_mean_per_100k": 29.1295470401
	},
	{
		"date": "2022-09-02",
		"county": "Muhlenberg",
		"title": "10. Muhlenberg",
		"cases_7day_mean_per_100k": 26.5727215946
	},
	{
		"date": "2022-09-03",
		"county": "Muhlenberg",
		"title": "10. Muhlenberg",
		"cases_7day_mean_per_100k": 26.3900912056
	},
	{
		"date": "2022-09-04",
		"county": "Muhlenberg",
		"title": "10. Muhlenberg",
		"cases_7day_mean_per_100k": 24.8377328994
	},
	{
		"date": "2022-09-05",
		"county": "Muhlenberg",
		"title": "10. Muhlenberg",
		"cases_7day_mean_per_100k": 20.9111795366
	},
	{
		"date": "2022-09-06",
		"county": "Muhlenberg",
		"title": "10. Muhlenberg",
		"cases_7day_mean_per_100k": 19.8153972028
	},
	{
		"date": "2022-09-07",
		"county": "Muhlenberg",
		"title": "10. Muhlenberg",
		"cases_7day_mean_per_100k": 18.3543540911
	},
	{
		"date": "2022-09-08",
		"county": "Muhlenberg",
		"title": "10. Muhlenberg",
		"cases_7day_mean_per_100k": 18.2630388966
	},
	{
		"date": "2022-09-09",
		"county": "Muhlenberg",
		"title": "10. Muhlenberg",
		"cases_7day_mean_per_100k": 18.3543540911
	},
	{
		"date": "2022-09-10",
		"county": "Muhlenberg",
		"title": "10. Muhlenberg",
		"cases_7day_mean_per_100k": 18.9935604525
	},
	{
		"date": "2022-09-11",
		"county": "Muhlenberg",
		"title": "10. Muhlenberg",
		"cases_7day_mean_per_100k": 18.719614869
	},
	{
		"date": "2022-09-12",
		"county": "Muhlenberg",
		"title": "10. Muhlenberg",
		"cases_7day_mean_per_100k": 20.8198643421
	},
	{
		"date": "2022-09-13",
		"county": "Muhlenberg",
		"title": "10. Muhlenberg",
		"cases_7day_mean_per_100k": 17.0759413683
	},
	{
		"date": "2022-09-14",
		"county": "Muhlenberg",
		"title": "10. Muhlenberg",
		"cases_7day_mean_per_100k": 16.7106805904
	},
	{
		"date": "2022-09-15",
		"county": "Muhlenberg",
		"title": "10. Muhlenberg",
		"cases_7day_mean_per_100k": 15.5235830621
	},
	{
		"date": "2022-09-16",
		"county": "Muhlenberg",
		"title": "10. Muhlenberg",
		"cases_7day_mean_per_100k": 14.4278007283
	},
	{
		"date": "2022-09-17",
		"county": "Muhlenberg",
		"title": "10. Muhlenberg",
		"cases_7day_mean_per_100k": 14.0625399504
	},
	{
		"date": "2022-09-18",
		"county": "Muhlenberg",
		"title": "10. Muhlenberg",
		"cases_7day_mean_per_100k": 14.1538551449
	},
	{
		"date": "2022-09-19",
		"county": "Muhlenberg",
		"title": "10. Muhlenberg",
		"cases_7day_mean_per_100k": 12.4188664497
	},
	{
		"date": "2022-09-20",
		"county": "Muhlenberg",
		"title": "10. Muhlenberg",
		"cases_7day_mean_per_100k": 12.1449208663
	},
	{
		"date": "2022-09-21",
		"county": "Muhlenberg",
		"title": "10. Muhlenberg",
		"cases_7day_mean_per_100k": 10.957823338
	},
	{
		"date": "2022-09-22",
		"county": "Muhlenberg",
		"title": "10. Muhlenberg",
		"cases_7day_mean_per_100k": 10.4099321711
	},
	{
		"date": "2022-09-23",
		"county": "Muhlenberg",
		"title": "10. Muhlenberg",
		"cases_7day_mean_per_100k": 10.2273017821
	},
	{
		"date": "2022-09-24",
		"county": "Muhlenberg",
		"title": "10. Muhlenberg",
		"cases_7day_mean_per_100k": 9.4967802262
	},
	{
		"date": "2022-09-25",
		"county": "Muhlenberg",
		"title": "10. Muhlenberg",
		"cases_7day_mean_per_100k": 9.5880954207
	},
	{
		"date": "2022-09-26",
		"county": "Muhlenberg",
		"title": "10. Muhlenberg",
		"cases_7day_mean_per_100k": 9.6794106152
	},
	{
		"date": "2022-09-27",
		"county": "Muhlenberg",
		"title": "10. Muhlenberg",
		"cases_7day_mean_per_100k": 9.4967802262
	},
	{
		"date": "2022-09-28",
		"county": "Muhlenberg",
		"title": "10. Muhlenberg",
		"cases_7day_mean_per_100k": 8.8575738649
	},
	{
		"date": "2022-09-29",
		"county": "Muhlenberg",
		"title": "10. Muhlenberg",
		"cases_7day_mean_per_100k": 9.2228346428
	},
	{
		"date": "2022-09-30",
		"county": "Muhlenberg",
		"title": "10. Muhlenberg",
		"cases_7day_mean_per_100k": 8.5836282814
	},
	{
		"date": "2022-10-01",
		"county": "Muhlenberg",
		"title": "10. Muhlenberg",
		"cases_7day_mean_per_100k": 8.4923130869
	},
	{
		"date": "2022-10-02",
		"county": "Muhlenberg",
		"title": "10. Muhlenberg",
		"cases_7day_mean_per_100k": 8.2183675035
	},
	{
		"date": "2022-10-03",
		"county": "Muhlenberg",
		"title": "10. Muhlenberg",
		"cases_7day_mean_per_100k": 7.8531067255
	},
	{
		"date": "2022-10-04",
		"county": "Muhlenberg",
		"title": "10. Muhlenberg",
		"cases_7day_mean_per_100k": 8.4009978924
	},
	{
		"date": "2022-10-05",
		"county": "Muhlenberg",
		"title": "10. Muhlenberg",
		"cases_7day_mean_per_100k": 8.309682698
	},
	{
		"date": "2022-10-06",
		"county": "Muhlenberg",
		"title": "10. Muhlenberg",
		"cases_7day_mean_per_100k": 7.3052155586
	},
	{
		"date": "2022-10-07",
		"county": "Muhlenberg",
		"title": "10. Muhlenberg",
		"cases_7day_mean_per_100k": 7.8531067255
	},
	{
		"date": "2022-10-08",
		"county": "Muhlenberg",
		"title": "10. Muhlenberg",
		"cases_7day_mean_per_100k": 8.0357371145
	},
	{
		"date": "2022-10-09",
		"county": "Muhlenberg",
		"title": "10. Muhlenberg",
		"cases_7day_mean_per_100k": 7.5791611421
	},
	{
		"date": "2022-10-10",
		"county": "Muhlenberg",
		"title": "10. Muhlenberg",
		"cases_7day_mean_per_100k": 7.7617915311
	},
	{
		"date": "2022-10-11",
		"county": "Muhlenberg",
		"title": "10. Muhlenberg",
		"cases_7day_mean_per_100k": 6.9399547807
	},
	{
		"date": "2022-10-12",
		"county": "Muhlenberg",
		"title": "10. Muhlenberg",
		"cases_7day_mean_per_100k": 6.8486395862
	},
	{
		"date": "2022-10-13",
		"county": "Muhlenberg",
		"title": "10. Muhlenberg",
		"cases_7day_mean_per_100k": 6.4833788083
	},
	{
		"date": "2022-10-14",
		"county": "Muhlenberg",
		"title": "10. Muhlenberg",
		"cases_7day_mean_per_100k": 5.9354876414
	},
	{
		"date": "2022-10-15",
		"county": "Muhlenberg",
		"title": "10. Muhlenberg",
		"cases_7day_mean_per_100k": 5.7528572524
	},
	{
		"date": "2022-10-16",
		"county": "Muhlenberg",
		"title": "10. Muhlenberg",
		"cases_7day_mean_per_100k": 6.8486395862
	},
	{
		"date": "2022-10-17",
		"county": "Muhlenberg",
		"title": "10. Muhlenberg",
		"cases_7day_mean_per_100k": 6.3007484193
	},
	{
		"date": "2022-10-18",
		"county": "Muhlenberg",
		"title": "10. Muhlenberg",
		"cases_7day_mean_per_100k": 6.6660091973
	},
	{
		"date": "2022-10-19",
		"county": "Muhlenberg",
		"title": "10. Muhlenberg",
		"cases_7day_mean_per_100k": 6.8486395862
	},
	{
		"date": "2022-10-20",
		"county": "Muhlenberg",
		"title": "10. Muhlenberg",
		"cases_7day_mean_per_100k": 7.6704763366
	},
	{
		"date": "2022-10-21",
		"county": "Muhlenberg",
		"title": "10. Muhlenberg",
		"cases_7day_mean_per_100k": 8.309682698
	},
	{
		"date": "2022-10-22",
		"county": "Muhlenberg",
		"title": "10. Muhlenberg",
		"cases_7day_mean_per_100k": 8.127052309
	},
	{
		"date": "2022-10-23",
		"county": "Muhlenberg",
		"title": "10. Muhlenberg",
		"cases_7day_mean_per_100k": 7.2139003642
	},
	{
		"date": "2022-10-24",
		"county": "Muhlenberg",
		"title": "10. Muhlenberg",
		"cases_7day_mean_per_100k": 8.127052309
	},
	{
		"date": "2022-10-25",
		"county": "Muhlenberg",
		"title": "10. Muhlenberg",
		"cases_7day_mean_per_100k": 8.5836282814
	},
	{
		"date": "2022-10-26",
		"county": "Muhlenberg",
		"title": "10. Muhlenberg",
		"cases_7day_mean_per_100k": 8.4009978924
	},
	{
		"date": "2022-10-27",
		"county": "Muhlenberg",
		"title": "10. Muhlenberg",
		"cases_7day_mean_per_100k": 7.5791611421
	},
	{
		"date": "2022-10-28",
		"county": "Muhlenberg",
		"title": "10. Muhlenberg",
		"cases_7day_mean_per_100k": 11.6883448938
	},
	{
		"date": "2022-10-29",
		"county": "Muhlenberg",
		"title": "10. Muhlenberg",
		"cases_7day_mean_per_100k": 11.5970296994
	},
	{
		"date": "2022-10-30",
		"county": "Muhlenberg",
		"title": "10. Muhlenberg",
		"cases_7day_mean_per_100k": 11.7796600883
	},
	{
		"date": "2022-10-31",
		"county": "Muhlenberg",
		"title": "10. Muhlenberg",
		"cases_7day_mean_per_100k": 10.6838777545
	},
	{
		"date": "2022-11-01",
		"county": "Muhlenberg",
		"title": "10. Muhlenberg",
		"cases_7day_mean_per_100k": 10.8665081435
	},
	{
		"date": "2022-11-02",
		"county": "Muhlenberg",
		"title": "10. Muhlenberg",
		"cases_7day_mean_per_100k": 11.1404537269
	},
	{
		"date": "2022-11-03",
		"county": "Muhlenberg",
		"title": "10. Muhlenberg",
		"cases_7day_mean_per_100k": 11.9622904773
	},
	{
		"date": "2022-11-04",
		"county": "Muhlenberg",
		"title": "10. Muhlenberg",
		"cases_7day_mean_per_100k": 7.8531067255
	},
	{
		"date": "2022-11-05",
		"county": "Muhlenberg",
		"title": "10. Muhlenberg",
		"cases_7day_mean_per_100k": 8.6749434759
	},
	{
		"date": "2022-11-06",
		"county": "Muhlenberg",
		"title": "10. Muhlenberg",
		"cases_7day_mean_per_100k": 9.1315194483
	},
	{
		"date": "2022-11-07",
		"county": "Muhlenberg",
		"title": "10. Muhlenberg",
		"cases_7day_mean_per_100k": 8.309682698
	},
	{
		"date": "2022-11-08",
		"county": "Muhlenberg",
		"title": "10. Muhlenberg",
		"cases_7day_mean_per_100k": 6.4833788083
	},
	{
		"date": "2022-03-01",
		"county": "Jefferson",
		"title": "6. Jefferson",
		"cases_7day_mean_per_100k": 10.6472024201
	},
	{
		"date": "2022-03-02",
		"county": "Jefferson",
		"title": "6. Jefferson",
		"cases_7day_mean_per_100k": 9.9327465873
	},
	{
		"date": "2022-03-03",
		"county": "Jefferson",
		"title": "6. Jefferson",
		"cases_7day_mean_per_100k": 9.2433593802
	},
	{
		"date": "2022-03-04",
		"county": "Jefferson",
		"title": "6. Jefferson",
		"cases_7day_mean_per_100k": 8.6389269603
	},
	{
		"date": "2022-03-05",
		"county": "Jefferson",
		"title": "6. Jefferson",
		"cases_7day_mean_per_100k": 8.5539721732
	},
	{
		"date": "2022-03-06",
		"county": "Jefferson",
		"title": "6. Jefferson",
		"cases_7day_mean_per_100k": 8.2628975747
	},
	{
		"date": "2022-03-07",
		"county": "Jefferson",
		"title": "6. Jefferson",
		"cases_7day_mean_per_100k": 7.7336710319
	},
	{
		"date": "2022-03-08",
		"county": "Jefferson",
		"title": "6. Jefferson",
		"cases_7day_mean_per_100k": 7.2309058162
	},
	{
		"date": "2022-03-09",
		"county": "Jefferson",
		"title": "6. Jefferson",
		"cases_7day_mean_per_100k": 6.8701961463
	},
	{
		"date": "2022-03-10",
		"county": "Jefferson",
		"title": "6. Jefferson",
		"cases_7day_mean_per_100k": 6.5484821163
	},
	{
		"date": "2022-03-11",
		"county": "Jefferson",
		"title": "6. Jefferson",
		"cases_7day_mean_per_100k": 6.3061520678
	},
	{
		"date": "2022-03-12",
		"county": "Jefferson",
		"title": "6. Jefferson",
		"cases_7day_mean_per_100k": 6.0206482749
	},
	{
		"date": "2022-03-13",
		"county": "Jefferson",
		"title": "6. Jefferson",
		"cases_7day_mean_per_100k": 5.9732964264
	},
	{
		"date": "2022-03-14",
		"county": "Jefferson",
		"title": "6. Jefferson",
		"cases_7day_mean_per_100k": 5.6863999321
	},
	{
		"date": "2022-03-15",
		"county": "Jefferson",
		"title": "6. Jefferson",
		"cases_7day_mean_per_100k": 5.4426771822
	},
	{
		"date": "2022-03-16",
		"county": "Jefferson",
		"title": "6. Jefferson",
		"cases_7day_mean_per_100k": 5.4371063764
	},
	{
		"date": "2022-03-17",
		"county": "Jefferson",
		"title": "6. Jefferson",
		"cases_7day_mean_per_100k": 5.4092523479
	},
	{
		"date": "2022-03-18",
		"county": "Jefferson",
		"title": "6. Jefferson",
		"cases_7day_mean_per_100k": 5.5554859979
	},
	{
		"date": "2022-03-19",
		"county": "Jefferson",
		"title": "6. Jefferson",
		"cases_7day_mean_per_100k": 5.5986597421
	},
	{
		"date": "2022-03-20",
		"county": "Jefferson",
		"title": "6. Jefferson",
		"cases_7day_mean_per_100k": 5.6627240078
	},
	{
		"date": "2022-03-21",
		"county": "Jefferson",
		"title": "6. Jefferson",
		"cases_7day_mean_per_100k": 5.7602131078
	},
	{
		"date": "2022-03-22",
		"county": "Jefferson",
		"title": "6. Jefferson",
		"cases_7day_mean_per_100k": 6.0805344364
	},
	{
		"date": "2022-03-23",
		"county": "Jefferson",
		"title": "6. Jefferson",
		"cases_7day_mean_per_100k": 6.0512877064
	},
	{
		"date": "2022-03-24",
		"county": "Jefferson",
		"title": "6. Jefferson",
		"cases_7day_mean_per_100k": 6.1209227778
	},
	{
		"date": "2022-03-25",
		"county": "Jefferson",
		"title": "6. Jefferson",
		"cases_7day_mean_per_100k": 6.0025431564
	},
	{
		"date": "2022-03-26",
		"county": "Jefferson",
		"title": "6. Jefferson",
		"cases_7day_mean_per_100k": 6.1000322564
	},
	{
		"date": "2022-03-27",
		"county": "Jefferson",
		"title": "6. Jefferson",
		"cases_7day_mean_per_100k": 6.2100556692
	},
	{
		"date": "2022-03-28",
		"county": "Jefferson",
		"title": "6. Jefferson",
		"cases_7day_mean_per_100k": 6.2379096978
	},
	{
		"date": "2022-03-29",
		"county": "Jefferson",
		"title": "6. Jefferson",
		"cases_7day_mean_per_100k": 6.2518367121
	},
	{
		"date": "2022-03-30",
		"county": "Jefferson",
		"title": "6. Jefferson",
		"cases_7day_mean_per_100k": 6.4774543435
	},
	{
		"date": "2022-03-31",
		"county": "Jefferson",
		"title": "6. Jefferson",
		"cases_7day_mean_per_100k": 6.6766106477
	},
	{
		"date": "2022-04-01",
		"county": "Jefferson",
		"title": "6. Jefferson",
		"cases_7day_mean_per_100k": 6.9175479948
	},
	{
		"date": "2022-04-02",
		"county": "Jefferson",
		"title": "6. Jefferson",
		"cases_7day_mean_per_100k": 7.0192151991
	},
	{
		"date": "2022-04-03",
		"county": "Jefferson",
		"title": "6. Jefferson",
		"cases_7day_mean_per_100k": 7.1097407919
	},
	{
		"date": "2022-04-04",
		"county": "Jefferson",
		"title": "6. Jefferson",
		"cases_7day_mean_per_100k": 7.6417527376
	},
	{
		"date": "2022-04-05",
		"county": "Jefferson",
		"title": "6. Jefferson",
		"cases_7day_mean_per_100k": 7.9578959618
	},
	{
		"date": "2022-04-06",
		"county": "Jefferson",
		"title": "6. Jefferson",
		"cases_7day_mean_per_100k": 8.2712537832
	},
	{
		"date": "2022-04-07",
		"county": "Jefferson",
		"title": "6. Jefferson",
		"cases_7day_mean_per_100k": 8.586004306
	},
	{
		"date": "2022-04-08",
		"county": "Jefferson",
		"title": "6. Jefferson",
		"cases_7day_mean_per_100k": 8.8158000417
	},
	{
		"date": "2022-04-09",
		"county": "Jefferson",
		"title": "6. Jefferson",
		"cases_7day_mean_per_100k": 9.0024220331
	},
	{
		"date": "2022-04-10",
		"county": "Jefferson",
		"title": "6. Jefferson",
		"cases_7day_mean_per_100k": 9.2322177688
	},
	{
		"date": "2022-04-11",
		"county": "Jefferson",
		"title": "6. Jefferson",
		"cases_7day_mean_per_100k": 9.4160543574
	},
	{
		"date": "2022-04-12",
		"county": "Jefferson",
		"title": "6. Jefferson",
		"cases_7day_mean_per_100k": 9.636101183
	},
	{
		"date": "2022-04-13",
		"county": "Jefferson",
		"title": "6. Jefferson",
		"cases_7day_mean_per_100k": 9.8979290516
	},
	{
		"date": "2022-04-14",
		"county": "Jefferson",
		"title": "6. Jefferson",
		"cases_7day_mean_per_100k": 10.1945744558
	},
	{
		"date": "2022-04-15",
		"county": "Jefferson",
		"title": "6. Jefferson",
		"cases_7day_mean_per_100k": 10.4424753101
	},
	{
		"date": "2022-04-16",
		"county": "Jefferson",
		"title": "6. Jefferson",
		"cases_7day_mean_per_100k": 10.6444170172
	},
	{
		"date": "2022-04-17",
		"county": "Jefferson",
		"title": "6. Jefferson",
		"cases_7day_mean_per_100k": 10.6903761643
	},
	{
		"date": "2022-04-18",
		"county": "Jefferson",
		"title": "6. Jefferson",
		"cases_7day_mean_per_100k": 11.6137372114
	},
	{
		"date": "2022-04-19",
		"county": "Jefferson",
		"title": "6. Jefferson",
		"cases_7day_mean_per_100k": 12.4145405327
	},
	{
		"date": "2022-04-20",
		"county": "Jefferson",
		"title": "6. Jefferson",
		"cases_7day_mean_per_100k": 13.1805263183
	},
	{
		"date": "2022-04-21",
		"county": "Jefferson",
		"title": "6. Jefferson",
		"cases_7day_mean_per_100k": 13.8406667954
	},
	{
		"date": "2022-04-22",
		"county": "Jefferson",
		"title": "6. Jefferson",
		"cases_7day_mean_per_100k": 14.616401491
	},
	{
		"date": "2022-04-23",
		"county": "Jefferson",
		"title": "6. Jefferson",
		"cases_7day_mean_per_100k": 15.0564951423
	},
	{
		"date": "2022-04-24",
		"county": "Jefferson",
		"title": "6. Jefferson",
		"cases_7day_mean_per_100k": 15.364282158
	},
	{
		"date": "2022-04-25",
		"county": "Jefferson",
		"title": "6. Jefferson",
		"cases_7day_mean_per_100k": 15.851727658
	},
	{
		"date": "2022-04-26",
		"county": "Jefferson",
		"title": "6. Jefferson",
		"cases_7day_mean_per_100k": 16.609357235
	},
	{
		"date": "2022-04-27",
		"county": "Jefferson",
		"title": "6. Jefferson",
		"cases_7day_mean_per_100k": 17.4407999878
	},
	{
		"date": "2022-04-28",
		"county": "Jefferson",
		"title": "6. Jefferson",
		"cases_7day_mean_per_100k": 18.2708500391
	},
	{
		"date": "2022-04-29",
		"county": "Jefferson",
		"title": "6. Jefferson",
		"cases_7day_mean_per_100k": 18.8543919376
	},
	{
		"date": "2022-04-30",
		"county": "Jefferson",
		"title": "6. Jefferson",
		"cases_7day_mean_per_100k": 19.1510373418
	},
	{
		"date": "2022-05-01",
		"county": "Jefferson",
		"title": "6. Jefferson",
		"cases_7day_mean_per_100k": 19.759647866
	},
	{
		"date": "2022-05-02",
		"county": "Jefferson",
		"title": "6. Jefferson",
		"cases_7day_mean_per_100k": 20.6941505245
	},
	{
		"date": "2022-05-03",
		"county": "Jefferson",
		"title": "6. Jefferson",
		"cases_7day_mean_per_100k": 21.6216896758
	},
	{
		"date": "2022-05-04",
		"county": "Jefferson",
		"title": "6. Jefferson",
		"cases_7day_mean_per_100k": 22.5603704385
	},
	{
		"date": "2022-05-05",
		"county": "Jefferson",
		"title": "6. Jefferson",
		"cases_7day_mean_per_100k": 23.1856933799
	},
	{
		"date": "2022-05-06",
		"county": "Jefferson",
		"title": "6. Jefferson",
		"cases_7day_mean_per_100k": 23.9140762269
	},
	{
		"date": "2022-05-07",
		"county": "Jefferson",
		"title": "6. Jefferson",
		"cases_7day_mean_per_100k": 24.6396736711
	},
	{
		"date": "2022-05-08",
		"county": "Jefferson",
		"title": "6. Jefferson",
		"cases_7day_mean_per_100k": 24.9418898811
	},
	{
		"date": "2022-05-09",
		"county": "Jefferson",
		"title": "6. Jefferson",
		"cases_7day_mean_per_100k": 25.7371223967
	},
	{
		"date": "2022-05-10",
		"county": "Jefferson",
		"title": "6. Jefferson",
		"cases_7day_mean_per_100k": 26.1786087495
	},
	{
		"date": "2022-05-11",
		"county": "Jefferson",
		"title": "6. Jefferson",
		"cases_7day_mean_per_100k": 26.5017154809
	},
	{
		"date": "2022-05-12",
		"county": "Jefferson",
		"title": "6. Jefferson",
		"cases_7day_mean_per_100k": 27.0003025922
	},
	{
		"date": "2022-05-13",
		"county": "Jefferson",
		"title": "6. Jefferson",
		"cases_7day_mean_per_100k": 27.870740985
	},
	{
		"date": "2022-05-14",
		"county": "Jefferson",
		"title": "6. Jefferson",
		"cases_7day_mean_per_100k": 28.0322943507
	},
	{
		"date": "2022-05-15",
		"county": "Jefferson",
		"title": "6. Jefferson",
		"cases_7day_mean_per_100k": 28.4779588078
	},
	{
		"date": "2022-05-16",
		"county": "Jefferson",
		"title": "6. Jefferson",
		"cases_7day_mean_per_100k": 29.9138339804
	},
	{
		"date": "2022-05-17",
		"county": "Jefferson",
		"title": "6. Jefferson",
		"cases_7day_mean_per_100k": 31.4263077317
	},
	{
		"date": "2022-05-18",
		"county": "Jefferson",
		"title": "6. Jefferson",
		"cases_7day_mean_per_100k": 33.1727553229
	},
	{
		"date": "2022-05-19",
		"county": "Jefferson",
		"title": "6. Jefferson",
		"cases_7day_mean_per_100k": 34.8481751412
	},
	{
		"date": "2022-05-20",
		"county": "Jefferson",
		"title": "6. Jefferson",
		"cases_7day_mean_per_100k": 35.8871304068
	},
	{
		"date": "2022-05-21",
		"county": "Jefferson",
		"title": "6. Jefferson",
		"cases_7day_mean_per_100k": 36.4595306939
	},
	{
		"date": "2022-05-22",
		"county": "Jefferson",
		"title": "6. Jefferson",
		"cases_7day_mean_per_100k": 36.9998988481
	},
	{
		"date": "2022-05-23",
		"county": "Jefferson",
		"title": "6. Jefferson",
		"cases_7day_mean_per_100k": 38.761666155
	},
	{
		"date": "2022-05-24",
		"county": "Jefferson",
		"title": "6. Jefferson",
		"cases_7day_mean_per_100k": 40.1320843605
	},
	{
		"date": "2022-05-25",
		"county": "Jefferson",
		"title": "6. Jefferson",
		"cases_7day_mean_per_100k": 41.164076119
	},
	{
		"date": "2022-05-26",
		"county": "Jefferson",
		"title": "6. Jefferson",
		"cases_7day_mean_per_100k": 41.5582106232
	},
	{
		"date": "2022-05-27",
		"county": "Jefferson",
		"title": "6. Jefferson",
		"cases_7day_mean_per_100k": 41.8492852218
	},
	{
		"date": "2022-05-28",
		"county": "Jefferson",
		"title": "6. Jefferson",
		"cases_7day_mean_per_100k": 41.8451071175
	},
	{
		"date": "2022-05-29",
		"county": "Jefferson",
		"title": "6. Jefferson",
		"cases_7day_mean_per_100k": 41.3966572575
	},
	{
		"date": "2022-05-30",
		"county": "Jefferson",
		"title": "6. Jefferson",
		"cases_7day_mean_per_100k": 36.2729087025
	},
	{
		"date": "2022-05-31",
		"county": "Jefferson",
		"title": "6. Jefferson",
		"cases_7day_mean_per_100k": 38.917648715
	},
	{
		"date": "2022-06-01",
		"county": "Jefferson",
		"title": "6. Jefferson",
		"cases_7day_mean_per_100k": 40.0081339334
	},
	{
		"date": "2022-06-02",
		"county": "Jefferson",
		"title": "6. Jefferson",
		"cases_7day_mean_per_100k": 41.0819067347
	},
	{
		"date": "2022-06-03",
		"county": "Jefferson",
		"title": "6. Jefferson",
		"cases_7day_mean_per_100k": 42.1250401046
	},
	{
		"date": "2022-06-04",
		"county": "Jefferson",
		"title": "6. Jefferson",
		"cases_7day_mean_per_100k": 42.8896331888
	},
	{
		"date": "2022-06-05",
		"county": "Jefferson",
		"title": "6. Jefferson",
		"cases_7day_mean_per_100k": 43.5483809644
	},
	{
		"date": "2022-06-06",
		"county": "Jefferson",
		"title": "6. Jefferson",
		"cases_7day_mean_per_100k": 48.9283865823
	},
	{
		"date": "2022-06-07",
		"county": "Jefferson",
		"title": "6. Jefferson",
		"cases_7day_mean_per_100k": 46.5747211683
	},
	{
		"date": "2022-06-08",
		"county": "Jefferson",
		"title": "6. Jefferson",
		"cases_7day_mean_per_100k": 45.5385513056
	},
	{
		"date": "2022-06-09",
		"county": "Jefferson",
		"title": "6. Jefferson",
		"cases_7day_mean_per_100k": 44.4675639071
	},
	{
		"date": "2022-06-10",
		"county": "Jefferson",
		"title": "6. Jefferson",
		"cases_7day_mean_per_100k": 43.7391810601
	},
	{
		"date": "2022-06-11",
		"county": "Jefferson",
		"title": "6. Jefferson",
		"cases_7day_mean_per_100k": 43.4996364144
	},
	{
		"date": "2022-06-12",
		"county": "Jefferson",
		"title": "6. Jefferson",
		"cases_7day_mean_per_100k": 43.3408684516
	},
	{
		"date": "2022-06-13",
		"county": "Jefferson",
		"title": "6. Jefferson",
		"cases_7day_mean_per_100k": 41.7712939418
	},
	{
		"date": "2022-06-14",
		"county": "Jefferson",
		"title": "6. Jefferson",
		"cases_7day_mean_per_100k": 40.2741399062
	},
	{
		"date": "2022-06-15",
		"county": "Jefferson",
		"title": "6. Jefferson",
		"cases_7day_mean_per_100k": 39.151622555
	},
	{
		"date": "2022-06-16",
		"county": "Jefferson",
		"title": "6. Jefferson",
		"cases_7day_mean_per_100k": 38.693423785
	},
	{
		"date": "2022-06-17",
		"county": "Jefferson",
		"title": "6. Jefferson",
		"cases_7day_mean_per_100k": 38.1321651094
	},
	{
		"date": "2022-06-18",
		"county": "Jefferson",
		"title": "6. Jefferson",
		"cases_7day_mean_per_100k": 38.2951111765
	},
	{
		"date": "2022-06-19",
		"county": "Jefferson",
		"title": "6. Jefferson",
		"cases_7day_mean_per_100k": 38.4288105136
	},
	{
		"date": "2022-06-20",
		"county": "Jefferson",
		"title": "6. Jefferson",
		"cases_7day_mean_per_100k": 38.3619608451
	},
	{
		"date": "2022-06-21",
		"county": "Jefferson",
		"title": "6. Jefferson",
		"cases_7day_mean_per_100k": 39.5346154478
	},
	{
		"date": "2022-06-22",
		"county": "Jefferson",
		"title": "6. Jefferson",
		"cases_7day_mean_per_100k": 39.9398915634
	},
	{
		"date": "2022-06-23",
		"county": "Jefferson",
		"title": "6. Jefferson",
		"cases_7day_mean_per_100k": 40.8674307147
	},
	{
		"date": "2022-06-24",
		"county": "Jefferson",
		"title": "6. Jefferson",
		"cases_7day_mean_per_100k": 41.8019333732
	},
	{
		"date": "2022-06-25",
		"county": "Jefferson",
		"title": "6. Jefferson",
		"cases_7day_mean_per_100k": 42.4105438974
	},
	{
		"date": "2022-06-26",
		"county": "Jefferson",
		"title": "6. Jefferson",
		"cases_7day_mean_per_100k": 43.2169180244
	},
	{
		"date": "2022-06-27",
		"county": "Jefferson",
		"title": "6. Jefferson",
		"cases_7day_mean_per_100k": 45.5747615427
	},
	{
		"date": "2022-06-28",
		"county": "Jefferson",
		"title": "6. Jefferson",
		"cases_7day_mean_per_100k": 46.687529984
	},
	{
		"date": "2022-06-29",
		"county": "Jefferson",
		"title": "6. Jefferson",
		"cases_7day_mean_per_100k": 48.2208942567
	},
	{
		"date": "2022-06-30",
		"county": "Jefferson",
		"title": "6. Jefferson",
		"cases_7day_mean_per_100k": 49.1205793794
	},
	{
		"date": "2022-07-01",
		"county": "Jefferson",
		"title": "6. Jefferson",
		"cases_7day_mean_per_100k": 50.1344660193
	},
	{
		"date": "2022-07-02",
		"county": "Jefferson",
		"title": "6. Jefferson",
		"cases_7day_mean_per_100k": 50.4130063049
	},
	{
		"date": "2022-07-03",
		"county": "Jefferson",
		"title": "6. Jefferson",
		"cases_7day_mean_per_100k": 49.9993739807
	},
	{
		"date": "2022-07-04",
		"county": "Jefferson",
		"title": "6. Jefferson",
		"cases_7day_mean_per_100k": 44.6876107328
	},
	{
		"date": "2022-07-05",
		"county": "Jefferson",
		"title": "6. Jefferson",
		"cases_7day_mean_per_100k": 47.8392940653
	},
	{
		"date": "2022-07-06",
		"county": "Jefferson",
		"title": "6. Jefferson",
		"cases_7day_mean_per_100k": 49.2292100908
	},
	{
		"date": "2022-07-07",
		"county": "Jefferson",
		"title": "6. Jefferson",
		"cases_7day_mean_per_100k": 50.3795814707
	},
	{
		"date": "2022-07-08",
		"county": "Jefferson",
		"title": "6. Jefferson",
		"cases_7day_mean_per_100k": 51.6831500076
	},
	{
		"date": "2022-07-09",
		"county": "Jefferson",
		"title": "6. Jefferson",
		"cases_7day_mean_per_100k": 52.7861695389
	},
	{
		"date": "2022-07-10",
		"county": "Jefferson",
		"title": "6. Jefferson",
		"cases_7day_mean_per_100k": 53.8877963688
	},
	{
		"date": "2022-07-11",
		"county": "Jefferson",
		"title": "6. Jefferson",
		"cases_7day_mean_per_100k": 60.1967338394
	},
	{
		"date": "2022-07-12",
		"county": "Jefferson",
		"title": "6. Jefferson",
		"cases_7day_mean_per_100k": 58.3388701339
	},
	{
		"date": "2022-07-13",
		"county": "Jefferson",
		"title": "6. Jefferson",
		"cases_7day_mean_per_100k": 58.1717459625
	},
	{
		"date": "2022-07-14",
		"county": "Jefferson",
		"title": "6. Jefferson",
		"cases_7day_mean_per_100k": 58.482318381
	},
	{
		"date": "2022-07-15",
		"county": "Jefferson",
		"title": "6. Jefferson",
		"cases_7day_mean_per_100k": 58.2789839725
	},
	{
		"date": "2022-07-16",
		"county": "Jefferson",
		"title": "6. Jefferson",
		"cases_7day_mean_per_100k": 58.1619970525
	},
	{
		"date": "2022-07-17",
		"county": "Jefferson",
		"title": "6. Jefferson",
		"cases_7day_mean_per_100k": 58.1090743982
	},
	{
		"date": "2022-07-18",
		"county": "Jefferson",
		"title": "6. Jefferson",
		"cases_7day_mean_per_100k": 58.0993254882
	},
	{
		"date": "2022-07-19",
		"county": "Jefferson",
		"title": "6. Jefferson",
		"cases_7day_mean_per_100k": 57.6620172397
	},
	{
		"date": "2022-07-20",
		"county": "Jefferson",
		"title": "6. Jefferson",
		"cases_7day_mean_per_100k": 56.7874007427
	},
	{
		"date": "2022-07-21",
		"county": "Jefferson",
		"title": "6. Jefferson",
		"cases_7day_mean_per_100k": 55.3111372286
	},
	{
		"date": "2022-07-22",
		"county": "Jefferson",
		"title": "6. Jefferson",
		"cases_7day_mean_per_100k": 54.5005849973
	},
	{
		"date": "2022-07-23",
		"county": "Jefferson",
		"title": "6. Jefferson",
		"cases_7day_mean_per_100k": 53.5800093531
	},
	{
		"date": "2022-07-24",
		"county": "Jefferson",
		"title": "6. Jefferson",
		"cases_7day_mean_per_100k": 52.7012147518
	},
	{
		"date": "2022-07-25",
		"county": "Jefferson",
		"title": "6. Jefferson",
		"cases_7day_mean_per_100k": 51.5661630876
	},
	{
		"date": "2022-07-26",
		"county": "Jefferson",
		"title": "6. Jefferson",
		"cases_7day_mean_per_100k": 50.1859959721
	},
	{
		"date": "2022-07-27",
		"county": "Jefferson",
		"title": "6. Jefferson",
		"cases_7day_mean_per_100k": 48.5857820309
	},
	{
		"date": "2022-07-28",
		"county": "Jefferson",
		"title": "6. Jefferson",
		"cases_7day_mean_per_100k": 47.4200909353
	},
	{
		"date": "2022-07-29",
		"county": "Jefferson",
		"title": "6. Jefferson",
		"cases_7day_mean_per_100k": 45.6360404056
	},
	{
		"date": "2022-07-30",
		"county": "Jefferson",
		"title": "6. Jefferson",
		"cases_7day_mean_per_100k": 44.7098939557
	},
	{
		"date": "2022-07-31",
		"county": "Jefferson",
		"title": "6. Jefferson",
		"cases_7day_mean_per_100k": 44.2196630529
	},
	{
		"date": "2022-08-01",
		"county": "Jefferson",
		"title": "6. Jefferson",
		"cases_7day_mean_per_100k": 42.506640296
	},
	{
		"date": "2022-08-02",
		"county": "Jefferson",
		"title": "6. Jefferson",
		"cases_7day_mean_per_100k": 40.9802395304
	},
	{
		"date": "2022-08-03",
		"county": "Jefferson",
		"title": "6. Jefferson",
		"cases_7day_mean_per_100k": 40.0401660663
	},
	{
		"date": "2022-08-04",
		"county": "Jefferson",
		"title": "6. Jefferson",
		"cases_7day_mean_per_100k": 38.5917565807
	},
	{
		"date": "2022-08-05",
		"county": "Jefferson",
		"title": "6. Jefferson",
		"cases_7day_mean_per_100k": 37.740816008
	},
	{
		"date": "2022-08-06",
		"county": "Jefferson",
		"title": "6. Jefferson",
		"cases_7day_mean_per_100k": 37.2436215981
	},
	{
		"date": "2022-08-07",
		"county": "Jefferson",
		"title": "6. Jefferson",
		"cases_7day_mean_per_100k": 36.8494870938
	},
	{
		"date": "2022-08-08",
		"county": "Jefferson",
		"title": "6. Jefferson",
		"cases_7day_mean_per_100k": 35.7255770411
	},
	{
		"date": "2022-08-09",
		"county": "Jefferson",
		"title": "6. Jefferson",
		"cases_7day_mean_per_100k": 34.1977835742
	},
	{
		"date": "2022-08-10",
		"county": "Jefferson",
		"title": "6. Jefferson",
		"cases_7day_mean_per_100k": 33.0181654643
	},
	{
		"date": "2022-08-11",
		"county": "Jefferson",
		"title": "6. Jefferson",
		"cases_7day_mean_per_100k": 32.3023169301
	},
	{
		"date": "2022-08-12",
		"county": "Jefferson",
		"title": "6. Jefferson",
		"cases_7day_mean_per_100k": 31.2828594845
	},
	{
		"date": "2022-08-13",
		"county": "Jefferson",
		"title": "6. Jefferson",
		"cases_7day_mean_per_100k": 30.7048883918
	},
	{
		"date": "2022-08-14",
		"county": "Jefferson",
		"title": "6. Jefferson",
		"cases_7day_mean_per_100k": 30.2285845033
	},
	{
		"date": "2022-08-15",
		"county": "Jefferson",
		"title": "6. Jefferson",
		"cases_7day_mean_per_100k": 28.9960437391
	},
	{
		"date": "2022-08-16",
		"county": "Jefferson",
		"title": "6. Jefferson",
		"cases_7day_mean_per_100k": 28.677115112
	},
	{
		"date": "2022-08-17",
		"county": "Jefferson",
		"title": "6. Jefferson",
		"cases_7day_mean_per_100k": 28.0712899907
	},
	{
		"date": "2022-08-18",
		"county": "Jefferson",
		"title": "6. Jefferson",
		"cases_7day_mean_per_100k": 27.4863553907
	},
	{
		"date": "2022-08-19",
		"county": "Jefferson",
		"title": "6. Jefferson",
		"cases_7day_mean_per_100k": 26.7844338708
	},
	{
		"date": "2022-08-20",
		"county": "Jefferson",
		"title": "6. Jefferson",
		"cases_7day_mean_per_100k": 26.4125825895
	},
	{
		"date": "2022-08-21",
		"county": "Jefferson",
		"title": "6. Jefferson",
		"cases_7day_mean_per_100k": 26.0309823981
	},
	{
		"date": "2022-08-22",
		"county": "Jefferson",
		"title": "6. Jefferson",
		"cases_7day_mean_per_100k": 25.6089938653
	},
	{
		"date": "2022-08-23",
		"county": "Jefferson",
		"title": "6. Jefferson",
		"cases_7day_mean_per_100k": 24.9223920611
	},
	{
		"date": "2022-08-24",
		"county": "Jefferson",
		"title": "6. Jefferson",
		"cases_7day_mean_per_100k": 24.3374574612
	},
	{
		"date": "2022-08-25",
		"county": "Jefferson",
		"title": "6. Jefferson",
		"cases_7day_mean_per_100k": 23.7288469369
	},
	{
		"date": "2022-08-26",
		"county": "Jefferson",
		"title": "6. Jefferson",
		"cases_7day_mean_per_100k": 23.2748262713
	},
	{
		"date": "2022-08-27",
		"county": "Jefferson",
		"title": "6. Jefferson",
		"cases_7day_mean_per_100k": 22.6940697757
	},
	{
		"date": "2022-08-28",
		"county": "Jefferson",
		"title": "6. Jefferson",
		"cases_7day_mean_per_100k": 22.31804039
	},
	{
		"date": "2022-08-29",
		"county": "Jefferson",
		"title": "6. Jefferson",
		"cases_7day_mean_per_100k": 21.5255932772
	},
	{
		"date": "2022-08-30",
		"county": "Jefferson",
		"title": "6. Jefferson",
		"cases_7day_mean_per_100k": 20.5493095759
	},
	{
		"date": "2022-08-31",
		"county": "Jefferson",
		"title": "6. Jefferson",
		"cases_7day_mean_per_100k": 19.7749675817
	},
	{
		"date": "2022-09-01",
		"county": "Jefferson",
		"title": "6. Jefferson",
		"cases_7day_mean_per_100k": 19.0229088104
	},
	{
		"date": "2022-09-02",
		"county": "Jefferson",
		"title": "6. Jefferson",
		"cases_7day_mean_per_100k": 18.2234981905
	},
	{
		"date": "2022-09-03",
		"county": "Jefferson",
		"title": "6. Jefferson",
		"cases_7day_mean_per_100k": 17.7235183777
	},
	{
		"date": "2022-09-04",
		"county": "Jefferson",
		"title": "6. Jefferson",
		"cases_7day_mean_per_100k": 17.2082188492
	},
	{
		"date": "2022-09-05",
		"county": "Jefferson",
		"title": "6. Jefferson",
		"cases_7day_mean_per_100k": 14.7765621552
	},
	{
		"date": "2022-09-06",
		"county": "Jefferson",
		"title": "6. Jefferson",
		"cases_7day_mean_per_100k": 15.0620659481
	},
	{
		"date": "2022-09-07",
		"county": "Jefferson",
		"title": "6. Jefferson",
		"cases_7day_mean_per_100k": 14.6345066095
	},
	{
		"date": "2022-09-08",
		"county": "Jefferson",
		"title": "6. Jefferson",
		"cases_7day_mean_per_100k": 14.3197560867
	},
	{
		"date": "2022-09-09",
		"county": "Jefferson",
		"title": "6. Jefferson",
		"cases_7day_mean_per_100k": 14.1540246167
	},
	{
		"date": "2022-09-10",
		"county": "Jefferson",
		"title": "6. Jefferson",
		"cases_7day_mean_per_100k": 14.1359194982
	},
	{
		"date": "2022-09-11",
		"county": "Jefferson",
		"title": "6. Jefferson",
		"cases_7day_mean_per_100k": 14.1164216782
	},
	{
		"date": "2022-09-12",
		"county": "Jefferson",
		"title": "6. Jefferson",
		"cases_7day_mean_per_100k": 15.2305828209
	},
	{
		"date": "2022-09-13",
		"county": "Jefferson",
		"title": "6. Jefferson",
		"cases_7day_mean_per_100k": 13.9743661325
	},
	{
		"date": "2022-09-14",
		"county": "Jefferson",
		"title": "6. Jefferson",
		"cases_7day_mean_per_100k": 13.3351161769
	},
	{
		"date": "2022-09-15",
		"county": "Jefferson",
		"title": "6. Jefferson",
		"cases_7day_mean_per_100k": 12.8574195869
	},
	{
		"date": "2022-09-16",
		"county": "Jefferson",
		"title": "6. Jefferson",
		"cases_7day_mean_per_100k": 12.4396091584
	},
	{
		"date": "2022-09-17",
		"county": "Jefferson",
		"title": "6. Jefferson",
		"cases_7day_mean_per_100k": 12.2376674513
	},
	{
		"date": "2022-09-18",
		"county": "Jefferson",
		"title": "6. Jefferson",
		"cases_7day_mean_per_100k": 12.0858629956
	},
	{
		"date": "2022-09-19",
		"county": "Jefferson",
		"title": "6. Jefferson",
		"cases_7day_mean_per_100k": 11.8031446056
	},
	{
		"date": "2022-09-20",
		"county": "Jefferson",
		"title": "6. Jefferson",
		"cases_7day_mean_per_100k": 11.5900612871
	},
	{
		"date": "2022-09-21",
		"county": "Jefferson",
		"title": "6. Jefferson",
		"cases_7day_mean_per_100k": 11.3644436557
	},
	{
		"date": "2022-09-22",
		"county": "Jefferson",
		"title": "6. Jefferson",
		"cases_7day_mean_per_100k": 11.2502421386
	},
	{
		"date": "2022-09-23",
		"county": "Jefferson",
		"title": "6. Jefferson",
		"cases_7day_mean_per_100k": 11.0886887729
	},
	{
		"date": "2022-09-24",
		"county": "Jefferson",
		"title": "6. Jefferson",
		"cases_7day_mean_per_100k": 10.9118156915
	},
	{
		"date": "2022-09-25",
		"county": "Jefferson",
		"title": "6. Jefferson",
		"cases_7day_mean_per_100k": 10.7781163543
	},
	{
		"date": "2022-09-26",
		"county": "Jefferson",
		"title": "6. Jefferson",
		"cases_7day_mean_per_100k": 10.6583440315
	},
	{
		"date": "2022-09-27",
		"county": "Jefferson",
		"title": "6. Jefferson",
		"cases_7day_mean_per_100k": 10.3756256415
	},
	{
		"date": "2022-09-28",
		"county": "Jefferson",
		"title": "6. Jefferson",
		"cases_7day_mean_per_100k": 10.4160139829
	},
	{
		"date": "2022-09-29",
		"county": "Jefferson",
		"title": "6. Jefferson",
		"cases_7day_mean_per_100k": 10.3603059258
	},
	{
		"date": "2022-09-30",
		"county": "Jefferson",
		"title": "6. Jefferson",
		"cases_7day_mean_per_100k": 10.2906708544
	},
	{
		"date": "2022-10-01",
		"county": "Jefferson",
		"title": "6. Jefferson",
		"cases_7day_mean_per_100k": 10.2558533187
	},
	{
		"date": "2022-10-02",
		"county": "Jefferson",
		"title": "6. Jefferson",
		"cases_7day_mean_per_100k": 10.1082269673
	},
	{
		"date": "2022-10-03",
		"county": "Jefferson",
		"title": "6. Jefferson",
		"cases_7day_mean_per_100k": 9.665347913
	},
	{
		"date": "2022-10-04",
		"county": "Jefferson",
		"title": "6. Jefferson",
		"cases_7day_mean_per_100k": 9.4745478174
	},
	{
		"date": "2022-10-05",
		"county": "Jefferson",
		"title": "6. Jefferson",
		"cases_7day_mean_per_100k": 9.0511665831
	},
	{
		"date": "2022-10-06",
		"county": "Jefferson",
		"title": "6. Jefferson",
		"cases_7day_mean_per_100k": 8.6472831689
	},
	{
		"date": "2022-10-07",
		"county": "Jefferson",
		"title": "6. Jefferson",
		"cases_7day_mean_per_100k": 8.4411633575
	},
	{
		"date": "2022-10-08",
		"county": "Jefferson",
		"title": "6. Jefferson",
		"cases_7day_mean_per_100k": 8.2559340675
	},
	{
		"date": "2022-10-09",
		"county": "Jefferson",
		"title": "6. Jefferson",
		"cases_7day_mean_per_100k": 8.1612303704
	},
	{
		"date": "2022-10-10",
		"county": "Jefferson",
		"title": "6. Jefferson",
		"cases_7day_mean_per_100k": 7.9439689475
	},
	{
		"date": "2022-10-11",
		"county": "Jefferson",
		"title": "6. Jefferson",
		"cases_7day_mean_per_100k": 7.7267075247
	},
	{
		"date": "2022-10-12",
		"county": "Jefferson",
		"title": "6. Jefferson",
		"cases_7day_mean_per_100k": 7.6403600362
	},
	{
		"date": "2022-10-13",
		"county": "Jefferson",
		"title": "6. Jefferson",
		"cases_7day_mean_per_100k": 7.5178023105
	},
	{
		"date": "2022-10-14",
		"county": "Jefferson",
		"title": "6. Jefferson",
		"cases_7day_mean_per_100k": 7.3771394662
	},
	{
		"date": "2022-10-15",
		"county": "Jefferson",
		"title": "6. Jefferson",
		"cases_7day_mean_per_100k": 7.2267277119
	},
	{
		"date": "2022-10-16",
		"county": "Jefferson",
		"title": "6. Jefferson",
		"cases_7day_mean_per_100k": 7.1041699862
	},
	{
		"date": "2022-10-17",
		"county": "Jefferson",
		"title": "6. Jefferson",
		"cases_7day_mean_per_100k": 7.0066808862
	},
	{
		"date": "2022-10-18",
		"county": "Jefferson",
		"title": "6. Jefferson",
		"cases_7day_mean_per_100k": 7.0303568105
	},
	{
		"date": "2022-10-19",
		"county": "Jefferson",
		"title": "6. Jefferson",
		"cases_7day_mean_per_100k": 7.0038954834
	},
	{
		"date": "2022-10-20",
		"county": "Jefferson",
		"title": "6. Jefferson",
		"cases_7day_mean_per_100k": 7.0930283748
	},
	{
		"date": "2022-10-21",
		"county": "Jefferson",
		"title": "6. Jefferson",
		"cases_7day_mean_per_100k": 7.0874575691
	},
	{
		"date": "2022-10-22",
		"county": "Jefferson",
		"title": "6. Jefferson",
		"cases_7day_mean_per_100k": 7.1570926405
	},
	{
		"date": "2022-10-23",
		"county": "Jefferson",
		"title": "6. Jefferson",
		"cases_7day_mean_per_100k": 7.2044444891
	},
	{
		"date": "2022-10-24",
		"county": "Jefferson",
		"title": "6. Jefferson",
		"cases_7day_mean_per_100k": 7.2058371905
	},
	{
		"date": "2022-10-25",
		"county": "Jefferson",
		"title": "6. Jefferson",
		"cases_7day_mean_per_100k": 7.2866138733
	},
	{
		"date": "2022-10-26",
		"county": "Jefferson",
		"title": "6. Jefferson",
		"cases_7day_mean_per_100k": 7.3242168119
	},
	{
		"date": "2022-10-27",
		"county": "Jefferson",
		"title": "6. Jefferson",
		"cases_7day_mean_per_100k": 7.3966372862
	},
	{
		"date": "2022-10-28",
		"county": "Jefferson",
		"title": "6. Jefferson",
		"cases_7day_mean_per_100k": 7.4425964333
	},
	{
		"date": "2022-10-29",
		"county": "Jefferson",
		"title": "6. Jefferson",
		"cases_7day_mean_per_100k": 7.4467745376
	},
	{
		"date": "2022-10-30",
		"county": "Jefferson",
		"title": "6. Jefferson",
		"cases_7day_mean_per_100k": 7.4370256276
	},
	{
		"date": "2022-10-31",
		"county": "Jefferson",
		"title": "6. Jefferson",
		"cases_7day_mean_per_100k": 7.6765702733
	},
	{
		"date": "2022-11-01",
		"county": "Jefferson",
		"title": "6. Jefferson",
		"cases_7day_mean_per_100k": 7.867370369
	},
	{
		"date": "2022-11-02",
		"county": "Jefferson",
		"title": "6. Jefferson",
		"cases_7day_mean_per_100k": 8.2461851575
	},
	{
		"date": "2022-11-03",
		"county": "Jefferson",
		"title": "6. Jefferson",
		"cases_7day_mean_per_100k": 8.5261181446
	},
	{
		"date": "2022-11-04",
		"county": "Jefferson",
		"title": "6. Jefferson",
		"cases_7day_mean_per_100k": 8.683493406
	},
	{
		"date": "2022-11-05",
		"county": "Jefferson",
		"title": "6. Jefferson",
		"cases_7day_mean_per_100k": 8.6681736903
	},
	{
		"date": "2022-11-06",
		"county": "Jefferson",
		"title": "6. Jefferson",
		"cases_7day_mean_per_100k": 8.3422815561
	},
	{
		"date": "2022-11-07",
		"county": "Jefferson",
		"title": "6. Jefferson",
		"cases_7day_mean_per_100k": 6.9398312177
	},
	{
		"date": "2022-11-08",
		"county": "Jefferson",
		"title": "6. Jefferson",
		"cases_7day_mean_per_100k": 5.4371063764
	},
	{
		"date": "2022-03-01",
		"county": "Oldham",
		"title": "1. Oldham",
		"cases_7day_mean_per_100k": 13.0164138099
	},
	{
		"date": "2022-03-02",
		"county": "Oldham",
		"title": "1. Oldham",
		"cases_7day_mean_per_100k": 12.6001447336
	},
	{
		"date": "2022-03-03",
		"county": "Oldham",
		"title": "1. Oldham",
		"cases_7day_mean_per_100k": 12.0878135627
	},
	{
		"date": "2022-03-04",
		"county": "Oldham",
		"title": "1. Oldham",
		"cases_7day_mean_per_100k": 11.3193168064
	},
	{
		"date": "2022-03-05",
		"county": "Oldham",
		"title": "1. Oldham",
		"cases_7day_mean_per_100k": 11.0471408719
	},
	{
		"date": "2022-03-06",
		"county": "Oldham",
		"title": "1. Oldham",
		"cases_7day_mean_per_100k": 11.0311305228
	},
	{
		"date": "2022-03-07",
		"county": "Oldham",
		"title": "1. Oldham",
		"cases_7day_mean_per_100k": 11.1752236646
	},
	{
		"date": "2022-03-08",
		"county": "Oldham",
		"title": "1. Oldham",
		"cases_7day_mean_per_100k": 10.4067269083
	},
	{
		"date": "2022-03-09",
		"county": "Oldham",
		"title": "1. Oldham",
		"cases_7day_mean_per_100k": 10.182582021
	},
	{
		"date": "2022-03-10",
		"county": "Oldham",
		"title": "1. Oldham",
		"cases_7day_mean_per_100k": 10.1025302756
	},
	{
		"date": "2022-03-11",
		"county": "Oldham",
		"title": "1. Oldham",
		"cases_7day_mean_per_100k": 10.006468181
	},
	{
		"date": "2022-03-12",
		"county": "Oldham",
		"title": "1. Oldham",
		"cases_7day_mean_per_100k": 9.7983336429
	},
	{
		"date": "2022-03-13",
		"county": "Oldham",
		"title": "1. Oldham",
		"cases_7day_mean_per_100k": 9.7342922465
	},
	{
		"date": "2022-03-14",
		"county": "Oldham",
		"title": "1. Oldham",
		"cases_7day_mean_per_100k": 9.5421680574
	},
	{
		"date": "2022-03-15",
		"county": "Oldham",
		"title": "1. Oldham",
		"cases_7day_mean_per_100k": 9.2059507265
	},
	{
		"date": "2022-03-16",
		"county": "Oldham",
		"title": "1. Oldham",
		"cases_7day_mean_per_100k": 9.6542405011
	},
	{
		"date": "2022-03-17",
		"county": "Oldham",
		"title": "1. Oldham",
		"cases_7day_mean_per_100k": 9.814343992
	},
	{
		"date": "2022-03-18",
		"county": "Oldham",
		"title": "1. Oldham",
		"cases_7day_mean_per_100k": 10.0224785301
	},
	{
		"date": "2022-03-19",
		"county": "Oldham",
		"title": "1. Oldham",
		"cases_7day_mean_per_100k": 10.4707683046
	},
	{
		"date": "2022-03-20",
		"county": "Oldham",
		"title": "1. Oldham",
		"cases_7day_mean_per_100k": 10.5508200501
	},
	{
		"date": "2022-03-21",
		"county": "Oldham",
		"title": "1. Oldham",
		"cases_7day_mean_per_100k": 11.0151201737
	},
	{
		"date": "2022-03-22",
		"county": "Oldham",
		"title": "1. Oldham",
		"cases_7day_mean_per_100k": 12.2479170536
	},
	{
		"date": "2022-03-23",
		"county": "Oldham",
		"title": "1. Oldham",
		"cases_7day_mean_per_100k": 12.0878135627
	},
	{
		"date": "2022-03-24",
		"county": "Oldham",
		"title": "1. Oldham",
		"cases_7day_mean_per_100k": 12.2959481009
	},
	{
		"date": "2022-03-25",
		"county": "Oldham",
		"title": "1. Oldham",
		"cases_7day_mean_per_100k": 12.3119584499
	},
	{
		"date": "2022-03-26",
		"county": "Oldham",
		"title": "1. Oldham",
		"cases_7day_mean_per_100k": 12.3439791481
	},
	{
		"date": "2022-03-27",
		"county": "Oldham",
		"title": "1. Oldham",
		"cases_7day_mean_per_100k": 12.9203517153
	},
	{
		"date": "2022-03-28",
		"county": "Oldham",
		"title": "1. Oldham",
		"cases_7day_mean_per_100k": 13.5127346317
	},
	{
		"date": "2022-03-29",
		"county": "Oldham",
		"title": "1. Oldham",
		"cases_7day_mean_per_100k": 13.0644448572
	},
	{
		"date": "2022-03-30",
		"county": "Oldham",
		"title": "1. Oldham",
		"cases_7day_mean_per_100k": 13.7689002171
	},
	{
		"date": "2022-03-31",
		"county": "Oldham",
		"title": "1. Oldham",
		"cases_7day_mean_per_100k": 13.6568277735
	},
	{
		"date": "2022-04-01",
		"county": "Oldham",
		"title": "1. Oldham",
		"cases_7day_mean_per_100k": 14.8576039552
	},
	{
		"date": "2022-04-02",
		"county": "Oldham",
		"title": "1. Oldham",
		"cases_7day_mean_per_100k": 15.3379144279
	},
	{
		"date": "2022-04-03",
		"county": "Oldham",
		"title": "1. Oldham",
		"cases_7day_mean_per_100k": 15.3058937297
	},
	{
		"date": "2022-04-04",
		"county": "Oldham",
		"title": "1. Oldham",
		"cases_7day_mean_per_100k": 16.0103490897
	},
	{
		"date": "2022-04-05",
		"county": "Oldham",
		"title": "1. Oldham",
		"cases_7day_mean_per_100k": 16.9549596859
	},
	{
		"date": "2022-04-06",
		"county": "Oldham",
		"title": "1. Oldham",
		"cases_7day_mean_per_100k": 17.7874978386
	},
	{
		"date": "2022-04-07",
		"county": "Oldham",
		"title": "1. Oldham",
		"cases_7day_mean_per_100k": 18.6360463404
	},
	{
		"date": "2022-04-08",
		"county": "Oldham",
		"title": "1. Oldham",
		"cases_7day_mean_per_100k": 18.6360463404
	},
	{
		"date": "2022-04-09",
		"county": "Oldham",
		"title": "1. Oldham",
		"cases_7day_mean_per_100k": 18.395891104
	},
	{
		"date": "2022-04-10",
		"county": "Oldham",
		"title": "1. Oldham",
		"cases_7day_mean_per_100k": 18.7160980858
	},
	{
		"date": "2022-04-11",
		"county": "Oldham",
		"title": "1. Oldham",
		"cases_7day_mean_per_100k": 18.8441808785
	},
	{
		"date": "2022-04-12",
		"county": "Oldham",
		"title": "1. Oldham",
		"cases_7day_mean_per_100k": 19.3725223985
	},
	{
		"date": "2022-04-13",
		"county": "Oldham",
		"title": "1. Oldham",
		"cases_7day_mean_per_100k": 19.5326258894
	},
	{
		"date": "2022-04-14",
		"county": "Oldham",
		"title": "1. Oldham",
		"cases_7day_mean_per_100k": 19.6927293803
	},
	{
		"date": "2022-04-15",
		"county": "Oldham",
		"title": "1. Oldham",
		"cases_7day_mean_per_100k": 20.4131950893
	},
	{
		"date": "2022-04-16",
		"county": "Oldham",
		"title": "1. Oldham",
		"cases_7day_mean_per_100k": 21.2617435911
	},
	{
		"date": "2022-04-17",
		"county": "Oldham",
		"title": "1. Oldham",
		"cases_7day_mean_per_100k": 21.7740747619
	},
	{
		"date": "2022-04-18",
		"county": "Oldham",
		"title": "1. Oldham",
		"cases_7day_mean_per_100k": 23.03889234
	},
	{
		"date": "2022-04-19",
		"county": "Oldham",
		"title": "1. Oldham",
		"cases_7day_mean_per_100k": 24.3997720126
	},
	{
		"date": "2022-04-20",
		"county": "Oldham",
		"title": "1. Oldham",
		"cases_7day_mean_per_100k": 26.3210139034
	},
	{
		"date": "2022-04-21",
		"county": "Oldham",
		"title": "1. Oldham",
		"cases_7day_mean_per_100k": 28.5304420778
	},
	{
		"date": "2022-04-22",
		"county": "Oldham",
		"title": "1. Oldham",
		"cases_7day_mean_per_100k": 28.8666594086
	},
	{
		"date": "2022-04-23",
		"county": "Oldham",
		"title": "1. Oldham",
		"cases_7day_mean_per_100k": 29.1548456923
	},
	{
		"date": "2022-04-24",
		"county": "Oldham",
		"title": "1. Oldham",
		"cases_7day_mean_per_100k": 29.9233424486
	},
	{
		"date": "2022-04-25",
		"county": "Oldham",
		"title": "1. Oldham",
		"cases_7day_mean_per_100k": 31.9566567829
	},
	{
		"date": "2022-04-26",
		"county": "Oldham",
		"title": "1. Oldham",
		"cases_7day_mean_per_100k": 32.6611121429
	},
	{
		"date": "2022-04-27",
		"county": "Oldham",
		"title": "1. Oldham",
		"cases_7day_mean_per_100k": 33.7177951828
	},
	{
		"date": "2022-04-28",
		"county": "Oldham",
		"title": "1. Oldham",
		"cases_7day_mean_per_100k": 34.4222505428
	},
	{
		"date": "2022-04-29",
		"county": "Oldham",
		"title": "1. Oldham",
		"cases_7day_mean_per_100k": 35.6870681208
	},
	{
		"date": "2022-04-30",
		"county": "Oldham",
		"title": "1. Oldham",
		"cases_7day_mean_per_100k": 36.5676373208
	},
	{
		"date": "2022-05-01",
		"county": "Oldham",
		"title": "1. Oldham",
		"cases_7day_mean_per_100k": 37.864475597
	},
	{
		"date": "2022-05-02",
		"county": "Oldham",
		"title": "1. Oldham",
		"cases_7day_mean_per_100k": 38.6169620042
	},
	{
		"date": "2022-05-03",
		"county": "Oldham",
		"title": "1. Oldham",
		"cases_7day_mean_per_100k": 39.7857174878
	},
	{
		"date": "2022-05-04",
		"county": "Oldham",
		"title": "1. Oldham",
		"cases_7day_mean_per_100k": 41.0025040186
	},
	{
		"date": "2022-05-05",
		"county": "Oldham",
		"title": "1. Oldham",
		"cases_7day_mean_per_100k": 41.8990835676
	},
	{
		"date": "2022-05-06",
		"county": "Oldham",
		"title": "1. Oldham",
		"cases_7day_mean_per_100k": 43.7242633638
	},
	{
		"date": "2022-05-07",
		"county": "Oldham",
		"title": "1. Oldham",
		"cases_7day_mean_per_100k": 45.4053500183
	},
	{
		"date": "2022-05-08",
		"county": "Oldham",
		"title": "1. Oldham",
		"cases_7day_mean_per_100k": 46.0937950291
	},
	{
		"date": "2022-05-09",
		"county": "Oldham",
		"title": "1. Oldham",
		"cases_7day_mean_per_100k": 48.6394405344
	},
	{
		"date": "2022-05-10",
		"county": "Oldham",
		"title": "1. Oldham",
		"cases_7day_mean_per_100k": 50.5766927742
	},
	{
		"date": "2022-05-11",
		"county": "Oldham",
		"title": "1. Oldham",
		"cases_7day_mean_per_100k": 51.7614586068
	},
	{
		"date": "2022-05-12",
		"county": "Oldham",
		"title": "1. Oldham",
		"cases_7day_mean_per_100k": 53.1863796758
	},
	{
		"date": "2022-05-13",
		"county": "Oldham",
		"title": "1. Oldham",
		"cases_7day_mean_per_100k": 52.5939967595
	},
	{
		"date": "2022-05-14",
		"county": "Oldham",
		"title": "1. Oldham",
		"cases_7day_mean_per_100k": 52.9622347886
	},
	{
		"date": "2022-05-15",
		"county": "Oldham",
		"title": "1. Oldham",
		"cases_7day_mean_per_100k": 53.4265349122
	},
	{
		"date": "2022-05-16",
		"county": "Oldham",
		"title": "1. Oldham",
		"cases_7day_mean_per_100k": 54.4191765557
	},
	{
		"date": "2022-05-17",
		"county": "Oldham",
		"title": "1. Oldham",
		"cases_7day_mean_per_100k": 56.8047185701
	},
	{
		"date": "2022-05-18",
		"county": "Oldham",
		"title": "1. Oldham",
		"cases_7day_mean_per_100k": 57.2369979955
	},
	{
		"date": "2022-05-19",
		"county": "Oldham",
		"title": "1. Oldham",
		"cases_7day_mean_per_100k": 57.7173084682
	},
	{
		"date": "2022-05-20",
		"county": "Oldham",
		"title": "1. Oldham",
		"cases_7day_mean_per_100k": 59.1422295372
	},
	{
		"date": "2022-05-21",
		"county": "Oldham",
		"title": "1. Oldham",
		"cases_7day_mean_per_100k": 58.8700536026
	},
	{
		"date": "2022-05-22",
		"county": "Oldham",
		"title": "1. Oldham",
		"cases_7day_mean_per_100k": 58.0535257991
	},
	{
		"date": "2022-05-23",
		"county": "Oldham",
		"title": "1. Oldham",
		"cases_7day_mean_per_100k": 57.6052360246
	},
	{
		"date": "2022-05-24",
		"county": "Oldham",
		"title": "1. Oldham",
		"cases_7day_mean_per_100k": 55.4438388975
	},
	{
		"date": "2022-05-25",
		"county": "Oldham",
		"title": "1. Oldham",
		"cases_7day_mean_per_100k": 54.819435283
	},
	{
		"date": "2022-05-26",
		"county": "Oldham",
		"title": "1. Oldham",
		"cases_7day_mean_per_100k": 54.4031662066
	},
	{
		"date": "2022-05-27",
		"county": "Oldham",
		"title": "1. Oldham",
		"cases_7day_mean_per_100k": 54.1309902721
	},
	{
		"date": "2022-05-28",
		"county": "Oldham",
		"title": "1. Oldham",
		"cases_7day_mean_per_100k": 54.0989695739
	},
	{
		"date": "2022-05-29",
		"county": "Oldham",
		"title": "1. Oldham",
		"cases_7day_mean_per_100k": 54.0509385267
	},
	{
		"date": "2022-05-30",
		"county": "Oldham",
		"title": "1. Oldham",
		"cases_7day_mean_per_100k": 49.8882477634
	},
	{
		"date": "2022-05-31",
		"county": "Oldham",
		"title": "1. Oldham",
		"cases_7day_mean_per_100k": 51.3131688323
	},
	{
		"date": "2022-06-01",
		"county": "Oldham",
		"title": "1. Oldham",
		"cases_7day_mean_per_100k": 52.9942554867
	},
	{
		"date": "2022-06-02",
		"county": "Oldham",
		"title": "1. Oldham",
		"cases_7day_mean_per_100k": 53.2984521195
	},
	{
		"date": "2022-06-03",
		"county": "Oldham",
		"title": "1. Oldham",
		"cases_7day_mean_per_100k": 52.7541002504
	},
	{
		"date": "2022-06-04",
		"county": "Oldham",
		"title": "1. Oldham",
		"cases_7day_mean_per_100k": 53.3464831667
	},
	{
		"date": "2022-06-05",
		"county": "Oldham",
		"title": "1. Oldham",
		"cases_7day_mean_per_100k": 53.746741894
	},
	{
		"date": "2022-06-06",
		"county": "Oldham",
		"title": "1. Oldham",
		"cases_7day_mean_per_100k": 56.3564287956
	},
	{
		"date": "2022-06-07",
		"county": "Oldham",
		"title": "1. Oldham",
		"cases_7day_mean_per_100k": 54.1309902721
	},
	{
		"date": "2022-06-08",
		"county": "Oldham",
		"title": "1. Oldham",
		"cases_7day_mean_per_100k": 52.0976759377
	},
	{
		"date": "2022-06-09",
		"county": "Oldham",
		"title": "1. Oldham",
		"cases_7day_mean_per_100k": 50.544672076
	},
	{
		"date": "2022-06-10",
		"county": "Oldham",
		"title": "1. Oldham",
		"cases_7day_mean_per_100k": 50.1604236979
	},
	{
		"date": "2022-06-11",
		"county": "Oldham",
		"title": "1. Oldham",
		"cases_7day_mean_per_100k": 49.295864847
	},
	{
		"date": "2022-06-12",
		"county": "Oldham",
		"title": "1. Oldham",
		"cases_7day_mean_per_100k": 49.1998027525
	},
	{
		"date": "2022-06-13",
		"county": "Oldham",
		"title": "1. Oldham",
		"cases_7day_mean_per_100k": 48.6554508835
	},
	{
		"date": "2022-06-14",
		"county": "Oldham",
		"title": "1. Oldham",
		"cases_7day_mean_per_100k": 48.8795957707
	},
	{
		"date": "2022-06-15",
		"county": "Oldham",
		"title": "1. Oldham",
		"cases_7day_mean_per_100k": 48.3192335526
	},
	{
		"date": "2022-06-16",
		"county": "Oldham",
		"title": "1. Oldham",
		"cases_7day_mean_per_100k": 48.4473163453
	},
	{
		"date": "2022-06-17",
		"county": "Oldham",
		"title": "1. Oldham",
		"cases_7day_mean_per_100k": 49.3118751961
	},
	{
		"date": "2022-06-18",
		"county": "Oldham",
		"title": "1. Oldham",
		"cases_7day_mean_per_100k": 49.3278855452
	},
	{
		"date": "2022-06-19",
		"county": "Oldham",
		"title": "1. Oldham",
		"cases_7day_mean_per_100k": 49.5200097343
	},
	{
		"date": "2022-06-20",
		"county": "Oldham",
		"title": "1. Oldham",
		"cases_7day_mean_per_100k": 48.9436371671
	},
	{
		"date": "2022-06-21",
		"county": "Oldham",
		"title": "1. Oldham",
		"cases_7day_mean_per_100k": 50.2564857924
	},
	{
		"date": "2022-06-22",
		"county": "Oldham",
		"title": "1. Oldham",
		"cases_7day_mean_per_100k": 50.2244650942
	},
	{
		"date": "2022-06-23",
		"county": "Oldham",
		"title": "1. Oldham",
		"cases_7day_mean_per_100k": 51.0249825487
	},
	{
		"date": "2022-06-24",
		"county": "Oldham",
		"title": "1. Oldham",
		"cases_7day_mean_per_100k": 51.3291791814
	},
	{
		"date": "2022-06-25",
		"county": "Oldham",
		"title": "1. Oldham",
		"cases_7day_mean_per_100k": 51.3131688323
	},
	{
		"date": "2022-06-26",
		"county": "Oldham",
		"title": "1. Oldham",
		"cases_7day_mean_per_100k": 50.6727548687
	},
	{
		"date": "2022-06-27",
		"county": "Oldham",
		"title": "1. Oldham",
		"cases_7day_mean_per_100k": 52.5299553631
	},
	{
		"date": "2022-06-28",
		"county": "Oldham",
		"title": "1. Oldham",
		"cases_7day_mean_per_100k": 51.5853447669
	},
	{
		"date": "2022-06-29",
		"county": "Oldham",
		"title": "1. Oldham",
		"cases_7day_mean_per_100k": 52.3858622213
	},
	{
		"date": "2022-06-30",
		"county": "Oldham",
		"title": "1. Oldham",
		"cases_7day_mean_per_100k": 52.6420278068
	},
	{
		"date": "2022-07-01",
		"county": "Oldham",
		"title": "1. Oldham",
		"cases_7day_mean_per_100k": 51.9856034941
	},
	{
		"date": "2022-07-02",
		"county": "Oldham",
		"title": "1. Oldham",
		"cases_7day_mean_per_100k": 51.3772102287
	},
	{
		"date": "2022-07-03",
		"county": "Oldham",
		"title": "1. Oldham",
		"cases_7day_mean_per_100k": 51.2171067378
	},
	{
		"date": "2022-07-04",
		"county": "Oldham",
		"title": "1. Oldham",
		"cases_7day_mean_per_100k": 46.43001236
	},
	{
		"date": "2022-07-05",
		"county": "Oldham",
		"title": "1. Oldham",
		"cases_7day_mean_per_100k": 47.4866953999
	},
	{
		"date": "2022-07-06",
		"county": "Oldham",
		"title": "1. Oldham",
		"cases_7day_mean_per_100k": 47.4226540035
	},
	{
		"date": "2022-07-07",
		"county": "Oldham",
		"title": "1. Oldham",
		"cases_7day_mean_per_100k": 46.2218778218
	},
	{
		"date": "2022-07-08",
		"county": "Oldham",
		"title": "1. Oldham",
		"cases_7day_mean_per_100k": 45.6134845564
	},
	{
		"date": "2022-07-09",
		"county": "Oldham",
		"title": "1. Oldham",
		"cases_7day_mean_per_100k": 45.4533810655
	},
	{
		"date": "2022-07-10",
		"county": "Oldham",
		"title": "1. Oldham",
		"cases_7day_mean_per_100k": 44.5728118656
	},
	{
		"date": "2022-07-11",
		"county": "Oldham",
		"title": "1. Oldham",
		"cases_7day_mean_per_100k": 47.9670058726
	},
	{
		"date": "2022-07-12",
		"county": "Oldham",
		"title": "1. Oldham",
		"cases_7day_mean_per_100k": 44.8770084983
	},
	{
		"date": "2022-07-13",
		"county": "Oldham",
		"title": "1. Oldham",
		"cases_7day_mean_per_100k": 43.035818353
	},
	{
		"date": "2022-07-14",
		"county": "Oldham",
		"title": "1. Oldham",
		"cases_7day_mean_per_100k": 42.7956631166
	},
	{
		"date": "2022-07-15",
		"county": "Oldham",
		"title": "1. Oldham",
		"cases_7day_mean_per_100k": 42.1232284549
	},
	{
		"date": "2022-07-16",
		"county": "Oldham",
		"title": "1. Oldham",
		"cases_7day_mean_per_100k": 41.9150939167
	},
	{
		"date": "2022-07-17",
		"county": "Oldham",
		"title": "1. Oldham",
		"cases_7day_mean_per_100k": 41.2106385568
	},
	{
		"date": "2022-07-18",
		"county": "Oldham",
		"title": "1. Oldham",
		"cases_7day_mean_per_100k": 39.9298106296
	},
	{
		"date": "2022-07-19",
		"county": "Oldham",
		"title": "1. Oldham",
		"cases_7day_mean_per_100k": 39.7697071387
	},
	{
		"date": "2022-07-20",
		"county": "Oldham",
		"title": "1. Oldham",
		"cases_7day_mean_per_100k": 38.8891379388
	},
	{
		"date": "2022-07-21",
		"county": "Oldham",
		"title": "1. Oldham",
		"cases_7day_mean_per_100k": 37.688361757
	},
	{
		"date": "2022-07-22",
		"county": "Oldham",
		"title": "1. Oldham",
		"cases_7day_mean_per_100k": 37.8324548988
	},
	{
		"date": "2022-07-23",
		"county": "Oldham",
		"title": "1. Oldham",
		"cases_7day_mean_per_100k": 36.8718339535
	},
	{
		"date": "2022-07-24",
		"county": "Oldham",
		"title": "1. Oldham",
		"cases_7day_mean_per_100k": 36.9839063971
	},
	{
		"date": "2022-07-25",
		"county": "Oldham",
		"title": "1. Oldham",
		"cases_7day_mean_per_100k": 36.791782208
	},
	{
		"date": "2022-07-26",
		"county": "Oldham",
		"title": "1. Oldham",
		"cases_7day_mean_per_100k": 35.1267059027
	},
	{
		"date": "2022-07-27",
		"county": "Oldham",
		"title": "1. Oldham",
		"cases_7day_mean_per_100k": 34.0540125137
	},
	{
		"date": "2022-07-28",
		"county": "Oldham",
		"title": "1. Oldham",
		"cases_7day_mean_per_100k": 32.7091431902
	},
	{
		"date": "2022-07-29",
		"county": "Oldham",
		"title": "1. Oldham",
		"cases_7day_mean_per_100k": 30.7718909503
	},
	{
		"date": "2022-07-30",
		"county": "Oldham",
		"title": "1. Oldham",
		"cases_7day_mean_per_100k": 30.531735714
	},
	{
		"date": "2022-07-31",
		"county": "Oldham",
		"title": "1. Oldham",
		"cases_7day_mean_per_100k": 29.8753114013
	},
	{
		"date": "2022-08-01",
		"county": "Oldham",
		"title": "1. Oldham",
		"cases_7day_mean_per_100k": 28.9627215032
	},
	{
		"date": "2022-08-02",
		"county": "Oldham",
		"title": "1. Oldham",
		"cases_7day_mean_per_100k": 27.9700798596
	},
	{
		"date": "2022-08-03",
		"county": "Oldham",
		"title": "1. Oldham",
		"cases_7day_mean_per_100k": 27.153552056
	},
	{
		"date": "2022-08-04",
		"county": "Oldham",
		"title": "1. Oldham",
		"cases_7day_mean_per_100k": 26.5131380925
	},
	{
		"date": "2022-08-05",
		"county": "Oldham",
		"title": "1. Oldham",
		"cases_7day_mean_per_100k": 26.1609104125
	},
	{
		"date": "2022-08-06",
		"county": "Oldham",
		"title": "1. Oldham",
		"cases_7day_mean_per_100k": 25.5845378453
	},
	{
		"date": "2022-08-07",
		"county": "Oldham",
		"title": "1. Oldham",
		"cases_7day_mean_per_100k": 25.6645895907
	},
	{
		"date": "2022-08-08",
		"county": "Oldham",
		"title": "1. Oldham",
		"cases_7day_mean_per_100k": 23.759358049
	},
	{
		"date": "2022-08-09",
		"county": "Oldham",
		"title": "1. Oldham",
		"cases_7day_mean_per_100k": 23.21500618
	},
	{
		"date": "2022-08-10",
		"county": "Oldham",
		"title": "1. Oldham",
		"cases_7day_mean_per_100k": 23.56723386
	},
	{
		"date": "2022-08-11",
		"county": "Oldham",
		"title": "1. Oldham",
		"cases_7day_mean_per_100k": 22.8947991982
	},
	{
		"date": "2022-08-12",
		"county": "Oldham",
		"title": "1. Oldham",
		"cases_7day_mean_per_100k": 22.0302403474
	},
	{
		"date": "2022-08-13",
		"county": "Oldham",
		"title": "1. Oldham",
		"cases_7day_mean_per_100k": 21.790085111
	},
	{
		"date": "2022-08-14",
		"county": "Oldham",
		"title": "1. Oldham",
		"cases_7day_mean_per_100k": 21.1656814965
	},
	{
		"date": "2022-08-15",
		"county": "Oldham",
		"title": "1. Oldham",
		"cases_7day_mean_per_100k": 20.1410191548
	},
	{
		"date": "2022-08-16",
		"county": "Oldham",
		"title": "1. Oldham",
		"cases_7day_mean_per_100k": 19.5166155403
	},
	{
		"date": "2022-08-17",
		"county": "Oldham",
		"title": "1. Oldham",
		"cases_7day_mean_per_100k": 17.9956323768
	},
	{
		"date": "2022-08-18",
		"county": "Oldham",
		"title": "1. Oldham",
		"cases_7day_mean_per_100k": 17.5313322532
	},
	{
		"date": "2022-08-19",
		"county": "Oldham",
		"title": "1. Oldham",
		"cases_7day_mean_per_100k": 17.4192598095
	},
	{
		"date": "2022-08-20",
		"county": "Oldham",
		"title": "1. Oldham",
		"cases_7day_mean_per_100k": 17.6434046968
	},
	{
		"date": "2022-08-21",
		"county": "Oldham",
		"title": "1. Oldham",
		"cases_7day_mean_per_100k": 17.7234564422
	},
	{
		"date": "2022-08-22",
		"county": "Oldham",
		"title": "1. Oldham",
		"cases_7day_mean_per_100k": 17.5153219041
	},
	{
		"date": "2022-08-23",
		"county": "Oldham",
		"title": "1. Oldham",
		"cases_7day_mean_per_100k": 17.0350114314
	},
	{
		"date": "2022-08-24",
		"county": "Oldham",
		"title": "1. Oldham",
		"cases_7day_mean_per_100k": 16.8909182896
	},
	{
		"date": "2022-08-25",
		"county": "Oldham",
		"title": "1. Oldham",
		"cases_7day_mean_per_100k": 16.9869803841
	},
	{
		"date": "2022-08-26",
		"county": "Oldham",
		"title": "1. Oldham",
		"cases_7day_mean_per_100k": 16.3945974678
	},
	{
		"date": "2022-08-27",
		"county": "Oldham",
		"title": "1. Oldham",
		"cases_7day_mean_per_100k": 15.4659972206
	},
	{
		"date": "2022-08-28",
		"county": "Oldham",
		"title": "1. Oldham",
		"cases_7day_mean_per_100k": 14.6654797661
	},
	{
		"date": "2022-08-29",
		"county": "Oldham",
		"title": "1. Oldham",
		"cases_7day_mean_per_100k": 13.9450140571
	},
	{
		"date": "2022-08-30",
		"county": "Oldham",
		"title": "1. Oldham",
		"cases_7day_mean_per_100k": 13.208537999
	},
	{
		"date": "2022-08-31",
		"county": "Oldham",
		"title": "1. Oldham",
		"cases_7day_mean_per_100k": 12.6481757808
	},
	{
		"date": "2022-09-01",
		"county": "Oldham",
		"title": "1. Oldham",
		"cases_7day_mean_per_100k": 12.2158963554
	},
	{
		"date": "2022-09-02",
		"county": "Oldham",
		"title": "1. Oldham",
		"cases_7day_mean_per_100k": 12.6001447336
	},
	{
		"date": "2022-09-03",
		"county": "Oldham",
		"title": "1. Oldham",
		"cases_7day_mean_per_100k": 12.327968799
	},
	{
		"date": "2022-09-04",
		"county": "Oldham",
		"title": "1. Oldham",
		"cases_7day_mean_per_100k": 12.0397825154
	},
	{
		"date": "2022-09-05",
		"county": "Oldham",
		"title": "1. Oldham",
		"cases_7day_mean_per_100k": 10.7589545882
	},
	{
		"date": "2022-09-06",
		"county": "Oldham",
		"title": "1. Oldham",
		"cases_7day_mean_per_100k": 11.7035651845
	},
	{
		"date": "2022-09-07",
		"county": "Oldham",
		"title": "1. Oldham",
		"cases_7day_mean_per_100k": 11.9437204209
	},
	{
		"date": "2022-09-08",
		"county": "Oldham",
		"title": "1. Oldham",
		"cases_7day_mean_per_100k": 11.7195755336
	},
	{
		"date": "2022-09-09",
		"county": "Oldham",
		"title": "1. Oldham",
		"cases_7day_mean_per_100k": 11.5274513445
	},
	{
		"date": "2022-09-10",
		"county": "Oldham",
		"title": "1. Oldham",
		"cases_7day_mean_per_100k": 11.60750309
	},
	{
		"date": "2022-09-11",
		"county": "Oldham",
		"title": "1. Oldham",
		"cases_7day_mean_per_100k": 11.6875548354
	},
	{
		"date": "2022-09-12",
		"county": "Oldham",
		"title": "1. Oldham",
		"cases_7day_mean_per_100k": 12.8883310172
	},
	{
		"date": "2022-09-13",
		"county": "Oldham",
		"title": "1. Oldham",
		"cases_7day_mean_per_100k": 12.1198342609
	},
	{
		"date": "2022-09-14",
		"county": "Oldham",
		"title": "1. Oldham",
		"cases_7day_mean_per_100k": 11.5914927409
	},
	{
		"date": "2022-09-15",
		"county": "Oldham",
		"title": "1. Oldham",
		"cases_7day_mean_per_100k": 11.5274513445
	},
	{
		"date": "2022-09-16",
		"county": "Oldham",
		"title": "1. Oldham",
		"cases_7day_mean_per_100k": 11.2072443628
	},
	{
		"date": "2022-09-17",
		"county": "Oldham",
		"title": "1. Oldham",
		"cases_7day_mean_per_100k": 10.9991098246
	},
	{
		"date": "2022-09-18",
		"county": "Oldham",
		"title": "1. Oldham",
		"cases_7day_mean_per_100k": 11.0311305228
	},
	{
		"date": "2022-09-19",
		"county": "Oldham",
		"title": "1. Oldham",
		"cases_7day_mean_per_100k": 10.7429442392
	},
	{
		"date": "2022-09-20",
		"county": "Oldham",
		"title": "1. Oldham",
		"cases_7day_mean_per_100k": 10.3426855119
	},
	{
		"date": "2022-09-21",
		"county": "Oldham",
		"title": "1. Oldham",
		"cases_7day_mean_per_100k": 10.2146027192
	},
	{
		"date": "2022-09-22",
		"county": "Oldham",
		"title": "1. Oldham",
		"cases_7day_mean_per_100k": 10.0705095774
	},
	{
		"date": "2022-09-23",
		"county": "Oldham",
		"title": "1. Oldham",
		"cases_7day_mean_per_100k": 10.0865199265
	},
	{
		"date": "2022-09-24",
		"county": "Oldham",
		"title": "1. Oldham",
		"cases_7day_mean_per_100k": 10.358695861
	},
	{
		"date": "2022-09-25",
		"county": "Oldham",
		"title": "1. Oldham",
		"cases_7day_mean_per_100k": 10.6468821446
	},
	{
		"date": "2022-09-26",
		"county": "Oldham",
		"title": "1. Oldham",
		"cases_7day_mean_per_100k": 10.3907165592
	},
	{
		"date": "2022-09-27",
		"county": "Oldham",
		"title": "1. Oldham",
		"cases_7day_mean_per_100k": 10.4547579555
	},
	{
		"date": "2022-09-28",
		"county": "Oldham",
		"title": "1. Oldham",
		"cases_7day_mean_per_100k": 10.6628924937
	},
	{
		"date": "2022-09-29",
		"county": "Oldham",
		"title": "1. Oldham",
		"cases_7day_mean_per_100k": 10.7749649373
	},
	{
		"date": "2022-09-30",
		"county": "Oldham",
		"title": "1. Oldham",
		"cases_7day_mean_per_100k": 10.4227372574
	},
	{
		"date": "2022-10-01",
		"county": "Oldham",
		"title": "1. Oldham",
		"cases_7day_mean_per_100k": 10.2466234174
	},
	{
		"date": "2022-10-02",
		"county": "Oldham",
		"title": "1. Oldham",
		"cases_7day_mean_per_100k": 9.8623750392
	},
	{
		"date": "2022-10-03",
		"county": "Oldham",
		"title": "1. Oldham",
		"cases_7day_mean_per_100k": 10.006468181
	},
	{
		"date": "2022-10-04",
		"county": "Oldham",
		"title": "1. Oldham",
		"cases_7day_mean_per_100k": 10.182582021
	},
	{
		"date": "2022-10-05",
		"county": "Oldham",
		"title": "1. Oldham",
		"cases_7day_mean_per_100k": 9.830354341
	},
	{
		"date": "2022-10-06",
		"county": "Oldham",
		"title": "1. Oldham",
		"cases_7day_mean_per_100k": 9.814343992
	},
	{
		"date": "2022-10-07",
		"county": "Oldham",
		"title": "1. Oldham",
		"cases_7day_mean_per_100k": 9.7342922465
	},
	{
		"date": "2022-10-08",
		"county": "Oldham",
		"title": "1. Oldham",
		"cases_7day_mean_per_100k": 9.6862611992
	},
	{
		"date": "2022-10-09",
		"county": "Oldham",
		"title": "1. Oldham",
		"cases_7day_mean_per_100k": 9.5741887556
	},
	{
		"date": "2022-10-10",
		"county": "Oldham",
		"title": "1. Oldham",
		"cases_7day_mean_per_100k": 8.9978161884
	},
	{
		"date": "2022-10-11",
		"county": "Oldham",
		"title": "1. Oldham",
		"cases_7day_mean_per_100k": 8.6936195557
	},
	{
		"date": "2022-10-12",
		"county": "Oldham",
		"title": "1. Oldham",
		"cases_7day_mean_per_100k": 8.8056919993
	},
	{
		"date": "2022-10-13",
		"county": "Oldham",
		"title": "1. Oldham",
		"cases_7day_mean_per_100k": 8.4694746684
	},
	{
		"date": "2022-10-14",
		"county": "Oldham",
		"title": "1. Oldham",
		"cases_7day_mean_per_100k": 8.6295781593
	},
	{
		"date": "2022-10-15",
		"county": "Oldham",
		"title": "1. Oldham",
		"cases_7day_mean_per_100k": 8.4054332721
	},
	{
		"date": "2022-10-16",
		"county": "Oldham",
		"title": "1. Oldham",
		"cases_7day_mean_per_100k": 8.4694746684
	},
	{
		"date": "2022-10-17",
		"county": "Oldham",
		"title": "1. Oldham",
		"cases_7day_mean_per_100k": 8.6455885084
	},
	{
		"date": "2022-10-18",
		"county": "Oldham",
		"title": "1. Oldham",
		"cases_7day_mean_per_100k": 8.5495264139
	},
	{
		"date": "2022-10-19",
		"county": "Oldham",
		"title": "1. Oldham",
		"cases_7day_mean_per_100k": 8.2933608284
	},
	{
		"date": "2022-10-20",
		"county": "Oldham",
		"title": "1. Oldham",
		"cases_7day_mean_per_100k": 8.3093711775
	},
	{
		"date": "2022-10-21",
		"county": "Oldham",
		"title": "1. Oldham",
		"cases_7day_mean_per_100k": 7.7970400067
	},
	{
		"date": "2022-10-22",
		"county": "Oldham",
		"title": "1. Oldham",
		"cases_7day_mean_per_100k": 7.6689572139
	},
	{
		"date": "2022-10-23",
		"county": "Oldham",
		"title": "1. Oldham",
		"cases_7day_mean_per_100k": 7.6209261667
	},
	{
		"date": "2022-10-24",
		"county": "Oldham",
		"title": "1. Oldham",
		"cases_7day_mean_per_100k": 7.4768330249
	},
	{
		"date": "2022-10-25",
		"county": "Oldham",
		"title": "1. Oldham",
		"cases_7day_mean_per_100k": 7.8450710539
	},
	{
		"date": "2022-10-26",
		"county": "Oldham",
		"title": "1. Oldham",
		"cases_7day_mean_per_100k": 7.9731538466
	},
	{
		"date": "2022-10-27",
		"county": "Oldham",
		"title": "1. Oldham",
		"cases_7day_mean_per_100k": 7.9571434976
	},
	{
		"date": "2022-10-28",
		"county": "Oldham",
		"title": "1. Oldham",
		"cases_7day_mean_per_100k": 8.4374539702
	},
	{
		"date": "2022-10-29",
		"county": "Oldham",
		"title": "1. Oldham",
		"cases_7day_mean_per_100k": 8.6776092066
	},
	{
		"date": "2022-10-30",
		"county": "Oldham",
		"title": "1. Oldham",
		"cases_7day_mean_per_100k": 8.9177644429
	},
	{
		"date": "2022-10-31",
		"county": "Oldham",
		"title": "1. Oldham",
		"cases_7day_mean_per_100k": 9.3660542174
	},
	{
		"date": "2022-11-01",
		"county": "Oldham",
		"title": "1. Oldham",
		"cases_7day_mean_per_100k": 9.3180231702
	},
	{
		"date": "2022-11-02",
		"county": "Oldham",
		"title": "1. Oldham",
		"cases_7day_mean_per_100k": 9.5421680574
	},
	{
		"date": "2022-11-03",
		"county": "Oldham",
		"title": "1. Oldham",
		"cases_7day_mean_per_100k": 9.814343992
	},
	{
		"date": "2022-11-04",
		"county": "Oldham",
		"title": "1. Oldham",
		"cases_7day_mean_per_100k": 9.6542405011
	},
	{
		"date": "2022-11-05",
		"county": "Oldham",
		"title": "1. Oldham",
		"cases_7day_mean_per_100k": 9.462116312
	},
	{
		"date": "2022-11-06",
		"county": "Oldham",
		"title": "1. Oldham",
		"cases_7day_mean_per_100k": 9.0778679338
	},
	{
		"date": "2022-11-07",
		"county": "Oldham",
		"title": "1. Oldham",
		"cases_7day_mean_per_100k": 7.140615694
	},
	{
		"date": "2022-11-08",
		"county": "Oldham",
		"title": "1. Oldham",
		"cases_7day_mean_per_100k": 5.539580785
	},
	{
		"date": "2022-03-01",
		"county": "Laurel",
		"title": "5. Laurel",
		"cases_7day_mean_per_100k": 11.1090565987
	},
	{
		"date": "2022-03-02",
		"county": "Laurel",
		"title": "5. Laurel",
		"cases_7day_mean_per_100k": 10.7969012893
	},
	{
		"date": "2022-03-03",
		"county": "Laurel",
		"title": "5. Laurel",
		"cases_7day_mean_per_100k": 10.7234529812
	},
	{
		"date": "2022-03-04",
		"county": "Laurel",
		"title": "5. Laurel",
		"cases_7day_mean_per_100k": 10.4112976719
	},
	{
		"date": "2022-03-05",
		"county": "Laurel",
		"title": "5. Laurel",
		"cases_7day_mean_per_100k": 10.3378493638
	},
	{
		"date": "2022-03-06",
		"county": "Laurel",
		"title": "5. Laurel",
		"cases_7day_mean_per_100k": 10.3562114408
	},
	{
		"date": "2022-03-07",
		"county": "Laurel",
		"title": "5. Laurel",
		"cases_7day_mean_per_100k": 9.8053491301
	},
	{
		"date": "2022-03-08",
		"county": "Laurel",
		"title": "5. Laurel",
		"cases_7day_mean_per_100k": 9.3830213586
	},
	{
		"date": "2022-03-09",
		"county": "Laurel",
		"title": "5. Laurel",
		"cases_7day_mean_per_100k": 9.4564696667
	},
	{
		"date": "2022-03-10",
		"county": "Laurel",
		"title": "5. Laurel",
		"cases_7day_mean_per_100k": 8.923969433
	},
	{
		"date": "2022-03-11",
		"county": "Laurel",
		"title": "5. Laurel",
		"cases_7day_mean_per_100k": 8.7036245087
	},
	{
		"date": "2022-03-12",
		"county": "Laurel",
		"title": "5. Laurel",
		"cases_7day_mean_per_100k": 8.5383658155
	},
	{
		"date": "2022-03-13",
		"county": "Laurel",
		"title": "5. Laurel",
		"cases_7day_mean_per_100k": 8.1894863521
	},
	{
		"date": "2022-03-14",
		"county": "Laurel",
		"title": "5. Laurel",
		"cases_7day_mean_per_100k": 8.097675967
	},
	{
		"date": "2022-03-15",
		"county": "Laurel",
		"title": "5. Laurel",
		"cases_7day_mean_per_100k": 8.0425897359
	},
	{
		"date": "2022-03-16",
		"county": "Laurel",
		"title": "5. Laurel",
		"cases_7day_mean_per_100k": 7.4917274252
	},
	{
		"date": "2022-03-17",
		"county": "Laurel",
		"title": "5. Laurel",
		"cases_7day_mean_per_100k": 7.5835378104
	},
	{
		"date": "2022-03-18",
		"county": "Laurel",
		"title": "5. Laurel",
		"cases_7day_mean_per_100k": 7.308106655
	},
	{
		"date": "2022-03-19",
		"county": "Laurel",
		"title": "5. Laurel",
		"cases_7day_mean_per_100k": 7.0510375767
	},
	{
		"date": "2022-03-20",
		"county": "Laurel",
		"title": "5. Laurel",
		"cases_7day_mean_per_100k": 7.0693996537
	},
	{
		"date": "2022-03-21",
		"county": "Laurel",
		"title": "5. Laurel",
		"cases_7day_mean_per_100k": 6.7388822673
	},
	{
		"date": "2022-03-22",
		"county": "Laurel",
		"title": "5. Laurel",
		"cases_7day_mean_per_100k": 8.3180208913
	},
	{
		"date": "2022-03-23",
		"county": "Laurel",
		"title": "5. Laurel",
		"cases_7day_mean_per_100k": 8.7219865858
	},
	{
		"date": "2022-03-24",
		"county": "Laurel",
		"title": "5. Laurel",
		"cases_7day_mean_per_100k": 9.1075902032
	},
	{
		"date": "2022-03-25",
		"county": "Laurel",
		"title": "5. Laurel",
		"cases_7day_mean_per_100k": 9.1075902032
	},
	{
		"date": "2022-03-26",
		"county": "Laurel",
		"title": "5. Laurel",
		"cases_7day_mean_per_100k": 9.4197455126
	},
	{
		"date": "2022-03-27",
		"county": "Laurel",
		"title": "5. Laurel",
		"cases_7day_mean_per_100k": 9.8237112071
	},
	{
		"date": "2022-03-28",
		"county": "Laurel",
		"title": "5. Laurel",
		"cases_7day_mean_per_100k": 10.6500046731
	},
	{
		"date": "2022-03-29",
		"county": "Laurel",
		"title": "5. Laurel",
		"cases_7day_mean_per_100k": 9.8237112071
	},
	{
		"date": "2022-03-30",
		"county": "Laurel",
		"title": "5. Laurel",
		"cases_7day_mean_per_100k": 10.2093148246
	},
	{
		"date": "2022-03-31",
		"county": "Laurel",
		"title": "5. Laurel",
		"cases_7day_mean_per_100k": 10.503108057
	},
	{
		"date": "2022-04-01",
		"county": "Laurel",
		"title": "5. Laurel",
		"cases_7day_mean_per_100k": 11.6415568324
	},
	{
		"date": "2022-04-02",
		"county": "Laurel",
		"title": "5. Laurel",
		"cases_7day_mean_per_100k": 11.8251776026
	},
	{
		"date": "2022-04-03",
		"county": "Laurel",
		"title": "5. Laurel",
		"cases_7day_mean_per_100k": 12.4862123754
	},
	{
		"date": "2022-04-04",
		"county": "Laurel",
		"title": "5. Laurel",
		"cases_7day_mean_per_100k": 13.1288850712
	},
	{
		"date": "2022-04-05",
		"county": "Laurel",
		"title": "5. Laurel",
		"cases_7day_mean_per_100k": 13.5328507657
	},
	{
		"date": "2022-04-06",
		"county": "Laurel",
		"title": "5. Laurel",
		"cases_7day_mean_per_100k": 13.9368164602
	},
	{
		"date": "2022-04-07",
		"county": "Laurel",
		"title": "5. Laurel",
		"cases_7day_mean_per_100k": 14.0837130764
	},
	{
		"date": "2022-04-08",
		"county": "Laurel",
		"title": "5. Laurel",
		"cases_7day_mean_per_100k": 14.3040580007
	},
	{
		"date": "2022-04-09",
		"county": "Laurel",
		"title": "5. Laurel",
		"cases_7day_mean_per_100k": 15.1303514667
	},
	{
		"date": "2022-04-10",
		"county": "Laurel",
		"title": "5. Laurel",
		"cases_7day_mean_per_100k": 15.0385410816
	},
	{
		"date": "2022-04-11",
		"county": "Laurel",
		"title": "5. Laurel",
		"cases_7day_mean_per_100k": 15.5343171612
	},
	{
		"date": "2022-04-12",
		"county": "Laurel",
		"title": "5. Laurel",
		"cases_7day_mean_per_100k": 16.4524210123
	},
	{
		"date": "2022-04-13",
		"county": "Laurel",
		"title": "5. Laurel",
		"cases_7day_mean_per_100k": 17.2052661702
	},
	{
		"date": "2022-04-14",
		"county": "Laurel",
		"title": "5. Laurel",
		"cases_7day_mean_per_100k": 17.9948354822
	},
	{
		"date": "2022-04-15",
		"county": "Laurel",
		"title": "5. Laurel",
		"cases_7day_mean_per_100k": 18.600784024
	},
	{
		"date": "2022-04-16",
		"county": "Laurel",
		"title": "5. Laurel",
		"cases_7day_mean_per_100k": 19.0414738725
	},
	{
		"date": "2022-04-17",
		"county": "Laurel",
		"title": "5. Laurel",
		"cases_7day_mean_per_100k": 19.1516463346
	},
	{
		"date": "2022-04-18",
		"county": "Laurel",
		"title": "5. Laurel",
		"cases_7day_mean_per_100k": 20.4186296492
	},
	{
		"date": "2022-04-19",
		"county": "Laurel",
		"title": "5. Laurel",
		"cases_7day_mean_per_100k": 21.2632851923
	},
	{
		"date": "2022-04-20",
		"county": "Laurel",
		"title": "5. Laurel",
		"cases_7day_mean_per_100k": 22.6220788919
	},
	{
		"date": "2022-04-21",
		"county": "Laurel",
		"title": "5. Laurel",
		"cases_7day_mean_per_100k": 23.8523380524
	},
	{
		"date": "2022-04-22",
		"county": "Laurel",
		"title": "5. Laurel",
		"cases_7day_mean_per_100k": 24.6969935955
	},
	{
		"date": "2022-04-23",
		"county": "Laurel",
		"title": "5. Laurel",
		"cases_7day_mean_per_100k": 25.2845800602
	},
	{
		"date": "2022-04-24",
		"county": "Laurel",
		"title": "5. Laurel",
		"cases_7day_mean_per_100k": 26.4046667586
	},
	{
		"date": "2022-04-25",
		"county": "Laurel",
		"title": "5. Laurel",
		"cases_7day_mean_per_100k": 27.7450983813
	},
	{
		"date": "2022-04-26",
		"county": "Laurel",
		"title": "5. Laurel",
		"cases_7day_mean_per_100k": 28.4795814622
	},
	{
		"date": "2022-04-27",
		"county": "Laurel",
		"title": "5. Laurel",
		"cases_7day_mean_per_100k": 29.195702466
	},
	{
		"date": "2022-04-28",
		"county": "Laurel",
		"title": "5. Laurel",
		"cases_7day_mean_per_100k": 29.4160473903
	},
	{
		"date": "2022-04-29",
		"county": "Laurel",
		"title": "5. Laurel",
		"cases_7day_mean_per_100k": 30.2056167023
	},
	{
		"date": "2022-04-30",
		"county": "Laurel",
		"title": "5. Laurel",
		"cases_7day_mean_per_100k": 30.8482893981
	},
	{
		"date": "2022-05-01",
		"county": "Laurel",
		"title": "5. Laurel",
		"cases_7day_mean_per_100k": 31.9683760965
	},
	{
		"date": "2022-05-02",
		"county": "Laurel",
		"title": "5. Laurel",
		"cases_7day_mean_per_100k": 33.0150144868
	},
	{
		"date": "2022-05-03",
		"county": "Laurel",
		"title": "5. Laurel",
		"cases_7day_mean_per_100k": 33.9514804149
	},
	{
		"date": "2022-05-04",
		"county": "Laurel",
		"title": "5. Laurel",
		"cases_7day_mean_per_100k": 35.3102741146
	},
	{
		"date": "2022-05-05",
		"county": "Laurel",
		"title": "5. Laurel",
		"cases_7day_mean_per_100k": 37.0179472777
	},
	{
		"date": "2022-05-06",
		"county": "Laurel",
		"title": "5. Laurel",
		"cases_7day_mean_per_100k": 38.7256204408
	},
	{
		"date": "2022-05-07",
		"county": "Laurel",
		"title": "5. Laurel",
		"cases_7day_mean_per_100k": 39.2397585974
	},
	{
		"date": "2022-05-08",
		"county": "Laurel",
		"title": "5. Laurel",
		"cases_7day_mean_per_100k": 40.4516556809
	},
	{
		"date": "2022-05-09",
		"county": "Laurel",
		"title": "5. Laurel",
		"cases_7day_mean_per_100k": 42.1960529981
	},
	{
		"date": "2022-05-10",
		"county": "Laurel",
		"title": "5. Laurel",
		"cases_7day_mean_per_100k": 44.1057090085
	},
	{
		"date": "2022-05-11",
		"county": "Laurel",
		"title": "5. Laurel",
		"cases_7day_mean_per_100k": 44.6932954732
	},
	{
		"date": "2022-05-12",
		"county": "Laurel",
		"title": "5. Laurel",
		"cases_7day_mean_per_100k": 46.0520891729
	},
	{
		"date": "2022-05-13",
		"county": "Laurel",
		"title": "5. Laurel",
		"cases_7day_mean_per_100k": 47.3741587185
	},
	{
		"date": "2022-05-14",
		"county": "Laurel",
		"title": "5. Laurel",
		"cases_7day_mean_per_100k": 48.5309695709
	},
	{
		"date": "2022-05-15",
		"county": "Laurel",
		"title": "5. Laurel",
		"cases_7day_mean_per_100k": 49.2470905748
	},
	{
		"date": "2022-05-16",
		"county": "Laurel",
		"title": "5. Laurel",
		"cases_7day_mean_per_100k": 50.5507980434
	},
	{
		"date": "2022-05-17",
		"county": "Laurel",
		"title": "5. Laurel",
		"cases_7day_mean_per_100k": 52.680798978
	},
	{
		"date": "2022-05-18",
		"county": "Laurel",
		"title": "5. Laurel",
		"cases_7day_mean_per_100k": 54.8658861437
	},
	{
		"date": "2022-05-19",
		"county": "Laurel",
		"title": "5. Laurel",
		"cases_7day_mean_per_100k": 55.3433001463
	},
	{
		"date": "2022-05-20",
		"county": "Laurel",
		"title": "5. Laurel",
		"cases_7day_mean_per_100k": 56.3899385366
	},
	{
		"date": "2022-05-21",
		"county": "Laurel",
		"title": "5. Laurel",
		"cases_7day_mean_per_100k": 56.8673525392
	},
	{
		"date": "2022-05-22",
		"county": "Laurel",
		"title": "5. Laurel",
		"cases_7day_mean_per_100k": 56.6470076149
	},
	{
		"date": "2022-05-23",
		"county": "Laurel",
		"title": "5. Laurel",
		"cases_7day_mean_per_100k": 57.3080423878
	},
	{
		"date": "2022-05-24",
		"county": "Laurel",
		"title": "5. Laurel",
		"cases_7day_mean_per_100k": 57.8405426214
	},
	{
		"date": "2022-05-25",
		"county": "Laurel",
		"title": "5. Laurel",
		"cases_7day_mean_per_100k": 58.5015773942
	},
	{
		"date": "2022-05-26",
		"county": "Laurel",
		"title": "5. Laurel",
		"cases_7day_mean_per_100k": 59.125888013
	},
	{
		"date": "2022-05-27",
		"county": "Laurel",
		"title": "5. Laurel",
		"cases_7day_mean_per_100k": 57.6936460052
	},
	{
		"date": "2022-05-28",
		"county": "Laurel",
		"title": "5. Laurel",
		"cases_7day_mean_per_100k": 56.5001109988
	},
	{
		"date": "2022-05-29",
		"county": "Laurel",
		"title": "5. Laurel",
		"cases_7day_mean_per_100k": 55.7839899949
	},
	{
		"date": "2022-05-30",
		"county": "Laurel",
		"title": "5. Laurel",
		"cases_7day_mean_per_100k": 49.9815736557
	},
	{
		"date": "2022-05-31",
		"county": "Laurel",
		"title": "5. Laurel",
		"cases_7day_mean_per_100k": 51.9279538201
	},
	{
		"date": "2022-06-01",
		"county": "Laurel",
		"title": "5. Laurel",
		"cases_7day_mean_per_100k": 52.4237298997
	},
	{
		"date": "2022-06-02",
		"county": "Laurel",
		"title": "5. Laurel",
		"cases_7day_mean_per_100k": 52.8644197483
	},
	{
		"date": "2022-06-03",
		"county": "Laurel",
		"title": "5. Laurel",
		"cases_7day_mean_per_100k": 52.680798978
	},
	{
		"date": "2022-06-04",
		"county": "Laurel",
		"title": "5. Laurel",
		"cases_7day_mean_per_100k": 53.2867475198
	},
	{
		"date": "2022-06-05",
		"county": "Laurel",
		"title": "5. Laurel",
		"cases_7day_mean_per_100k": 53.8743339845
	},
	{
		"date": "2022-06-06",
		"county": "Laurel",
		"title": "5. Laurel",
		"cases_7day_mean_per_100k": 58.6851981645
	},
	{
		"date": "2022-06-07",
		"county": "Laurel",
		"title": "5. Laurel",
		"cases_7day_mean_per_100k": 55.049506914
	},
	{
		"date": "2022-06-08",
		"county": "Laurel",
		"title": "5. Laurel",
		"cases_7day_mean_per_100k": 52.4971782078
	},
	{
		"date": "2022-06-09",
		"county": "Laurel",
		"title": "5. Laurel",
		"cases_7day_mean_per_100k": 51.009849969
	},
	{
		"date": "2022-06-10",
		"county": "Laurel",
		"title": "5. Laurel",
		"cases_7day_mean_per_100k": 51.1383845081
	},
	{
		"date": "2022-06-11",
		"county": "Laurel",
		"title": "5. Laurel",
		"cases_7day_mean_per_100k": 50.6242463515
	},
	{
		"date": "2022-06-12",
		"county": "Laurel",
		"title": "5. Laurel",
		"cases_7day_mean_per_100k": 49.1369181127
	},
	{
		"date": "2022-06-13",
		"county": "Laurel",
		"title": "5. Laurel",
		"cases_7day_mean_per_100k": 48.2371763386
	},
	{
		"date": "2022-06-14",
		"county": "Laurel",
		"title": "5. Laurel",
		"cases_7day_mean_per_100k": 47.5026932576
	},
	{
		"date": "2022-06-15",
		"county": "Laurel",
		"title": "5. Laurel",
		"cases_7day_mean_per_100k": 46.8232964078
	},
	{
		"date": "2022-06-16",
		"county": "Laurel",
		"title": "5. Laurel",
		"cases_7day_mean_per_100k": 46.7682101767
	},
	{
		"date": "2022-06-17",
		"county": "Laurel",
		"title": "5. Laurel",
		"cases_7day_mean_per_100k": 46.4009686363
	},
	{
		"date": "2022-06-18",
		"county": "Laurel",
		"title": "5. Laurel",
		"cases_7day_mean_per_100k": 47.2639862564
	},
	{
		"date": "2022-06-19",
		"county": "Laurel",
		"title": "5. Laurel",
		"cases_7day_mean_per_100k": 48.1086417994
	},
	{
		"date": "2022-06-20",
		"county": "Laurel",
		"title": "5. Laurel",
		"cases_7day_mean_per_100k": 47.9066589521
	},
	{
		"date": "2022-06-21",
		"county": "Laurel",
		"title": "5. Laurel",
		"cases_7day_mean_per_100k": 49.1185560356
	},
	{
		"date": "2022-06-22",
		"county": "Laurel",
		"title": "5. Laurel",
		"cases_7day_mean_per_100k": 51.0649362
	},
	{
		"date": "2022-06-23",
		"county": "Laurel",
		"title": "5. Laurel",
		"cases_7day_mean_per_100k": 51.2669190473
	},
	{
		"date": "2022-06-24",
		"county": "Laurel",
		"title": "5. Laurel",
		"cases_7day_mean_per_100k": 50.9547637379
	},
	{
		"date": "2022-06-25",
		"county": "Laurel",
		"title": "5. Laurel",
		"cases_7day_mean_per_100k": 51.5056260486
	},
	{
		"date": "2022-06-26",
		"county": "Laurel",
		"title": "5. Laurel",
		"cases_7day_mean_per_100k": 51.5974364337
	},
	{
		"date": "2022-06-27",
		"county": "Laurel",
		"title": "5. Laurel",
		"cases_7day_mean_per_100k": 52.662436901
	},
	{
		"date": "2022-06-28",
		"county": "Laurel",
		"title": "5. Laurel",
		"cases_7day_mean_per_100k": 52.1115745903
	},
	{
		"date": "2022-06-29",
		"county": "Laurel",
		"title": "5. Laurel",
		"cases_7day_mean_per_100k": 51.5974364337
	},
	{
		"date": "2022-06-30",
		"county": "Laurel",
		"title": "5. Laurel",
		"cases_7day_mean_per_100k": 51.1567465852
	},
	{
		"date": "2022-07-01",
		"county": "Laurel",
		"title": "5. Laurel",
		"cases_7day_mean_per_100k": 52.5155402848
	},
	{
		"date": "2022-07-02",
		"county": "Laurel",
		"title": "5. Laurel",
		"cases_7day_mean_per_100k": 51.4872639716
	},
	{
		"date": "2022-07-03",
		"county": "Laurel",
		"title": "5. Laurel",
		"cases_7day_mean_per_100k": 51.1751086622
	},
	{
		"date": "2022-07-04",
		"county": "Laurel",
		"title": "5. Laurel",
		"cases_7day_mean_per_100k": 47.3741587185
	},
	{
		"date": "2022-07-05",
		"county": "Laurel",
		"title": "5. Laurel",
		"cases_7day_mean_per_100k": 48.3289867237
	},
	{
		"date": "2022-07-06",
		"county": "Laurel",
		"title": "5. Laurel",
		"cases_7day_mean_per_100k": 48.8614869573
	},
	{
		"date": "2022-07-07",
		"county": "Laurel",
		"title": "5. Laurel",
		"cases_7day_mean_per_100k": 49.2838147288
	},
	{
		"date": "2022-07-08",
		"county": "Laurel",
		"title": "5. Laurel",
		"cases_7day_mean_per_100k": 48.0168314143
	},
	{
		"date": "2022-07-09",
		"county": "Laurel",
		"title": "5. Laurel",
		"cases_7day_mean_per_100k": 48.3840729547
	},
	{
		"date": "2022-07-10",
		"county": "Laurel",
		"title": "5. Laurel",
		"cases_7day_mean_per_100k": 48.1453659534
	},
	{
		"date": "2022-07-11",
		"county": "Laurel",
		"title": "5. Laurel",
		"cases_7day_mean_per_100k": 51.2669190473
	},
	{
		"date": "2022-07-12",
		"county": "Laurel",
		"title": "5. Laurel",
		"cases_7day_mean_per_100k": 48.9900214965
	},
	{
		"date": "2022-07-13",
		"county": "Laurel",
		"title": "5. Laurel",
		"cases_7day_mean_per_100k": 47.4659691036
	},
	{
		"date": "2022-07-14",
		"county": "Laurel",
		"title": "5. Laurel",
		"cases_7day_mean_per_100k": 46.3275203282
	},
	{
		"date": "2022-07-15",
		"county": "Laurel",
		"title": "5. Laurel",
		"cases_7day_mean_per_100k": 45.2625198609
	},
	{
		"date": "2022-07-16",
		"county": "Laurel",
		"title": "5. Laurel",
		"cases_7day_mean_per_100k": 44.1791573165
	},
	{
		"date": "2022-07-17",
		"county": "Laurel",
		"title": "5. Laurel",
		"cases_7day_mean_per_100k": 44.1240710855
	},
	{
		"date": "2022-07-18",
		"county": "Laurel",
		"title": "5. Laurel",
		"cases_7day_mean_per_100k": 42.1593288441
	},
	{
		"date": "2022-07-19",
		"county": "Laurel",
		"title": "5. Laurel",
		"cases_7day_mean_per_100k": 41.5717423793
	},
	{
		"date": "2022-07-20",
		"county": "Laurel",
		"title": "5. Laurel",
		"cases_7day_mean_per_100k": 39.5335518298
	},
	{
		"date": "2022-07-21",
		"county": "Laurel",
		"title": "5. Laurel",
		"cases_7day_mean_per_100k": 38.4869134395
	},
	{
		"date": "2022-07-22",
		"county": "Laurel",
		"title": "5. Laurel",
		"cases_7day_mean_per_100k": 38.5603617476
	},
	{
		"date": "2022-07-23",
		"county": "Laurel",
		"title": "5. Laurel",
		"cases_7day_mean_per_100k": 38.3951030544
	},
	{
		"date": "2022-07-24",
		"county": "Laurel",
		"title": "5. Laurel",
		"cases_7day_mean_per_100k": 37.1832059709
	},
	{
		"date": "2022-07-25",
		"county": "Laurel",
		"title": "5. Laurel",
		"cases_7day_mean_per_100k": 36.6874298913
	},
	{
		"date": "2022-07-26",
		"county": "Laurel",
		"title": "5. Laurel",
		"cases_7day_mean_per_100k": 36.7057919683
	},
	{
		"date": "2022-07-27",
		"county": "Laurel",
		"title": "5. Laurel",
		"cases_7day_mean_per_100k": 36.5038091211
	},
	{
		"date": "2022-07-28",
		"county": "Laurel",
		"title": "5. Laurel",
		"cases_7day_mean_per_100k": 35.7509639631
	},
	{
		"date": "2022-07-29",
		"county": "Laurel",
		"title": "5. Laurel",
		"cases_7day_mean_per_100k": 34.9246704971
	},
	{
		"date": "2022-07-30",
		"county": "Laurel",
		"title": "5. Laurel",
		"cases_7day_mean_per_100k": 33.9698424919
	},
	{
		"date": "2022-07-31",
		"county": "Laurel",
		"title": "5. Laurel",
		"cases_7day_mean_per_100k": 34.1534632622
	},
	{
		"date": "2022-08-01",
		"county": "Laurel",
		"title": "5. Laurel",
		"cases_7day_mean_per_100k": 32.409065945
	},
	{
		"date": "2022-08-02",
		"county": "Laurel",
		"title": "5. Laurel",
		"cases_7day_mean_per_100k": 30.9217377062
	},
	{
		"date": "2022-08-03",
		"county": "Laurel",
		"title": "5. Laurel",
		"cases_7day_mean_per_100k": 30.2056167023
	},
	{
		"date": "2022-08-04",
		"county": "Laurel",
		"title": "5. Laurel",
		"cases_7day_mean_per_100k": 29.158978312
	},
	{
		"date": "2022-08-05",
		"county": "Laurel",
		"title": "5. Laurel",
		"cases_7day_mean_per_100k": 28.5530297703
	},
	{
		"date": "2022-08-06",
		"county": "Laurel",
		"title": "5. Laurel",
		"cases_7day_mean_per_100k": 28.4795814622
	},
	{
		"date": "2022-08-07",
		"county": "Laurel",
		"title": "5. Laurel",
		"cases_7day_mean_per_100k": 27.5798396881
	},
	{
		"date": "2022-08-08",
		"county": "Laurel",
		"title": "5. Laurel",
		"cases_7day_mean_per_100k": 27.6716500732
	},
	{
		"date": "2022-08-09",
		"county": "Laurel",
		"title": "5. Laurel",
		"cases_7day_mean_per_100k": 26.1843218343
	},
	{
		"date": "2022-08-10",
		"county": "Laurel",
		"title": "5. Laurel",
		"cases_7day_mean_per_100k": 25.3029421372
	},
	{
		"date": "2022-08-11",
		"county": "Laurel",
		"title": "5. Laurel",
		"cases_7day_mean_per_100k": 25.4131145994
	},
	{
		"date": "2022-08-12",
		"county": "Laurel",
		"title": "5. Laurel",
		"cases_7day_mean_per_100k": 24.3848382861
	},
	{
		"date": "2022-08-13",
		"county": "Laurel",
		"title": "5. Laurel",
		"cases_7day_mean_per_100k": 23.5952689741
	},
	{
		"date": "2022-08-14",
		"county": "Laurel",
		"title": "5. Laurel",
		"cases_7day_mean_per_100k": 23.1545791256
	},
	{
		"date": "2022-08-15",
		"county": "Laurel",
		"title": "5. Laurel",
		"cases_7day_mean_per_100k": 22.3282856596
	},
	{
		"date": "2022-08-16",
		"county": "Laurel",
		"title": "5. Laurel",
		"cases_7day_mean_per_100k": 22.2181131974
	},
	{
		"date": "2022-08-17",
		"county": "Laurel",
		"title": "5. Laurel",
		"cases_7day_mean_per_100k": 21.5387163476
	},
	{
		"date": "2022-08-18",
		"county": "Laurel",
		"title": "5. Laurel",
		"cases_7day_mean_per_100k": 19.7392327994
	},
	{
		"date": "2022-08-19",
		"county": "Laurel",
		"title": "5. Laurel",
		"cases_7day_mean_per_100k": 19.9963018777
	},
	{
		"date": "2022-08-20",
		"county": "Laurel",
		"title": "5. Laurel",
		"cases_7day_mean_per_100k": 19.7208707223
	},
	{
		"date": "2022-08-21",
		"county": "Laurel",
		"title": "5. Laurel",
		"cases_7day_mean_per_100k": 19.4821637211
	},
	{
		"date": "2022-08-22",
		"county": "Laurel",
		"title": "5. Laurel",
		"cases_7day_mean_per_100k": 18.619146101
	},
	{
		"date": "2022-08-23",
		"county": "Laurel",
		"title": "5. Laurel",
		"cases_7day_mean_per_100k": 17.4806973256
	},
	{
		"date": "2022-08-24",
		"county": "Laurel",
		"title": "5. Laurel",
		"cases_7day_mean_per_100k": 16.8196625528
	},
	{
		"date": "2022-08-25",
		"county": "Laurel",
		"title": "5. Laurel",
		"cases_7day_mean_per_100k": 17.1501799392
	},
	{
		"date": "2022-08-26",
		"county": "Laurel",
		"title": "5. Laurel",
		"cases_7day_mean_per_100k": 16.195351934
	},
	{
		"date": "2022-08-27",
		"county": "Laurel",
		"title": "5. Laurel",
		"cases_7day_mean_per_100k": 15.7546620855
	},
	{
		"date": "2022-08-28",
		"county": "Laurel",
		"title": "5. Laurel",
		"cases_7day_mean_per_100k": 15.6628517003
	},
	{
		"date": "2022-08-29",
		"county": "Laurel",
		"title": "5. Laurel",
		"cases_7day_mean_per_100k": 15.5159550842
	},
	{
		"date": "2022-08-30",
		"county": "Laurel",
		"title": "5. Laurel",
		"cases_7day_mean_per_100k": 14.8365582343
	},
	{
		"date": "2022-08-31",
		"county": "Laurel",
		"title": "5. Laurel",
		"cases_7day_mean_per_100k": 14.5060408479
	},
	{
		"date": "2022-09-01",
		"county": "Laurel",
		"title": "5. Laurel",
		"cases_7day_mean_per_100k": 14.2673338466
	},
	{
		"date": "2022-09-02",
		"county": "Laurel",
		"title": "5. Laurel",
		"cases_7day_mean_per_100k": 13.6797473819
	},
	{
		"date": "2022-09-03",
		"county": "Laurel",
		"title": "5. Laurel",
		"cases_7day_mean_per_100k": 13.5512128427
	},
	{
		"date": "2022-09-04",
		"county": "Laurel",
		"title": "5. Laurel",
		"cases_7day_mean_per_100k": 12.945264301
	},
	{
		"date": "2022-09-05",
		"county": "Laurel",
		"title": "5. Laurel",
		"cases_7day_mean_per_100k": 11.2008669838
	},
	{
		"date": "2022-09-06",
		"county": "Laurel",
		"title": "5. Laurel",
		"cases_7day_mean_per_100k": 11.4762981392
	},
	{
		"date": "2022-09-07",
		"county": "Laurel",
		"title": "5. Laurel",
		"cases_7day_mean_per_100k": 11.5130222932
	},
	{
		"date": "2022-09-08",
		"county": "Laurel",
		"title": "5. Laurel",
		"cases_7day_mean_per_100k": 11.4762981392
	},
	{
		"date": "2022-09-09",
		"county": "Laurel",
		"title": "5. Laurel",
		"cases_7day_mean_per_100k": 11.2559532149
	},
	{
		"date": "2022-09-10",
		"county": "Laurel",
		"title": "5. Laurel",
		"cases_7day_mean_per_100k": 10.7418150583
	},
	{
		"date": "2022-09-11",
		"county": "Laurel",
		"title": "5. Laurel",
		"cases_7day_mean_per_100k": 10.9805220596
	},
	{
		"date": "2022-09-12",
		"county": "Laurel",
		"title": "5. Laurel",
		"cases_7day_mean_per_100k": 12.0087983728
	},
	{
		"date": "2022-09-13",
		"county": "Laurel",
		"title": "5. Laurel",
		"cases_7day_mean_per_100k": 11.4762981392
	},
	{
		"date": "2022-09-14",
		"county": "Laurel",
		"title": "5. Laurel",
		"cases_7day_mean_per_100k": 11.0723324447
	},
	{
		"date": "2022-09-15",
		"county": "Laurel",
		"title": "5. Laurel",
		"cases_7day_mean_per_100k": 10.6132805191
	},
	{
		"date": "2022-09-16",
		"county": "Laurel",
		"title": "5. Laurel",
		"cases_7day_mean_per_100k": 10.7785392123
	},
	{
		"date": "2022-09-17",
		"county": "Laurel",
		"title": "5. Laurel",
		"cases_7day_mean_per_100k": 11.0172462136
	},
	{
		"date": "2022-09-18",
		"county": "Laurel",
		"title": "5. Laurel",
		"cases_7day_mean_per_100k": 10.8336254434
	},
	{
		"date": "2022-09-19",
		"county": "Laurel",
		"title": "5. Laurel",
		"cases_7day_mean_per_100k": 10.7234529812
	},
	{
		"date": "2022-09-20",
		"county": "Laurel",
		"title": "5. Laurel",
		"cases_7day_mean_per_100k": 10.8336254434
	},
	{
		"date": "2022-09-21",
		"county": "Laurel",
		"title": "5. Laurel",
		"cases_7day_mean_per_100k": 10.7785392123
	},
	{
		"date": "2022-09-22",
		"county": "Laurel",
		"title": "5. Laurel",
		"cases_7day_mean_per_100k": 10.7785392123
	},
	{
		"date": "2022-09-23",
		"county": "Laurel",
		"title": "5. Laurel",
		"cases_7day_mean_per_100k": 10.2644010557
	},
	{
		"date": "2022-09-24",
		"county": "Laurel",
		"title": "5. Laurel",
		"cases_7day_mean_per_100k": 10.2827631327
	},
	{
		"date": "2022-09-25",
		"county": "Laurel",
		"title": "5. Laurel",
		"cases_7day_mean_per_100k": 10.4112976719
	},
	{
		"date": "2022-09-26",
		"county": "Laurel",
		"title": "5. Laurel",
		"cases_7day_mean_per_100k": 10.7601771353
	},
	{
		"date": "2022-09-27",
		"county": "Laurel",
		"title": "5. Laurel",
		"cases_7day_mean_per_100k": 10.558194288
	},
	{
		"date": "2022-09-28",
		"county": "Laurel",
		"title": "5. Laurel",
		"cases_7day_mean_per_100k": 10.3011252097
	},
	{
		"date": "2022-09-29",
		"county": "Laurel",
		"title": "5. Laurel",
		"cases_7day_mean_per_100k": 10.3011252097
	},
	{
		"date": "2022-09-30",
		"county": "Laurel",
		"title": "5. Laurel",
		"cases_7day_mean_per_100k": 10.6500046731
	},
	{
		"date": "2022-10-01",
		"county": "Laurel",
		"title": "5. Laurel",
		"cases_7day_mean_per_100k": 10.539832211
	},
	{
		"date": "2022-10-02",
		"county": "Laurel",
		"title": "5. Laurel",
		"cases_7day_mean_per_100k": 10.0256940544
	},
	{
		"date": "2022-10-03",
		"county": "Laurel",
		"title": "5. Laurel",
		"cases_7day_mean_per_100k": 9.9338836693
	},
	{
		"date": "2022-10-04",
		"county": "Laurel",
		"title": "5. Laurel",
		"cases_7day_mean_per_100k": 9.8237112071
	},
	{
		"date": "2022-10-05",
		"county": "Laurel",
		"title": "5. Laurel",
		"cases_7day_mean_per_100k": 10.1175044395
	},
	{
		"date": "2022-10-06",
		"county": "Laurel",
		"title": "5. Laurel",
		"cases_7day_mean_per_100k": 10.1542285935
	},
	{
		"date": "2022-10-07",
		"county": "Laurel",
		"title": "5. Laurel",
		"cases_7day_mean_per_100k": 9.8237112071
	},
	{
		"date": "2022-10-08",
		"county": "Laurel",
		"title": "5. Laurel",
		"cases_7day_mean_per_100k": 9.9338836693
	},
	{
		"date": "2022-10-09",
		"county": "Laurel",
		"title": "5. Laurel",
		"cases_7day_mean_per_100k": 10.0624182084
	},
	{
		"date": "2022-10-10",
		"county": "Laurel",
		"title": "5. Laurel",
		"cases_7day_mean_per_100k": 9.7869870531
	},
	{
		"date": "2022-10-11",
		"county": "Laurel",
		"title": "5. Laurel",
		"cases_7day_mean_per_100k": 9.8971595152
	},
	{
		"date": "2022-10-12",
		"county": "Laurel",
		"title": "5. Laurel",
		"cases_7day_mean_per_100k": 9.750262899
	},
	{
		"date": "2022-10-13",
		"county": "Laurel",
		"title": "5. Laurel",
		"cases_7day_mean_per_100k": 9.8053491301
	},
	{
		"date": "2022-10-14",
		"county": "Laurel",
		"title": "5. Laurel",
		"cases_7day_mean_per_100k": 10.3011252097
	},
	{
		"date": "2022-10-15",
		"county": "Laurel",
		"title": "5. Laurel",
		"cases_7day_mean_per_100k": 9.9706078233
	},
	{
		"date": "2022-10-16",
		"county": "Laurel",
		"title": "5. Laurel",
		"cases_7day_mean_per_100k": 10.0256940544
	},
	{
		"date": "2022-10-17",
		"county": "Laurel",
		"title": "5. Laurel",
		"cases_7day_mean_per_100k": 9.9706078233
	},
	{
		"date": "2022-10-18",
		"county": "Laurel",
		"title": "5. Laurel",
		"cases_7day_mean_per_100k": 9.5299179748
	},
	{
		"date": "2022-10-19",
		"county": "Laurel",
		"title": "5. Laurel",
		"cases_7day_mean_per_100k": 9.4748317437
	},
	{
		"date": "2022-10-20",
		"county": "Laurel",
		"title": "5. Laurel",
		"cases_7day_mean_per_100k": 9.1994005884
	},
	{
		"date": "2022-10-21",
		"county": "Laurel",
		"title": "5. Laurel",
		"cases_7day_mean_per_100k": 8.8321590479
	},
	{
		"date": "2022-10-22",
		"county": "Laurel",
		"title": "5. Laurel",
		"cases_7day_mean_per_100k": 8.6118141236
	},
	{
		"date": "2022-10-23",
		"county": "Laurel",
		"title": "5. Laurel",
		"cases_7day_mean_per_100k": 8.6669003547
	},
	{
		"date": "2022-10-24",
		"county": "Laurel",
		"title": "5. Laurel",
		"cases_7day_mean_per_100k": 8.4832795845
	},
	{
		"date": "2022-10-25",
		"county": "Laurel",
		"title": "5. Laurel",
		"cases_7day_mean_per_100k": 8.4281933534
	},
	{
		"date": "2022-10-26",
		"county": "Laurel",
		"title": "5. Laurel",
		"cases_7day_mean_per_100k": 8.3914691994
	},
	{
		"date": "2022-10-27",
		"county": "Laurel",
		"title": "5. Laurel",
		"cases_7day_mean_per_100k": 8.7770728168
	},
	{
		"date": "2022-10-28",
		"county": "Laurel",
		"title": "5. Laurel",
		"cases_7day_mean_per_100k": 9.0341418952
	},
	{
		"date": "2022-10-29",
		"county": "Laurel",
		"title": "5. Laurel",
		"cases_7day_mean_per_100k": 9.3646592816
	},
	{
		"date": "2022-10-30",
		"county": "Laurel",
		"title": "5. Laurel",
		"cases_7day_mean_per_100k": 9.2912109735
	},
	{
		"date": "2022-10-31",
		"county": "Laurel",
		"title": "5. Laurel",
		"cases_7day_mean_per_100k": 9.1075902032
	},
	{
		"date": "2022-11-01",
		"county": "Laurel",
		"title": "5. Laurel",
		"cases_7day_mean_per_100k": 9.6033662829
	},
	{
		"date": "2022-11-02",
		"county": "Laurel",
		"title": "5. Laurel",
		"cases_7day_mean_per_100k": 9.5850042058
	},
	{
		"date": "2022-11-03",
		"county": "Laurel",
		"title": "5. Laurel",
		"cases_7day_mean_per_100k": 8.9974177411
	},
	{
		"date": "2022-11-04",
		"county": "Laurel",
		"title": "5. Laurel",
		"cases_7day_mean_per_100k": 8.7770728168
	},
	{
		"date": "2022-11-05",
		"county": "Laurel",
		"title": "5. Laurel",
		"cases_7day_mean_per_100k": 8.5750899696
	},
	{
		"date": "2022-11-06",
		"county": "Laurel",
		"title": "5. Laurel",
		"cases_7day_mean_per_100k": 8.0425897359
	},
	{
		"date": "2022-11-07",
		"county": "Laurel",
		"title": "5. Laurel",
		"cases_7day_mean_per_100k": 6.5368994201
	},
	{
		"date": "2022-11-08",
		"county": "Laurel",
		"title": "5. Laurel",
		"cases_7day_mean_per_100k": 4.9393987191
	},
	{
		"date": "2022-03-01",
		"county": "Grayson",
		"title": "2. Grayson",
		"cases_7day_mean_per_100k": 18.0102986162
	},
	{
		"date": "2022-03-02",
		"county": "Grayson",
		"title": "2. Grayson",
		"cases_7day_mean_per_100k": 15.0085821802
	},
	{
		"date": "2022-03-03",
		"county": "Grayson",
		"title": "2. Grayson",
		"cases_7day_mean_per_100k": 13.9170489307
	},
	{
		"date": "2022-03-04",
		"county": "Grayson",
		"title": "2. Grayson",
		"cases_7day_mean_per_100k": 14.1899322431
	},
	{
		"date": "2022-03-05",
		"county": "Grayson",
		"title": "2. Grayson",
		"cases_7day_mean_per_100k": 14.7356988678
	},
	{
		"date": "2022-03-06",
		"county": "Grayson",
		"title": "2. Grayson",
		"cases_7day_mean_per_100k": 15.0085821802
	},
	{
		"date": "2022-03-07",
		"county": "Grayson",
		"title": "2. Grayson",
		"cases_7day_mean_per_100k": 13.0983989936
	},
	{
		"date": "2022-03-08",
		"county": "Grayson",
		"title": "2. Grayson",
		"cases_7day_mean_per_100k": 12.0068657441
	},
	{
		"date": "2022-03-09",
		"county": "Grayson",
		"title": "2. Grayson",
		"cases_7day_mean_per_100k": 11.4610991194
	},
	{
		"date": "2022-03-10",
		"county": "Grayson",
		"title": "2. Grayson",
		"cases_7day_mean_per_100k": 10.6424491823
	},
	{
		"date": "2022-03-11",
		"county": "Grayson",
		"title": "2. Grayson",
		"cases_7day_mean_per_100k": 8.4593826834
	},
	{
		"date": "2022-03-12",
		"county": "Grayson",
		"title": "2. Grayson",
		"cases_7day_mean_per_100k": 7.6407327463
	},
	{
		"date": "2022-03-13",
		"county": "Grayson",
		"title": "2. Grayson",
		"cases_7day_mean_per_100k": 6.8220828092
	},
	{
		"date": "2022-03-14",
		"county": "Grayson",
		"title": "2. Grayson",
		"cases_7day_mean_per_100k": 6.0034328721
	},
	{
		"date": "2022-03-15",
		"county": "Grayson",
		"title": "2. Grayson",
		"cases_7day_mean_per_100k": 4.6390163102
	},
	{
		"date": "2022-03-16",
		"county": "Grayson",
		"title": "2. Grayson",
		"cases_7day_mean_per_100k": 4.3661329979
	},
	{
		"date": "2022-03-17",
		"county": "Grayson",
		"title": "2. Grayson",
		"cases_7day_mean_per_100k": 5.184782935
	},
	{
		"date": "2022-03-18",
		"county": "Grayson",
		"title": "2. Grayson",
		"cases_7day_mean_per_100k": 4.9118996226
	},
	{
		"date": "2022-03-19",
		"county": "Grayson",
		"title": "2. Grayson",
		"cases_7day_mean_per_100k": 4.6390163102
	},
	{
		"date": "2022-03-20",
		"county": "Grayson",
		"title": "2. Grayson",
		"cases_7day_mean_per_100k": 4.6390163102
	},
	{
		"date": "2022-03-21",
		"county": "Grayson",
		"title": "2. Grayson",
		"cases_7day_mean_per_100k": 5.184782935
	},
	{
		"date": "2022-03-22",
		"county": "Grayson",
		"title": "2. Grayson",
		"cases_7day_mean_per_100k": 4.9118996226
	},
	{
		"date": "2022-03-23",
		"county": "Grayson",
		"title": "2. Grayson",
		"cases_7day_mean_per_100k": 3.8203663731
	},
	{
		"date": "2022-03-24",
		"county": "Grayson",
		"title": "2. Grayson",
		"cases_7day_mean_per_100k": 2.7288331237
	},
	{
		"date": "2022-03-25",
		"county": "Grayson",
		"title": "2. Grayson",
		"cases_7day_mean_per_100k": 2.7288331237
	},
	{
		"date": "2022-03-26",
		"county": "Grayson",
		"title": "2. Grayson",
		"cases_7day_mean_per_100k": 2.7288331237
	},
	{
		"date": "2022-03-27",
		"county": "Grayson",
		"title": "2. Grayson",
		"cases_7day_mean_per_100k": 3.001716436
	},
	{
		"date": "2022-03-28",
		"county": "Grayson",
		"title": "2. Grayson",
		"cases_7day_mean_per_100k": 1.9101831866
	},
	{
		"date": "2022-03-29",
		"county": "Grayson",
		"title": "2. Grayson",
		"cases_7day_mean_per_100k": 1.9101831866
	},
	{
		"date": "2022-03-30",
		"county": "Grayson",
		"title": "2. Grayson",
		"cases_7day_mean_per_100k": 2.4559498113
	},
	{
		"date": "2022-03-31",
		"county": "Grayson",
		"title": "2. Grayson",
		"cases_7day_mean_per_100k": 2.7288331237
	},
	{
		"date": "2022-04-01",
		"county": "Grayson",
		"title": "2. Grayson",
		"cases_7day_mean_per_100k": 2.4559498113
	},
	{
		"date": "2022-04-02",
		"county": "Grayson",
		"title": "2. Grayson",
		"cases_7day_mean_per_100k": 2.4559498113
	},
	{
		"date": "2022-04-03",
		"county": "Grayson",
		"title": "2. Grayson",
		"cases_7day_mean_per_100k": 2.4559498113
	},
	{
		"date": "2022-04-04",
		"county": "Grayson",
		"title": "2. Grayson",
		"cases_7day_mean_per_100k": 2.4559498113
	},
	{
		"date": "2022-04-05",
		"county": "Grayson",
		"title": "2. Grayson",
		"cases_7day_mean_per_100k": 4.3661329979
	},
	{
		"date": "2022-04-06",
		"county": "Grayson",
		"title": "2. Grayson",
		"cases_7day_mean_per_100k": 4.0932496855
	},
	{
		"date": "2022-04-07",
		"county": "Grayson",
		"title": "2. Grayson",
		"cases_7day_mean_per_100k": 4.0932496855
	},
	{
		"date": "2022-04-08",
		"county": "Grayson",
		"title": "2. Grayson",
		"cases_7day_mean_per_100k": 4.3661329979
	},
	{
		"date": "2022-04-09",
		"county": "Grayson",
		"title": "2. Grayson",
		"cases_7day_mean_per_100k": 4.3661329979
	},
	{
		"date": "2022-04-10",
		"county": "Grayson",
		"title": "2. Grayson",
		"cases_7day_mean_per_100k": 4.3661329979
	},
	{
		"date": "2022-04-11",
		"county": "Grayson",
		"title": "2. Grayson",
		"cases_7day_mean_per_100k": 6.0034328721
	},
	{
		"date": "2022-04-12",
		"county": "Grayson",
		"title": "2. Grayson",
		"cases_7day_mean_per_100k": 4.9118996226
	},
	{
		"date": "2022-04-13",
		"county": "Grayson",
		"title": "2. Grayson",
		"cases_7day_mean_per_100k": 5.184782935
	},
	{
		"date": "2022-04-14",
		"county": "Grayson",
		"title": "2. Grayson",
		"cases_7day_mean_per_100k": 6.2763161844
	},
	{
		"date": "2022-04-15",
		"county": "Grayson",
		"title": "2. Grayson",
		"cases_7day_mean_per_100k": 6.8220828092
	},
	{
		"date": "2022-04-16",
		"county": "Grayson",
		"title": "2. Grayson",
		"cases_7day_mean_per_100k": 7.3678494339
	},
	{
		"date": "2022-04-17",
		"county": "Grayson",
		"title": "2. Grayson",
		"cases_7day_mean_per_100k": 7.0949661215
	},
	{
		"date": "2022-04-18",
		"county": "Grayson",
		"title": "2. Grayson",
		"cases_7day_mean_per_100k": 6.8220828092
	},
	{
		"date": "2022-04-19",
		"county": "Grayson",
		"title": "2. Grayson",
		"cases_7day_mean_per_100k": 7.9136160586
	},
	{
		"date": "2022-04-20",
		"county": "Grayson",
		"title": "2. Grayson",
		"cases_7day_mean_per_100k": 7.9136160586
	},
	{
		"date": "2022-04-21",
		"county": "Grayson",
		"title": "2. Grayson",
		"cases_7day_mean_per_100k": 7.6407327463
	},
	{
		"date": "2022-04-22",
		"county": "Grayson",
		"title": "2. Grayson",
		"cases_7day_mean_per_100k": 7.9136160586
	},
	{
		"date": "2022-04-23",
		"county": "Grayson",
		"title": "2. Grayson",
		"cases_7day_mean_per_100k": 8.7322659957
	},
	{
		"date": "2022-04-24",
		"county": "Grayson",
		"title": "2. Grayson",
		"cases_7day_mean_per_100k": 9.8237992452
	},
	{
		"date": "2022-04-25",
		"county": "Grayson",
		"title": "2. Grayson",
		"cases_7day_mean_per_100k": 11.7339824318
	},
	{
		"date": "2022-04-26",
		"county": "Grayson",
		"title": "2. Grayson",
		"cases_7day_mean_per_100k": 12.2797490565
	},
	{
		"date": "2022-04-27",
		"county": "Grayson",
		"title": "2. Grayson",
		"cases_7day_mean_per_100k": 16.9187653667
	},
	{
		"date": "2022-04-28",
		"county": "Grayson",
		"title": "2. Grayson",
		"cases_7day_mean_per_100k": 20.1933651151
	},
	{
		"date": "2022-04-29",
		"county": "Grayson",
		"title": "2. Grayson",
		"cases_7day_mean_per_100k": 22.1035483017
	},
	{
		"date": "2022-04-30",
		"county": "Grayson",
		"title": "2. Grayson",
		"cases_7day_mean_per_100k": 22.3764316141
	},
	{
		"date": "2022-05-01",
		"county": "Grayson",
		"title": "2. Grayson",
		"cases_7day_mean_per_100k": 23.4679648635
	},
	{
		"date": "2022-05-02",
		"county": "Grayson",
		"title": "2. Grayson",
		"cases_7day_mean_per_100k": 25.1052647377
	},
	{
		"date": "2022-05-03",
		"county": "Grayson",
		"title": "2. Grayson",
		"cases_7day_mean_per_100k": 24.2866148006
	},
	{
		"date": "2022-05-04",
		"county": "Grayson",
		"title": "2. Grayson",
		"cases_7day_mean_per_100k": 22.6493149264
	},
	{
		"date": "2022-05-05",
		"county": "Grayson",
		"title": "2. Grayson",
		"cases_7day_mean_per_100k": 19.9204818028
	},
	{
		"date": "2022-05-06",
		"county": "Grayson",
		"title": "2. Grayson",
		"cases_7day_mean_per_100k": 21.557781677
	},
	{
		"date": "2022-05-07",
		"county": "Grayson",
		"title": "2. Grayson",
		"cases_7day_mean_per_100k": 21.557781677
	},
	{
		"date": "2022-05-08",
		"county": "Grayson",
		"title": "2. Grayson",
		"cases_7day_mean_per_100k": 21.0120150522
	},
	{
		"date": "2022-05-09",
		"county": "Grayson",
		"title": "2. Grayson",
		"cases_7day_mean_per_100k": 19.374715178
	},
	{
		"date": "2022-05-10",
		"county": "Grayson",
		"title": "2. Grayson",
		"cases_7day_mean_per_100k": 19.9204818028
	},
	{
		"date": "2022-05-11",
		"county": "Grayson",
		"title": "2. Grayson",
		"cases_7day_mean_per_100k": 19.6475984904
	},
	{
		"date": "2022-05-12",
		"county": "Grayson",
		"title": "2. Grayson",
		"cases_7day_mean_per_100k": 22.3764316141
	},
	{
		"date": "2022-05-13",
		"county": "Grayson",
		"title": "2. Grayson",
		"cases_7day_mean_per_100k": 22.9221982388
	},
	{
		"date": "2022-05-14",
		"county": "Grayson",
		"title": "2. Grayson",
		"cases_7day_mean_per_100k": 25.3781480501
	},
	{
		"date": "2022-05-15",
		"county": "Grayson",
		"title": "2. Grayson",
		"cases_7day_mean_per_100k": 26.4696812996
	},
	{
		"date": "2022-05-16",
		"county": "Grayson",
		"title": "2. Grayson",
		"cases_7day_mean_per_100k": 37.6578971066
	},
	{
		"date": "2022-05-17",
		"county": "Grayson",
		"title": "2. Grayson",
		"cases_7day_mean_per_100k": 44.4799799158
	},
	{
		"date": "2022-05-18",
		"county": "Grayson",
		"title": "2. Grayson",
		"cases_7day_mean_per_100k": 45.0257465405
	},
	{
		"date": "2022-05-19",
		"county": "Grayson",
		"title": "2. Grayson",
		"cases_7day_mean_per_100k": 45.5715131653
	},
	{
		"date": "2022-05-20",
		"county": "Grayson",
		"title": "2. Grayson",
		"cases_7day_mean_per_100k": 46.6630464147
	},
	{
		"date": "2022-05-21",
		"county": "Grayson",
		"title": "2. Grayson",
		"cases_7day_mean_per_100k": 47.4816963518
	},
	{
		"date": "2022-05-22",
		"county": "Grayson",
		"title": "2. Grayson",
		"cases_7day_mean_per_100k": 46.3901631024
	},
	{
		"date": "2022-05-23",
		"county": "Grayson",
		"title": "2. Grayson",
		"cases_7day_mean_per_100k": 37.1121304819
	},
	{
		"date": "2022-05-24",
		"county": "Grayson",
		"title": "2. Grayson",
		"cases_7day_mean_per_100k": 34.6561806706
	},
	{
		"date": "2022-05-25",
		"county": "Grayson",
		"title": "2. Grayson",
		"cases_7day_mean_per_100k": 34.929063983
	},
	{
		"date": "2022-05-26",
		"county": "Grayson",
		"title": "2. Grayson",
		"cases_7day_mean_per_100k": 35.7477139201
	},
	{
		"date": "2022-05-27",
		"county": "Grayson",
		"title": "2. Grayson",
		"cases_7day_mean_per_100k": 34.6561806706
	},
	{
		"date": "2022-05-28",
		"county": "Grayson",
		"title": "2. Grayson",
		"cases_7day_mean_per_100k": 32.2002308593
	},
	{
		"date": "2022-05-29",
		"county": "Grayson",
		"title": "2. Grayson",
		"cases_7day_mean_per_100k": 34.3832973582
	},
	{
		"date": "2022-05-30",
		"county": "Grayson",
		"title": "2. Grayson",
		"cases_7day_mean_per_100k": 33.0188807964
	},
	{
		"date": "2022-05-31",
		"county": "Grayson",
		"title": "2. Grayson",
		"cases_7day_mean_per_100k": 33.2917641087
	},
	{
		"date": "2022-06-01",
		"county": "Grayson",
		"title": "2. Grayson",
		"cases_7day_mean_per_100k": 33.2917641087
	},
	{
		"date": "2022-06-02",
		"county": "Grayson",
		"title": "2. Grayson",
		"cases_7day_mean_per_100k": 31.1086976098
	},
	{
		"date": "2022-06-03",
		"county": "Grayson",
		"title": "2. Grayson",
		"cases_7day_mean_per_100k": 30.8358142974
	},
	{
		"date": "2022-06-04",
		"county": "Grayson",
		"title": "2. Grayson",
		"cases_7day_mean_per_100k": 31.1086976098
	},
	{
		"date": "2022-06-05",
		"county": "Grayson",
		"title": "2. Grayson",
		"cases_7day_mean_per_100k": 29.744281048
	},
	{
		"date": "2022-06-06",
		"county": "Grayson",
		"title": "2. Grayson",
		"cases_7day_mean_per_100k": 33.5646474211
	},
	{
		"date": "2022-06-07",
		"county": "Grayson",
		"title": "2. Grayson",
		"cases_7day_mean_per_100k": 31.9273475469
	},
	{
		"date": "2022-06-08",
		"county": "Grayson",
		"title": "2. Grayson",
		"cases_7day_mean_per_100k": 31.3815809222
	},
	{
		"date": "2022-06-09",
		"county": "Grayson",
		"title": "2. Grayson",
		"cases_7day_mean_per_100k": 31.9273475469
	},
	{
		"date": "2022-06-10",
		"county": "Grayson",
		"title": "2. Grayson",
		"cases_7day_mean_per_100k": 35.2019472953
	},
	{
		"date": "2022-06-11",
		"county": "Grayson",
		"title": "2. Grayson",
		"cases_7day_mean_per_100k": 36.0205972324
	},
	{
		"date": "2022-06-12",
		"county": "Grayson",
		"title": "2. Grayson",
		"cases_7day_mean_per_100k": 40.3867302303
	},
	{
		"date": "2022-06-13",
		"county": "Grayson",
		"title": "2. Grayson",
		"cases_7day_mean_per_100k": 40.1138469179
	},
	{
		"date": "2022-06-14",
		"county": "Grayson",
		"title": "2. Grayson",
		"cases_7day_mean_per_100k": 41.2053801674
	},
	{
		"date": "2022-06-15",
		"county": "Grayson",
		"title": "2. Grayson",
		"cases_7day_mean_per_100k": 43.3884466663
	},
	{
		"date": "2022-06-16",
		"county": "Grayson",
		"title": "2. Grayson",
		"cases_7day_mean_per_100k": 42.0240301045
	},
	{
		"date": "2022-06-17",
		"county": "Grayson",
		"title": "2. Grayson",
		"cases_7day_mean_per_100k": 40.1138469179
	},
	{
		"date": "2022-06-18",
		"county": "Grayson",
		"title": "2. Grayson",
		"cases_7day_mean_per_100k": 39.8409636056
	},
	{
		"date": "2022-06-19",
		"county": "Grayson",
		"title": "2. Grayson",
		"cases_7day_mean_per_100k": 38.7494303561
	},
	{
		"date": "2022-06-20",
		"county": "Grayson",
		"title": "2. Grayson",
		"cases_7day_mean_per_100k": 38.4765470437
	},
	{
		"date": "2022-06-21",
		"county": "Grayson",
		"title": "2. Grayson",
		"cases_7day_mean_per_100k": 42.0240301045
	},
	{
		"date": "2022-06-22",
		"county": "Grayson",
		"title": "2. Grayson",
		"cases_7day_mean_per_100k": 42.8426800416
	},
	{
		"date": "2022-06-23",
		"county": "Grayson",
		"title": "2. Grayson",
		"cases_7day_mean_per_100k": 45.0257465405
	},
	{
		"date": "2022-06-24",
		"county": "Grayson",
		"title": "2. Grayson",
		"cases_7day_mean_per_100k": 45.8443964776
	},
	{
		"date": "2022-06-25",
		"county": "Grayson",
		"title": "2. Grayson",
		"cases_7day_mean_per_100k": 47.4816963518
	},
	{
		"date": "2022-06-26",
		"county": "Grayson",
		"title": "2. Grayson",
		"cases_7day_mean_per_100k": 46.3901631024
	},
	{
		"date": "2022-06-27",
		"county": "Grayson",
		"title": "2. Grayson",
		"cases_7day_mean_per_100k": 46.6630464147
	},
	{
		"date": "2022-06-28",
		"county": "Grayson",
		"title": "2. Grayson",
		"cases_7day_mean_per_100k": 46.3901631024
	},
	{
		"date": "2022-06-29",
		"county": "Grayson",
		"title": "2. Grayson",
		"cases_7day_mean_per_100k": 48.3003462889
	},
	{
		"date": "2022-06-30",
		"county": "Grayson",
		"title": "2. Grayson",
		"cases_7day_mean_per_100k": 49.6647628508
	},
	{
		"date": "2022-07-01",
		"county": "Grayson",
		"title": "2. Grayson",
		"cases_7day_mean_per_100k": 47.4816963518
	},
	{
		"date": "2022-07-02",
		"county": "Grayson",
		"title": "2. Grayson",
		"cases_7day_mean_per_100k": 47.4816963518
	},
	{
		"date": "2022-07-03",
		"county": "Grayson",
		"title": "2. Grayson",
		"cases_7day_mean_per_100k": 46.11727979
	},
	{
		"date": "2022-07-04",
		"county": "Grayson",
		"title": "2. Grayson",
		"cases_7day_mean_per_100k": 44.7528632282
	},
	{
		"date": "2022-07-05",
		"county": "Grayson",
		"title": "2. Grayson",
		"cases_7day_mean_per_100k": 46.6630464147
	},
	{
		"date": "2022-07-06",
		"county": "Grayson",
		"title": "2. Grayson",
		"cases_7day_mean_per_100k": 47.4816963518
	},
	{
		"date": "2022-07-07",
		"county": "Grayson",
		"title": "2. Grayson",
		"cases_7day_mean_per_100k": 49.9376461631
	},
	{
		"date": "2022-07-08",
		"county": "Grayson",
		"title": "2. Grayson",
		"cases_7day_mean_per_100k": 54.8495457857
	},
	{
		"date": "2022-07-09",
		"county": "Grayson",
		"title": "2. Grayson",
		"cases_7day_mean_per_100k": 58.1241455341
	},
	{
		"date": "2022-07-10",
		"county": "Grayson",
		"title": "2. Grayson",
		"cases_7day_mean_per_100k": 64.9462283433
	},
	{
		"date": "2022-07-11",
		"county": "Grayson",
		"title": "2. Grayson",
		"cases_7day_mean_per_100k": 68.2208280917
	},
	{
		"date": "2022-07-12",
		"county": "Grayson",
		"title": "2. Grayson",
		"cases_7day_mean_per_100k": 67.675061467
	},
	{
		"date": "2022-07-13",
		"county": "Grayson",
		"title": "2. Grayson",
		"cases_7day_mean_per_100k": 67.675061467
	},
	{
		"date": "2022-07-14",
		"county": "Grayson",
		"title": "2. Grayson",
		"cases_7day_mean_per_100k": 65.2191116557
	},
	{
		"date": "2022-07-15",
		"county": "Grayson",
		"title": "2. Grayson",
		"cases_7day_mean_per_100k": 66.0377615928
	},
	{
		"date": "2022-07-16",
		"county": "Grayson",
		"title": "2. Grayson",
		"cases_7day_mean_per_100k": 69.3123613412
	},
	{
		"date": "2022-07-17",
		"county": "Grayson",
		"title": "2. Grayson",
		"cases_7day_mean_per_100k": 65.491994968
	},
	{
		"date": "2022-07-18",
		"county": "Grayson",
		"title": "2. Grayson",
		"cases_7day_mean_per_100k": 64.9462283433
	},
	{
		"date": "2022-07-19",
		"county": "Grayson",
		"title": "2. Grayson",
		"cases_7day_mean_per_100k": 63.8546950938
	},
	{
		"date": "2022-07-20",
		"county": "Grayson",
		"title": "2. Grayson",
		"cases_7day_mean_per_100k": 61.1258619702
	},
	{
		"date": "2022-07-21",
		"county": "Grayson",
		"title": "2. Grayson",
		"cases_7day_mean_per_100k": 61.6716285949
	},
	{
		"date": "2022-07-22",
		"county": "Grayson",
		"title": "2. Grayson",
		"cases_7day_mean_per_100k": 59.7614454083
	},
	{
		"date": "2022-07-23",
		"county": "Grayson",
		"title": "2. Grayson",
		"cases_7day_mean_per_100k": 54.5766624734
	},
	{
		"date": "2022-07-24",
		"county": "Grayson",
		"title": "2. Grayson",
		"cases_7day_mean_per_100k": 54.303779161
	},
	{
		"date": "2022-07-25",
		"county": "Grayson",
		"title": "2. Grayson",
		"cases_7day_mean_per_100k": 54.5766624734
	},
	{
		"date": "2022-07-26",
		"county": "Grayson",
		"title": "2. Grayson",
		"cases_7day_mean_per_100k": 49.9376461631
	},
	{
		"date": "2022-07-27",
		"county": "Grayson",
		"title": "2. Grayson",
		"cases_7day_mean_per_100k": 48.5732296013
	},
	{
		"date": "2022-07-28",
		"county": "Grayson",
		"title": "2. Grayson",
		"cases_7day_mean_per_100k": 49.6647628508
	},
	{
		"date": "2022-07-29",
		"county": "Grayson",
		"title": "2. Grayson",
		"cases_7day_mean_per_100k": 45.8443964776
	},
	{
		"date": "2022-07-30",
		"county": "Grayson",
		"title": "2. Grayson",
		"cases_7day_mean_per_100k": 42.8426800416
	},
	{
		"date": "2022-07-31",
		"county": "Grayson",
		"title": "2. Grayson",
		"cases_7day_mean_per_100k": 41.7511467921
	},
	{
		"date": "2022-08-01",
		"county": "Grayson",
		"title": "2. Grayson",
		"cases_7day_mean_per_100k": 39.0223136685
	},
	{
		"date": "2022-08-02",
		"county": "Grayson",
		"title": "2. Grayson",
		"cases_7day_mean_per_100k": 39.0223136685
	},
	{
		"date": "2022-08-03",
		"county": "Grayson",
		"title": "2. Grayson",
		"cases_7day_mean_per_100k": 38.4765470437
	},
	{
		"date": "2022-08-04",
		"county": "Grayson",
		"title": "2. Grayson",
		"cases_7day_mean_per_100k": 35.4748306077
	},
	{
		"date": "2022-08-05",
		"county": "Grayson",
		"title": "2. Grayson",
		"cases_7day_mean_per_100k": 36.8392471695
	},
	{
		"date": "2022-08-06",
		"county": "Grayson",
		"title": "2. Grayson",
		"cases_7day_mean_per_100k": 36.8392471695
	},
	{
		"date": "2022-08-07",
		"county": "Grayson",
		"title": "2. Grayson",
		"cases_7day_mean_per_100k": 33.8375307335
	},
	{
		"date": "2022-08-08",
		"county": "Grayson",
		"title": "2. Grayson",
		"cases_7day_mean_per_100k": 31.9273475469
	},
	{
		"date": "2022-08-09",
		"county": "Grayson",
		"title": "2. Grayson",
		"cases_7day_mean_per_100k": 28.9256311109
	},
	{
		"date": "2022-08-10",
		"county": "Grayson",
		"title": "2. Grayson",
		"cases_7day_mean_per_100k": 28.6527477985
	},
	{
		"date": "2022-08-11",
		"county": "Grayson",
		"title": "2. Grayson",
		"cases_7day_mean_per_100k": 33.0188807964
	},
	{
		"date": "2022-08-12",
		"county": "Grayson",
		"title": "2. Grayson",
		"cases_7day_mean_per_100k": 28.6527477985
	},
	{
		"date": "2022-08-13",
		"county": "Grayson",
		"title": "2. Grayson",
		"cases_7day_mean_per_100k": 27.0154479243
	},
	{
		"date": "2022-08-14",
		"county": "Grayson",
		"title": "2. Grayson",
		"cases_7day_mean_per_100k": 28.6527477985
	},
	{
		"date": "2022-08-15",
		"county": "Grayson",
		"title": "2. Grayson",
		"cases_7day_mean_per_100k": 29.4713977356
	},
	{
		"date": "2022-08-16",
		"county": "Grayson",
		"title": "2. Grayson",
		"cases_7day_mean_per_100k": 29.4713977356
	},
	{
		"date": "2022-08-17",
		"county": "Grayson",
		"title": "2. Grayson",
		"cases_7day_mean_per_100k": 28.9256311109
	},
	{
		"date": "2022-08-18",
		"county": "Grayson",
		"title": "2. Grayson",
		"cases_7day_mean_per_100k": 21.557781677
	},
	{
		"date": "2022-08-19",
		"county": "Grayson",
		"title": "2. Grayson",
		"cases_7day_mean_per_100k": 30.5629309851
	},
	{
		"date": "2022-08-20",
		"county": "Grayson",
		"title": "2. Grayson",
		"cases_7day_mean_per_100k": 30.5629309851
	},
	{
		"date": "2022-08-21",
		"county": "Grayson",
		"title": "2. Grayson",
		"cases_7day_mean_per_100k": 29.1985144232
	},
	{
		"date": "2022-08-22",
		"county": "Grayson",
		"title": "2. Grayson",
		"cases_7day_mean_per_100k": 28.1069811738
	},
	{
		"date": "2022-08-23",
		"county": "Grayson",
		"title": "2. Grayson",
		"cases_7day_mean_per_100k": 32.2002308593
	},
	{
		"date": "2022-08-24",
		"county": "Grayson",
		"title": "2. Grayson",
		"cases_7day_mean_per_100k": 32.4731141716
	},
	{
		"date": "2022-08-25",
		"county": "Grayson",
		"title": "2. Grayson",
		"cases_7day_mean_per_100k": 33.0188807964
	},
	{
		"date": "2022-08-26",
		"county": "Grayson",
		"title": "2. Grayson",
		"cases_7day_mean_per_100k": 26.7425646119
	},
	{
		"date": "2022-08-27",
		"county": "Grayson",
		"title": "2. Grayson",
		"cases_7day_mean_per_100k": 28.1069811738
	},
	{
		"date": "2022-08-28",
		"county": "Grayson",
		"title": "2. Grayson",
		"cases_7day_mean_per_100k": 27.2883312367
	},
	{
		"date": "2022-08-29",
		"county": "Grayson",
		"title": "2. Grayson",
		"cases_7day_mean_per_100k": 24.559498113
	},
	{
		"date": "2022-08-30",
		"county": "Grayson",
		"title": "2. Grayson",
		"cases_7day_mean_per_100k": 22.3764316141
	},
	{
		"date": "2022-08-31",
		"county": "Grayson",
		"title": "2. Grayson",
		"cases_7day_mean_per_100k": 22.3764316141
	},
	{
		"date": "2022-09-01",
		"county": "Grayson",
		"title": "2. Grayson",
		"cases_7day_mean_per_100k": 22.1035483017
	},
	{
		"date": "2022-09-02",
		"county": "Grayson",
		"title": "2. Grayson",
		"cases_7day_mean_per_100k": 19.374715178
	},
	{
		"date": "2022-09-03",
		"county": "Grayson",
		"title": "2. Grayson",
		"cases_7day_mean_per_100k": 16.6458820544
	},
	{
		"date": "2022-09-04",
		"county": "Grayson",
		"title": "2. Grayson",
		"cases_7day_mean_per_100k": 16.1001154296
	},
	{
		"date": "2022-09-05",
		"county": "Grayson",
		"title": "2. Grayson",
		"cases_7day_mean_per_100k": 18.2831819286
	},
	{
		"date": "2022-09-06",
		"county": "Grayson",
		"title": "2. Grayson",
		"cases_7day_mean_per_100k": 19.374715178
	},
	{
		"date": "2022-09-07",
		"county": "Grayson",
		"title": "2. Grayson",
		"cases_7day_mean_per_100k": 18.2831819286
	},
	{
		"date": "2022-09-08",
		"county": "Grayson",
		"title": "2. Grayson",
		"cases_7day_mean_per_100k": 17.7374153038
	},
	{
		"date": "2022-09-09",
		"county": "Grayson",
		"title": "2. Grayson",
		"cases_7day_mean_per_100k": 17.4645319915
	},
	{
		"date": "2022-09-10",
		"county": "Grayson",
		"title": "2. Grayson",
		"cases_7day_mean_per_100k": 17.1916486791
	},
	{
		"date": "2022-09-11",
		"county": "Grayson",
		"title": "2. Grayson",
		"cases_7day_mean_per_100k": 17.7374153038
	},
	{
		"date": "2022-09-12",
		"county": "Grayson",
		"title": "2. Grayson",
		"cases_7day_mean_per_100k": 16.1001154296
	},
	{
		"date": "2022-09-13",
		"county": "Grayson",
		"title": "2. Grayson",
		"cases_7day_mean_per_100k": 13.371282306
	},
	{
		"date": "2022-09-14",
		"county": "Grayson",
		"title": "2. Grayson",
		"cases_7day_mean_per_100k": 12.0068657441
	},
	{
		"date": "2022-09-15",
		"county": "Grayson",
		"title": "2. Grayson",
		"cases_7day_mean_per_100k": 12.2797490565
	},
	{
		"date": "2022-09-16",
		"county": "Grayson",
		"title": "2. Grayson",
		"cases_7day_mean_per_100k": 12.8255156812
	},
	{
		"date": "2022-09-17",
		"county": "Grayson",
		"title": "2. Grayson",
		"cases_7day_mean_per_100k": 15.5543488049
	},
	{
		"date": "2022-09-18",
		"county": "Grayson",
		"title": "2. Grayson",
		"cases_7day_mean_per_100k": 15.2814654925
	},
	{
		"date": "2022-09-19",
		"county": "Grayson",
		"title": "2. Grayson",
		"cases_7day_mean_per_100k": 15.5543488049
	},
	{
		"date": "2022-09-20",
		"county": "Grayson",
		"title": "2. Grayson",
		"cases_7day_mean_per_100k": 14.7356988678
	},
	{
		"date": "2022-09-21",
		"county": "Grayson",
		"title": "2. Grayson",
		"cases_7day_mean_per_100k": 14.7356988678
	},
	{
		"date": "2022-09-22",
		"county": "Grayson",
		"title": "2. Grayson",
		"cases_7day_mean_per_100k": 13.6441656183
	},
	{
		"date": "2022-09-23",
		"county": "Grayson",
		"title": "2. Grayson",
		"cases_7day_mean_per_100k": 13.0983989936
	},
	{
		"date": "2022-09-24",
		"county": "Grayson",
		"title": "2. Grayson",
		"cases_7day_mean_per_100k": 11.7339824318
	},
	{
		"date": "2022-09-25",
		"county": "Grayson",
		"title": "2. Grayson",
		"cases_7day_mean_per_100k": 12.5526323689
	},
	{
		"date": "2022-09-26",
		"county": "Grayson",
		"title": "2. Grayson",
		"cases_7day_mean_per_100k": 11.7339824318
	},
	{
		"date": "2022-09-27",
		"county": "Grayson",
		"title": "2. Grayson",
		"cases_7day_mean_per_100k": 10.3695658699
	},
	{
		"date": "2022-09-28",
		"county": "Grayson",
		"title": "2. Grayson",
		"cases_7day_mean_per_100k": 10.0966825576
	},
	{
		"date": "2022-09-29",
		"county": "Grayson",
		"title": "2. Grayson",
		"cases_7day_mean_per_100k": 10.0966825576
	},
	{
		"date": "2022-09-30",
		"county": "Grayson",
		"title": "2. Grayson",
		"cases_7day_mean_per_100k": 9.2780326205
	},
	{
		"date": "2022-10-01",
		"county": "Grayson",
		"title": "2. Grayson",
		"cases_7day_mean_per_100k": 8.4593826834
	},
	{
		"date": "2022-10-02",
		"county": "Grayson",
		"title": "2. Grayson",
		"cases_7day_mean_per_100k": 6.8220828092
	},
	{
		"date": "2022-10-03",
		"county": "Grayson",
		"title": "2. Grayson",
		"cases_7day_mean_per_100k": 6.2763161844
	},
	{
		"date": "2022-10-04",
		"county": "Grayson",
		"title": "2. Grayson",
		"cases_7day_mean_per_100k": 6.8220828092
	},
	{
		"date": "2022-10-05",
		"county": "Grayson",
		"title": "2. Grayson",
		"cases_7day_mean_per_100k": 5.7305495597
	},
	{
		"date": "2022-10-06",
		"county": "Grayson",
		"title": "2. Grayson",
		"cases_7day_mean_per_100k": 6.2763161844
	},
	{
		"date": "2022-10-07",
		"county": "Grayson",
		"title": "2. Grayson",
		"cases_7day_mean_per_100k": 6.0034328721
	},
	{
		"date": "2022-10-08",
		"county": "Grayson",
		"title": "2. Grayson",
		"cases_7day_mean_per_100k": 6.2763161844
	},
	{
		"date": "2022-10-09",
		"county": "Grayson",
		"title": "2. Grayson",
		"cases_7day_mean_per_100k": 7.0949661215
	},
	{
		"date": "2022-10-10",
		"county": "Grayson",
		"title": "2. Grayson",
		"cases_7day_mean_per_100k": 7.9136160586
	},
	{
		"date": "2022-10-11",
		"county": "Grayson",
		"title": "2. Grayson",
		"cases_7day_mean_per_100k": 8.7322659957
	},
	{
		"date": "2022-10-12",
		"county": "Grayson",
		"title": "2. Grayson",
		"cases_7day_mean_per_100k": 10.3695658699
	},
	{
		"date": "2022-10-13",
		"county": "Grayson",
		"title": "2. Grayson",
		"cases_7day_mean_per_100k": 9.8237992452
	},
	{
		"date": "2022-10-14",
		"county": "Grayson",
		"title": "2. Grayson",
		"cases_7day_mean_per_100k": 10.9153324947
	},
	{
		"date": "2022-10-15",
		"county": "Grayson",
		"title": "2. Grayson",
		"cases_7day_mean_per_100k": 10.9153324947
	},
	{
		"date": "2022-10-16",
		"county": "Grayson",
		"title": "2. Grayson",
		"cases_7day_mean_per_100k": 11.188215807
	},
	{
		"date": "2022-10-17",
		"county": "Grayson",
		"title": "2. Grayson",
		"cases_7day_mean_per_100k": 9.8237992452
	},
	{
		"date": "2022-10-18",
		"county": "Grayson",
		"title": "2. Grayson",
		"cases_7day_mean_per_100k": 9.8237992452
	},
	{
		"date": "2022-10-19",
		"county": "Grayson",
		"title": "2. Grayson",
		"cases_7day_mean_per_100k": 9.0051493081
	},
	{
		"date": "2022-10-20",
		"county": "Grayson",
		"title": "2. Grayson",
		"cases_7day_mean_per_100k": 9.0051493081
	},
	{
		"date": "2022-10-21",
		"county": "Grayson",
		"title": "2. Grayson",
		"cases_7day_mean_per_100k": 8.7322659957
	},
	{
		"date": "2022-10-22",
		"county": "Grayson",
		"title": "2. Grayson",
		"cases_7day_mean_per_100k": 9.0051493081
	},
	{
		"date": "2022-10-23",
		"county": "Grayson",
		"title": "2. Grayson",
		"cases_7day_mean_per_100k": 7.9136160586
	},
	{
		"date": "2022-10-24",
		"county": "Grayson",
		"title": "2. Grayson",
		"cases_7day_mean_per_100k": 7.9136160586
	},
	{
		"date": "2022-10-25",
		"county": "Grayson",
		"title": "2. Grayson",
		"cases_7day_mean_per_100k": 6.8220828092
	},
	{
		"date": "2022-10-26",
		"county": "Grayson",
		"title": "2. Grayson",
		"cases_7day_mean_per_100k": 5.7305495597
	},
	{
		"date": "2022-10-27",
		"county": "Grayson",
		"title": "2. Grayson",
		"cases_7day_mean_per_100k": 6.2763161844
	},
	{
		"date": "2022-10-28",
		"county": "Grayson",
		"title": "2. Grayson",
		"cases_7day_mean_per_100k": 5.184782935
	},
	{
		"date": "2022-10-29",
		"county": "Grayson",
		"title": "2. Grayson",
		"cases_7day_mean_per_100k": 4.3661329979
	},
	{
		"date": "2022-10-30",
		"county": "Grayson",
		"title": "2. Grayson",
		"cases_7day_mean_per_100k": 5.184782935
	},
	{
		"date": "2022-10-31",
		"county": "Grayson",
		"title": "2. Grayson",
		"cases_7day_mean_per_100k": 6.0034328721
	},
	{
		"date": "2022-11-01",
		"county": "Grayson",
		"title": "2. Grayson",
		"cases_7day_mean_per_100k": 14.1899322431
	},
	{
		"date": "2022-11-02",
		"county": "Grayson",
		"title": "2. Grayson",
		"cases_7day_mean_per_100k": 15.5543488049
	},
	{
		"date": "2022-11-03",
		"county": "Grayson",
		"title": "2. Grayson",
		"cases_7day_mean_per_100k": 15.0085821802
	},
	{
		"date": "2022-11-04",
		"county": "Grayson",
		"title": "2. Grayson",
		"cases_7day_mean_per_100k": 15.2814654925
	},
	{
		"date": "2022-11-05",
		"county": "Grayson",
		"title": "2. Grayson",
		"cases_7day_mean_per_100k": 15.2814654925
	},
	{
		"date": "2022-11-06",
		"county": "Grayson",
		"title": "2. Grayson",
		"cases_7day_mean_per_100k": 13.9170489307
	},
	{
		"date": "2022-11-07",
		"county": "Grayson",
		"title": "2. Grayson",
		"cases_7day_mean_per_100k": 12.5526323689
	},
	{
		"date": "2022-11-08",
		"county": "Grayson",
		"title": "2. Grayson",
		"cases_7day_mean_per_100k": 3.8203663731
	},
	{
		"date": "2022-03-01",
		"county": "Clark",
		"title": "7. Clark",
		"cases_7day_mean_per_100k": 12.7772340355
	},
	{
		"date": "2022-03-02",
		"county": "Clark",
		"title": "7. Clark",
		"cases_7day_mean_per_100k": 12.0105999934
	},
	{
		"date": "2022-03-03",
		"county": "Clark",
		"title": "7. Clark",
		"cases_7day_mean_per_100k": 10.79676276
	},
	{
		"date": "2022-03-04",
		"county": "Clark",
		"title": "7. Clark",
		"cases_7day_mean_per_100k": 10.6689904196
	},
	{
		"date": "2022-03-05",
		"county": "Clark",
		"title": "7. Clark",
		"cases_7day_mean_per_100k": 10.79676276
	},
	{
		"date": "2022-03-06",
		"county": "Clark",
		"title": "7. Clark",
		"cases_7day_mean_per_100k": 10.3495595687
	},
	{
		"date": "2022-03-07",
		"county": "Clark",
		"title": "7. Clark",
		"cases_7day_mean_per_100k": 10.2217872284
	},
	{
		"date": "2022-03-08",
		"county": "Clark",
		"title": "7. Clark",
		"cases_7day_mean_per_100k": 9.3912670161
	},
	{
		"date": "2022-03-09",
		"county": "Clark",
		"title": "7. Clark",
		"cases_7day_mean_per_100k": 9.4551531863
	},
	{
		"date": "2022-03-10",
		"county": "Clark",
		"title": "7. Clark",
		"cases_7day_mean_per_100k": 9.5190393564
	},
	{
		"date": "2022-03-11",
		"county": "Clark",
		"title": "7. Clark",
		"cases_7day_mean_per_100k": 8.8162914845
	},
	{
		"date": "2022-03-12",
		"county": "Clark",
		"title": "7. Clark",
		"cases_7day_mean_per_100k": 8.4329744634
	},
	{
		"date": "2022-03-13",
		"county": "Clark",
		"title": "7. Clark",
		"cases_7day_mean_per_100k": 7.9857712722
	},
	{
		"date": "2022-03-14",
		"county": "Clark",
		"title": "7. Clark",
		"cases_7day_mean_per_100k": 7.5385680809
	},
	{
		"date": "2022-03-15",
		"county": "Clark",
		"title": "7. Clark",
		"cases_7day_mean_per_100k": 7.0913648897
	},
	{
		"date": "2022-03-16",
		"county": "Clark",
		"title": "7. Clark",
		"cases_7day_mean_per_100k": 6.4525031879
	},
	{
		"date": "2022-03-17",
		"county": "Clark",
		"title": "7. Clark",
		"cases_7day_mean_per_100k": 6.7080478686
	},
	{
		"date": "2022-03-18",
		"county": "Clark",
		"title": "7. Clark",
		"cases_7day_mean_per_100k": 6.7719340388
	},
	{
		"date": "2022-03-19",
		"county": "Clark",
		"title": "7. Clark",
		"cases_7day_mean_per_100k": 6.7719340388
	},
	{
		"date": "2022-03-20",
		"county": "Clark",
		"title": "7. Clark",
		"cases_7day_mean_per_100k": 6.8997063792
	},
	{
		"date": "2022-03-21",
		"county": "Clark",
		"title": "7. Clark",
		"cases_7day_mean_per_100k": 6.9635925493
	},
	{
		"date": "2022-03-22",
		"county": "Clark",
		"title": "7. Clark",
		"cases_7day_mean_per_100k": 6.9635925493
	},
	{
		"date": "2022-03-23",
		"county": "Clark",
		"title": "7. Clark",
		"cases_7day_mean_per_100k": 7.21913723
	},
	{
		"date": "2022-03-24",
		"county": "Clark",
		"title": "7. Clark",
		"cases_7day_mean_per_100k": 7.0274787195
	},
	{
		"date": "2022-03-25",
		"county": "Clark",
		"title": "7. Clark",
		"cases_7day_mean_per_100k": 6.5163893581
	},
	{
		"date": "2022-03-26",
		"county": "Clark",
		"title": "7. Clark",
		"cases_7day_mean_per_100k": 6.5802755283
	},
	{
		"date": "2022-03-27",
		"county": "Clark",
		"title": "7. Clark",
		"cases_7day_mean_per_100k": 6.5802755283
	},
	{
		"date": "2022-03-28",
		"county": "Clark",
		"title": "7. Clark",
		"cases_7day_mean_per_100k": 6.6441616985
	},
	{
		"date": "2022-03-29",
		"county": "Clark",
		"title": "7. Clark",
		"cases_7day_mean_per_100k": 6.7719340388
	},
	{
		"date": "2022-03-30",
		"county": "Clark",
		"title": "7. Clark",
		"cases_7day_mean_per_100k": 6.3247308476
	},
	{
		"date": "2022-03-31",
		"county": "Clark",
		"title": "7. Clark",
		"cases_7day_mean_per_100k": 5.6858691458
	},
	{
		"date": "2022-04-01",
		"county": "Clark",
		"title": "7. Clark",
		"cases_7day_mean_per_100k": 6.3247308476
	},
	{
		"date": "2022-04-02",
		"county": "Clark",
		"title": "7. Clark",
		"cases_7day_mean_per_100k": 6.4525031879
	},
	{
		"date": "2022-04-03",
		"county": "Clark",
		"title": "7. Clark",
		"cases_7day_mean_per_100k": 6.6441616985
	},
	{
		"date": "2022-04-04",
		"county": "Clark",
		"title": "7. Clark",
		"cases_7day_mean_per_100k": 6.6441616985
	},
	{
		"date": "2022-04-05",
		"county": "Clark",
		"title": "7. Clark",
		"cases_7day_mean_per_100k": 6.3886170177
	},
	{
		"date": "2022-04-06",
		"county": "Clark",
		"title": "7. Clark",
		"cases_7day_mean_per_100k": 6.5163893581
	},
	{
		"date": "2022-04-07",
		"county": "Clark",
		"title": "7. Clark",
		"cases_7day_mean_per_100k": 7.4746819108
	},
	{
		"date": "2022-04-08",
		"county": "Clark",
		"title": "7. Clark",
		"cases_7day_mean_per_100k": 7.6024542511
	},
	{
		"date": "2022-04-09",
		"county": "Clark",
		"title": "7. Clark",
		"cases_7day_mean_per_100k": 7.2830234002
	},
	{
		"date": "2022-04-10",
		"county": "Clark",
		"title": "7. Clark",
		"cases_7day_mean_per_100k": 7.7302265915
	},
	{
		"date": "2022-04-11",
		"county": "Clark",
		"title": "7. Clark",
		"cases_7day_mean_per_100k": 8.3690882932
	},
	{
		"date": "2022-04-12",
		"county": "Clark",
		"title": "7. Clark",
		"cases_7day_mean_per_100k": 9.8384702073
	},
	{
		"date": "2022-04-13",
		"county": "Clark",
		"title": "7. Clark",
		"cases_7day_mean_per_100k": 11.4356244618
	},
	{
		"date": "2022-04-14",
		"county": "Clark",
		"title": "7. Clark",
		"cases_7day_mean_per_100k": 12.3300308442
	},
	{
		"date": "2022-04-15",
		"county": "Clark",
		"title": "7. Clark",
		"cases_7day_mean_per_100k": 12.9050063758
	},
	{
		"date": "2022-04-16",
		"county": "Clark",
		"title": "7. Clark",
		"cases_7day_mean_per_100k": 13.4160957373
	},
	{
		"date": "2022-04-17",
		"county": "Clark",
		"title": "7. Clark",
		"cases_7day_mean_per_100k": 12.7772340355
	},
	{
		"date": "2022-04-18",
		"county": "Clark",
		"title": "7. Clark",
		"cases_7day_mean_per_100k": 13.9271850987
	},
	{
		"date": "2022-04-19",
		"county": "Clark",
		"title": "7. Clark",
		"cases_7day_mean_per_100k": 15.2049085022
	},
	{
		"date": "2022-04-20",
		"county": "Clark",
		"title": "7. Clark",
		"cases_7day_mean_per_100k": 15.5243393531
	},
	{
		"date": "2022-04-21",
		"county": "Clark",
		"title": "7. Clark",
		"cases_7day_mean_per_100k": 16.2270872251
	},
	{
		"date": "2022-04-22",
		"county": "Clark",
		"title": "7. Clark",
		"cases_7day_mean_per_100k": 16.4187457356
	},
	{
		"date": "2022-04-23",
		"county": "Clark",
		"title": "7. Clark",
		"cases_7day_mean_per_100k": 16.6742904163
	},
	{
		"date": "2022-04-24",
		"county": "Clark",
		"title": "7. Clark",
		"cases_7day_mean_per_100k": 17.8881276497
	},
	{
		"date": "2022-04-25",
		"county": "Clark",
		"title": "7. Clark",
		"cases_7day_mean_per_100k": 17.3131521181
	},
	{
		"date": "2022-04-26",
		"county": "Clark",
		"title": "7. Clark",
		"cases_7day_mean_per_100k": 17.6964691391
	},
	{
		"date": "2022-04-27",
		"county": "Clark",
		"title": "7. Clark",
		"cases_7day_mean_per_100k": 18.5908755216
	},
	{
		"date": "2022-04-28",
		"county": "Clark",
		"title": "7. Clark",
		"cases_7day_mean_per_100k": 18.5269893515
	},
	{
		"date": "2022-04-29",
		"county": "Clark",
		"title": "7. Clark",
		"cases_7day_mean_per_100k": 19.0380787129
	},
	{
		"date": "2022-04-30",
		"county": "Clark",
		"title": "7. Clark",
		"cases_7day_mean_per_100k": 19.804712755
	},
	{
		"date": "2022-05-01",
		"county": "Clark",
		"title": "7. Clark",
		"cases_7day_mean_per_100k": 20.9546638182
	},
	{
		"date": "2022-05-02",
		"county": "Clark",
		"title": "7. Clark",
		"cases_7day_mean_per_100k": 22.5518180726
	},
	{
		"date": "2022-05-03",
		"county": "Clark",
		"title": "7. Clark",
		"cases_7day_mean_per_100k": 23.5739967955
	},
	{
		"date": "2022-05-04",
		"county": "Clark",
		"title": "7. Clark",
		"cases_7day_mean_per_100k": 24.2128584972
	},
	{
		"date": "2022-05-05",
		"county": "Clark",
		"title": "7. Clark",
		"cases_7day_mean_per_100k": 25.937785092
	},
	{
		"date": "2022-05-06",
		"county": "Clark",
		"title": "7. Clark",
		"cases_7day_mean_per_100k": 28.0460287079
	},
	{
		"date": "2022-05-07",
		"county": "Clark",
		"title": "7. Clark",
		"cases_7day_mean_per_100k": 28.9404350904
	},
	{
		"date": "2022-05-08",
		"county": "Clark",
		"title": "7. Clark",
		"cases_7day_mean_per_100k": 28.8765489202
	},
	{
		"date": "2022-05-09",
		"county": "Clark",
		"title": "7. Clark",
		"cases_7day_mean_per_100k": 31.5597680676
	},
	{
		"date": "2022-05-10",
		"county": "Clark",
		"title": "7. Clark",
		"cases_7day_mean_per_100k": 33.476353173
	},
	{
		"date": "2022-05-11",
		"county": "Clark",
		"title": "7. Clark",
		"cases_7day_mean_per_100k": 35.7123691292
	},
	{
		"date": "2022-05-12",
		"county": "Clark",
		"title": "7. Clark",
		"cases_7day_mean_per_100k": 38.2039297661
	},
	{
		"date": "2022-05-13",
		"county": "Clark",
		"title": "7. Clark",
		"cases_7day_mean_per_100k": 40.8871489136
	},
	{
		"date": "2022-05-14",
		"county": "Clark",
		"title": "7. Clark",
		"cases_7day_mean_per_100k": 41.9093276364
	},
	{
		"date": "2022-05-15",
		"county": "Clark",
		"title": "7. Clark",
		"cases_7day_mean_per_100k": 43.5064818908
	},
	{
		"date": "2022-05-16",
		"county": "Clark",
		"title": "7. Clark",
		"cases_7day_mean_per_100k": 44.0175712522
	},
	{
		"date": "2022-05-17",
		"county": "Clark",
		"title": "7. Clark",
		"cases_7day_mean_per_100k": 45.6786116769
	},
	{
		"date": "2022-05-18",
		"county": "Clark",
		"title": "7. Clark",
		"cases_7day_mean_per_100k": 47.7868552927
	},
	{
		"date": "2022-05-19",
		"county": "Clark",
		"title": "7. Clark",
		"cases_7day_mean_per_100k": 47.5951967822
	},
	{
		"date": "2022-05-20",
		"county": "Clark",
		"title": "7. Clark",
		"cases_7day_mean_per_100k": 46.1897010383
	},
	{
		"date": "2022-05-21",
		"county": "Clark",
		"title": "7. Clark",
		"cases_7day_mean_per_100k": 46.5730180593
	},
	{
		"date": "2022-05-22",
		"county": "Clark",
		"title": "7. Clark",
		"cases_7day_mean_per_100k": 46.1897010383
	},
	{
		"date": "2022-05-23",
		"county": "Clark",
		"title": "7. Clark",
		"cases_7day_mean_per_100k": 46.8924489102
	},
	{
		"date": "2022-05-24",
		"county": "Clark",
		"title": "7. Clark",
		"cases_7day_mean_per_100k": 46.7646765699
	},
	{
		"date": "2022-05-25",
		"county": "Clark",
		"title": "7. Clark",
		"cases_7day_mean_per_100k": 44.656432954
	},
	{
		"date": "2022-05-26",
		"county": "Clark",
		"title": "7. Clark",
		"cases_7day_mean_per_100k": 43.5064818908
	},
	{
		"date": "2022-05-27",
		"county": "Clark",
		"title": "7. Clark",
		"cases_7day_mean_per_100k": 44.3370021031
	},
	{
		"date": "2022-05-28",
		"county": "Clark",
		"title": "7. Clark",
		"cases_7day_mean_per_100k": 44.4647744435
	},
	{
		"date": "2022-05-29",
		"county": "Clark",
		"title": "7. Clark",
		"cases_7day_mean_per_100k": 43.8259127417
	},
	{
		"date": "2022-05-30",
		"county": "Clark",
		"title": "7. Clark",
		"cases_7day_mean_per_100k": 39.0983361486
	},
	{
		"date": "2022-05-31",
		"county": "Clark",
		"title": "7. Clark",
		"cases_7day_mean_per_100k": 42.8037340189
	},
	{
		"date": "2022-06-01",
		"county": "Clark",
		"title": "7. Clark",
		"cases_7day_mean_per_100k": 47.2757659313
	},
	{
		"date": "2022-06-02",
		"county": "Clark",
		"title": "7. Clark",
		"cases_7day_mean_per_100k": 46.6369042295
	},
	{
		"date": "2022-06-03",
		"county": "Clark",
		"title": "7. Clark",
		"cases_7day_mean_per_100k": 46.9563350804
	},
	{
		"date": "2022-06-04",
		"county": "Clark",
		"title": "7. Clark",
		"cases_7day_mean_per_100k": 46.445245719
	},
	{
		"date": "2022-06-05",
		"county": "Clark",
		"title": "7. Clark",
		"cases_7day_mean_per_100k": 47.9785138032
	},
	{
		"date": "2022-06-06",
		"county": "Clark",
		"title": "7. Clark",
		"cases_7day_mean_per_100k": 53.0255212473
	},
	{
		"date": "2022-06-07",
		"county": "Clark",
		"title": "7. Clark",
		"cases_7day_mean_per_100k": 50.9172776314
	},
	{
		"date": "2022-06-08",
		"county": "Clark",
		"title": "7. Clark",
		"cases_7day_mean_per_100k": 47.2757659313
	},
	{
		"date": "2022-06-09",
		"county": "Clark",
		"title": "7. Clark",
		"cases_7day_mean_per_100k": 48.6812616752
	},
	{
		"date": "2022-06-10",
		"county": "Clark",
		"title": "7. Clark",
		"cases_7day_mean_per_100k": 48.9368063559
	},
	{
		"date": "2022-06-11",
		"county": "Clark",
		"title": "7. Clark",
		"cases_7day_mean_per_100k": 50.6617329507
	},
	{
		"date": "2022-06-12",
		"county": "Clark",
		"title": "7. Clark",
		"cases_7day_mean_per_100k": 49.7673265682
	},
	{
		"date": "2022-06-13",
		"county": "Clark",
		"title": "7. Clark",
		"cases_7day_mean_per_100k": 49.1284648664
	},
	{
		"date": "2022-06-14",
		"county": "Clark",
		"title": "7. Clark",
		"cases_7day_mean_per_100k": 47.8507414629
	},
	{
		"date": "2022-06-15",
		"county": "Clark",
		"title": "7. Clark",
		"cases_7day_mean_per_100k": 47.2118797611
	},
	{
		"date": "2022-06-16",
		"county": "Clark",
		"title": "7. Clark",
		"cases_7day_mean_per_100k": 47.2118797611
	},
	{
		"date": "2022-06-17",
		"county": "Clark",
		"title": "7. Clark",
		"cases_7day_mean_per_100k": 45.8063840172
	},
	{
		"date": "2022-06-18",
		"county": "Clark",
		"title": "7. Clark",
		"cases_7day_mean_per_100k": 45.359180826
	},
	{
		"date": "2022-06-19",
		"county": "Clark",
		"title": "7. Clark",
		"cases_7day_mean_per_100k": 45.6786116769
	},
	{
		"date": "2022-06-20",
		"county": "Clark",
		"title": "7. Clark",
		"cases_7day_mean_per_100k": 43.6342542312
	},
	{
		"date": "2022-06-21",
		"county": "Clark",
		"title": "7. Clark",
		"cases_7day_mean_per_100k": 45.1036361453
	},
	{
		"date": "2022-06-22",
		"county": "Clark",
		"title": "7. Clark",
		"cases_7day_mean_per_100k": 46.7646765699
	},
	{
		"date": "2022-06-23",
		"county": "Clark",
		"title": "7. Clark",
		"cases_7day_mean_per_100k": 47.6590829524
	},
	{
		"date": "2022-06-24",
		"county": "Clark",
		"title": "7. Clark",
		"cases_7day_mean_per_100k": 48.4896031647
	},
	{
		"date": "2022-06-25",
		"county": "Clark",
		"title": "7. Clark",
		"cases_7day_mean_per_100k": 49.1923510366
	},
	{
		"date": "2022-06-26",
		"county": "Clark",
		"title": "7. Clark",
		"cases_7day_mean_per_100k": 48.8729201857
	},
	{
		"date": "2022-06-27",
		"county": "Clark",
		"title": "7. Clark",
		"cases_7day_mean_per_100k": 50.5339606103
	},
	{
		"date": "2022-06-28",
		"county": "Clark",
		"title": "7. Clark",
		"cases_7day_mean_per_100k": 48.2979446541
	},
	{
		"date": "2022-06-29",
		"county": "Clark",
		"title": "7. Clark",
		"cases_7day_mean_per_100k": 47.0202212506
	},
	{
		"date": "2022-06-30",
		"county": "Clark",
		"title": "7. Clark",
		"cases_7day_mean_per_100k": 45.8702701874
	},
	{
		"date": "2022-07-01",
		"county": "Clark",
		"title": "7. Clark",
		"cases_7day_mean_per_100k": 43.8897989119
	},
	{
		"date": "2022-07-02",
		"county": "Clark",
		"title": "7. Clark",
		"cases_7day_mean_per_100k": 40.1205148714
	},
	{
		"date": "2022-07-03",
		"county": "Clark",
		"title": "7. Clark",
		"cases_7day_mean_per_100k": 38.9066776381
	},
	{
		"date": "2022-07-04",
		"county": "Clark",
		"title": "7. Clark",
		"cases_7day_mean_per_100k": 34.3068733853
	},
	{
		"date": "2022-07-05",
		"county": "Clark",
		"title": "7. Clark",
		"cases_7day_mean_per_100k": 32.2625159396
	},
	{
		"date": "2022-07-06",
		"county": "Clark",
		"title": "7. Clark",
		"cases_7day_mean_per_100k": 30.5375893448
	},
	{
		"date": "2022-07-07",
		"county": "Clark",
		"title": "7. Clark",
		"cases_7day_mean_per_100k": 29.3237521114
	},
	{
		"date": "2022-07-08",
		"county": "Clark",
		"title": "7. Clark",
		"cases_7day_mean_per_100k": 28.3015733886
	},
	{
		"date": "2022-07-09",
		"county": "Clark",
		"title": "7. Clark",
		"cases_7day_mean_per_100k": 29.3876382816
	},
	{
		"date": "2022-07-10",
		"county": "Clark",
		"title": "7. Clark",
		"cases_7day_mean_per_100k": 29.7070691325
	},
	{
		"date": "2022-07-11",
		"county": "Clark",
		"title": "7. Clark",
		"cases_7day_mean_per_100k": 31.9430850887
	},
	{
		"date": "2022-07-12",
		"county": "Clark",
		"title": "7. Clark",
		"cases_7day_mean_per_100k": 30.1542723237
	},
	{
		"date": "2022-07-13",
		"county": "Clark",
		"title": "7. Clark",
		"cases_7day_mean_per_100k": 29.1320936009
	},
	{
		"date": "2022-07-14",
		"county": "Clark",
		"title": "7. Clark",
		"cases_7day_mean_per_100k": 27.7904840272
	},
	{
		"date": "2022-07-15",
		"county": "Clark",
		"title": "7. Clark",
		"cases_7day_mean_per_100k": 28.3015733886
	},
	{
		"date": "2022-07-16",
		"county": "Clark",
		"title": "7. Clark",
		"cases_7day_mean_per_100k": 27.9182563675
	},
	{
		"date": "2022-07-17",
		"county": "Clark",
		"title": "7. Clark",
		"cases_7day_mean_per_100k": 27.6627116868
	},
	{
		"date": "2022-07-18",
		"county": "Clark",
		"title": "7. Clark",
		"cases_7day_mean_per_100k": 27.5988255166
	},
	{
		"date": "2022-07-19",
		"county": "Clark",
		"title": "7. Clark",
		"cases_7day_mean_per_100k": 27.8543701974
	},
	{
		"date": "2022-07-20",
		"county": "Clark",
		"title": "7. Clark",
		"cases_7day_mean_per_100k": 27.2793946658
	},
	{
		"date": "2022-07-21",
		"county": "Clark",
		"title": "7. Clark",
		"cases_7day_mean_per_100k": 26.8960776447
	},
	{
		"date": "2022-07-22",
		"county": "Clark",
		"title": "7. Clark",
		"cases_7day_mean_per_100k": 26.640532964
	},
	{
		"date": "2022-07-23",
		"county": "Clark",
		"title": "7. Clark",
		"cases_7day_mean_per_100k": 27.1516223254
	},
	{
		"date": "2022-07-24",
		"county": "Clark",
		"title": "7. Clark",
		"cases_7day_mean_per_100k": 26.4488744535
	},
	{
		"date": "2022-07-25",
		"county": "Clark",
		"title": "7. Clark",
		"cases_7day_mean_per_100k": 26.3211021131
	},
	{
		"date": "2022-07-26",
		"county": "Clark",
		"title": "7. Clark",
		"cases_7day_mean_per_100k": 25.937785092
	},
	{
		"date": "2022-07-27",
		"county": "Clark",
		"title": "7. Clark",
		"cases_7day_mean_per_100k": 25.1711510499
	},
	{
		"date": "2022-07-28",
		"county": "Clark",
		"title": "7. Clark",
		"cases_7day_mean_per_100k": 24.468403178
	},
	{
		"date": "2022-07-29",
		"county": "Clark",
		"title": "7. Clark",
		"cases_7day_mean_per_100k": 23.7017691358
	},
	{
		"date": "2022-07-30",
		"county": "Clark",
		"title": "7. Clark",
		"cases_7day_mean_per_100k": 22.4879319025
	},
	{
		"date": "2022-07-31",
		"county": "Clark",
		"title": "7. Clark",
		"cases_7day_mean_per_100k": 21.976842541
	},
	{
		"date": "2022-08-01",
		"county": "Clark",
		"title": "7. Clark",
		"cases_7day_mean_per_100k": 21.0824361586
	},
	{
		"date": "2022-08-02",
		"county": "Clark",
		"title": "7. Clark",
		"cases_7day_mean_per_100k": 20.2519159462
	},
	{
		"date": "2022-08-03",
		"county": "Clark",
		"title": "7. Clark",
		"cases_7day_mean_per_100k": 20.1241436059
	},
	{
		"date": "2022-08-04",
		"county": "Clark",
		"title": "7. Clark",
		"cases_7day_mean_per_100k": 20.2519159462
	},
	{
		"date": "2022-08-05",
		"county": "Clark",
		"title": "7. Clark",
		"cases_7day_mean_per_100k": 19.4213957339
	},
	{
		"date": "2022-08-06",
		"county": "Clark",
		"title": "7. Clark",
		"cases_7day_mean_per_100k": 18.3353308409
	},
	{
		"date": "2022-08-07",
		"county": "Clark",
		"title": "7. Clark",
		"cases_7day_mean_per_100k": 18.6547616918
	},
	{
		"date": "2022-08-08",
		"county": "Clark",
		"title": "7. Clark",
		"cases_7day_mean_per_100k": 17.9520138199
	},
	{
		"date": "2022-08-09",
		"county": "Clark",
		"title": "7. Clark",
		"cases_7day_mean_per_100k": 18.1436723304
	},
	{
		"date": "2022-08-10",
		"county": "Clark",
		"title": "7. Clark",
		"cases_7day_mean_per_100k": 17.8242414795
	},
	{
		"date": "2022-08-11",
		"county": "Clark",
		"title": "7. Clark",
		"cases_7day_mean_per_100k": 16.9937212672
	},
	{
		"date": "2022-08-12",
		"county": "Clark",
		"title": "7. Clark",
		"cases_7day_mean_per_100k": 16.8659489268
	},
	{
		"date": "2022-08-13",
		"county": "Clark",
		"title": "7. Clark",
		"cases_7day_mean_per_100k": 17.1214936075
	},
	{
		"date": "2022-08-14",
		"county": "Clark",
		"title": "7. Clark",
		"cases_7day_mean_per_100k": 16.8659489268
	},
	{
		"date": "2022-08-15",
		"county": "Clark",
		"title": "7. Clark",
		"cases_7day_mean_per_100k": 16.6104042461
	},
	{
		"date": "2022-08-16",
		"county": "Clark",
		"title": "7. Clark",
		"cases_7day_mean_per_100k": 15.3965670128
	},
	{
		"date": "2022-08-17",
		"county": "Clark",
		"title": "7. Clark",
		"cases_7day_mean_per_100k": 13.9271850987
	},
	{
		"date": "2022-08-18",
		"county": "Clark",
		"title": "7. Clark",
		"cases_7day_mean_per_100k": 13.7994127583
	},
	{
		"date": "2022-08-19",
		"county": "Clark",
		"title": "7. Clark",
		"cases_7day_mean_per_100k": 13.1605510565
	},
	{
		"date": "2022-08-20",
		"county": "Clark",
		"title": "7. Clark",
		"cases_7day_mean_per_100k": 13.1605510565
	},
	{
		"date": "2022-08-21",
		"county": "Clark",
		"title": "7. Clark",
		"cases_7day_mean_per_100k": 13.1605510565
	},
	{
		"date": "2022-08-22",
		"county": "Clark",
		"title": "7. Clark",
		"cases_7day_mean_per_100k": 12.7772340355
	},
	{
		"date": "2022-08-23",
		"county": "Clark",
		"title": "7. Clark",
		"cases_7day_mean_per_100k": 13.0327787162
	},
	{
		"date": "2022-08-24",
		"county": "Clark",
		"title": "7. Clark",
		"cases_7day_mean_per_100k": 13.3522095671
	},
	{
		"date": "2022-08-25",
		"county": "Clark",
		"title": "7. Clark",
		"cases_7day_mean_per_100k": 13.1605510565
	},
	{
		"date": "2022-08-26",
		"county": "Clark",
		"title": "7. Clark",
		"cases_7day_mean_per_100k": 13.4160957373
	},
	{
		"date": "2022-08-27",
		"county": "Clark",
		"title": "7. Clark",
		"cases_7day_mean_per_100k": 12.7772340355
	},
	{
		"date": "2022-08-28",
		"county": "Clark",
		"title": "7. Clark",
		"cases_7day_mean_per_100k": 12.3300308442
	},
	{
		"date": "2022-08-29",
		"county": "Clark",
		"title": "7. Clark",
		"cases_7day_mean_per_100k": 12.968892546
	},
	{
		"date": "2022-08-30",
		"county": "Clark",
		"title": "7. Clark",
		"cases_7day_mean_per_100k": 12.1383723337
	},
	{
		"date": "2022-08-31",
		"county": "Clark",
		"title": "7. Clark",
		"cases_7day_mean_per_100k": 11.8189414828
	},
	{
		"date": "2022-09-01",
		"county": "Clark",
		"title": "7. Clark",
		"cases_7day_mean_per_100k": 12.0744861635
	},
	{
		"date": "2022-09-02",
		"county": "Clark",
		"title": "7. Clark",
		"cases_7day_mean_per_100k": 12.0105999934
	},
	{
		"date": "2022-09-03",
		"county": "Clark",
		"title": "7. Clark",
		"cases_7day_mean_per_100k": 11.9467138232
	},
	{
		"date": "2022-09-04",
		"county": "Clark",
		"title": "7. Clark",
		"cases_7day_mean_per_100k": 11.2439659512
	},
	{
		"date": "2022-09-05",
		"county": "Clark",
		"title": "7. Clark",
		"cases_7day_mean_per_100k": 8.6885191441
	},
	{
		"date": "2022-09-06",
		"county": "Clark",
		"title": "7. Clark",
		"cases_7day_mean_per_100k": 8.5607468038
	},
	{
		"date": "2022-09-07",
		"county": "Clark",
		"title": "7. Clark",
		"cases_7day_mean_per_100k": 8.3690882932
	},
	{
		"date": "2022-09-08",
		"county": "Clark",
		"title": "7. Clark",
		"cases_7day_mean_per_100k": 8.1135436125
	},
	{
		"date": "2022-09-09",
		"county": "Clark",
		"title": "7. Clark",
		"cases_7day_mean_per_100k": 7.7302265915
	},
	{
		"date": "2022-09-10",
		"county": "Clark",
		"title": "7. Clark",
		"cases_7day_mean_per_100k": 7.9857712722
	},
	{
		"date": "2022-09-11",
		"county": "Clark",
		"title": "7. Clark",
		"cases_7day_mean_per_100k": 7.9857712722
	},
	{
		"date": "2022-09-12",
		"county": "Clark",
		"title": "7. Clark",
		"cases_7day_mean_per_100k": 9.1357223354
	},
	{
		"date": "2022-09-13",
		"county": "Clark",
		"title": "7. Clark",
		"cases_7day_mean_per_100k": 8.5607468038
	},
	{
		"date": "2022-09-14",
		"county": "Clark",
		"title": "7. Clark",
		"cases_7day_mean_per_100k": 8.3052021231
	},
	{
		"date": "2022-09-15",
		"county": "Clark",
		"title": "7. Clark",
		"cases_7day_mean_per_100k": 6.9635925493
	},
	{
		"date": "2022-09-16",
		"county": "Clark",
		"title": "7. Clark",
		"cases_7day_mean_per_100k": 6.4525031879
	},
	{
		"date": "2022-09-17",
		"county": "Clark",
		"title": "7. Clark",
		"cases_7day_mean_per_100k": 6.133072337
	},
	{
		"date": "2022-09-18",
		"county": "Clark",
		"title": "7. Clark",
		"cases_7day_mean_per_100k": 6.0691861669
	},
	{
		"date": "2022-09-19",
		"county": "Clark",
		"title": "7. Clark",
		"cases_7day_mean_per_100k": 5.1108936142
	},
	{
		"date": "2022-09-20",
		"county": "Clark",
		"title": "7. Clark",
		"cases_7day_mean_per_100k": 5.1108936142
	},
	{
		"date": "2022-09-21",
		"county": "Clark",
		"title": "7. Clark",
		"cases_7day_mean_per_100k": 5.6219829756
	},
	{
		"date": "2022-09-22",
		"county": "Clark",
		"title": "7. Clark",
		"cases_7day_mean_per_100k": 6.3247308476
	},
	{
		"date": "2022-09-23",
		"county": "Clark",
		"title": "7. Clark",
		"cases_7day_mean_per_100k": 6.4525031879
	},
	{
		"date": "2022-09-24",
		"county": "Clark",
		"title": "7. Clark",
		"cases_7day_mean_per_100k": 6.835820209
	},
	{
		"date": "2022-09-25",
		"county": "Clark",
		"title": "7. Clark",
		"cases_7day_mean_per_100k": 7.21913723
	},
	{
		"date": "2022-09-26",
		"county": "Clark",
		"title": "7. Clark",
		"cases_7day_mean_per_100k": 8.0496574424
	},
	{
		"date": "2022-09-27",
		"county": "Clark",
		"title": "7. Clark",
		"cases_7day_mean_per_100k": 8.7524053143
	},
	{
		"date": "2022-09-28",
		"county": "Clark",
		"title": "7. Clark",
		"cases_7day_mean_per_100k": 9.3273808459
	},
	{
		"date": "2022-09-29",
		"county": "Clark",
		"title": "7. Clark",
		"cases_7day_mean_per_100k": 9.5829255266
	},
	{
		"date": "2022-09-30",
		"county": "Clark",
		"title": "7. Clark",
		"cases_7day_mean_per_100k": 9.3912670161
	},
	{
		"date": "2022-10-01",
		"county": "Clark",
		"title": "7. Clark",
		"cases_7day_mean_per_100k": 9.0718361652
	},
	{
		"date": "2022-10-02",
		"county": "Clark",
		"title": "7. Clark",
		"cases_7day_mean_per_100k": 8.7524053143
	},
	{
		"date": "2022-10-03",
		"county": "Clark",
		"title": "7. Clark",
		"cases_7day_mean_per_100k": 7.8579989318
	},
	{
		"date": "2022-10-04",
		"county": "Clark",
		"title": "7. Clark",
		"cases_7day_mean_per_100k": 7.2830234002
	},
	{
		"date": "2022-10-05",
		"county": "Clark",
		"title": "7. Clark",
		"cases_7day_mean_per_100k": 6.4525031879
	},
	{
		"date": "2022-10-06",
		"county": "Clark",
		"title": "7. Clark",
		"cases_7day_mean_per_100k": 6.0052999967
	},
	{
		"date": "2022-10-07",
		"county": "Clark",
		"title": "7. Clark",
		"cases_7day_mean_per_100k": 5.9414138265
	},
	{
		"date": "2022-10-08",
		"county": "Clark",
		"title": "7. Clark",
		"cases_7day_mean_per_100k": 5.6858691458
	},
	{
		"date": "2022-10-09",
		"county": "Clark",
		"title": "7. Clark",
		"cases_7day_mean_per_100k": 5.749755316
	},
	{
		"date": "2022-10-10",
		"county": "Clark",
		"title": "7. Clark",
		"cases_7day_mean_per_100k": 6.4525031879
	},
	{
		"date": "2022-10-11",
		"county": "Clark",
		"title": "7. Clark",
		"cases_7day_mean_per_100k": 6.835820209
	},
	{
		"date": "2022-10-12",
		"county": "Clark",
		"title": "7. Clark",
		"cases_7day_mean_per_100k": 6.2608446774
	},
	{
		"date": "2022-10-13",
		"county": "Clark",
		"title": "7. Clark",
		"cases_7day_mean_per_100k": 6.4525031879
	},
	{
		"date": "2022-10-14",
		"county": "Clark",
		"title": "7. Clark",
		"cases_7day_mean_per_100k": 6.8997063792
	},
	{
		"date": "2022-10-15",
		"county": "Clark",
		"title": "7. Clark",
		"cases_7day_mean_per_100k": 7.0913648897
	},
	{
		"date": "2022-10-16",
		"county": "Clark",
		"title": "7. Clark",
		"cases_7day_mean_per_100k": 6.9635925493
	},
	{
		"date": "2022-10-17",
		"county": "Clark",
		"title": "7. Clark",
		"cases_7day_mean_per_100k": 6.4525031879
	},
	{
		"date": "2022-10-18",
		"county": "Clark",
		"title": "7. Clark",
		"cases_7day_mean_per_100k": 6.3247308476
	},
	{
		"date": "2022-10-19",
		"county": "Clark",
		"title": "7. Clark",
		"cases_7day_mean_per_100k": 6.4525031879
	},
	{
		"date": "2022-10-20",
		"county": "Clark",
		"title": "7. Clark",
		"cases_7day_mean_per_100k": 5.8775276563
	},
	{
		"date": "2022-10-21",
		"county": "Clark",
		"title": "7. Clark",
		"cases_7day_mean_per_100k": 5.3664382949
	},
	{
		"date": "2022-10-22",
		"county": "Clark",
		"title": "7. Clark",
		"cases_7day_mean_per_100k": 5.3664382949
	},
	{
		"date": "2022-10-23",
		"county": "Clark",
		"title": "7. Clark",
		"cases_7day_mean_per_100k": 5.4303244651
	},
	{
		"date": "2022-10-24",
		"county": "Clark",
		"title": "7. Clark",
		"cases_7day_mean_per_100k": 5.5580968054
	},
	{
		"date": "2022-10-25",
		"county": "Clark",
		"title": "7. Clark",
		"cases_7day_mean_per_100k": 4.9192351037
	},
	{
		"date": "2022-10-26",
		"county": "Clark",
		"title": "7. Clark",
		"cases_7day_mean_per_100k": 5.047007444
	},
	{
		"date": "2022-10-27",
		"county": "Clark",
		"title": "7. Clark",
		"cases_7day_mean_per_100k": 4.9831212738
	},
	{
		"date": "2022-10-28",
		"county": "Clark",
		"title": "7. Clark",
		"cases_7day_mean_per_100k": 4.4720319124
	},
	{
		"date": "2022-10-29",
		"county": "Clark",
		"title": "7. Clark",
		"cases_7day_mean_per_100k": 4.4081457422
	},
	{
		"date": "2022-10-30",
		"county": "Clark",
		"title": "7. Clark",
		"cases_7day_mean_per_100k": 4.663690423
	},
	{
		"date": "2022-10-31",
		"county": "Clark",
		"title": "7. Clark",
		"cases_7day_mean_per_100k": 4.9831212738
	},
	{
		"date": "2022-11-01",
		"county": "Clark",
		"title": "7. Clark",
		"cases_7day_mean_per_100k": 8.6885191441
	},
	{
		"date": "2022-11-02",
		"county": "Clark",
		"title": "7. Clark",
		"cases_7day_mean_per_100k": 9.0718361652
	},
	{
		"date": "2022-11-03",
		"county": "Clark",
		"title": "7. Clark",
		"cases_7day_mean_per_100k": 9.5829255266
	},
	{
		"date": "2022-11-04",
		"county": "Clark",
		"title": "7. Clark",
		"cases_7day_mean_per_100k": 10.4134457389
	},
	{
		"date": "2022-11-05",
		"county": "Clark",
		"title": "7. Clark",
		"cases_7day_mean_per_100k": 10.2217872284
	},
	{
		"date": "2022-11-06",
		"county": "Clark",
		"title": "7. Clark",
		"cases_7day_mean_per_100k": 9.5190393564
	},
	{
		"date": "2022-11-07",
		"county": "Clark",
		"title": "7. Clark",
		"cases_7day_mean_per_100k": 8.1135436125
	},
	{
		"date": "2022-11-08",
		"county": "Clark",
		"title": "7. Clark",
		"cases_7day_mean_per_100k": 3.7053978703
	}
];

const case3_spec = {
	"artboard": {
		"name": "railways-desktop",
		"screen_type": "Desktop-Landscape",
		"artboard_width": 920,
		"artboard_height": 750,
		"device_width": 1440,
		"device_height": 900,
		"ppi": 227
	},
	"original_artboard": {
		"name": "railways-desktop",
		"screen_type": "Desktop-Landscape",
		"artboard_width": 920,
		"artboard_height": 750,
		"device_width": 1440,
		"device_height": 900,
		"ppi": 227
	},
	"fronto": {
		"data": [],
		"datatype": {},
		"name": "",
		"layout": {
			"width": 920,
			"height": 750,
			"composition": "single",
			"column": [
				{
					"field": "date",
					"type": "quantitative",
					"scale": {
						"domain": [
							1970,
							2020
						]
					}
				}
			],
			"row": [
				{
					"field": "value",
					"type": "quantitative",
					"scale": {
						"domain": [
							15,
							100
						]
					}
				}
			],
			"vaxis": {
				"grid": true
			}
		},
		"layer": [
			{
				"name": "layer_0",
				"mark": {
					"type": "line",
					"detail": {
						"field": "category"
					},
					"endMark": true,
					"stroke": {
						"field": "category",
						"scale": {
							"domain": [
								"Logistik & Transport",
								"Stubai Valley Railway",
								"Austrian Federal Railways",
								"Styrian Provincial Railways",
								"Montafonerbahn",
								"WESTbahn",
								"Graz-Köflacher Ebahn"
							],
							"range": [
								"rgba(127,50,153,1)",
								"rgba(236,16,106,1)",
								"rgba(255,174,0,1)",
								"rgba(63,81,153,1)",
								"rgba(13,137,145,1)",
								"rgba(147,207,30,1)",
								"rgba(242,94,2,1)"
							]
						}
					},
					"interpolate": "cardinal"
				},
				"text": [
					{
						"type": "on-axis",
						"field": "value",
						"values": [
							20,
							40,
							60,
							80,
							100
						],
						"items": [
							{
								"fontSize": 13,
								"index": 0,
								"width": 20,
								"color": "rgba(165,165,165,1)"
							}
						]
					},
					{
						"type": "on-axis",
						"field": "date",
						"items": [
							{
								"index": 0,
								"fontSize": 12,
								"color": "rgba(165,165,165,1)",
								"align": "center",
								"width": 30
							}
						],
						"values": [
							1970,
							1975,
							1980,
							1985,
							1990,
							1995,
							2000,
							2005,
							2010,
							2015,
							2020
						],
						"tick": {
							"color": "rgba(165,165,165,1)",
							"width": 1,
							"opacity": 0.48
						},
						"padding": 10,
						"anchor": "middle"
					},
					{
						"type": "on-mark",
						"items": [
							{
								"index": 0,
								"color": "$mark",
								"fontSize": 14,
								"width": 101,
								"fontWeight": "700"
							}
						],
						"field": "category",
						"name": "label_2",
						"orient": "top-center",
						"values": [
							"Logistik & Transport",
							"Stubai Valley Railway",
							"Austrian Federal Railways",
							"Styrian Provincial Railways",
							"Montafonerbahn",
							"WESTbahn",
							"Graz-Köflacher Ebahn"
						],
						"dx": 5
					}
				]
			}
		],
		"title": {
			"items": [
				{
					"name": "title_0",
					"text": "Different railways has scaled up in different speeds",
					"fontWeight": 700,
					"fontSize": 22
				},
				{
					"name": "title_1",
					"text": "Daily passengers (Mil.)",
					"fontWeight": "400",
					"fontSize": 15,
					"fontColor": "rgba(75,75,75,1)"
				}
			]
		},
		"annotation": {
			"items": [
				{
					"type": "text",
					"text": [
						{
							"text": "<span style=\"background-color: rgb(127,50,153); color: #ffffff; padding-left: 4px; padding-right: 4px;\">Logistik & Transport</span> and <span style=\"background-color: rgb(236,16,106); color: #ffffff; padding-left: 4px; padding-right: 4px;\">Stubai Valley Railway</span> have scaled up most fast while more and more passenegers use railways for various reasons in general. In 2019, the daily passenger count doubled from 1970.",
							"align": "left",
							"index": "0",
							"fontSize": 18
						}
					],
					"name": "annotation_0",
					"x": "50%",
					"y": "75%",
					"width": 400,
					"box": {
						"radius": 0,
						"stroke": "rgba(220,220,220,1)",
						"fill": "rgba(255,255,255,0.6773)",
						"opacity": 0.36,
						"strokeWidth": 1,
						"padding": "10px 10px 10px 10px"
					},
					"dx": "-50%",
					"dy": "-40%"
				}
			]
		}
	}
};

const case3_data = [
	{
		"category": "Logistik & Transport",
		"date": 1970,
		"value": 48
	},
	{
		"category": "Stubai Valley Railway",
		"date": 1970,
		"value": 54.9
	},
	{
		"category": "Austrian Federal Railways",
		"date": 1970,
		"value": 49.3
	},
	{
		"category": "Styrian Provincial Railways",
		"date": 1970,
		"value": 34.7
	},
	{
		"category": "Montafonerbahn",
		"date": 1970,
		"value": 64.9
	},
	{
		"category": "WESTbahn",
		"date": 1970,
		"value": 42.6
	},
	{
		"category": "Graz-Köflacher Ebahn",
		"date": 1970,
		"value": 37.6
	},
	{
		"category": "Logistik & Transport",
		"date": 1971,
		"value": 48
	},
	{
		"category": "Stubai Valley Railway",
		"date": 1971,
		"value": 54.3
	},
	{
		"category": "Austrian Federal Railways",
		"date": 1971,
		"value": 50.1
	},
	{
		"category": "Styrian Provincial Railways",
		"date": 1971,
		"value": 34.7
	},
	{
		"category": "Montafonerbahn",
		"date": 1971,
		"value": 64.9
	},
	{
		"category": "WESTbahn",
		"date": 1971,
		"value": 42.6
	},
	{
		"category": "Graz-Köflacher Ebahn",
		"date": 1971,
		"value": 38
	},
	{
		"category": "Logistik & Transport",
		"date": 1972,
		"value": 48.3
	},
	{
		"category": "Stubai Valley Railway",
		"date": 1972,
		"value": 55.7
	},
	{
		"category": "Austrian Federal Railways",
		"date": 1972,
		"value": 50.8
	},
	{
		"category": "Styrian Provincial Railways",
		"date": 1972,
		"value": 34.7
	},
	{
		"category": "Montafonerbahn",
		"date": 1972,
		"value": 66.3
	},
	{
		"category": "WESTbahn",
		"date": 1972,
		"value": 42.6
	},
	{
		"category": "Graz-Köflacher Ebahn",
		"date": 1972,
		"value": 38.2
	},
	{
		"category": "Logistik & Transport",
		"date": 1973,
		"value": 49.1
	},
	{
		"category": "Stubai Valley Railway",
		"date": 1973,
		"value": 56.7
	},
	{
		"category": "Austrian Federal Railways",
		"date": 1973,
		"value": 51.8
	},
	{
		"category": "Styrian Provincial Railways",
		"date": 1973,
		"value": 34.7
	},
	{
		"category": "Montafonerbahn",
		"date": 1973,
		"value": 66.3
	},
	{
		"category": "WESTbahn",
		"date": 1973,
		"value": 43
	},
	{
		"category": "Graz-Köflacher Ebahn",
		"date": 1973,
		"value": 39.5
	},
	{
		"category": "Logistik & Transport",
		"date": 1974,
		"value": 50.2
	},
	{
		"category": "Stubai Valley Railway",
		"date": 1974,
		"value": 57
	},
	{
		"category": "Austrian Federal Railways",
		"date": 1974,
		"value": 51.9
	},
	{
		"category": "Styrian Provincial Railways",
		"date": 1974,
		"value": 35.4
	},
	{
		"category": "Montafonerbahn",
		"date": 1974,
		"value": 66.3
	},
	{
		"category": "WESTbahn",
		"date": 1974,
		"value": 43
	},
	{
		"category": "Graz-Köflacher Ebahn",
		"date": 1974,
		"value": 39.7
	},
	{
		"category": "Logistik & Transport",
		"date": 1975,
		"value": 50.2
	},
	{
		"category": "Stubai Valley Railway",
		"date": 1975,
		"value": 58
	},
	{
		"category": "Austrian Federal Railways",
		"date": 1975,
		"value": 52.3
	},
	{
		"category": "Styrian Provincial Railways",
		"date": 1975,
		"value": 35.4
	},
	{
		"category": "Montafonerbahn",
		"date": 1975,
		"value": 69.5
	},
	{
		"category": "WESTbahn",
		"date": 1975,
		"value": 43
	},
	{
		"category": "Graz-Köflacher Ebahn",
		"date": 1975,
		"value": 39.7
	},
	{
		"category": "Logistik & Transport",
		"date": 1976,
		"value": 50.5
	},
	{
		"category": "Stubai Valley Railway",
		"date": 1976,
		"value": 58.5
	},
	{
		"category": "Austrian Federal Railways",
		"date": 1976,
		"value": 52.9
	},
	{
		"category": "Styrian Provincial Railways",
		"date": 1976,
		"value": 35.4
	},
	{
		"category": "Montafonerbahn",
		"date": 1976,
		"value": 69.5
	},
	{
		"category": "WESTbahn",
		"date": 1976,
		"value": 43.9
	},
	{
		"category": "Graz-Köflacher Ebahn",
		"date": 1976,
		"value": 39.9
	},
	{
		"category": "Logistik & Transport",
		"date": 1977,
		"value": 51.3
	},
	{
		"category": "Stubai Valley Railway",
		"date": 1977,
		"value": 59.4
	},
	{
		"category": "Austrian Federal Railways",
		"date": 1977,
		"value": 53.3
	},
	{
		"category": "Styrian Provincial Railways",
		"date": 1977,
		"value": 36
	},
	{
		"category": "Montafonerbahn",
		"date": 1977,
		"value": 71.2
	},
	{
		"category": "WESTbahn",
		"date": 1977,
		"value": 43.9
	},
	{
		"category": "Graz-Köflacher Ebahn",
		"date": 1977,
		"value": 40.1
	},
	{
		"category": "Logistik & Transport",
		"date": 1978,
		"value": 51.7
	},
	{
		"category": "Stubai Valley Railway",
		"date": 1978,
		"value": 60.3
	},
	{
		"category": "Austrian Federal Railways",
		"date": 1978,
		"value": 53.4
	},
	{
		"category": "Styrian Provincial Railways",
		"date": 1978,
		"value": 36
	},
	{
		"category": "Montafonerbahn",
		"date": 1978,
		"value": 73
	},
	{
		"category": "WESTbahn",
		"date": 1978,
		"value": 43.9
	},
	{
		"category": "Graz-Köflacher Ebahn",
		"date": 1978,
		"value": 41.1
	},
	{
		"category": "Logistik & Transport",
		"date": 1979,
		"value": 51.8
	},
	{
		"category": "Stubai Valley Railway",
		"date": 1979,
		"value": 60.8
	},
	{
		"category": "Austrian Federal Railways",
		"date": 1979,
		"value": 54
	},
	{
		"category": "Styrian Provincial Railways",
		"date": 1979,
		"value": 36
	},
	{
		"category": "Montafonerbahn",
		"date": 1979,
		"value": 76.1
	},
	{
		"category": "WESTbahn",
		"date": 1979,
		"value": 43.9
	},
	{
		"category": "Graz-Köflacher Ebahn",
		"date": 1979,
		"value": 41.6
	},
	{
		"category": "Logistik & Transport",
		"date": 1980,
		"value": 51.8
	},
	{
		"category": "Stubai Valley Railway",
		"date": 1980,
		"value": 61.3
	},
	{
		"category": "Austrian Federal Railways",
		"date": 1980,
		"value": 54.5
	},
	{
		"category": "Styrian Provincial Railways",
		"date": 1980,
		"value": 36.2
	},
	{
		"category": "Montafonerbahn",
		"date": 1980,
		"value": 76.1
	},
	{
		"category": "WESTbahn",
		"date": 1980,
		"value": 43.9
	},
	{
		"category": "Graz-Köflacher Ebahn",
		"date": 1980,
		"value": 42.2
	},
	{
		"category": "Logistik & Transport",
		"date": 1981,
		"value": 52.2
	},
	{
		"category": "Stubai Valley Railway",
		"date": 1981,
		"value": 61.6
	},
	{
		"category": "Austrian Federal Railways",
		"date": 1981,
		"value": 55.8
	},
	{
		"category": "Styrian Provincial Railways",
		"date": 1981,
		"value": 36.2
	},
	{
		"category": "Montafonerbahn",
		"date": 1981,
		"value": 81.1
	},
	{
		"category": "WESTbahn",
		"date": 1981,
		"value": 43.9
	},
	{
		"category": "Graz-Köflacher Ebahn",
		"date": 1981,
		"value": 42.5
	},
	{
		"category": "Logistik & Transport",
		"date": 1982,
		"value": 52.6
	},
	{
		"category": "Stubai Valley Railway",
		"date": 1982,
		"value": 61.9
	},
	{
		"category": "Austrian Federal Railways",
		"date": 1982,
		"value": 55.9
	},
	{
		"category": "Styrian Provincial Railways",
		"date": 1982,
		"value": 36.2
	},
	{
		"category": "Montafonerbahn",
		"date": 1982,
		"value": 81.1
	},
	{
		"category": "WESTbahn",
		"date": 1982,
		"value": 43.9
	},
	{
		"category": "Graz-Köflacher Ebahn",
		"date": 1982,
		"value": 43.1
	},
	{
		"category": "Logistik & Transport",
		"date": 1983,
		"value": 52.8
	},
	{
		"category": "Stubai Valley Railway",
		"date": 1983,
		"value": 62.1
	},
	{
		"category": "Austrian Federal Railways",
		"date": 1983,
		"value": 57
	},
	{
		"category": "Styrian Provincial Railways",
		"date": 1983,
		"value": 36.3
	},
	{
		"category": "Montafonerbahn",
		"date": 1983,
		"value": 81.1
	},
	{
		"category": "WESTbahn",
		"date": 1983,
		"value": 43.9
	},
	{
		"category": "Graz-Köflacher Ebahn",
		"date": 1983,
		"value": 43.4
	},
	{
		"category": "Logistik & Transport",
		"date": 1984,
		"value": 53.3
	},
	{
		"category": "Stubai Valley Railway",
		"date": 1984,
		"value": 62.2
	},
	{
		"category": "Austrian Federal Railways",
		"date": 1984,
		"value": 57.5
	},
	{
		"category": "Styrian Provincial Railways",
		"date": 1984,
		"value": 36.5
	},
	{
		"category": "Montafonerbahn",
		"date": 1984,
		"value": 81.1
	},
	{
		"category": "WESTbahn",
		"date": 1984,
		"value": 43.9
	},
	{
		"category": "Graz-Köflacher Ebahn",
		"date": 1984,
		"value": 43.8
	},
	{
		"category": "Logistik & Transport",
		"date": 1985,
		"value": 53.5
	},
	{
		"category": "Stubai Valley Railway",
		"date": 1985,
		"value": 62.7
	},
	{
		"category": "Austrian Federal Railways",
		"date": 1985,
		"value": 58.1
	},
	{
		"category": "Styrian Provincial Railways",
		"date": 1985,
		"value": 36.5
	},
	{
		"category": "Montafonerbahn",
		"date": 1985,
		"value": 84.2
	},
	{
		"category": "WESTbahn",
		"date": 1985,
		"value": 43.5
	},
	{
		"category": "Graz-Köflacher Ebahn",
		"date": 1985,
		"value": 44.1
	},
	{
		"category": "Logistik & Transport",
		"date": 1986,
		"value": 53.7
	},
	{
		"category": "Stubai Valley Railway",
		"date": 1986,
		"value": 63.5
	},
	{
		"category": "Austrian Federal Railways",
		"date": 1986,
		"value": 58.3
	},
	{
		"category": "Styrian Provincial Railways",
		"date": 1986,
		"value": 36.8
	},
	{
		"category": "Montafonerbahn",
		"date": 1986,
		"value": 84.2
	},
	{
		"category": "WESTbahn",
		"date": 1986,
		"value": 43.5
	},
	{
		"category": "Graz-Köflacher Ebahn",
		"date": 1986,
		"value": 44.5
	},
	{
		"category": "Logistik & Transport",
		"date": 1987,
		"value": 53.9
	},
	{
		"category": "Stubai Valley Railway",
		"date": 1987,
		"value": 63.9
	},
	{
		"category": "Austrian Federal Railways",
		"date": 1987,
		"value": 58.3
	},
	{
		"category": "Styrian Provincial Railways",
		"date": 1987,
		"value": 36.6
	},
	{
		"category": "Montafonerbahn",
		"date": 1987,
		"value": 86
	},
	{
		"category": "WESTbahn",
		"date": 1987,
		"value": 43
	},
	{
		"category": "Graz-Köflacher Ebahn",
		"date": 1987,
		"value": 44.7
	},
	{
		"category": "Logistik & Transport",
		"date": 1988,
		"value": 54.8
	},
	{
		"category": "Stubai Valley Railway",
		"date": 1988,
		"value": 64.1
	},
	{
		"category": "Austrian Federal Railways",
		"date": 1988,
		"value": 59.4
	},
	{
		"category": "Styrian Provincial Railways",
		"date": 1988,
		"value": 37.1
	},
	{
		"category": "Montafonerbahn",
		"date": 1988,
		"value": 86
	},
	{
		"category": "WESTbahn",
		"date": 1988,
		"value": 43.4
	},
	{
		"category": "Graz-Köflacher Ebahn",
		"date": 1988,
		"value": 45.4
	},
	{
		"category": "Logistik & Transport",
		"date": 1989,
		"value": 55.1
	},
	{
		"category": "Stubai Valley Railway",
		"date": 1989,
		"value": 64.5
	},
	{
		"category": "Austrian Federal Railways",
		"date": 1989,
		"value": 60.1
	},
	{
		"category": "Styrian Provincial Railways",
		"date": 1989,
		"value": 37.1
	},
	{
		"category": "Montafonerbahn",
		"date": 1989,
		"value": 86
	},
	{
		"category": "WESTbahn",
		"date": 1989,
		"value": 43.4
	},
	{
		"category": "Graz-Köflacher Ebahn",
		"date": 1989,
		"value": 45.5
	},
	{
		"category": "Logistik & Transport",
		"date": 1990,
		"value": 55.7
	},
	{
		"category": "Stubai Valley Railway",
		"date": 1990,
		"value": 64.9
	},
	{
		"category": "Austrian Federal Railways",
		"date": 1990,
		"value": 61.3
	},
	{
		"category": "Styrian Provincial Railways",
		"date": 1990,
		"value": 37.7
	},
	{
		"category": "Montafonerbahn",
		"date": 1990,
		"value": 87.9
	},
	{
		"category": "WESTbahn",
		"date": 1990,
		"value": 43.4
	},
	{
		"category": "Graz-Köflacher Ebahn",
		"date": 1990,
		"value": 46.3
	},
	{
		"category": "Logistik & Transport",
		"date": 1991,
		"value": 56.3
	},
	{
		"category": "Stubai Valley Railway",
		"date": 1991,
		"value": 65.5
	},
	{
		"category": "Austrian Federal Railways",
		"date": 1991,
		"value": 61.8
	},
	{
		"category": "Styrian Provincial Railways",
		"date": 1991,
		"value": 37.7
	},
	{
		"category": "Montafonerbahn",
		"date": 1991,
		"value": 89.3
	},
	{
		"category": "WESTbahn",
		"date": 1991,
		"value": 43.4
	},
	{
		"category": "Graz-Köflacher Ebahn",
		"date": 1991,
		"value": 46.4
	},
	{
		"category": "Logistik & Transport",
		"date": 1992,
		"value": 56.4
	},
	{
		"category": "Stubai Valley Railway",
		"date": 1992,
		"value": 66.2
	},
	{
		"category": "Austrian Federal Railways",
		"date": 1992,
		"value": 62.5
	},
	{
		"category": "Styrian Provincial Railways",
		"date": 1992,
		"value": 37.9
	},
	{
		"category": "Montafonerbahn",
		"date": 1992,
		"value": 89.3
	},
	{
		"category": "WESTbahn",
		"date": 1992,
		"value": 43.4
	},
	{
		"category": "Graz-Köflacher Ebahn",
		"date": 1992,
		"value": 47.3
	},
	{
		"category": "Logistik & Transport",
		"date": 1993,
		"value": 56.4
	},
	{
		"category": "Stubai Valley Railway",
		"date": 1993,
		"value": 66.8
	},
	{
		"category": "Austrian Federal Railways",
		"date": 1993,
		"value": 63.2
	},
	{
		"category": "Styrian Provincial Railways",
		"date": 1993,
		"value": 37.9
	},
	{
		"category": "Montafonerbahn",
		"date": 1993,
		"value": 89.3
	},
	{
		"category": "WESTbahn",
		"date": 1993,
		"value": 43.4
	},
	{
		"category": "Graz-Köflacher Ebahn",
		"date": 1993,
		"value": 48.3
	},
	{
		"category": "Logistik & Transport",
		"date": 1994,
		"value": 57
	},
	{
		"category": "Stubai Valley Railway",
		"date": 1994,
		"value": 67.4
	},
	{
		"category": "Austrian Federal Railways",
		"date": 1994,
		"value": 64.1
	},
	{
		"category": "Styrian Provincial Railways",
		"date": 1994,
		"value": 38.5
	},
	{
		"category": "Montafonerbahn",
		"date": 1994,
		"value": 89.5
	},
	{
		"category": "WESTbahn",
		"date": 1994,
		"value": 43.4
	},
	{
		"category": "Graz-Köflacher Ebahn",
		"date": 1994,
		"value": 49.2
	},
	{
		"category": "Logistik & Transport",
		"date": 1995,
		"value": 58
	},
	{
		"category": "Stubai Valley Railway",
		"date": 1995,
		"value": 68.4
	},
	{
		"category": "Austrian Federal Railways",
		"date": 1995,
		"value": 64.7
	},
	{
		"category": "Styrian Provincial Railways",
		"date": 1995,
		"value": 38.8
	},
	{
		"category": "Montafonerbahn",
		"date": 1995,
		"value": 89.5
	},
	{
		"category": "WESTbahn",
		"date": 1995,
		"value": 44.1
	},
	{
		"category": "Graz-Köflacher Ebahn",
		"date": 1995,
		"value": 49.9
	},
	{
		"category": "Logistik & Transport",
		"date": 1996,
		"value": 58.5
	},
	{
		"category": "Stubai Valley Railway",
		"date": 1996,
		"value": 70.1
	},
	{
		"category": "Austrian Federal Railways",
		"date": 1996,
		"value": 65.1
	},
	{
		"category": "Styrian Provincial Railways",
		"date": 1996,
		"value": 39.2
	},
	{
		"category": "Montafonerbahn",
		"date": 1996,
		"value": 89.5
	},
	{
		"category": "WESTbahn",
		"date": 1996,
		"value": 44.9
	},
	{
		"category": "Graz-Köflacher Ebahn",
		"date": 1996,
		"value": 50.7
	},
	{
		"category": "Logistik & Transport",
		"date": 1997,
		"value": 59.3
	},
	{
		"category": "Stubai Valley Railway",
		"date": 1997,
		"value": 70.8
	},
	{
		"category": "Austrian Federal Railways",
		"date": 1997,
		"value": 66.3
	},
	{
		"category": "Styrian Provincial Railways",
		"date": 1997,
		"value": 39
	},
	{
		"category": "Montafonerbahn",
		"date": 1997,
		"value": 89.5
	},
	{
		"category": "WESTbahn",
		"date": 1997,
		"value": 44.9
	},
	{
		"category": "Graz-Köflacher Ebahn",
		"date": 1997,
		"value": 51.3
	},
	{
		"category": "Logistik & Transport",
		"date": 1998,
		"value": 59.8
	},
	{
		"category": "Stubai Valley Railway",
		"date": 1998,
		"value": 71.1
	},
	{
		"category": "Austrian Federal Railways",
		"date": 1998,
		"value": 67.3
	},
	{
		"category": "Styrian Provincial Railways",
		"date": 1998,
		"value": 39.3
	},
	{
		"category": "Montafonerbahn",
		"date": 1998,
		"value": 89.5
	},
	{
		"category": "WESTbahn",
		"date": 1998,
		"value": 45
	},
	{
		"category": "Graz-Köflacher Ebahn",
		"date": 1998,
		"value": 52.1
	},
	{
		"category": "Logistik & Transport",
		"date": 1999,
		"value": 60.4
	},
	{
		"category": "Stubai Valley Railway",
		"date": 1999,
		"value": 72.1
	},
	{
		"category": "Austrian Federal Railways",
		"date": 1999,
		"value": 68
	},
	{
		"category": "Styrian Provincial Railways",
		"date": 1999,
		"value": 39.8
	},
	{
		"category": "Montafonerbahn",
		"date": 1999,
		"value": 89.5
	},
	{
		"category": "WESTbahn",
		"date": 1999,
		"value": 45.1
	},
	{
		"category": "Graz-Köflacher Ebahn",
		"date": 1999,
		"value": 52.7
	},
	{
		"category": "Logistik & Transport",
		"date": 2000,
		"value": 60.9
	},
	{
		"category": "Stubai Valley Railway",
		"date": 2000,
		"value": 73
	},
	{
		"category": "Austrian Federal Railways",
		"date": 2000,
		"value": 69.2
	},
	{
		"category": "Styrian Provincial Railways",
		"date": 2000,
		"value": 40.4
	},
	{
		"category": "Montafonerbahn",
		"date": 2000,
		"value": 89.5
	},
	{
		"category": "WESTbahn",
		"date": 2000,
		"value": 45.1
	},
	{
		"category": "Graz-Köflacher Ebahn",
		"date": 2000,
		"value": 53.5
	},
	{
		"category": "Logistik & Transport",
		"date": 2001,
		"value": 60.9
	},
	{
		"category": "Stubai Valley Railway",
		"date": 2001,
		"value": 73.5
	},
	{
		"category": "Austrian Federal Railways",
		"date": 2001,
		"value": 69.7
	},
	{
		"category": "Styrian Provincial Railways",
		"date": 2001,
		"value": 40.6
	},
	{
		"category": "Montafonerbahn",
		"date": 2001,
		"value": 89.5
	},
	{
		"category": "WESTbahn",
		"date": 2001,
		"value": 44.6
	},
	{
		"category": "Graz-Köflacher Ebahn",
		"date": 2001,
		"value": 53.8
	},
	{
		"category": "Logistik & Transport",
		"date": 2002,
		"value": 61.5
	},
	{
		"category": "Stubai Valley Railway",
		"date": 2002,
		"value": 75.3
	},
	{
		"category": "Austrian Federal Railways",
		"date": 2002,
		"value": 70.8
	},
	{
		"category": "Styrian Provincial Railways",
		"date": 2002,
		"value": 40.6
	},
	{
		"category": "Montafonerbahn",
		"date": 2002,
		"value": 89.5
	},
	{
		"category": "WESTbahn",
		"date": 2002,
		"value": 45.3
	},
	{
		"category": "Graz-Köflacher Ebahn",
		"date": 2002,
		"value": 54.4
	},
	{
		"category": "Logistik & Transport",
		"date": 2003,
		"value": 61.7
	},
	{
		"category": "Stubai Valley Railway",
		"date": 2003,
		"value": 77.2
	},
	{
		"category": "Austrian Federal Railways",
		"date": 2003,
		"value": 71.3
	},
	{
		"category": "Styrian Provincial Railways",
		"date": 2003,
		"value": 41.6
	},
	{
		"category": "Montafonerbahn",
		"date": 2003,
		"value": 89.5
	},
	{
		"category": "WESTbahn",
		"date": 2003,
		"value": 45.3
	},
	{
		"category": "Graz-Köflacher Ebahn",
		"date": 2003,
		"value": 54.9
	},
	{
		"category": "Logistik & Transport",
		"date": 2004,
		"value": 62.3
	},
	{
		"category": "Stubai Valley Railway",
		"date": 2004,
		"value": 78.9
	},
	{
		"category": "Austrian Federal Railways",
		"date": 2004,
		"value": 71.7
	},
	{
		"category": "Styrian Provincial Railways",
		"date": 2004,
		"value": 43.1
	},
	{
		"category": "Montafonerbahn",
		"date": 2004,
		"value": 89.5
	},
	{
		"category": "WESTbahn",
		"date": 2004,
		"value": 45.3
	},
	{
		"category": "Graz-Köflacher Ebahn",
		"date": 2004,
		"value": 55.8
	},
	{
		"category": "Logistik & Transport",
		"date": 2005,
		"value": 62.3
	},
	{
		"category": "Stubai Valley Railway",
		"date": 2005,
		"value": 80.4
	},
	{
		"category": "Austrian Federal Railways",
		"date": 2005,
		"value": 71.9
	},
	{
		"category": "Styrian Provincial Railways",
		"date": 2005,
		"value": 43.6
	},
	{
		"category": "Montafonerbahn",
		"date": 2005,
		"value": 89.5
	},
	{
		"category": "WESTbahn",
		"date": 2005,
		"value": 45.3
	},
	{
		"category": "Graz-Köflacher Ebahn",
		"date": 2005,
		"value": 58
	},
	{
		"category": "Logistik & Transport",
		"date": 2006,
		"value": 62.8
	},
	{
		"category": "Stubai Valley Railway",
		"date": 2006,
		"value": 81.6
	},
	{
		"category": "Austrian Federal Railways",
		"date": 2006,
		"value": 72.6
	},
	{
		"category": "Styrian Provincial Railways",
		"date": 2006,
		"value": 44.2
	},
	{
		"category": "Montafonerbahn",
		"date": 2006,
		"value": 89.5
	},
	{
		"category": "WESTbahn",
		"date": 2006,
		"value": 45.4
	},
	{
		"category": "Graz-Köflacher Ebahn",
		"date": 2006,
		"value": 59
	},
	{
		"category": "Logistik & Transport",
		"date": 2007,
		"value": 63.3
	},
	{
		"category": "Stubai Valley Railway",
		"date": 2007,
		"value": 82.9
	},
	{
		"category": "Austrian Federal Railways",
		"date": 2007,
		"value": 73.1
	},
	{
		"category": "Styrian Provincial Railways",
		"date": 2007,
		"value": 44.4
	},
	{
		"category": "Montafonerbahn",
		"date": 2007,
		"value": 89.5
	},
	{
		"category": "WESTbahn",
		"date": 2007,
		"value": 48.6
	},
	{
		"category": "Graz-Köflacher Ebahn",
		"date": 2007,
		"value": 60.2
	},
	{
		"category": "Logistik & Transport",
		"date": 2008,
		"value": 64.5
	},
	{
		"category": "Stubai Valley Railway",
		"date": 2008,
		"value": 83.9
	},
	{
		"category": "Austrian Federal Railways",
		"date": 2008,
		"value": 73.7
	},
	{
		"category": "Styrian Provincial Railways",
		"date": 2008,
		"value": 44.9
	},
	{
		"category": "Montafonerbahn",
		"date": 2008,
		"value": 89.5
	},
	{
		"category": "WESTbahn",
		"date": 2008,
		"value": 49.9
	},
	{
		"category": "Graz-Köflacher Ebahn",
		"date": 2008,
		"value": 62
	},
	{
		"category": "Logistik & Transport",
		"date": 2009,
		"value": 64.8
	},
	{
		"category": "Stubai Valley Railway",
		"date": 2009,
		"value": 85.3
	},
	{
		"category": "Austrian Federal Railways",
		"date": 2009,
		"value": 74.3
	},
	{
		"category": "Styrian Provincial Railways",
		"date": 2009,
		"value": 44.9
	},
	{
		"category": "Montafonerbahn",
		"date": 2009,
		"value": 89.5
	},
	{
		"category": "WESTbahn",
		"date": 2009,
		"value": 51.6
	},
	{
		"category": "Graz-Köflacher Ebahn",
		"date": 2009,
		"value": 63.2
	},
	{
		"category": "Logistik & Transport",
		"date": 2010,
		"value": 65.4
	},
	{
		"category": "Stubai Valley Railway",
		"date": 2010,
		"value": 86.4
	},
	{
		"category": "Austrian Federal Railways",
		"date": 2010,
		"value": 74.5
	},
	{
		"category": "Styrian Provincial Railways",
		"date": 2010,
		"value": 46.2
	},
	{
		"category": "Montafonerbahn",
		"date": 2010,
		"value": 89.5
	},
	{
		"category": "WESTbahn",
		"date": 2010,
		"value": 52.8
	},
	{
		"category": "Graz-Köflacher Ebahn",
		"date": 2010,
		"value": 63.3
	},
	{
		"category": "Logistik & Transport",
		"date": 2011,
		"value": 66.3
	},
	{
		"category": "Stubai Valley Railway",
		"date": 2011,
		"value": 87.2
	},
	{
		"category": "Austrian Federal Railways",
		"date": 2011,
		"value": 74.7
	},
	{
		"category": "Styrian Provincial Railways",
		"date": 2011,
		"value": 46.4
	},
	{
		"category": "Montafonerbahn",
		"date": 2011,
		"value": 89.5
	},
	{
		"category": "WESTbahn",
		"date": 2011,
		"value": 52.8
	},
	{
		"category": "Graz-Köflacher Ebahn",
		"date": 2011,
		"value": 63.7
	},
	{
		"category": "Logistik & Transport",
		"date": 2012,
		"value": 67.7
	},
	{
		"category": "Stubai Valley Railway",
		"date": 2012,
		"value": 87.4
	},
	{
		"category": "Austrian Federal Railways",
		"date": 2012,
		"value": 75.1
	},
	{
		"category": "Styrian Provincial Railways",
		"date": 2012,
		"value": 46.4
	},
	{
		"category": "Montafonerbahn",
		"date": 2012,
		"value": 89.5
	},
	{
		"category": "WESTbahn",
		"date": 2012,
		"value": 52.9
	},
	{
		"category": "Graz-Köflacher Ebahn",
		"date": 2012,
		"value": 64.6
	},
	{
		"category": "Logistik & Transport",
		"date": 2013,
		"value": 69.1
	},
	{
		"category": "Stubai Valley Railway",
		"date": 2013,
		"value": 87.8
	},
	{
		"category": "Austrian Federal Railways",
		"date": 2013,
		"value": 75.9
	},
	{
		"category": "Styrian Provincial Railways",
		"date": 2013,
		"value": 46.6
	},
	{
		"category": "Montafonerbahn",
		"date": 2013,
		"value": 89.5
	},
	{
		"category": "WESTbahn",
		"date": 2013,
		"value": 53.8
	},
	{
		"category": "Graz-Köflacher Ebahn",
		"date": 2013,
		"value": 65.4
	},
	{
		"category": "Logistik & Transport",
		"date": 2014,
		"value": 69.6
	},
	{
		"category": "Stubai Valley Railway",
		"date": 2014,
		"value": 88.1
	},
	{
		"category": "Austrian Federal Railways",
		"date": 2014,
		"value": 76.3
	},
	{
		"category": "Styrian Provincial Railways",
		"date": 2014,
		"value": 47.2
	},
	{
		"category": "Montafonerbahn",
		"date": 2014,
		"value": 89.5
	},
	{
		"category": "WESTbahn",
		"date": 2014,
		"value": 53.8
	},
	{
		"category": "Graz-Köflacher Ebahn",
		"date": 2014,
		"value": 66.2
	},
	{
		"category": "Logistik & Transport",
		"date": 2015,
		"value": 70
	},
	{
		"category": "Stubai Valley Railway",
		"date": 2015,
		"value": 88.2
	},
	{
		"category": "Austrian Federal Railways",
		"date": 2015,
		"value": 76.9
	},
	{
		"category": "Styrian Provincial Railways",
		"date": 2015,
		"value": 47.6
	},
	{
		"category": "Montafonerbahn",
		"date": 2015,
		"value": 89.5
	},
	{
		"category": "WESTbahn",
		"date": 2015,
		"value": 55.6
	},
	{
		"category": "Graz-Köflacher Ebahn",
		"date": 2015,
		"value": 66.6
	},
	{
		"category": "Logistik & Transport",
		"date": 2016,
		"value": 70.8
	},
	{
		"category": "Stubai Valley Railway",
		"date": 2016,
		"value": 88.6
	},
	{
		"category": "Austrian Federal Railways",
		"date": 2016,
		"value": 77.2
	},
	{
		"category": "Styrian Provincial Railways",
		"date": 2016,
		"value": 48.8
	},
	{
		"category": "Montafonerbahn",
		"date": 2016,
		"value": 89.5
	},
	{
		"category": "WESTbahn",
		"date": 2016,
		"value": 56.9
	},
	{
		"category": "Graz-Köflacher Ebahn",
		"date": 2016,
		"value": 67.6
	},
	{
		"category": "Logistik & Transport",
		"date": 2017,
		"value": 70.9
	},
	{
		"category": "Stubai Valley Railway",
		"date": 2017,
		"value": 89.1
	},
	{
		"category": "Austrian Federal Railways",
		"date": 2017,
		"value": 77.5
	},
	{
		"category": "Styrian Provincial Railways",
		"date": 2017,
		"value": 48.9
	},
	{
		"category": "Montafonerbahn",
		"date": 2017,
		"value": 89.5
	},
	{
		"category": "WESTbahn",
		"date": 2017,
		"value": 57.7
	},
	{
		"category": "Graz-Köflacher Ebahn",
		"date": 2017,
		"value": 68.8
	},
	{
		"category": "Logistik & Transport",
		"date": 2018,
		"value": 71
	},
	{
		"category": "Stubai Valley Railway",
		"date": 2018,
		"value": 89.4
	},
	{
		"category": "Austrian Federal Railways",
		"date": 2018,
		"value": 77.9
	},
	{
		"category": "Styrian Provincial Railways",
		"date": 2018,
		"value": 49.8
	},
	{
		"category": "Montafonerbahn",
		"date": 2018,
		"value": 93.7
	},
	{
		"category": "WESTbahn",
		"date": 2018,
		"value": 60.2
	},
	{
		"category": "Graz-Köflacher Ebahn",
		"date": 2018,
		"value": 69.4
	},
	{
		"category": "Logistik & Transport",
		"date": 2019,
		"value": 71.5
	},
	{
		"category": "Stubai Valley Railway",
		"date": 2019,
		"value": 89.6
	},
	{
		"category": "Austrian Federal Railways",
		"date": 2019,
		"value": 78
	},
	{
		"category": "Styrian Provincial Railways",
		"date": 2019,
		"value": 53
	},
	{
		"category": "Montafonerbahn",
		"date": 2019,
		"value": 95.1
	},
	{
		"category": "WESTbahn",
		"date": 2019,
		"value": 61.4
	},
	{
		"category": "Graz-Köflacher Ebahn",
		"date": 2019,
		"value": 70.2
	}
];

const case4_data = [
	{
		"year": "1976",
		"title": "ARIEL",
		"count": 1,
		"genre": "north-west"
	},
	{
		"year": "1976",
		"title": "Hole",
		"count": 1,
		"genre": "north-west"
	},
	{
		"year": "1976",
		"title": "Hum",
		"count": 1,
		"genre": "north-west"
	},
	{
		"year": "1976",
		"title": "Laika",
		"count": 1,
		"genre": "north-west"
	},
	{
		"year": "1976",
		"title": "Patti Smith",
		"count": 1,
		"genre": "north-west"
	},
	{
		"year": "1976",
		"title": "PSYCHOTICA",
		"count": 1,
		"genre": "north-west"
	},
	{
		"year": "1976",
		"title": "SINEAD O'CONNOR",
		"count": 1,
		"genre": "north-west"
	},
	{
		"year": "1976",
		"title": "Spring Heeled Jack",
		"count": 1,
		"genre": "north-west"
	},
	{
		"year": "1976",
		"title": "St. Johnny",
		"count": 1,
		"genre": "north-west"
	},
	{
		"year": "1976",
		"title": "The Mighty Mighty Bosstones",
		"count": 1,
		"genre": "north-west"
	},
	{
		"year": "1976",
		"title": "Moby",
		"count": 1,
		"genre": "south-east"
	},
	{
		"year": "1976",
		"title": "The Coctails",
		"count": 1,
		"genre": "south-east"
	},
	{
		"year": "1976",
		"title": "Beck",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1976",
		"title": "Blonde Redhead",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1976",
		"title": "Brainiac",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1976",
		"title": "Built To Spill",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1976",
		"title": "Dirty Three",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1976",
		"title": "Doo Rag",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1976",
		"title": "Elastica",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1976",
		"title": "Helium",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1976",
		"title": "Overpass",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1976",
		"title": "PAVEMENT",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1976",
		"title": "Pork Queen",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1976",
		"title": "Poster Children",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1976",
		"title": "Sabalon Glitz",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1976",
		"title": "SONIC YOUTH",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1976",
		"title": "Superchunk",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1976",
		"title": "The Dambuilders",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1976",
		"title": "The Geraldine Fibbers",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1976",
		"title": "The Jesus Lizard",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1976",
		"title": "Thomas Jefferson Slave Apartments",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1976",
		"title": "Tuscadero",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1976",
		"title": "Versus",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1976",
		"title": "Yo La Tengo",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1976",
		"title": "Blowhole",
		"count": 1,
		"genre": "south-west"
	},
	{
		"year": "1976",
		"title": "God Lives Underwater",
		"count": 1,
		"genre": "south-west"
	},
	{
		"year": "1976",
		"title": "Mike Watt",
		"count": 1,
		"genre": "east-midlands"
	},
	{
		"year": "1976",
		"title": "The Zeros",
		"count": 1,
		"genre": "east-midlands"
	},
	{
		"year": "1976",
		"title": "coolio",
		"count": 1,
		"genre": "north-east"
	},
	{
		"year": "1976",
		"title": "Cypress Hill",
		"count": 1,
		"genre": "north-east"
	},
	{
		"year": "1976",
		"title": "Redman",
		"count": 1,
		"genre": "north-east"
	},
	{
		"year": "1976",
		"title": "The Pharcyde",
		"count": 1,
		"genre": "north-east"
	},
	{
		"year": "1976",
		"title": "The Roots",
		"count": 1,
		"genre": "north-east"
	},
	{
		"year": "1976",
		"title": "Possum Dixon",
		"count": 1,
		"genre": "west"
	},
	{
		"year": "1977",
		"title": "311",
		"count": 1,
		"genre": "north-west"
	},
	{
		"year": "1977",
		"title": "Crumb",
		"count": 1,
		"genre": "north-west"
	},
	{
		"year": "1977",
		"title": "DEVO",
		"count": 1,
		"genre": "north-west"
	},
	{
		"year": "1977",
		"title": "Fireside",
		"count": 1,
		"genre": "north-west"
	},
	{
		"year": "1977",
		"title": "PSYCHOTICA",
		"count": 1,
		"genre": "north-west"
	},
	{
		"year": "1977",
		"title": "Satchel",
		"count": 1,
		"genre": "north-west"
	},
	{
		"year": "1977",
		"title": "Screaming Trees",
		"count": 1,
		"genre": "north-west"
	},
	{
		"year": "1977",
		"title": "Soundgarden",
		"count": 1,
		"genre": "north-west"
	},
	{
		"year": "1977",
		"title": "Sponge",
		"count": 1,
		"genre": "north-west"
	},
	{
		"year": "1977",
		"title": "You Am I",
		"count": 1,
		"genre": "north-west"
	},
	{
		"year": "1977",
		"title": "Cornershop",
		"count": 1,
		"genre": "south-east"
	},
	{
		"year": "1977",
		"title": "Ruby",
		"count": 1,
		"genre": "south-east"
	},
	{
		"year": "1977",
		"title": "Cocteau Twins",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1977",
		"title": "Cows",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1977",
		"title": "Girls Against Boys",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1977",
		"title": "Long Fin Killie",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1977",
		"title": "Lutefisk",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1977",
		"title": "Moonshake",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1977",
		"title": "Soul Coughing",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1977",
		"title": "Varnaline",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1977",
		"title": "Violent Femmes",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1977",
		"title": "Metallica",
		"count": 1,
		"genre": "south-west"
	},
	{
		"year": "1977",
		"title": "Rage Against The Machine",
		"count": 1,
		"genre": "south-west"
	},
	{
		"year": "1977",
		"title": "Shaolin Monks",
		"count": 1,
		"genre": "south-west"
	},
	{
		"year": "1977",
		"title": "Steve Earle",
		"count": 1,
		"genre": "south-west"
	},
	{
		"year": "1977",
		"title": "The Melvins",
		"count": 1,
		"genre": "south-west"
	},
	{
		"year": "1977",
		"title": "Waylon Jennings",
		"count": 1,
		"genre": "south-west"
	},
	{
		"year": "1977",
		"title": "Ben Folds Five",
		"count": 1,
		"genre": "london"
	},
	{
		"year": "1977",
		"title": "Capsize 7",
		"count": 1,
		"genre": "east-midlands"
	},
	{
		"year": "1977",
		"title": "Chune",
		"count": 1,
		"genre": "east-midlands"
	},
	{
		"year": "1977",
		"title": "RAMONES",
		"count": 1,
		"genre": "east-midlands"
	},
	{
		"year": "1977",
		"title": "Rancid",
		"count": 1,
		"genre": "east-midlands"
	},
	{
		"year": "1977",
		"title": "Thirty Ought Six",
		"count": 1,
		"genre": "east-midlands"
	},
	{
		"year": "1977",
		"title": "Wu-Tang Clan",
		"count": 1,
		"genre": "north-east"
	},
	{
		"year": "1977",
		"title": "Beth Hart Band",
		"count": 1,
		"genre": "west"
	},
	{
		"year": "1977",
		"title": "CHEAP TRICK",
		"count": 1,
		"genre": "west"
	},
	{
		"year": "1977",
		"title": "Jonny Polonsky",
		"count": 1,
		"genre": "west"
	},
	{
		"year": "1977",
		"title": "The Tea Party",
		"count": 1,
		"genre": "west"
	},
	{
		"year": "1978",
		"title": "Arson Garden",
		"count": 1,
		"genre": "north-west"
	},
	{
		"year": "1978",
		"title": "Chris Cornell and Eddie Vedder",
		"count": 1,
		"genre": "north-west"
	},
	{
		"year": "1978",
		"title": "Ministry",
		"count": 1,
		"genre": "north-west"
	},
	{
		"year": "1978",
		"title": "Pearl Jam",
		"count": 1,
		"genre": "north-west"
	},
	{
		"year": "1978",
		"title": "Porno for Pyros",
		"count": 1,
		"genre": "north-west"
	},
	{
		"year": "1978",
		"title": "Red Hot Chili Peppers",
		"count": 1,
		"genre": "north-west"
	},
	{
		"year": "1978",
		"title": "Seaweed",
		"count": 1,
		"genre": "north-west"
	},
	{
		"year": "1978",
		"title": "Sharkbait",
		"count": 1,
		"genre": "north-west"
	},
	{
		"year": "1978",
		"title": "Soundgarden",
		"count": 1,
		"genre": "north-west"
	},
	{
		"year": "1978",
		"title": "Stone Temple Pilots",
		"count": 1,
		"genre": "north-west"
	},
	{
		"year": "1978",
		"title": "Sweaty Nipples",
		"count": 1,
		"genre": "north-west"
	},
	{
		"year": "1978",
		"title": "Tribe",
		"count": 1,
		"genre": "north-west"
	},
	{
		"year": "1978",
		"title": "Truly",
		"count": 1,
		"genre": "north-west"
	},
	{
		"year": "1978",
		"title": "Lush",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1978",
		"title": "Samba Hell",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1978",
		"title": "Seam",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1978",
		"title": "The Jesus and Mary Chain",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1978",
		"title": "The Look People",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1978",
		"title": "Vulgar Boatmen",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1978",
		"title": "Archie Bell",
		"count": 1,
		"genre": "south-west"
	},
	{
		"year": "1978",
		"title": "jim rose circus",
		"count": 1,
		"genre": "south-west"
	},
	{
		"year": "1978",
		"title": "Rage Against The Machine",
		"count": 1,
		"genre": "south-west"
	},
	{
		"year": "1978",
		"title": "Skrew",
		"count": 1,
		"genre": "south-west"
	},
	{
		"year": "1978",
		"title": "Basehead",
		"count": 1,
		"genre": "north-east"
	},
	{
		"year": "1978",
		"title": "Boo Yaa! T.R.I.B.E.",
		"count": 1,
		"genre": "north-east"
	},
	{
		"year": "1978",
		"title": "Cypress Hill",
		"count": 1,
		"genre": "north-east"
	},
	{
		"year": "1978",
		"title": "Ice Cube",
		"count": 1,
		"genre": "north-east"
	},
	{
		"year": "1978",
		"title": "The Authority",
		"count": 1,
		"genre": "west"
	},
	{
		"year": "1979",
		"title": "Arctic Monkeys",
		"count": 1,
		"genre": "north-west"
	},
	{
		"year": "1979",
		"title": "Bat For Lashes",
		"count": 1,
		"genre": "north-west"
	},
	{
		"year": "1979",
		"title": "Depeche Mode",
		"count": 1,
		"genre": "north-west"
	},
	{
		"year": "1979",
		"title": "Dirty Sweet",
		"count": 1,
		"genre": "north-west"
	},
	{
		"year": "1979",
		"title": "Hey Champ",
		"count": 1,
		"genre": "north-west"
	},
	{
		"year": "1979",
		"title": "Hockey",
		"count": 1,
		"genre": "north-west"
	},
	{
		"year": "1979",
		"title": "Jane's Addiction",
		"count": 1,
		"genre": "north-west"
	},
	{
		"year": "1979",
		"title": "Kevin Devine",
		"count": 1,
		"genre": "north-west"
	},
	{
		"year": "1979",
		"title": "Kings of Leon",
		"count": 1,
		"genre": "north-west"
	},
	{
		"year": "1979",
		"title": "Lou Reed",
		"count": 1,
		"genre": "north-west"
	},
	{
		"year": "1979",
		"title": "Mike's Pawn Shop",
		"count": 1,
		"genre": "north-west"
	},
	{
		"year": "1979",
		"title": "Passion Pit",
		"count": 1,
		"genre": "north-west"
	},
	{
		"year": "1979",
		"title": "Perry Farrell",
		"count": 1,
		"genre": "north-west"
	},
	{
		"year": "1979",
		"title": "Ra Ra Riot",
		"count": 1,
		"genre": "north-west"
	},
	{
		"year": "1979",
		"title": "Silversun Pickups",
		"count": 1,
		"genre": "north-west"
	},
	{
		"year": "1979",
		"title": "The Killers",
		"count": 1,
		"genre": "north-west"
	},
	{
		"year": "1979",
		"title": "The Knux",
		"count": 1,
		"genre": "north-west"
	},
	{
		"year": "1979",
		"title": "The Virgins",
		"count": 1,
		"genre": "north-west"
	},
	{
		"year": "1979",
		"title": "White Lies",
		"count": 1,
		"genre": "north-west"
	},
	{
		"year": "1979",
		"title": "Yeah Yeah Yeahs",
		"count": 1,
		"genre": "north-west"
	},
	{
		"year": "1979",
		"title": "Boys Noize",
		"count": 1,
		"genre": "east"
	},
	{
		"year": "1979",
		"title": "Crookers",
		"count": 1,
		"genre": "east"
	},
	{
		"year": "1979",
		"title": "Deadmau5",
		"count": 1,
		"genre": "east"
	},
	{
		"year": "1979",
		"title": "Hercules and Love Affair (DJ Set)",
		"count": 1,
		"genre": "east"
	},
	{
		"year": "1979",
		"title": "Kaskade",
		"count": 1,
		"genre": "east"
	},
	{
		"year": "1979",
		"title": "LA Riots",
		"count": 1,
		"genre": "east"
	},
	{
		"year": "1979",
		"title": "MSTRKRFT",
		"count": 1,
		"genre": "east"
	},
	{
		"year": "1979",
		"title": "Simian Mobile Disco (DJ Set)",
		"count": 1,
		"genre": "east"
	},
	{
		"year": "1979",
		"title": "The Bloody Beetroots (DJ Set)",
		"count": 1,
		"genre": "east"
	},
	{
		"year": "1979",
		"title": "A-Trak",
		"count": 1,
		"genre": "south-east"
	},
	{
		"year": "1979",
		"title": "Bassnectar",
		"count": 1,
		"genre": "south-east"
	},
	{
		"year": "1979",
		"title": "Dark Wave Disco",
		"count": 1,
		"genre": "south-east"
	},
	{
		"year": "1979",
		"title": "Diplo",
		"count": 1,
		"genre": "south-east"
	},
	{
		"year": "1979",
		"title": "Federico Aubele",
		"count": 1,
		"genre": "south-east"
	},
	{
		"year": "1979",
		"title": "He Say, She Say",
		"count": 1,
		"genre": "south-east"
	},
	{
		"year": "1979",
		"title": "Miike Snow",
		"count": 1,
		"genre": "south-east"
	},
	{
		"year": "1979",
		"title": "The Glitch Mob",
		"count": 1,
		"genre": "south-east"
	},
	{
		"year": "1979",
		"title": "The Hood Internet",
		"count": 1,
		"genre": "south-east"
	},
	{
		"year": "1979",
		"title": "Thievery Corporation",
		"count": 1,
		"genre": "south-east"
	},
	{
		"year": "1979",
		"title": "Alberta Cross",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1979",
		"title": "Amazing Baby",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1979",
		"title": "Andrew Bird",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1979",
		"title": "Animal Collective",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1979",
		"title": "Animal Collective (DJ Set)",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1979",
		"title": "Band Of Horses",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1979",
		"title": "Band of Skulls",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1979",
		"title": "Blind Pilot",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1979",
		"title": "Bon Iver",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1979",
		"title": "Cage the Elephant",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1979",
		"title": "Car Stereo Wars",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1979",
		"title": "Chairlift",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1979",
		"title": "Cold War Kids",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1979",
		"title": "Constantines",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1979",
		"title": "Crystal Castles",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1979",
		"title": "Dan Auerbach",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1979",
		"title": "Dan Deacon",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1979",
		"title": "Deerhunter",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1979",
		"title": "Delta Spirit",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1979",
		"title": "Esser",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1979",
		"title": "Ezra Furman &amp; The Harpoons",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1979",
		"title": "Fleet Foxes",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1979",
		"title": "Friendly Fires",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1979",
		"title": "Gang Gang Dance",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1979",
		"title": "Glasvegas",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1979",
		"title": "Gomez",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1979",
		"title": "Gringo Star",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1979",
		"title": "Ida Maria",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1979",
		"title": "Kaiser Chiefs",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1979",
		"title": "Living Things",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1979",
		"title": "Los Campesinos!",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1979",
		"title": "Lykke Li",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1979",
		"title": "Manchester Orchestra",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1979",
		"title": "Moneypenny",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1979",
		"title": "Neko Case",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1979",
		"title": "Of Montreal",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1979",
		"title": "south-west Lives",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1979",
		"title": "Peter Bjorn and John",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1979",
		"title": "Portugal. The Man",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1979",
		"title": "Santigold",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1979",
		"title": "The Airborne Toxic Event",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1979",
		"title": "The Builders And The Butchers",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1979",
		"title": "The Decemberists",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1979",
		"title": "The Henry Clay People",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1979",
		"title": "The Low Anthem",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1979",
		"title": "The Raveonettes",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1979",
		"title": "Thenewno2",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1979",
		"title": "TV on the Radio",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1979",
		"title": "Vampire Weekend",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1979",
		"title": "Yello Fever",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1979",
		"title": "Black Joe Lewis &amp; the Honeybears",
		"count": 1,
		"genre": "south-west"
	},
	{
		"year": "1979",
		"title": "Davy Knowles and Back Door Slam",
		"count": 1,
		"genre": "south-west"
	},
	{
		"year": "1979",
		"title": "Eric Church",
		"count": 1,
		"genre": "south-west"
	},
	{
		"year": "1979",
		"title": "Frances England",
		"count": 1,
		"genre": "south-west"
	},
	{
		"year": "1979",
		"title": "Joe Pug",
		"count": 1,
		"genre": "south-west"
	},
	{
		"year": "1979",
		"title": "John Yost’s Rhythm Revolution Drum Circle",
		"count": 1,
		"genre": "south-west"
	},
	{
		"year": "1979",
		"title": "Langhorne Slim",
		"count": 1,
		"genre": "south-west"
	},
	{
		"year": "1979",
		"title": "Lunch Money",
		"count": 1,
		"genre": "south-west"
	},
	{
		"year": "1979",
		"title": "Quinn Sullivan",
		"count": 1,
		"genre": "south-west"
	},
	{
		"year": "1979",
		"title": "Ralph's World",
		"count": 1,
		"genre": "south-west"
	},
	{
		"year": "1979",
		"title": "Reeve Carney",
		"count": 1,
		"genre": "south-west"
	},
	{
		"year": "1979",
		"title": "Robert Earl Keen",
		"count": 1,
		"genre": "south-west"
	},
	{
		"year": "1979",
		"title": "School Of west",
		"count": 1,
		"genre": "south-west"
	},
	{
		"year": "1979",
		"title": "Secret Agent 23 Skidoo",
		"count": 1,
		"genre": "south-west"
	},
	{
		"year": "1979",
		"title": "The Greencards",
		"count": 1,
		"genre": "south-west"
	},
	{
		"year": "1979",
		"title": "Tool",
		"count": 1,
		"genre": "south-west"
	},
	{
		"year": "1979",
		"title": "Yuto Miyazawa",
		"count": 1,
		"genre": "south-west"
	},
	{
		"year": "1979",
		"title": "Zap Mama",
		"count": 1,
		"genre": "south-west"
	},
	{
		"year": "1979",
		"title": "April Smith",
		"count": 1,
		"genre": "london"
	},
	{
		"year": "1979",
		"title": "Ben Folds",
		"count": 1,
		"genre": "london"
	},
	{
		"year": "1979",
		"title": "KE$HA",
		"count": 1,
		"genre": "london"
	},
	{
		"year": "1979",
		"title": "Priscilla Renea",
		"count": 1,
		"genre": "london"
	},
	{
		"year": "1979",
		"title": "Coheed and Cambria",
		"count": 1,
		"genre": "east-midlands"
	},
	{
		"year": "1979",
		"title": "No Age",
		"count": 1,
		"genre": "east-midlands"
	},
	{
		"year": "1979",
		"title": "Rise Against",
		"count": 1,
		"genre": "east-midlands"
	},
	{
		"year": "1979",
		"title": "The Gaslight Anthem",
		"count": 1,
		"genre": "east-midlands"
	},
	{
		"year": "1979",
		"title": "Asher Roth",
		"count": 1,
		"genre": "north-east"
	},
	{
		"year": "1979",
		"title": "Atmosphere",
		"count": 1,
		"genre": "north-east"
	},
	{
		"year": "1979",
		"title": "DJ Mel",
		"count": 1,
		"genre": "north-east"
	},
	{
		"year": "1979",
		"title": "Hollywood Holt",
		"count": 1,
		"genre": "north-east"
	},
	{
		"year": "1979",
		"title": "KiD CuDi",
		"count": 1,
		"genre": "north-east"
	},
	{
		"year": "1979",
		"title": "Nick Catchdubs",
		"count": 1,
		"genre": "north-east"
	},
	{
		"year": "1979",
		"title": "Prophit",
		"count": 1,
		"genre": "north-east"
	},
	{
		"year": "1979",
		"title": "Q Brsouth-wests",
		"count": 1,
		"genre": "north-east"
	},
	{
		"year": "1979",
		"title": "Snoop Dogg",
		"count": 1,
		"genre": "north-east"
	},
	{
		"year": "1979",
		"title": "Ben Harper &amp; Relentless7",
		"count": 1,
		"genre": "west"
	},
	{
		"year": "1979",
		"title": "Heartless Bastards",
		"count": 1,
		"genre": "west"
	},
	{
		"year": "1979",
		"title": "Peter DiStefano &amp; Tor Hyams",
		"count": 1,
		"genre": "west"
	},
	{
		"year": "1979",
		"title": "Sam Roberts Band",
		"count": 1,
		"genre": "west"
	},
	{
		"year": "1979",
		"title": "STS9",
		"count": 1,
		"genre": "west"
	},
	{
		"year": "1979",
		"title": "Zach Gill",
		"count": 1,
		"genre": "west"
	},
	{
		"year": "1980",
		"title": "Assassins",
		"count": 1,
		"genre": "north-west"
	},
	{
		"year": "1980",
		"title": "Ben Kweller",
		"count": 1,
		"genre": "north-west"
	},
	{
		"year": "1980",
		"title": "Blue October",
		"count": 1,
		"genre": "north-west"
	},
	{
		"year": "1980",
		"title": "Boy Kill Boy",
		"count": 1,
		"genre": "north-west"
	},
	{
		"year": "1980",
		"title": "Editors",
		"count": 1,
		"genre": "north-west"
	},
	{
		"year": "1980",
		"title": "Feist",
		"count": 1,
		"genre": "north-west"
	},
	{
		"year": "1980",
		"title": "Moses Mayfield",
		"count": 1,
		"genre": "north-west"
	},
	{
		"year": "1980",
		"title": "Patti Smith",
		"count": 1,
		"genre": "north-west"
	},
	{
		"year": "1980",
		"title": "Pepper",
		"count": 1,
		"genre": "north-west"
	},
	{
		"year": "1980",
		"title": "Queens Of The Stone Age",
		"count": 1,
		"genre": "north-west"
	},
	{
		"year": "1980",
		"title": "Red Hot Chili Peppers",
		"count": 1,
		"genre": "north-west"
	},
	{
		"year": "1980",
		"title": "She Wants Revenge",
		"count": 1,
		"genre": "north-west"
	},
	{
		"year": "1980",
		"title": "VHS or BETA (DJ Set)",
		"count": 1,
		"genre": "north-west"
	},
	{
		"year": "1980",
		"title": "Wolfmsouth-west",
		"count": 1,
		"genre": "north-west"
	},
	{
		"year": "1980",
		"title": "Mixin' Marc",
		"count": 1,
		"genre": "east"
	},
	{
		"year": "1980",
		"title": "Husky Rescue",
		"count": 1,
		"genre": "south-east"
	},
	{
		"year": "1980",
		"title": "Peeping Tom",
		"count": 1,
		"genre": "south-east"
	},
	{
		"year": "1980",
		"title": "Thievery Corporation",
		"count": 1,
		"genre": "south-east"
	},
	{
		"year": "1980",
		"title": "Anathallo",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1980",
		"title": "Andrew Bird",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1980",
		"title": "Aqualung",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1980",
		"title": "Broken Social Scene",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1980",
		"title": "Built To Spill",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1980",
		"title": "Calexico",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1980",
		"title": "Cameron McGill and What Army",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1980",
		"title": "Catfish Haven",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1980",
		"title": "Cold War Kids",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1980",
		"title": "deadboy &amp; The Elephantmen",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1980",
		"title": "Death Cab For Cutie",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1980",
		"title": "EELS",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1980",
		"title": "Elvis Perkins",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1980",
		"title": "Ghostland Observatory",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1980",
		"title": "Hot Chip",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1980",
		"title": "Iron &amp; Wine",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1980",
		"title": "Jeremy Enigk",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1980",
		"title": "Jim Noir",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1980",
		"title": "Kelley Stoltz",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1980",
		"title": "Living Things",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1980",
		"title": "Manchester Orchestra",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1980",
		"title": "Manishevitz",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1980",
		"title": "Mates of State",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1980",
		"title": "Midlake",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1980",
		"title": "Mucca Pazza",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1980",
		"title": "My Morning Jacket",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1980",
		"title": "Nada Surf",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1980",
		"title": "Of Montreal",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1980",
		"title": "OFFICE",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1980",
		"title": "Oh No! Oh My!",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1980",
		"title": "Reverend Horton Heat",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1980",
		"title": "Ryan Adams",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1980",
		"title": "SONIC YOUTH",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1980",
		"title": "Sound Team",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1980",
		"title": "Sparta",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1980",
		"title": "St. James Inc.",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1980",
		"title": "Stars",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1980",
		"title": "Sybris",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1980",
		"title": "The Blisters",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1980",
		"title": "The Dresden Dolls",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1980",
		"title": "The Flaming Lips",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1980",
		"title": "The Frames",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1980",
		"title": "The Go! Team",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1980",
		"title": "The Hold Steady",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1980",
		"title": "The M's",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1980",
		"title": "The New Amsterdams",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1980",
		"title": "The New Pornographers",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1980",
		"title": "The Raconteurs",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1980",
		"title": "The Redwalls",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1980",
		"title": "The Shins",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1980",
		"title": "The Subways",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1980",
		"title": "Violent Femmes",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1980",
		"title": "Ween",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1980",
		"title": "What Made Milwaukee Famous",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1980",
		"title": "Wilco",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1980",
		"title": "Alvin Ailey",
		"count": 1,
		"genre": "south-west"
	},
	{
		"year": "1980",
		"title": "Asheba",
		"count": 1,
		"genre": "south-west"
	},
	{
		"year": "1980",
		"title": "Benevento/Russo Duo",
		"count": 1,
		"genre": "south-west"
	},
	{
		"year": "1980",
		"title": "Candy Band",
		"count": 1,
		"genre": "south-west"
	},
	{
		"year": "1980",
		"title": "Chutzpah",
		"count": 1,
		"genre": "south-west"
	},
	{
		"year": "1980",
		"title": "Deadsy",
		"count": 1,
		"genre": "south-west"
	},
	{
		"year": "1980",
		"title": "Ella Jenkins",
		"count": 1,
		"genre": "south-west"
	},
	{
		"year": "1980",
		"title": "Gnarls Barkley",
		"count": 1,
		"genre": "south-west"
	},
	{
		"year": "1980",
		"title": "Guadalajara Joe",
		"count": 1,
		"genre": "south-west"
	},
	{
		"year": "1980",
		"title": "Justin Roberts",
		"count": 1,
		"genre": "south-west"
	},
	{
		"year": "1980",
		"title": "Kelly McQuinn and KidTribe",
		"count": 1,
		"genre": "south-west"
	},
	{
		"year": "1980",
		"title": "Kill Hannah",
		"count": 1,
		"genre": "south-west"
	},
	{
		"year": "1980",
		"title": "MANU CHAO",
		"count": 1,
		"genre": "south-west"
	},
	{
		"year": "1980",
		"title": "Matisyahu",
		"count": 1,
		"genre": "south-west"
	},
	{
		"year": "1980",
		"title": "Mission IMPROVable",
		"count": 1,
		"genre": "south-west"
	},
	{
		"year": "1980",
		"title": "Nickel Creek",
		"count": 1,
		"genre": "south-west"
	},
	{
		"year": "1980",
		"title": "Schadenfreude",
		"count": 1,
		"genre": "south-west"
	},
	{
		"year": "1980",
		"title": "School Of west",
		"count": 1,
		"genre": "south-west"
	},
	{
		"year": "1980",
		"title": "ScribbleMonster &amp; His Pals",
		"count": 1,
		"genre": "south-west"
	},
	{
		"year": "1980",
		"title": "The Second City",
		"count": 1,
		"genre": "south-west"
	},
	{
		"year": "1980",
		"title": "Jon McLaughlin",
		"count": 1,
		"genre": "london"
	},
	{
		"year": "1980",
		"title": "Katie Todd Band",
		"count": 1,
		"genre": "london"
	},
	{
		"year": "1980",
		"title": "Matt Costa",
		"count": 1,
		"genre": "london"
	},
	{
		"year": "1980",
		"title": "30 Seconds To Mars",
		"count": 1,
		"genre": "east-midlands"
	},
	{
		"year": "1980",
		"title": "be your own pet",
		"count": 1,
		"genre": "east-midlands"
	},
	{
		"year": "1980",
		"title": "Coheed and Cambria",
		"count": 1,
		"genre": "east-midlands"
	},
	{
		"year": "1980",
		"title": "Cursive",
		"count": 1,
		"genre": "east-midlands"
	},
	{
		"year": "1980",
		"title": "Makeshifte",
		"count": 1,
		"genre": "east-midlands"
	},
	{
		"year": "1980",
		"title": "Panic! At The Disco",
		"count": 1,
		"genre": "east-midlands"
	},
	{
		"year": "1980",
		"title": "Rainer Maria",
		"count": 1,
		"genre": "east-midlands"
	},
	{
		"year": "1980",
		"title": "Sleater-Kinney",
		"count": 1,
		"genre": "east-midlands"
	},
	{
		"year": "1980",
		"title": "Smoking londones",
		"count": 1,
		"genre": "east-midlands"
	},
	{
		"year": "1980",
		"title": "Towers Of London",
		"count": 1,
		"genre": "east-midlands"
	},
	{
		"year": "1980",
		"title": "Blackalicious",
		"count": 1,
		"genre": "north-east"
	},
	{
		"year": "1980",
		"title": "common",
		"count": 1,
		"genre": "north-east"
	},
	{
		"year": "1980",
		"title": "DJ Rashida",
		"count": 1,
		"genre": "north-east"
	},
	{
		"year": "1980",
		"title": "KanYe West",
		"count": 1,
		"genre": "north-east"
	},
	{
		"year": "1980",
		"title": "Lady Sovereign",
		"count": 1,
		"genre": "north-east"
	},
	{
		"year": "1980",
		"title": "Lanz Pierce",
		"count": 1,
		"genre": "north-east"
	},
	{
		"year": "1980",
		"title": "Lyrics Born",
		"count": 1,
		"genre": "north-east"
	},
	{
		"year": "1980",
		"title": "Mindfield Electronic Ambush-Mix Master Mike",
		"count": 1,
		"genre": "north-east"
	},
	{
		"year": "1980",
		"title": "Ohmega Watts",
		"count": 1,
		"genre": "north-east"
	},
	{
		"year": "1980",
		"title": "Q Brsouth-wests",
		"count": 1,
		"genre": "north-east"
	},
	{
		"year": "1980",
		"title": "Sa-Ra",
		"count": 1,
		"genre": "north-east"
	},
	{
		"year": "1980",
		"title": "Tonedeff",
		"count": 1,
		"genre": "north-east"
	},
	{
		"year": "1980",
		"title": "Blues Traveler",
		"count": 1,
		"genre": "west"
	},
	{
		"year": "1980",
		"title": "Burden Brsouth-wests",
		"count": 1,
		"genre": "west"
	},
	{
		"year": "1980",
		"title": "Musical Outfits",
		"count": 1,
		"genre": "west"
	},
	{
		"year": "1980",
		"title": "Mutemath",
		"count": 1,
		"genre": "west"
	},
	{
		"year": "1980",
		"title": "Particle",
		"count": 1,
		"genre": "west"
	},
	{
		"year": "1980",
		"title": "Peter Distefano &amp; Perry Farrell",
		"count": 1,
		"genre": "west"
	},
	{
		"year": "1980",
		"title": "Poi Dog Pondering",
		"count": 1,
		"genre": "west"
	},
	{
		"year": "1980",
		"title": "The Bon Mots",
		"count": 1,
		"genre": "west"
	},
	{
		"year": "1980",
		"title": "The Disco Biscuits",
		"count": 1,
		"genre": "west"
	},
	{
		"year": "1980",
		"title": "The Secret Machines",
		"count": 1,
		"genre": "west"
	},
	{
		"year": "1980",
		"title": "Trevor Hall",
		"count": 1,
		"genre": "west"
	},
	{
		"year": "1980",
		"title": "Umphrey's McGee",
		"count": 1,
		"genre": "west"
	},
	{
		"year": "1981",
		"title": "Bloc Party",
		"count": 1,
		"genre": "north-west"
	},
	{
		"year": "1981",
		"title": "Cat Power",
		"count": 1,
		"genre": "north-west"
	},
	{
		"year": "1981",
		"title": "Electric Touch",
		"count": 1,
		"genre": "north-west"
	},
	{
		"year": "1981",
		"title": "Foals",
		"count": 1,
		"genre": "north-west"
	},
	{
		"year": "1981",
		"title": "Innerpartysystem",
		"count": 1,
		"genre": "north-west"
	},
	{
		"year": "1981",
		"title": "Love and westets",
		"count": 1,
		"genre": "north-west"
	},
	{
		"year": "1981",
		"title": "Nicole Atkins &amp; the Sea",
		"count": 1,
		"genre": "north-west"
	},
	{
		"year": "1981",
		"title": "Nine Inch Nails",
		"count": 1,
		"genre": "north-west"
	},
	{
		"year": "1981",
		"title": "Perry Farrell",
		"count": 1,
		"genre": "north-west"
	},
	{
		"year": "1981",
		"title": "The Gutter Twins",
		"count": 1,
		"genre": "north-west"
	},
	{
		"year": "1981",
		"title": "The Toadies",
		"count": 1,
		"genre": "north-west"
	},
	{
		"year": "1981",
		"title": "VHS or BETA (DJ Set)",
		"count": 1,
		"genre": "north-west"
	},
	{
		"year": "1981",
		"title": "We Go To 11",
		"count": 1,
		"genre": "north-west"
	},
	{
		"year": "1981",
		"title": "White Lies",
		"count": 1,
		"genre": "north-west"
	},
	{
		"year": "1981",
		"title": "Booka Shade",
		"count": 1,
		"genre": "east"
	},
	{
		"year": "1981",
		"title": "Dani Deahl",
		"count": 1,
		"genre": "east"
	},
	{
		"year": "1981",
		"title": "DJ Bald Eagle",
		"count": 1,
		"genre": "east"
	},
	{
		"year": "1981",
		"title": "Franki Chan",
		"count": 1,
		"genre": "east"
	},
	{
		"year": "1981",
		"title": "Girl Talk",
		"count": 1,
		"genre": "east"
	},
	{
		"year": "1981",
		"title": "James Curd",
		"count": 1,
		"genre": "east"
	},
	{
		"year": "1981",
		"title": "The Glamour",
		"count": 1,
		"genre": "east"
	},
	{
		"year": "1981",
		"title": "Brazilian Girls",
		"count": 1,
		"genre": "south-east"
	},
	{
		"year": "1981",
		"title": "Devlin &amp; Darko",
		"count": 1,
		"genre": "south-east"
	},
	{
		"year": "1981",
		"title": "DJ MomJeans (aka Danny Masterson)",
		"count": 1,
		"genre": "south-east"
	},
	{
		"year": "1981",
		"title": "DJ Zebo",
		"count": 1,
		"genre": "south-east"
	},
	{
		"year": "1981",
		"title": "E-Six &amp; Roan",
		"count": 1,
		"genre": "south-east"
	},
	{
		"year": "1981",
		"title": "Small Town DJs",
		"count": 1,
		"genre": "south-east"
	},
	{
		"year": "1981",
		"title": "Uffie",
		"count": 1,
		"genre": "south-east"
	},
	{
		"year": "1981",
		"title": "Willy Joy",
		"count": 1,
		"genre": "south-east"
	},
	{
		"year": "1981",
		"title": "Bang Camaro",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1981",
		"title": "Battles",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1981",
		"title": "Black Kids",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1981",
		"title": "Broken Social Scene",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1981",
		"title": "Cansei de Ser Sexy",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1981",
		"title": "Chromeo",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1981",
		"title": "De Novo Dahl",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1981",
		"title": "DeVotchka",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1981",
		"title": "Does It Offend You, Yeah?",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1981",
		"title": "Dr. Dog",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1981",
		"title": "Explosions in the Sky",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1981",
		"title": "Gogol Bordello",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1981",
		"title": "Grizzly Bear",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1981",
		"title": "Ha Ha Tonka",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1981",
		"title": "Holy F---",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1981",
		"title": "Iron &amp; Wine",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1981",
		"title": "Jamie Lidell",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1981",
		"title": "Jeff Tweedy",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1981",
		"title": "Louis XIV",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1981",
		"title": "Magic Wands",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1981",
		"title": "Manchester Orchestra",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1981",
		"title": "Margot &amp; the Nuclear So and So's",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1981",
		"title": "Mark Ronson",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1981",
		"title": "Mates of State",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1981",
		"title": "MGMT",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1981",
		"title": "OFFICE",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1981",
		"title": "Okkervil River",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1981",
		"title": "Radiohead",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1981",
		"title": "Rogue Wave",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1981",
		"title": "Stephen Malkmus &amp; The Jicks",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1981",
		"title": "The Black Keys",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1981",
		"title": "The Blakes",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1981",
		"title": "The Enemy UK",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1981",
		"title": "The Go! Team",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1981",
		"title": "The Kills",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1981",
		"title": "The National",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1981",
		"title": "The Octopus Project",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1981",
		"title": "The Postelles",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1981",
		"title": "The Raconteurs",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1981",
		"title": "The Ting Tings",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1981",
		"title": "The Whigs",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1981",
		"title": "What Made Milwaukee Famous",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1981",
		"title": "Wilco",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1981",
		"title": "Wild Sweet Orange",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1981",
		"title": "Yeasayer",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1981",
		"title": "Your Vegas",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1981",
		"title": "Amadou &amp; Mariam",
		"count": 1,
		"genre": "south-west"
	},
	{
		"year": "1981",
		"title": "Black Joe Lewis &amp; the Honeybears",
		"count": 1,
		"genre": "south-west"
	},
	{
		"year": "1981",
		"title": "Dash Mihok",
		"count": 1,
		"genre": "south-west"
	},
	{
		"year": "1981",
		"title": "Dierks Bentley",
		"count": 1,
		"genre": "south-west"
	},
	{
		"year": "1981",
		"title": "Duffy",
		"count": 1,
		"genre": "south-west"
	},
	{
		"year": "1981",
		"title": "Eli “Paperboy” Reed &amp; the True Loves",
		"count": 1,
		"genre": "south-west"
	},
	{
		"year": "1981",
		"title": "Gnarls Barkley",
		"count": 1,
		"genre": "south-west"
	},
	{
		"year": "1981",
		"title": "Homemade Jamz Blues Band",
		"count": 1,
		"genre": "south-west"
	},
	{
		"year": "1981",
		"title": "Mason Jennings",
		"count": 1,
		"genre": "south-west"
	},
	{
		"year": "1981",
		"title": "Rage Against The Machine",
		"count": 1,
		"genre": "south-west"
	},
	{
		"year": "1981",
		"title": "Saul Williams",
		"count": 1,
		"genre": "south-west"
	},
	{
		"year": "1981",
		"title": "School Of west",
		"count": 1,
		"genre": "south-west"
	},
	{
		"year": "1981",
		"title": "Sharon Jones &amp; The Dap-Kings",
		"count": 1,
		"genre": "south-west"
	},
	{
		"year": "1981",
		"title": "The Dream Jam Band",
		"count": 1,
		"genre": "south-west"
	},
	{
		"year": "1981",
		"title": "The Jimmies",
		"count": 1,
		"genre": "south-west"
	},
	{
		"year": "1981",
		"title": "The Terrible Twos",
		"count": 1,
		"genre": "south-west"
	},
	{
		"year": "1981",
		"title": "Witchcraft",
		"count": 1,
		"genre": "south-west"
	},
	{
		"year": "1981",
		"title": "Ferras",
		"count": 1,
		"genre": "london"
	},
	{
		"year": "1981",
		"title": "Krista",
		"count": 1,
		"genre": "london"
	},
	{
		"year": "1981",
		"title": "Newton Faulkner",
		"count": 1,
		"genre": "london"
	},
	{
		"year": "1981",
		"title": "Sofia Talvik",
		"count": 1,
		"genre": "london"
	},
	{
		"year": "1981",
		"title": "Black Lips",
		"count": 1,
		"genre": "east-midlands"
	},
	{
		"year": "1981",
		"title": "Brand New",
		"count": 1,
		"genre": "east-midlands"
	},
	{
		"year": "1981",
		"title": "Flogging Molly",
		"count": 1,
		"genre": "east-midlands"
	},
	{
		"year": "1981",
		"title": "Tiny Masters of Today",
		"count": 1,
		"genre": "east-midlands"
	},
	{
		"year": "1981",
		"title": "Cadence Weapon",
		"count": 1,
		"genre": "north-east"
	},
	{
		"year": "1981",
		"title": "DJ AM",
		"count": 1,
		"genre": "north-east"
	},
	{
		"year": "1981",
		"title": "DJ Mel",
		"count": 1,
		"genre": "north-east"
	},
	{
		"year": "1981",
		"title": "Flosstradamus",
		"count": 1,
		"genre": "north-east"
	},
	{
		"year": "1981",
		"title": "FreeSol",
		"count": 1,
		"genre": "north-east"
	},
	{
		"year": "1981",
		"title": "K'Naan",
		"count": 1,
		"genre": "north-east"
	},
	{
		"year": "1981",
		"title": "KanYe West",
		"count": 1,
		"genre": "north-east"
	},
	{
		"year": "1981",
		"title": "Kid Sister",
		"count": 1,
		"genre": "north-east"
	},
	{
		"year": "1981",
		"title": "Lupe Fiasco",
		"count": 1,
		"genre": "north-east"
	},
	{
		"year": "1981",
		"title": "MILLION $ MANO",
		"count": 1,
		"genre": "north-east"
	},
	{
		"year": "1981",
		"title": "Q Brsouth-wests",
		"count": 1,
		"genre": "north-east"
	},
	{
		"year": "1981",
		"title": "Spank west",
		"count": 1,
		"genre": "north-east"
	},
	{
		"year": "1981",
		"title": "The Cool Kids",
		"count": 1,
		"genre": "north-east"
	},
	{
		"year": "1981",
		"title": "Blues Traveler",
		"count": 1,
		"genre": "west"
	},
	{
		"year": "1981",
		"title": "Butch Walker",
		"count": 1,
		"genre": "west"
	},
	{
		"year": "1981",
		"title": "G. Love &amp; Special Sauce",
		"count": 1,
		"genre": "west"
	},
	{
		"year": "1981",
		"title": "John Butler Trio",
		"count": 1,
		"genre": "west"
	},
	{
		"year": "1981",
		"title": "Peter DiStefano &amp; Tor Hyams",
		"count": 1,
		"genre": "west"
	},
	{
		"year": "1981",
		"title": "Serena Ryder",
		"count": 1,
		"genre": "west"
	},
	{
		"year": "1981",
		"title": "Steel Train",
		"count": 1,
		"genre": "west"
	},
	{
		"year": "1981",
		"title": "Suzy Brack and the New Jack Lords",
		"count": 1,
		"genre": "west"
	},
	{
		"year": "1981",
		"title": "Tally Hall",
		"count": 1,
		"genre": "west"
	},
	{
		"year": "1981",
		"title": "The Parlor Mob",
		"count": 1,
		"genre": "west"
	},
	{
		"year": "1982",
		"title": "Audioslave",
		"count": 1,
		"genre": "north-west"
	},
	{
		"year": "1982",
		"title": "Fingertight",
		"count": 1,
		"genre": "north-west"
	},
	{
		"year": "1982",
		"title": "Hierosonic",
		"count": 1,
		"genre": "north-west"
	},
	{
		"year": "1982",
		"title": "Incubus",
		"count": 1,
		"genre": "north-west"
	},
	{
		"year": "1982",
		"title": "Jane's Addiction",
		"count": 1,
		"genre": "north-west"
	},
	{
		"year": "1982",
		"title": "Kings of Leon",
		"count": 1,
		"genre": "north-west"
	},
	{
		"year": "1982",
		"title": "Mondo Generator",
		"count": 1,
		"genre": "north-west"
	},
	{
		"year": "1982",
		"title": "Queens Of The Stone Age",
		"count": 1,
		"genre": "north-west"
	},
	{
		"year": "1982",
		"title": "Campfire Girls",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1982",
		"title": "The Mooney Suzuki",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1982",
		"title": "The Music",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1982",
		"title": "A Perfect Circle",
		"count": 1,
		"genre": "south-west"
	},
	{
		"year": "1982",
		"title": "Boysetsfire",
		"count": 1,
		"genre": "south-west"
	},
	{
		"year": "1982",
		"title": "Cave In",
		"count": 1,
		"genre": "south-west"
	},
	{
		"year": "1982",
		"title": "Steve-O",
		"count": 1,
		"genre": "south-west"
	},
	{
		"year": "1982",
		"title": "30 Seconds To Mars",
		"count": 1,
		"genre": "east-midlands"
	},
	{
		"year": "1982",
		"title": "Billy Talent",
		"count": 1,
		"genre": "east-midlands"
	},
	{
		"year": "1982",
		"title": "The Donnas",
		"count": 1,
		"genre": "east-midlands"
	},
	{
		"year": "1982",
		"title": "Jurassic 5",
		"count": 1,
		"genre": "north-east"
	},
	{
		"year": "1982",
		"title": "Supernatural",
		"count": 1,
		"genre": "north-east"
	},
	{
		"year": "1982",
		"title": "Burning Brides",
		"count": 1,
		"genre": "west"
	},
	{
		"year": "1988",
		"title": "Agnes Gooch",
		"count": 1,
		"genre": "north-west"
	},
	{
		"year": "1988",
		"title": "DEVO",
		"count": 1,
		"genre": "north-west"
	},
	{
		"year": "1988",
		"title": "Molly McGuire",
		"count": 1,
		"genre": "north-west"
	},
	{
		"year": "1988",
		"title": "Porno for Pyros",
		"count": 1,
		"genre": "north-west"
	},
	{
		"year": "1988",
		"title": "Radish",
		"count": 1,
		"genre": "north-west"
	},
	{
		"year": "1988",
		"title": "Orbital",
		"count": 1,
		"genre": "south-east"
	},
	{
		"year": "1988",
		"title": "The Orb",
		"count": 1,
		"genre": "south-east"
	},
	{
		"year": "1988",
		"title": "The Prodigy",
		"count": 1,
		"genre": "south-east"
	},
	{
		"year": "1988",
		"title": "Tricky",
		"count": 1,
		"genre": "south-east"
	},
	{
		"year": "1988",
		"title": "Demolition Doll Rods",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1988",
		"title": "EELS",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1988",
		"title": "Old 97's",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1988",
		"title": "Skeleton Key",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1988",
		"title": "Julian Marley, Damian &quot;Jr. Gong&quot; Marley &amp; The Uprising Band",
		"count": 1,
		"genre": "south-west"
	},
	{
		"year": "1988",
		"title": "KORN",
		"count": 1,
		"genre": "south-west"
	},
	{
		"year": "1988",
		"title": "The Pugs",
		"count": 1,
		"genre": "south-west"
	},
	{
		"year": "1988",
		"title": "Tool",
		"count": 1,
		"genre": "south-west"
	},
	{
		"year": "1988",
		"title": "Inch",
		"count": 1,
		"genre": "east-midlands"
	},
	{
		"year": "1988",
		"title": "Lost Boyz",
		"count": 1,
		"genre": "north-east"
	},
	{
		"year": "1988",
		"title": "Snoop Dogg",
		"count": 1,
		"genre": "north-east"
	},
	{
		"year": "1988",
		"title": "Artificial Joy Club",
		"count": 1,
		"genre": "west"
	},
	{
		"year": "1988",
		"title": "Jeremy Toback",
		"count": 1,
		"genre": "west"
	},
	{
		"year": "1988",
		"title": "Summercamp",
		"count": 1,
		"genre": "west"
	},
	{
		"year": "1990",
		"title": "Atarah Valentine",
		"count": 1,
		"genre": "north-west"
	},
	{
		"year": "1990",
		"title": "BROODS",
		"count": 1,
		"genre": "north-west"
	},
	{
		"year": "1990",
		"title": "Charli XCX",
		"count": 1,
		"genre": "north-west"
	},
	{
		"year": "1990",
		"title": "Florence + The Machine",
		"count": 1,
		"genre": "north-west"
	},
	{
		"year": "1990",
		"title": "HOLYCHILD",
		"count": 1,
		"genre": "north-west"
	},
	{
		"year": "1990",
		"title": "Jessica Hernandez & The Deltas",
		"count": 1,
		"genre": "north-west"
	},
	{
		"year": "1990",
		"title": "Marina And The Diamonds",
		"count": 1,
		"genre": "north-west"
	},
	{
		"year": "1990",
		"title": "Motown Pete",
		"count": 1,
		"genre": "north-west"
	},
	{
		"year": "1990",
		"title": "MS MR",
		"count": 1,
		"genre": "north-west"
	},
	{
		"year": "1990",
		"title": "Ryn Weaver",
		"count": 1,
		"genre": "north-west"
	},
	{
		"year": "1990",
		"title": "SirenXX",
		"count": 1,
		"genre": "north-west"
	},
	{
		"year": "1990",
		"title": "The New Pacific",
		"count": 1,
		"genre": "north-west"
	},
	{
		"year": "1990",
		"title": "Toro Y Moi",
		"count": 1,
		"genre": "north-west"
	},
	{
		"year": "1990",
		"title": "Twenty One Pilots",
		"count": 1,
		"genre": "north-west"
	},
	{
		"year": "1990",
		"title": "Walk The Moon",
		"count": 1,
		"genre": "north-west"
	},
	{
		"year": "1990",
		"title": "Alesso",
		"count": 1,
		"genre": "east"
	},
	{
		"year": "1990",
		"title": "Boys Noize",
		"count": 1,
		"genre": "east"
	},
	{
		"year": "1990",
		"title": "DESTRUCTO",
		"count": 1,
		"genre": "east"
	},
	{
		"year": "1990",
		"title": "FKA Twigs",
		"count": 1,
		"genre": "east"
	},
	{
		"year": "1990",
		"title": "Galantis",
		"count": 1,
		"genre": "east"
	},
	{
		"year": "1990",
		"title": "Jack Novak",
		"count": 1,
		"genre": "east"
	},
	{
		"year": "1990",
		"title": "JackLNDN",
		"count": 1,
		"genre": "east"
	},
	{
		"year": "1990",
		"title": "Kaskade",
		"count": 1,
		"genre": "east"
	},
	{
		"year": "1990",
		"title": "Kygo",
		"count": 1,
		"genre": "east"
	},
	{
		"year": "1990",
		"title": "Mako",
		"count": 1,
		"genre": "east"
	},
	{
		"year": "1990",
		"title": "Nicky Romero",
		"count": 1,
		"genre": "east"
	},
	{
		"year": "1990",
		"title": "Skylar Spence",
		"count": 1,
		"genre": "east"
	},
	{
		"year": "1990",
		"title": "SNBRN",
		"count": 1,
		"genre": "east"
	},
	{
		"year": "1990",
		"title": "The Chainsmokers",
		"count": 1,
		"genre": "east"
	},
	{
		"year": "1990",
		"title": "Alison Wonderland",
		"count": 1,
		"genre": "south-east"
	},
	{
		"year": "1990",
		"title": "Banks",
		"count": 1,
		"genre": "south-east"
	},
	{
		"year": "1990",
		"title": "Bassnectar",
		"count": 1,
		"genre": "south-east"
	},
	{
		"year": "1990",
		"title": "Black Tiger Sex Machine",
		"count": 1,
		"genre": "south-east"
	},
	{
		"year": "1990",
		"title": "BØRNS",
		"count": 1,
		"genre": "south-east"
	},
	{
		"year": "1990",
		"title": "CAKED UP",
		"count": 1,
		"genre": "south-east"
	},
	{
		"year": "1990",
		"title": "Carnage",
		"count": 1,
		"genre": "south-east"
	},
	{
		"year": "1990",
		"title": "Chet Faker",
		"count": 1,
		"genre": "south-east"
	},
	{
		"year": "1990",
		"title": "Dillon Francis",
		"count": 1,
		"genre": "south-east"
	},
	{
		"year": "1990",
		"title": "DJ Snake",
		"count": 1,
		"genre": "south-east"
	},
	{
		"year": "1990",
		"title": "Flying Lotus",
		"count": 1,
		"genre": "south-east"
	},
	{
		"year": "1990",
		"title": "Glass Animals",
		"count": 1,
		"genre": "south-east"
	},
	{
		"year": "1990",
		"title": "Halsey",
		"count": 1,
		"genre": "south-east"
	},
	{
		"year": "1990",
		"title": "Lion Babe",
		"count": 1,
		"genre": "south-east"
	},
	{
		"year": "1990",
		"title": "Mt. Eden",
		"count": 1,
		"genre": "south-east"
	},
	{
		"year": "1990",
		"title": "NERO",
		"count": 1,
		"genre": "south-east"
	},
	{
		"year": "1990",
		"title": "ODESZA",
		"count": 1,
		"genre": "south-east"
	},
	{
		"year": "1990",
		"title": "Peking Duk",
		"count": 1,
		"genre": "south-east"
	},
	{
		"year": "1990",
		"title": "RL Grime",
		"count": 1,
		"genre": "south-east"
	},
	{
		"year": "1990",
		"title": "Tove Lo",
		"count": 1,
		"genre": "south-east"
	},
	{
		"year": "1990",
		"title": "Vérité",
		"count": 1,
		"genre": "south-east"
	},
	{
		"year": "1990",
		"title": "What So Not",
		"count": 1,
		"genre": "south-east"
	},
	{
		"year": "1990",
		"title": "White Sea",
		"count": 1,
		"genre": "south-east"
	},
	{
		"year": "1990",
		"title": "Zella Day",
		"count": 1,
		"genre": "south-east"
	},
	{
		"year": "1990",
		"title": "Alt-J",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1990",
		"title": "Angus & Julia Stone",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1990",
		"title": "BADBADNOTGOOD",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1990",
		"title": "Bear’s Den",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1990",
		"title": "Beat Connection",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1990",
		"title": "Black Pistol Fire",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1990",
		"title": "Catfish And The Bottlemen",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1990",
		"title": "Circa Waves",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1990",
		"title": "Coasts",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1990",
		"title": "COIN",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1990",
		"title": "Cold War Kids",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1990",
		"title": "Death From Above 1979",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1990",
		"title": "Delta Spirit",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1990",
		"title": "Django Django",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1990",
		"title": "DMA's",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1990",
		"title": "Father John Misty",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1990",
		"title": "First Aid Kit",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1990",
		"title": "Gabriel Garzón-Montano",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1990",
		"title": "GIVERS",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1990",
		"title": "Gogol Bordello",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1990",
		"title": "Hermitude",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1990",
		"title": "Hippo Campus",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1990",
		"title": "Hot Chip",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1990",
		"title": "James Bay",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1990",
		"title": "Jamestown Revival",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1990",
		"title": "Lord Huron",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1990",
		"title": "Mighty Oaks",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1990",
		"title": "MisterWives",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1990",
		"title": "Night Terrors of 1927",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1990",
		"title": "Of Monsters And Men",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1990",
		"title": "Philip Selway",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1990",
		"title": "Shakey Graves",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1990",
		"title": "Sheppard",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1990",
		"title": "Spookyland",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1990",
		"title": "Strand Of Oaks",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1990",
		"title": "Sylvan Esso",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1990",
		"title": "Tame Impala",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1990",
		"title": "The Tallest Man On Earth",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1990",
		"title": "The War On Drugs",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1990",
		"title": "The Wombats",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1990",
		"title": "TV on the Radio",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1990",
		"title": "Twin Peaks",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1990",
		"title": "Wet",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1990",
		"title": "Wild Belle",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1990",
		"title": "Danny Weinkauf",
		"count": 1,
		"genre": "south-west"
	},
	{
		"year": "1990",
		"title": "Elle King",
		"count": 1,
		"genre": "south-west"
	},
	{
		"year": "1990",
		"title": "Gary Clark Jr.",
		"count": 1,
		"genre": "south-west"
	},
	{
		"year": "1990",
		"title": "Kyle Thorton & The Company",
		"count": 1,
		"genre": "south-west"
	},
	{
		"year": "1990",
		"title": "Metallica",
		"count": 1,
		"genre": "south-west"
	},
	{
		"year": "1990",
		"title": "Mista Cookie Jar & The Chocolate Chips",
		"count": 1,
		"genre": "south-west"
	},
	{
		"year": "1990",
		"title": "Raury",
		"count": 1,
		"genre": "south-west"
	},
	{
		"year": "1990",
		"title": "Sam Smith",
		"count": 1,
		"genre": "south-west"
	},
	{
		"year": "1990",
		"title": "School Of west AllStars",
		"count": 1,
		"genre": "south-west"
	},
	{
		"year": "1990",
		"title": "St. Paul & The Broken Bones",
		"count": 1,
		"genre": "south-west"
	},
	{
		"year": "1990",
		"title": "Sturgill Simpson",
		"count": 1,
		"genre": "south-west"
	},
	{
		"year": "1990",
		"title": "SZA",
		"count": 1,
		"genre": "south-west"
	},
	{
		"year": "1990",
		"title": "The london Ups",
		"count": 1,
		"genre": "south-west"
	},
	{
		"year": "1990",
		"title": "The Weeknd",
		"count": 1,
		"genre": "south-west"
	},
	{
		"year": "1990",
		"title": "George Ezra",
		"count": 1,
		"genre": "london"
	},
	{
		"year": "1990",
		"title": "Paul McCartney",
		"count": 1,
		"genre": "london"
	},
	{
		"year": "1990",
		"title": "Stromae",
		"count": 1,
		"genre": "london"
	},
	{
		"year": "1990",
		"title": "Brand New",
		"count": 1,
		"genre": "east-midlands"
	},
	{
		"year": "1990",
		"title": "In The Whale",
		"count": 1,
		"genre": "east-midlands"
	},
	{
		"year": "1990",
		"title": "The Helmets",
		"count": 1,
		"genre": "east-midlands"
	},
	{
		"year": "1990",
		"title": "A$AP westy",
		"count": 1,
		"genre": "north-east"
	},
	{
		"year": "1990",
		"title": "Daye Jack",
		"count": 1,
		"genre": "north-east"
	},
	{
		"year": "1990",
		"title": "DJ Mustard",
		"count": 1,
		"genre": "north-east"
	},
	{
		"year": "1990",
		"title": "G-Eazy",
		"count": 1,
		"genre": "north-east"
	},
	{
		"year": "1990",
		"title": "Kid Cudi",
		"count": 1,
		"genre": "north-east"
	},
	{
		"year": "1990",
		"title": "LOGIC",
		"count": 1,
		"genre": "north-east"
	},
	{
		"year": "1990",
		"title": "Mick Jenkins",
		"count": 1,
		"genre": "north-east"
	},
	{
		"year": "1990",
		"title": "Pell",
		"count": 1,
		"genre": "north-east"
	},
	{
		"year": "1990",
		"title": "Q Brsouth-wests",
		"count": 1,
		"genre": "north-east"
	},
	{
		"year": "1990",
		"title": "Travi$ Scott",
		"count": 1,
		"genre": "north-east"
	},
	{
		"year": "1990",
		"title": "Tyler, The Creator",
		"count": 1,
		"genre": "north-east"
	},
	{
		"year": "1990",
		"title": "Young Thug",
		"count": 1,
		"genre": "north-east"
	},
	{
		"year": "1990",
		"title": "ZEBRA KATZ",
		"count": 1,
		"genre": "north-east"
	},
	{
		"year": "1990",
		"title": "Alabama Shakes",
		"count": 1,
		"genre": "west"
	},
	{
		"year": "1990",
		"title": "MOON TAXI",
		"count": 1,
		"genre": "west"
	},
	{
		"year": "1990",
		"title": "The Lonely Biscuits",
		"count": 1,
		"genre": "west"
	},
	{
		"year": "1991",
		"title": "Arctic Monkeys",
		"count": 1,
		"genre": "north-west"
	},
	{
		"year": "1991",
		"title": "Big Audio Dynamite",
		"count": 1,
		"genre": "north-west"
	},
	{
		"year": "1991",
		"title": "Bright Eyes",
		"count": 1,
		"genre": "north-west"
	},
	{
		"year": "1991",
		"title": "Electric Touch",
		"count": 1,
		"genre": "north-west"
	},
	{
		"year": "1991",
		"title": "Foo Fighters",
		"count": 1,
		"genre": "north-west"
	},
	{
		"year": "1991",
		"title": "Grouplove",
		"count": 1,
		"genre": "north-west"
	},
	{
		"year": "1991",
		"title": "Lia Ices",
		"count": 1,
		"genre": "north-west"
	},
	{
		"year": "1991",
		"title": "Patrick Stump",
		"count": 1,
		"genre": "north-west"
	},
	{
		"year": "1991",
		"title": "Perry Farrell",
		"count": 1,
		"genre": "north-west"
	},
	{
		"year": "1991",
		"title": "Phantogram",
		"count": 1,
		"genre": "north-west"
	},
	{
		"year": "1991",
		"title": "The Cars",
		"count": 1,
		"genre": "north-west"
	},
	{
		"year": "1991",
		"title": "The Drums",
		"count": 1,
		"genre": "north-west"
	},
	{
		"year": "1991",
		"title": "The Joy Formidable",
		"count": 1,
		"genre": "north-west"
	},
	{
		"year": "1991",
		"title": "The Pretty Reckless",
		"count": 1,
		"genre": "north-west"
	},
	{
		"year": "1991",
		"title": "Two Door Cinema Club",
		"count": 1,
		"genre": "north-west"
	},
	{
		"year": "1991",
		"title": "Walk The Moon",
		"count": 1,
		"genre": "north-west"
	},
	{
		"year": "1991",
		"title": "White Lies",
		"count": 1,
		"genre": "north-west"
	},
	{
		"year": "1991",
		"title": "Young The Giant",
		"count": 1,
		"genre": "north-west"
	},
	{
		"year": "1991",
		"title": "Afrojack",
		"count": 1,
		"genre": "east"
	},
	{
		"year": "1991",
		"title": "Black Cards",
		"count": 1,
		"genre": "east"
	},
	{
		"year": "1991",
		"title": "Busy P",
		"count": 1,
		"genre": "east"
	},
	{
		"year": "1991",
		"title": "Chuckie",
		"count": 1,
		"genre": "east"
	},
	{
		"year": "1991",
		"title": "Dani Deahl",
		"count": 1,
		"genre": "east"
	},
	{
		"year": "1991",
		"title": "Deadmau5",
		"count": 1,
		"genre": "east"
	},
	{
		"year": "1991",
		"title": "DJ Lady D",
		"count": 1,
		"genre": "east"
	},
	{
		"year": "1991",
		"title": "Girl Talk",
		"count": 1,
		"genre": "east"
	},
	{
		"year": "1991",
		"title": "Jackmaster",
		"count": 1,
		"genre": "east"
	},
	{
		"year": "1991",
		"title": "Joachim Garraud",
		"count": 1,
		"genre": "east"
	},
	{
		"year": "1991",
		"title": "Light",
		"count": 1,
		"genre": "east"
	},
	{
		"year": "1991",
		"title": "MIDNIGHT CONSPIRACY",
		"count": 1,
		"genre": "east"
	},
	{
		"year": "1991",
		"title": "PerryEtty vs Chris Cox",
		"count": 1,
		"genre": "east"
	},
	{
		"year": "1991",
		"title": "The Bloody Beetroots Death Crew 77",
		"count": 1,
		"genre": "east"
	},
	{
		"year": "1991",
		"title": "12th Planet",
		"count": 1,
		"genre": "south-east"
	},
	{
		"year": "1991",
		"title": "Beats Antique",
		"count": 1,
		"genre": "south-east"
	},
	{
		"year": "1991",
		"title": "Daedelus",
		"count": 1,
		"genre": "south-east"
	},
	{
		"year": "1991",
		"title": "Ellie Goulding",
		"count": 1,
		"genre": "south-east"
	},
	{
		"year": "1991",
		"title": "Feed Me",
		"count": 1,
		"genre": "south-east"
	},
	{
		"year": "1991",
		"title": "Modeselektor",
		"count": 1,
		"genre": "south-east"
	},
	{
		"year": "1991",
		"title": "Pretty Lights",
		"count": 1,
		"genre": "south-east"
	},
	{
		"year": "1991",
		"title": "Skrillex",
		"count": 1,
		"genre": "south-east"
	},
	{
		"year": "1991",
		"title": "Super Mash Bros.",
		"count": 1,
		"genre": "south-east"
	},
	{
		"year": "1991",
		"title": "The Glitch Mob",
		"count": 1,
		"genre": "south-east"
	},
	{
		"year": "1991",
		"title": "An Horse",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1991",
		"title": "Beirut",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1991",
		"title": "Best Coast",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1991",
		"title": "Boy &amp; Bear",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1991",
		"title": "Cage the Elephant",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1991",
		"title": "Cold War Kids",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1991",
		"title": "Coldplay",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1991",
		"title": "Crystal Castles",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1991",
		"title": "Cults",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1991",
		"title": "DALE EARNHARDT JR. JR.",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1991",
		"title": "Death From Above 1979",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1991",
		"title": "Delta Spirit",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1991",
		"title": "Deluka",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1991",
		"title": "Disappears",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1991",
		"title": "Dom",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1991",
		"title": "Elizaveta",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1991",
		"title": "Explosions in the Sky",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1991",
		"title": "Fences",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1991",
		"title": "Foster The People",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1991",
		"title": "Friendly Fires",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1991",
		"title": "Gold Motel",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1991",
		"title": "Haley Bonar",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1991",
		"title": "Imelda May",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1991",
		"title": "J. Roddy Walston and The Business",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1991",
		"title": "Julia Easterlin",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1991",
		"title": "little hurricane",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1991",
		"title": "Local Natives",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1991",
		"title": "Lord Huron",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1991",
		"title": "Lykke Li",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1991",
		"title": "Manchester Orchestra",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1991",
		"title": "Maps &amp; Atlases",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1991",
		"title": "Muse",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1991",
		"title": "My Morning Jacket",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1991",
		"title": "Noah And The Whale",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1991",
		"title": "Portugal. The Man",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1991",
		"title": "Ratatat",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1991",
		"title": "Reptar",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1991",
		"title": "Ryan Bingham &amp; The Dead Horses",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1991",
		"title": "Smith Westerns",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1991",
		"title": "TAB the band",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1991",
		"title": "Tennis",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1991",
		"title": "The Chain Gang of 1974",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1991",
		"title": "The Kills",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1991",
		"title": "The Kingston Springs",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1991",
		"title": "The Mountain Goats",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1991",
		"title": "The Naked and Famous",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1991",
		"title": "The Pains of Being Pure at Heart",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1991",
		"title": "The Vaccines",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1991",
		"title": "Titus Andronicus",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1991",
		"title": "Typhoon",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1991",
		"title": "Ween",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1991",
		"title": "Wye Oak",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1991",
		"title": "Young Man",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1991",
		"title": "A Perfect Circle",
		"count": 1,
		"genre": "south-west"
	},
	{
		"year": "1991",
		"title": "Big Bang Boom",
		"count": 1,
		"genre": "south-west"
	},
	{
		"year": "1991",
		"title": "Brady Rymer",
		"count": 1,
		"genre": "south-west"
	},
	{
		"year": "1991",
		"title": "Ceci Bastida",
		"count": 1,
		"genre": "south-west"
	},
	{
		"year": "1991",
		"title": "Chico Trujillo",
		"count": 1,
		"genre": "south-west"
	},
	{
		"year": "1991",
		"title": "Collie Buddz",
		"count": 1,
		"genre": "south-west"
	},
	{
		"year": "1991",
		"title": "Damian &quot;Jr. Gong&quot; Marley &amp; Nas",
		"count": 1,
		"genre": "south-west"
	},
	{
		"year": "1991",
		"title": "Deftones",
		"count": 1,
		"genre": "south-west"
	},
	{
		"year": "1991",
		"title": "Fitz &amp; The Tantrums",
		"count": 1,
		"genre": "south-west"
	},
	{
		"year": "1991",
		"title": "Iration",
		"count": 1,
		"genre": "south-west"
	},
	{
		"year": "1991",
		"title": "Los Bunkers",
		"count": 1,
		"genre": "south-west"
	},
	{
		"year": "1991",
		"title": "Mayer Hawthorne &amp; The County",
		"count": 1,
		"genre": "south-west"
	},
	{
		"year": "1991",
		"title": "Northbrook Garage",
		"count": 1,
		"genre": "south-west"
	},
	{
		"year": "1991",
		"title": "Ralph's World",
		"count": 1,
		"genre": "south-west"
	},
	{
		"year": "1991",
		"title": "Ruby Jane",
		"count": 1,
		"genre": "south-west"
	},
	{
		"year": "1991",
		"title": "Ryan Leslie",
		"count": 1,
		"genre": "south-west"
	},
	{
		"year": "1991",
		"title": "The Happiness Club",
		"count": 1,
		"genre": "south-west"
	},
	{
		"year": "1991",
		"title": "Ximena Sarinana",
		"count": 1,
		"genre": "south-west"
	},
	{
		"year": "1991",
		"title": "Christina Perri",
		"count": 1,
		"genre": "london"
	},
	{
		"year": "1991",
		"title": "Kate Diaz",
		"count": 1,
		"genre": "london"
	},
	{
		"year": "1991",
		"title": "Lissie",
		"count": 1,
		"genre": "london"
	},
	{
		"year": "1991",
		"title": "Skylar Grey",
		"count": 1,
		"genre": "london"
	},
	{
		"year": "1991",
		"title": "Black Lips",
		"count": 1,
		"genre": "east-midlands"
	},
	{
		"year": "1991",
		"title": "City and Colour",
		"count": 1,
		"genre": "east-midlands"
	},
	{
		"year": "1991",
		"title": "Flogging Molly",
		"count": 1,
		"genre": "east-midlands"
	},
	{
		"year": "1991",
		"title": "Le Butcherettes",
		"count": 1,
		"genre": "east-midlands"
	},
	{
		"year": "1991",
		"title": "Rival Schools",
		"count": 1,
		"genre": "east-midlands"
	},
	{
		"year": "1991",
		"title": "Savoy",
		"count": 1,
		"genre": "east-midlands"
	},
	{
		"year": "1991",
		"title": "Ana Tijoux",
		"count": 1,
		"genre": "north-east"
	},
	{
		"year": "1991",
		"title": "Atmosphere",
		"count": 1,
		"genre": "north-east"
	},
	{
		"year": "1991",
		"title": "Cee Lo Green",
		"count": 1,
		"genre": "north-east"
	},
	{
		"year": "1991",
		"title": "DJ Mel",
		"count": 1,
		"genre": "north-east"
	},
	{
		"year": "1991",
		"title": "DJ Neil Armstrong",
		"count": 1,
		"genre": "north-east"
	},
	{
		"year": "1991",
		"title": "Eminem",
		"count": 1,
		"genre": "north-east"
	},
	{
		"year": "1991",
		"title": "Jay south-east",
		"count": 1,
		"genre": "north-east"
	},
	{
		"year": "1991",
		"title": "KiD CuDi",
		"count": 1,
		"genre": "north-east"
	},
	{
		"year": "1991",
		"title": "Kids These Days",
		"count": 1,
		"genre": "north-east"
	},
	{
		"year": "1991",
		"title": "Kyle Lucas &amp; Captain Midnite",
		"count": 1,
		"genre": "north-east"
	},
	{
		"year": "1991",
		"title": "Narcisse",
		"count": 1,
		"genre": "north-east"
	},
	{
		"year": "1991",
		"title": "Q Brsouth-wests",
		"count": 1,
		"genre": "north-east"
	},
	{
		"year": "1991",
		"title": "Sammy Adams",
		"count": 1,
		"genre": "north-east"
	},
	{
		"year": "1991",
		"title": "The Cool Kids",
		"count": 1,
		"genre": "north-east"
	},
	{
		"year": "1991",
		"title": "Tinie Tempah",
		"count": 1,
		"genre": "north-east"
	},
	{
		"year": "1991",
		"title": "Grace Potter &amp; the Nocturnals",
		"count": 1,
		"genre": "west"
	},
	{
		"year": "1991",
		"title": "Keller Williams",
		"count": 1,
		"genre": "west"
	},
	{
		"year": "1991",
		"title": "Kerli",
		"count": 1,
		"genre": "west"
	},
	{
		"year": "1991",
		"title": "Ok Go",
		"count": 1,
		"genre": "west"
	},
	{
		"year": "1991",
		"title": "Peter DiStefano &amp; Tor Hyams",
		"count": 1,
		"genre": "west"
	},
	{
		"year": "1992",
		"title": "Arkells",
		"count": 1,
		"genre": "north-west"
	},
	{
		"year": "1992",
		"title": "Bloc Party",
		"count": 1,
		"genre": "north-west"
	},
	{
		"year": "1992",
		"title": "Foals",
		"count": 1,
		"genre": "north-west"
	},
	{
		"year": "1992",
		"title": "Frank Turner & The Sleeping Souls",
		"count": 1,
		"genre": "north-west"
	},
	{
		"year": "1992",
		"title": "HÆLOS",
		"count": 1,
		"genre": "north-west"
	},
	{
		"year": "1992",
		"title": "Jane’s Addiction",
		"count": 1,
		"genre": "north-west"
	},
	{
		"year": "1992",
		"title": "LOLAWOLF",
		"count": 1,
		"genre": "north-west"
	},
	{
		"year": "1992",
		"title": "Marian Hill",
		"count": 1,
		"genre": "north-west"
	},
	{
		"year": "1992",
		"title": "MØ",
		"count": 1,
		"genre": "north-west"
	},
	{
		"year": "1992",
		"title": "MUTEMATH",
		"count": 1,
		"genre": "north-west"
	},
	{
		"year": "1992",
		"title": "Oh Wonder",
		"count": 1,
		"genre": "north-west"
	},
	{
		"year": "1992",
		"title": "Red Hot Chili Peppers",
		"count": 1,
		"genre": "north-west"
	},
	{
		"year": "1992",
		"title": "Silversun Pickups",
		"count": 1,
		"genre": "north-west"
	},
	{
		"year": "1992",
		"title": "The Joy Formidable",
		"count": 1,
		"genre": "north-west"
	},
	{
		"year": "1992",
		"title": "Two Door Cinema Club",
		"count": 1,
		"genre": "north-west"
	},
	{
		"year": "1992",
		"title": "Alle Farben",
		"count": 1,
		"genre": "east"
	},
	{
		"year": "1992",
		"title": "AlunaGeorge",
		"count": 1,
		"genre": "east"
	},
	{
		"year": "1992",
		"title": "BURNS",
		"count": 1,
		"genre": "east"
	},
	{
		"year": "1992",
		"title": "Cashmere Cat",
		"count": 1,
		"genre": "east"
	},
	{
		"year": "1992",
		"title": "Classixx",
		"count": 1,
		"genre": "east"
	},
	{
		"year": "1992",
		"title": "Curt Reynolds",
		"count": 1,
		"genre": "east"
	},
	{
		"year": "1992",
		"title": "Don Diablo",
		"count": 1,
		"genre": "east"
	},
	{
		"year": "1992",
		"title": "Duke Dumont",
		"count": 1,
		"genre": "east"
	},
	{
		"year": "1992",
		"title": "Flume",
		"count": 1,
		"genre": "east"
	},
	{
		"year": "1992",
		"title": "Generik",
		"count": 1,
		"genre": "east"
	},
	{
		"year": "1992",
		"title": "Hardwell",
		"count": 1,
		"genre": "east"
	},
	{
		"year": "1992",
		"title": "Hayden James",
		"count": 1,
		"genre": "east"
	},
	{
		"year": "1992",
		"title": "Jack Garratt",
		"count": 1,
		"genre": "east"
	},
	{
		"year": "1992",
		"title": "JAUZ",
		"count": 1,
		"genre": "east"
	},
	{
		"year": "1992",
		"title": "Martin Garrix",
		"count": 1,
		"genre": "east"
	},
	{
		"year": "1992",
		"title": "Mija",
		"count": 1,
		"genre": "east"
	},
	{
		"year": "1992",
		"title": "Oliver Heldens",
		"count": 1,
		"genre": "east"
	},
	{
		"year": "1992",
		"title": "Race Banyon",
		"count": 1,
		"genre": "east"
	},
	{
		"year": "1992",
		"title": "SLUMBERJACK",
		"count": 1,
		"genre": "east"
	},
	{
		"year": "1992",
		"title": "SMIIRK",
		"count": 1,
		"genre": "east"
	},
	{
		"year": "1992",
		"title": "Tchami",
		"count": 1,
		"genre": "east"
	},
	{
		"year": "1992",
		"title": "Tennyson",
		"count": 1,
		"genre": "east"
	},
	{
		"year": "1992",
		"title": "The Noisy Freaks",
		"count": 1,
		"genre": "east"
	},
	{
		"year": "1992",
		"title": "ZHU",
		"count": 1,
		"genre": "east"
	},
	{
		"year": "1992",
		"title": "AC Slater",
		"count": 1,
		"genre": "south-east"
	},
	{
		"year": "1992",
		"title": "Adventure Club",
		"count": 1,
		"genre": "south-east"
	},
	{
		"year": "1992",
		"title": "Alina Baraz",
		"count": 1,
		"genre": "south-east"
	},
	{
		"year": "1992",
		"title": "Audien",
		"count": 1,
		"genre": "south-east"
	},
	{
		"year": "1992",
		"title": "Bad Royale",
		"count": 1,
		"genre": "south-east"
	},
	{
		"year": "1992",
		"title": "Baio",
		"count": 1,
		"genre": "south-east"
	},
	{
		"year": "1992",
		"title": "Big Gigantic",
		"count": 1,
		"genre": "south-east"
	},
	{
		"year": "1992",
		"title": "Bob Moses",
		"count": 1,
		"genre": "south-east"
	},
	{
		"year": "1992",
		"title": "Boombox Cartel",
		"count": 1,
		"genre": "south-east"
	},
	{
		"year": "1992",
		"title": "Bro Safari",
		"count": 1,
		"genre": "south-east"
	},
	{
		"year": "1992",
		"title": "Ellie Goulding",
		"count": 1,
		"genre": "south-east"
	},
	{
		"year": "1992",
		"title": "Excision",
		"count": 1,
		"genre": "south-east"
	},
	{
		"year": "1992",
		"title": "Flosstradamus",
		"count": 1,
		"genre": "south-east"
	},
	{
		"year": "1992",
		"title": "Grandtheft",
		"count": 1,
		"genre": "south-east"
	},
	{
		"year": "1992",
		"title": "Grimes",
		"count": 1,
		"genre": "south-east"
	},
	{
		"year": "1992",
		"title": "GRiZ",
		"count": 1,
		"genre": "south-east"
	},
	{
		"year": "1992",
		"title": "Halsey",
		"count": 1,
		"genre": "south-east"
	},
	{
		"year": "1992",
		"title": "Illenium",
		"count": 1,
		"genre": "south-east"
	},
	{
		"year": "1992",
		"title": "Jackal",
		"count": 1,
		"genre": "south-east"
	},
	{
		"year": "1992",
		"title": "Lana Del Rey",
		"count": 1,
		"genre": "south-east"
	},
	{
		"year": "1992",
		"title": "Låpsley",
		"count": 1,
		"genre": "south-east"
	},
	{
		"year": "1992",
		"title": "Louis The Child",
		"count": 1,
		"genre": "south-east"
	},
	{
		"year": "1992",
		"title": "Major Lazer",
		"count": 1,
		"genre": "south-east"
	},
	{
		"year": "1992",
		"title": "Marshmello",
		"count": 1,
		"genre": "south-east"
	},
	{
		"year": "1992",
		"title": "Miike Snow",
		"count": 1,
		"genre": "south-east"
	},
	{
		"year": "1992",
		"title": "Mr. Carmack",
		"count": 1,
		"genre": "south-east"
	},
	{
		"year": "1992",
		"title": "MUNA",
		"count": 1,
		"genre": "south-east"
	},
	{
		"year": "1992",
		"title": "Party Favor",
		"count": 1,
		"genre": "south-east"
	},
	{
		"year": "1992",
		"title": "Seven Lions",
		"count": 1,
		"genre": "south-east"
	},
	{
		"year": "1992",
		"title": "SNAILS",
		"count": 1,
		"genre": "south-east"
	},
	{
		"year": "1992",
		"title": "Years & Years",
		"count": 1,
		"genre": "south-east"
	},
	{
		"year": "1992",
		"title": "Yellow Claw",
		"count": 1,
		"genre": "south-east"
	},
	{
		"year": "1992",
		"title": "Autolux",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1992",
		"title": "Chairlift",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1992",
		"title": "Cherub",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1992",
		"title": "Cloves",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1992",
		"title": "Day Wave",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1992",
		"title": "DREAMERS",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1992",
		"title": "DROWNERS",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1992",
		"title": "Frightened Rabbit",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1992",
		"title": "HAIM",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1992",
		"title": "Honeysuckle",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1992",
		"title": "Horse Thief",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1992",
		"title": "Kurt Vile and the Violators",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1992",
		"title": "LCD Soundsystem",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1992",
		"title": "Lewis Del Mar",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1992",
		"title": "Local Natives",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1992",
		"title": "Lucy Dacus",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1992",
		"title": "M83",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1992",
		"title": "Msouth-wests",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1992",
		"title": "Nothing",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1992",
		"title": "Panama Wedding",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1992",
		"title": "Pinegrove",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1992",
		"title": "Radiohead",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1992",
		"title": "RÜFÜS DU SOL",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1992",
		"title": "Saint Motel",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1992",
		"title": "Snakehips",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1992",
		"title": "ST. LUCIA",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1992",
		"title": "Sunflower Bean",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1992",
		"title": "The 1975",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1992",
		"title": "The Arcs",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1992",
		"title": "The Front Bottoms",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1992",
		"title": "The Greeting Committee",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1992",
		"title": "The Last Shadow Puppets",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1992",
		"title": "The Strumbellas",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1992",
		"title": "The Struts",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1992",
		"title": "VHS Collection",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1992",
		"title": "Wavves",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1992",
		"title": "Wild Child",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1992",
		"title": "Wolf Alice",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1992",
		"title": "Yeasayer",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1992",
		"title": "Bryson Tiller",
		"count": 1,
		"genre": "south-west"
	},
	{
		"year": "1992",
		"title": "Chris Stapleton",
		"count": 1,
		"genre": "south-west"
	},
	{
		"year": "1992",
		"title": "Christone \"Kingfish\" Ingram",
		"count": 1,
		"genre": "south-west"
	},
	{
		"year": "1992",
		"title": "Con Brio",
		"count": 1,
		"genre": "south-west"
	},
	{
		"year": "1992",
		"title": "Ghost",
		"count": 1,
		"genre": "south-west"
	},
	{
		"year": "1992",
		"title": "Hiatus Kaiyote",
		"count": 1,
		"genre": "south-west"
	},
	{
		"year": "1992",
		"title": "Houndmouth",
		"count": 1,
		"genre": "south-west"
	},
	{
		"year": "1992",
		"title": "Jarryd James",
		"count": 1,
		"genre": "south-west"
	},
	{
		"year": "1992",
		"title": "Jazzy Ash and the Leaping Lizards",
		"count": 1,
		"genre": "south-west"
	},
	{
		"year": "1992",
		"title": "Kiiara",
		"count": 1,
		"genre": "south-west"
	},
	{
		"year": "1992",
		"title": "LANco",
		"count": 1,
		"genre": "south-west"
	},
	{
		"year": "1992",
		"title": "Leon Bridges",
		"count": 1,
		"genre": "south-west"
	},
	{
		"year": "1992",
		"title": "Lindsey Stirling",
		"count": 1,
		"genre": "south-west"
	},
	{
		"year": "1992",
		"title": "Muddy Magnolias",
		"count": 1,
		"genre": "south-west"
	},
	{
		"year": "1992",
		"title": "Nathaniel Rateliff & The Night Sweats",
		"count": 1,
		"genre": "south-west"
	},
	{
		"year": "1992",
		"title": "Ralph Covert",
		"count": 1,
		"genre": "south-west"
	},
	{
		"year": "1992",
		"title": "Recess Monkey",
		"count": 1,
		"genre": "south-west"
	},
	{
		"year": "1992",
		"title": "School of west",
		"count": 1,
		"genre": "south-west"
	},
	{
		"year": "1992",
		"title": "Secret Agent 23 Skidoo",
		"count": 1,
		"genre": "south-west"
	},
	{
		"year": "1992",
		"title": "SoMo",
		"count": 1,
		"genre": "south-west"
	},
	{
		"year": "1992",
		"title": "Unified Highway",
		"count": 1,
		"genre": "south-west"
	},
	{
		"year": "1992",
		"title": "Alessia Cara",
		"count": 1,
		"genre": "london"
	},
	{
		"year": "1992",
		"title": "AudioDamn!",
		"count": 1,
		"genre": "london"
	},
	{
		"year": "1992",
		"title": "AURORA",
		"count": 1,
		"genre": "london"
	},
	{
		"year": "1992",
		"title": "BANNERS",
		"count": 1,
		"genre": "london"
	},
	{
		"year": "1992",
		"title": "Bastille",
		"count": 1,
		"genre": "london"
	},
	{
		"year": "1992",
		"title": "Dua Lipa",
		"count": 1,
		"genre": "london"
	},
	{
		"year": "1992",
		"title": "firekid",
		"count": 1,
		"genre": "london"
	},
	{
		"year": "1992",
		"title": "Frances",
		"count": 1,
		"genre": "london"
	},
	{
		"year": "1992",
		"title": "FRANKIE",
		"count": 1,
		"genre": "london"
	},
	{
		"year": "1992",
		"title": "Kehlani",
		"count": 1,
		"genre": "london"
	},
	{
		"year": "1992",
		"title": "Melanie Martinez",
		"count": 1,
		"genre": "london"
	},
	{
		"year": "1992",
		"title": "Nothing But Thieves",
		"count": 1,
		"genre": "london"
	},
	{
		"year": "1992",
		"title": "Polly A",
		"count": 1,
		"genre": "london"
	},
	{
		"year": "1992",
		"title": "Secret Weapons",
		"count": 1,
		"genre": "london"
	},
	{
		"year": "1992",
		"title": "Tor Miller",
		"count": 1,
		"genre": "london"
	},
	{
		"year": "1992",
		"title": "TOTEM",
		"count": 1,
		"genre": "london"
	},
	{
		"year": "1992",
		"title": "City and Colour",
		"count": 1,
		"genre": "east-midlands"
	},
	{
		"year": "1992",
		"title": "Daughter",
		"count": 1,
		"genre": "east-midlands"
	},
	{
		"year": "1992",
		"title": "Disclosure",
		"count": 1,
		"genre": "east-midlands"
	},
	{
		"year": "1992",
		"title": "FIDLAR",
		"count": 1,
		"genre": "east-midlands"
	},
	{
		"year": "1992",
		"title": "Modern Baseball",
		"count": 1,
		"genre": "east-midlands"
	},
	{
		"year": "1992",
		"title": "Potty Mouth",
		"count": 1,
		"genre": "east-midlands"
	},
	{
		"year": "1992",
		"title": "PVRIS",
		"count": 1,
		"genre": "east-midlands"
	},
	{
		"year": "1992",
		"title": "A$AP FERG",
		"count": 1,
		"genre": "north-east"
	},
	{
		"year": "1992",
		"title": "Bas, Cozz, Omen",
		"count": 1,
		"genre": "north-east"
	},
	{
		"year": "1992",
		"title": "Big Grams (Big Boi + Phantogram)",
		"count": 1,
		"genre": "north-east"
	},
	{
		"year": "1992",
		"title": "D.R.A.M.",
		"count": 1,
		"genre": "north-east"
	},
	{
		"year": "1992",
		"title": "Danny Brown",
		"count": 1,
		"genre": "north-east"
	},
	{
		"year": "1992",
		"title": "Die Antwoord",
		"count": 1,
		"genre": "north-east"
	},
	{
		"year": "1992",
		"title": "Flatbush Zombies",
		"count": 1,
		"genre": "north-east"
	},
	{
		"year": "1992",
		"title": "Future",
		"count": 1,
		"genre": "north-east"
	},
	{
		"year": "1992",
		"title": "G-Eazy",
		"count": 1,
		"genre": "north-east"
	},
	{
		"year": "1992",
		"title": "J. Cole",
		"count": 1,
		"genre": "north-east"
	},
	{
		"year": "1992",
		"title": "JAHKOY",
		"count": 1,
		"genre": "north-east"
	},
	{
		"year": "1992",
		"title": "Jazz Cartier",
		"count": 1,
		"genre": "north-east"
	},
	{
		"year": "1992",
		"title": "Mac Miller",
		"count": 1,
		"genre": "north-east"
	},
	{
		"year": "1992",
		"title": "Q Brsouth-wests",
		"count": 1,
		"genre": "north-east"
	},
	{
		"year": "1992",
		"title": "Saba",
		"count": 1,
		"genre": "north-east"
	},
	{
		"year": "1992",
		"title": "Sir The Baptist",
		"count": 1,
		"genre": "north-east"
	},
	{
		"year": "1992",
		"title": "Joey Purp",
		"count": 1,
		"genre": "north-east"
	},
	{
		"year": "1992",
		"title": "Skizzy Mars",
		"count": 1,
		"genre": "north-east"
	},
	{
		"year": "1992",
		"title": "Smino",
		"count": 1,
		"genre": "north-east"
	},
	{
		"year": "1992",
		"title": "Tory Lanez",
		"count": 1,
		"genre": "north-east"
	},
	{
		"year": "1992",
		"title": "Towkio",
		"count": 1,
		"genre": "north-east"
	},
	{
		"year": "1992",
		"title": "Vic Mensa",
		"count": 1,
		"genre": "north-east"
	},
	{
		"year": "1992",
		"title": "Vince Staples",
		"count": 1,
		"genre": "north-east"
	},
	{
		"year": "1992",
		"title": "Frankie + The Studs",
		"count": 1,
		"genre": "west"
	},
	{
		"year": "1992",
		"title": "Lettuce",
		"count": 1,
		"genre": "west"
	},
	{
		"year": "1992",
		"title": "Third Eye Blind",
		"count": 1,
		"genre": "west"
	},
	{
		"year": "1992",
		"title": "X Ambassadors",
		"count": 1,
		"genre": "west"
	},
	{
		"year": "1993",
		"title": "Alice In Chains",
		"count": 1,
		"genre": "north-west"
	},
	{
		"year": "1993",
		"title": "Babes In Toyland",
		"count": 1,
		"genre": "north-west"
	},
	{
		"year": "1993",
		"title": "Cell",
		"count": 1,
		"genre": "north-west"
	},
	{
		"year": "1993",
		"title": "Fishbone",
		"count": 1,
		"genre": "north-west"
	},
	{
		"year": "1993",
		"title": "Front 242",
		"count": 1,
		"genre": "north-west"
	},
	{
		"year": "1993",
		"title": "Luscious Jackson",
		"count": 1,
		"genre": "north-west"
	},
	{
		"year": "1993",
		"title": "Primus",
		"count": 1,
		"genre": "north-west"
	},
	{
		"year": "1993",
		"title": "Scrawl",
		"count": 1,
		"genre": "north-west"
	},
	{
		"year": "1993",
		"title": "Truly",
		"count": 1,
		"genre": "north-west"
	},
	{
		"year": "1993",
		"title": "The Coctails",
		"count": 1,
		"genre": "south-east"
	},
	{
		"year": "1993",
		"title": "Dinosaur Jr.",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1993",
		"title": "Eggs",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1993",
		"title": "Free Kitten",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1993",
		"title": "Girls Against Boys",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1993",
		"title": "Hurl",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1993",
		"title": "Mercury Rev",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1993",
		"title": "Mosquito",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1993",
		"title": "Royal Trux",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1993",
		"title": "Sebadoh",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1993",
		"title": "The Karl Hendricks Trio",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1993",
		"title": "Thurston Moore",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1993",
		"title": "Unrest",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1993",
		"title": "Genitorturers",
		"count": 1,
		"genre": "south-west"
	},
	{
		"year": "1993",
		"title": "Glue",
		"count": 1,
		"genre": "south-west"
	},
	{
		"year": "1993",
		"title": "Mutabaruka",
		"count": 1,
		"genre": "south-west"
	},
	{
		"year": "1993",
		"title": "Rage Against The Machine",
		"count": 1,
		"genre": "south-west"
	},
	{
		"year": "1993",
		"title": "Tsunami",
		"count": 1,
		"genre": "south-west"
	},
	{
		"year": "1993",
		"title": "A Lighter Shade Of Brown",
		"count": 1,
		"genre": "north-east"
	},
	{
		"year": "1993",
		"title": "Arrested Development",
		"count": 1,
		"genre": "north-east"
	},
	{
		"year": "1993",
		"title": "The Goats",
		"count": 1,
		"genre": "north-east"
	},
	{
		"year": "1994",
		"title": "Bloc Party",
		"count": 1,
		"genre": "north-west"
	},
	{
		"year": "1994",
		"title": "Florence + The Machine",
		"count": 1,
		"genre": "north-west"
	},
	{
		"year": "1994",
		"title": "Franz Ferdinand",
		"count": 1,
		"genre": "north-west"
	},
	{
		"year": "1994",
		"title": "Kevin Devine",
		"count": 1,
		"genre": "north-west"
	},
	{
		"year": "1994",
		"title": "Metric",
		"count": 1,
		"genre": "north-west"
	},
	{
		"year": "1994",
		"title": "Mona",
		"count": 1,
		"genre": "north-west"
	},
	{
		"year": "1994",
		"title": "Passion Pit",
		"count": 1,
		"genre": "north-west"
	},
	{
		"year": "1994",
		"title": "Polica",
		"count": 1,
		"genre": "north-west"
	},
	{
		"year": "1994",
		"title": "Red Hot Chili Peppers",
		"count": 1,
		"genre": "north-west"
	},
	{
		"year": "1994",
		"title": "Red Oblivion",
		"count": 1,
		"genre": "north-west"
	},
	{
		"year": "1994",
		"title": "Sharon Van Etten",
		"count": 1,
		"genre": "north-west"
	},
	{
		"year": "1994",
		"title": "The Afghan Whigs",
		"count": 1,
		"genre": "north-west"
	},
	{
		"year": "1994",
		"title": "The Temper Trap",
		"count": 1,
		"genre": "north-west"
	},
	{
		"year": "1994",
		"title": "Toro Y Moi",
		"count": 1,
		"genre": "north-west"
	},
	{
		"year": "1994",
		"title": "Twin Shadow",
		"count": 1,
		"genre": "north-west"
	},
	{
		"year": "1994",
		"title": "Avicii",
		"count": 1,
		"genre": "east"
	},
	{
		"year": "1994",
		"title": "Helena",
		"count": 1,
		"genre": "east"
	},
	{
		"year": "1994",
		"title": "Justice",
		"count": 1,
		"genre": "east"
	},
	{
		"year": "1994",
		"title": "Kaskade",
		"count": 1,
		"genre": "east"
	},
	{
		"year": "1994",
		"title": "Kid Color",
		"count": 1,
		"genre": "east"
	},
	{
		"year": "1994",
		"title": "Madeon",
		"count": 1,
		"genre": "east"
	},
	{
		"year": "1994",
		"title": "Porter Robinson",
		"count": 1,
		"genre": "east"
	},
	{
		"year": "1994",
		"title": "SBTRKT",
		"count": 1,
		"genre": "east"
	},
	{
		"year": "1994",
		"title": "Star Slinger",
		"count": 1,
		"genre": "east"
	},
	{
		"year": "1994",
		"title": "Totally Enormous Extinct Dinosaurs",
		"count": 1,
		"genre": "east"
	},
	{
		"year": "1994",
		"title": "Young Bloods",
		"count": 1,
		"genre": "east"
	},
	{
		"year": "1994",
		"title": "Zedd",
		"count": 1,
		"genre": "east"
	},
	{
		"year": "1994",
		"title": "Anamanaguchi",
		"count": 1,
		"genre": "south-east"
	},
	{
		"year": "1994",
		"title": "Bassnectar",
		"count": 1,
		"genre": "south-east"
	},
	{
		"year": "1994",
		"title": "Big Gigantic",
		"count": 1,
		"genre": "south-east"
	},
	{
		"year": "1994",
		"title": "DJ Nihal",
		"count": 1,
		"genre": "south-east"
	},
	{
		"year": "1994",
		"title": "DJ Zebo",
		"count": 1,
		"genre": "south-east"
	},
	{
		"year": "1994",
		"title": "Doctor P",
		"count": 1,
		"genre": "south-east"
	},
	{
		"year": "1994",
		"title": "Knife Party",
		"count": 1,
		"genre": "south-east"
	},
	{
		"year": "1994",
		"title": "Little Dragon",
		"count": 1,
		"genre": "south-east"
	},
	{
		"year": "1994",
		"title": "Miike Snow",
		"count": 1,
		"genre": "south-east"
	},
	{
		"year": "1994",
		"title": "Nadastrom",
		"count": 1,
		"genre": "south-east"
	},
	{
		"year": "1994",
		"title": "NERO",
		"count": 1,
		"genre": "south-east"
	},
	{
		"year": "1994",
		"title": "Orchard Lounge",
		"count": 1,
		"genre": "south-east"
	},
	{
		"year": "1994",
		"title": "SALVA",
		"count": 1,
		"genre": "south-east"
	},
	{
		"year": "1994",
		"title": "Skream &amp; Benga",
		"count": 1,
		"genre": "south-east"
	},
	{
		"year": "1994",
		"title": "Sub Focus",
		"count": 1,
		"genre": "south-east"
	},
	{
		"year": "1994",
		"title": "The White Panda",
		"count": 1,
		"genre": "south-east"
	},
	{
		"year": "1994",
		"title": "Zeds Dead",
		"count": 1,
		"genre": "south-east"
	},
	{
		"year": "1994",
		"title": "Animal Kingdom",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1994",
		"title": "At The Drive-In",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1994",
		"title": "Band of Skulls",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1994",
		"title": "Bear in Heaven",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1994",
		"title": "Blind Pilot",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1994",
		"title": "Bombay Bicycle Club",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1994",
		"title": "Bowerbirds",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1994",
		"title": "Chairlift",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1994",
		"title": "Dawes",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1994",
		"title": "Delta Spirit",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1994",
		"title": "Dr. Dog",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1994",
		"title": "Dry the River",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1994",
		"title": "Dum Dum Girls",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1994",
		"title": "Empires",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1994",
		"title": "FIDLAR",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1994",
		"title": "First Aid Kit",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1994",
		"title": "GIVERS",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1994",
		"title": "Hey Rosetta!",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1994",
		"title": "Imaginary Cities",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1994",
		"title": "Jack White",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1994",
		"title": "JEFF the Brsouth-westhood",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1994",
		"title": "Kopecky Family Band",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1994",
		"title": "M83",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1994",
		"title": "Milo Greene",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1994",
		"title": "Neon Indian",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1994",
		"title": "Oberhofer",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1994",
		"title": "Of Monsters And Men",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1994",
		"title": "Point To Infinity",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1994",
		"title": "Santigold",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1994",
		"title": "Sigur Ros",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1994",
		"title": "Tame Impala",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1994",
		"title": "The Big Pink",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1994",
		"title": "The Black Angels",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1994",
		"title": "The Black Keys",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1994",
		"title": "The Growlers",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1994",
		"title": "The Head And The Heart",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1994",
		"title": "The Jezabels",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1994",
		"title": "The Shins",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1994",
		"title": "The Tallest Man On Earth",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1994",
		"title": "The Walkmen",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1994",
		"title": "The War On Drugs",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1994",
		"title": "Thenewno2",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1994",
		"title": "tUnE-yArDs",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1994",
		"title": "Walk Off The Earth",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1994",
		"title": "Washed Out",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1994",
		"title": "White Rabbits",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1994",
		"title": "Yellow Ostrich",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1994",
		"title": "Aloe Blacc",
		"count": 1,
		"genre": "south-west"
	},
	{
		"year": "1994",
		"title": "Amadou &amp; Mariam",
		"count": 1,
		"genre": "south-west"
	},
	{
		"year": "1994",
		"title": "Black Sabbath",
		"count": 1,
		"genre": "south-west"
	},
	{
		"year": "1994",
		"title": "Frank Ocean",
		"count": 1,
		"genre": "south-west"
	},
	{
		"year": "1994",
		"title": "Gary Clark Jr.",
		"count": 1,
		"genre": "south-west"
	},
	{
		"year": "1994",
		"title": "Haley Reinhart",
		"count": 1,
		"genre": "south-west"
	},
	{
		"year": "1994",
		"title": "JC Brooks &amp; The Uptown Sound",
		"count": 1,
		"genre": "south-west"
	},
	{
		"year": "1994",
		"title": "Michael Kiwanuka",
		"count": 1,
		"genre": "south-west"
	},
	{
		"year": "1994",
		"title": "O Rappa",
		"count": 1,
		"genre": "south-west"
	},
	{
		"year": "1994",
		"title": "The Devil Makes Three",
		"count": 1,
		"genre": "south-west"
	},
	{
		"year": "1994",
		"title": "The Weeknd",
		"count": 1,
		"genre": "south-west"
	},
	{
		"year": "1994",
		"title": "Trampled By Turtles",
		"count": 1,
		"genre": "south-west"
	},
	{
		"year": "1994",
		"title": "Andrew Christopoulos",
		"count": 1,
		"genre": "london"
	},
	{
		"year": "1994",
		"title": "Calvin Harris",
		"count": 1,
		"genre": "london"
	},
	{
		"year": "1994",
		"title": "Dev",
		"count": 1,
		"genre": "london"
	},
	{
		"year": "1994",
		"title": "fun.",
		"count": 1,
		"genre": "london"
	},
	{
		"year": "1994",
		"title": "Harrison Ivaz",
		"count": 1,
		"genre": "london"
	},
	{
		"year": "1994",
		"title": "Outasight",
		"count": 1,
		"genre": "london"
	},
	{
		"year": "1994",
		"title": "Purple Apple",
		"count": 1,
		"genre": "london"
	},
	{
		"year": "1994",
		"title": "The Gaslight Anthem",
		"count": 1,
		"genre": "east-midlands"
	},
	{
		"year": "1994",
		"title": "Wax",
		"count": 1,
		"genre": "east-midlands"
	},
	{
		"year": "1994",
		"title": "Chancellor Warhol",
		"count": 1,
		"genre": "north-east"
	},
	{
		"year": "1994",
		"title": "Chief Keef",
		"count": 1,
		"genre": "north-east"
	},
	{
		"year": "1994",
		"title": "Childish Gambino",
		"count": 1,
		"genre": "north-east"
	},
	{
		"year": "1994",
		"title": "Die Antwoord",
		"count": 1,
		"genre": "north-east"
	},
	{
		"year": "1994",
		"title": "DJ Mel",
		"count": 1,
		"genre": "north-east"
	},
	{
		"year": "1994",
		"title": "Doomtree",
		"count": 1,
		"genre": "north-east"
	},
	{
		"year": "1994",
		"title": "J. Cole",
		"count": 1,
		"genre": "north-east"
	},
	{
		"year": "1994",
		"title": "Macklemore &amp; Ryan Lewis",
		"count": 1,
		"genre": "north-east"
	},
	{
		"year": "1994",
		"title": "OverDoz.",
		"count": 1,
		"genre": "north-east"
	},
	{
		"year": "1994",
		"title": "Paper Diamond",
		"count": 1,
		"genre": "north-east"
	},
	{
		"year": "1994",
		"title": "Wale",
		"count": 1,
		"genre": "north-east"
	},
	{
		"year": "1994",
		"title": "Alabama Shakes",
		"count": 1,
		"genre": "west"
	},
	{
		"year": "1994",
		"title": "JJ Grey &amp; Mofro",
		"count": 1,
		"genre": "west"
	},
	{
		"year": "1994",
		"title": "Laura Warshauer",
		"count": 1,
		"genre": "west"
	},
	{
		"year": "1994",
		"title": "Los Jaivas",
		"count": 1,
		"genre": "west"
	},
	{
		"year": "1994",
		"title": "LP",
		"count": 1,
		"genre": "west"
	},
	{
		"year": "1994",
		"title": "Moon Taxi",
		"count": 1,
		"genre": "west"
	},
	{
		"year": "1994",
		"title": "The Dunwells",
		"count": 1,
		"genre": "west"
	},
	{
		"year": "1994",
		"title": "The Sheepdogs",
		"count": 1,
		"genre": "west"
	},
	{
		"year": "1994",
		"title": "X Ambassadors",
		"count": 1,
		"genre": "west"
	},
	{
		"year": "1994",
		"title": "Yuna",
		"count": 1,
		"genre": "west"
	},
	{
		"year": "1995",
		"title": "American Bang (fka Bang Bang Bang)",
		"count": 1,
		"genre": "north-west"
	},
	{
		"year": "1995",
		"title": "Blue October",
		"count": 1,
		"genre": "north-west"
	},
	{
		"year": "1995",
		"title": "Interpol",
		"count": 1,
		"genre": "north-west"
	},
	{
		"year": "1995",
		"title": "Inward Eye",
		"count": 1,
		"genre": "north-west"
	},
	{
		"year": "1995",
		"title": "Kings of Leon",
		"count": 1,
		"genre": "north-west"
	},
	{
		"year": "1995",
		"title": "Patti Smith",
		"count": 1,
		"genre": "north-west"
	},
	{
		"year": "1995",
		"title": "Pearl Jam",
		"count": 1,
		"genre": "north-west"
	},
	{
		"year": "1995",
		"title": "Peter Himmelman",
		"count": 1,
		"genre": "north-west"
	},
	{
		"year": "1995",
		"title": "Satellite Party",
		"count": 1,
		"genre": "north-west"
	},
	{
		"year": "1995",
		"title": "Silverchair",
		"count": 1,
		"genre": "north-west"
	},
	{
		"year": "1995",
		"title": "Silversun Pickups",
		"count": 1,
		"genre": "north-west"
	},
	{
		"year": "1995",
		"title": "Slightly Stoopid",
		"count": 1,
		"genre": "north-west"
	},
	{
		"year": "1995",
		"title": "Tokyo Police Club",
		"count": 1,
		"genre": "north-west"
	},
	{
		"year": "1995",
		"title": "Yeah Yeah Yeahs",
		"count": 1,
		"genre": "north-west"
	},
	{
		"year": "1995",
		"title": "Daft east-midlands",
		"count": 1,
		"genre": "east"
	},
	{
		"year": "1995",
		"title": "M.I.A.",
		"count": 1,
		"genre": "south-east"
	},
	{
		"year": "1995",
		"title": "Soulive",
		"count": 1,
		"genre": "south-east"
	},
	{
		"year": "1995",
		"title": "!!!",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1995",
		"title": "Annuals",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1995",
		"title": "Apostle of Hustle",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1995",
		"title": "Aqueduct",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1995",
		"title": "Arckid",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1995",
		"title": "Blonde Redhead",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1995",
		"title": "Bound Stems",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1995",
		"title": "Cage the Elephant",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1995",
		"title": "Chin Up Chin Up",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1995",
		"title": "Clap Your Hands Say Yeah",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1995",
		"title": "Cold War Kids",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1995",
		"title": "Colour Revolt",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1995",
		"title": "David Vandervelde",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1995",
		"title": "Dax Riggs",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1995",
		"title": "Dear and the Headlights",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1995",
		"title": "Dios (Malos)",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1995",
		"title": "DJ Matt Roan",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1995",
		"title": "electric six",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1995",
		"title": "Elvis Perkins in Dearland",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1995",
		"title": "Ghostland Observatory",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1995",
		"title": "High Class Elite",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1995",
		"title": "I'm From Barcelona",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1995",
		"title": "Illinois",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1995",
		"title": "Jim James",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1995",
		"title": "LCD Soundsystem",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1995",
		"title": "Los Campesinos!",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1995",
		"title": "Matt &amp; Kim",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1995",
		"title": "Modest Mouse",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1995",
		"title": "Mr. North",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1995",
		"title": "Muse",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1995",
		"title": "My Morning Jacket",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1995",
		"title": "Peter Bjorn and John",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1995",
		"title": "Regina Spektor",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1995",
		"title": "Sherwood",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1995",
		"title": "Smoosh",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1995",
		"title": "Snow Patrol",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1995",
		"title": "Sparklehorse",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1995",
		"title": "Spoon",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1995",
		"title": "Switches",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1995",
		"title": "Tapes 'n Tapes",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1995",
		"title": "Ted Leo and the Pharmacists",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1995",
		"title": "The 19'00s",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1995",
		"title": "The Black Angels",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1995",
		"title": "The Black Keys",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1995",
		"title": "The Blisters",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1995",
		"title": "The Cribs",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1995",
		"title": "The Fratellis",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1995",
		"title": "The Hold Steady",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1995",
		"title": "The Polyphonic Spree",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1995",
		"title": "The Postmarks",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1995",
		"title": "The Rapture",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1995",
		"title": "The Satin Peaches",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1995",
		"title": "TV on the Radio",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1995",
		"title": "Viva Voce",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1995",
		"title": "Wax on Radio",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1995",
		"title": "White Rabbits",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1995",
		"title": "Yo La Tengo",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1995",
		"title": "Amy Winehouse",
		"count": 1,
		"genre": "south-west"
	},
	{
		"year": "1995",
		"title": "Café Tacuba",
		"count": 1,
		"genre": "south-west"
	},
	{
		"year": "1995",
		"title": "Candy Band",
		"count": 1,
		"genre": "south-west"
	},
	{
		"year": "1995",
		"title": "Charlie Musselwhite",
		"count": 1,
		"genre": "south-west"
	},
	{
		"year": "1995",
		"title": "Davy Knowles and Back Door Slam",
		"count": 1,
		"genre": "south-west"
	},
	{
		"year": "1995",
		"title": "Femi Kuti &amp; The Positive Force",
		"count": 1,
		"genre": "south-west"
	},
	{
		"year": "1995",
		"title": "Josh Hopkins",
		"count": 1,
		"genre": "south-west"
	},
	{
		"year": "1995",
		"title": "Kevin Michael",
		"count": 1,
		"genre": "south-west"
	},
	{
		"year": "1995",
		"title": "Mission IMPROVable",
		"count": 1,
		"genre": "south-west"
	},
	{
		"year": "1995",
		"title": "Rodrigo Y Gabriela",
		"count": 1,
		"genre": "south-west"
	},
	{
		"year": "1995",
		"title": "RYAN SHAW",
		"count": 1,
		"genre": "south-west"
	},
	{
		"year": "1995",
		"title": "School Of west",
		"count": 1,
		"genre": "south-west"
	},
	{
		"year": "1995",
		"title": "STEPHEN MARLEY",
		"count": 1,
		"genre": "south-west"
	},
	{
		"year": "1995",
		"title": "The Hipwaders",
		"count": 1,
		"genre": "south-west"
	},
	{
		"year": "1995",
		"title": "The Second City",
		"count": 1,
		"genre": "south-west"
	},
	{
		"year": "1995",
		"title": "The Sippy Cups",
		"count": 1,
		"genre": "south-west"
	},
	{
		"year": "1995",
		"title": "The Wailers",
		"count": 1,
		"genre": "south-west"
	},
	{
		"year": "1995",
		"title": "Wee Hairy Beasties",
		"count": 1,
		"genre": "south-west"
	},
	{
		"year": "1995",
		"title": "Carey Ott",
		"count": 1,
		"genre": "london"
	},
	{
		"year": "1995",
		"title": "Jack's Mannequin",
		"count": 1,
		"genre": "london"
	},
	{
		"year": "1995",
		"title": "Lady Gaga",
		"count": 1,
		"genre": "london"
	},
	{
		"year": "1995",
		"title": "Paolo Nutini",
		"count": 1,
		"genre": "london"
	},
	{
		"year": "1995",
		"title": "Against Me!",
		"count": 1,
		"genre": "east-midlands"
	},
	{
		"year": "1995",
		"title": "Iggy &amp; The Stooges",
		"count": 1,
		"genre": "east-midlands"
	},
	{
		"year": "1995",
		"title": "Juliette &amp; The Licks",
		"count": 1,
		"genre": "east-midlands"
	},
	{
		"year": "1995",
		"title": "MOTION CITY SOUNDTRACK",
		"count": 1,
		"genre": "east-midlands"
	},
	{
		"year": "1995",
		"title": "powerspace",
		"count": 1,
		"genre": "east-midlands"
	},
	{
		"year": "1995",
		"title": "The Diffs",
		"count": 1,
		"genre": "east-midlands"
	},
	{
		"year": "1995",
		"title": "The Graduate",
		"count": 1,
		"genre": "east-midlands"
	},
	{
		"year": "1995",
		"title": "DJ Craze &amp; DJ Klever",
		"count": 1,
		"genre": "north-east"
	},
	{
		"year": "1995",
		"title": "Flosstradamus",
		"count": 1,
		"genre": "north-east"
	},
	{
		"year": "1995",
		"title": "Kid Sister",
		"count": 1,
		"genre": "north-east"
	},
	{
		"year": "1995",
		"title": "Lupe Fiasco",
		"count": 1,
		"genre": "north-east"
	},
	{
		"year": "1995",
		"title": "Mickey Avalon",
		"count": 1,
		"genre": "north-east"
	},
	{
		"year": "1995",
		"title": "Q Brsouth-wests",
		"count": 1,
		"genre": "north-east"
	},
	{
		"year": "1995",
		"title": "Rhymefest",
		"count": 1,
		"genre": "north-east"
	},
	{
		"year": "1995",
		"title": "The Roots",
		"count": 1,
		"genre": "north-east"
	},
	{
		"year": "1995",
		"title": "Ben Harper &amp; The Innocent Criminals",
		"count": 1,
		"genre": "west"
	},
	{
		"year": "1995",
		"title": "G. Love &amp; Special Sauce",
		"count": 1,
		"genre": "west"
	},
	{
		"year": "1995",
		"title": "Heartless Bastards",
		"count": 1,
		"genre": "west"
	},
	{
		"year": "1995",
		"title": "John Paul White",
		"count": 1,
		"genre": "west"
	},
	{
		"year": "1995",
		"title": "Ludo",
		"count": 1,
		"genre": "west"
	},
	{
		"year": "1995",
		"title": "Moe.",
		"count": 1,
		"genre": "west"
	},
	{
		"year": "1995",
		"title": "Pete Yorn",
		"count": 1,
		"genre": "west"
	},
	{
		"year": "1995",
		"title": "Peter Distefano &amp; Perry Farrell",
		"count": 1,
		"genre": "west"
	},
	{
		"year": "1995",
		"title": "Roky Erickson &amp; The Explosives",
		"count": 1,
		"genre": "west"
	},
	{
		"year": "1995",
		"title": "Sam Roberts Band",
		"count": 1,
		"genre": "west"
	},
	{
		"year": "1995",
		"title": "Son Volt",
		"count": 1,
		"genre": "west"
	},
	{
		"year": "1995",
		"title": "STS9",
		"count": 1,
		"genre": "west"
	},
	{
		"year": "1995",
		"title": "Tom Schraeder",
		"count": 1,
		"genre": "west"
	},
	{
		"year": "1996",
		"title": "Ben Kweller",
		"count": 1,
		"genre": "north-west"
	},
	{
		"year": "1996",
		"title": "Billy Idol",
		"count": 1,
		"genre": "north-west"
	},
	{
		"year": "1996",
		"title": "CAKE",
		"count": 1,
		"genre": "north-west"
	},
	{
		"year": "1996",
		"title": "Cathedrals",
		"count": 1,
		"genre": "north-west"
	},
	{
		"year": "1996",
		"title": "LIZ PHAIR",
		"count": 1,
		"genre": "north-west"
	},
	{
		"year": "1996",
		"title": "Primus",
		"count": 1,
		"genre": "north-west"
	},
	{
		"year": "1996",
		"title": "Satellite Party",
		"count": 1,
		"genre": "north-west"
	},
	{
		"year": "1996",
		"title": "The Bravery",
		"count": 1,
		"genre": "north-west"
	},
	{
		"year": "1996",
		"title": "The Dandy Warhols",
		"count": 1,
		"genre": "north-west"
	},
	{
		"year": "1996",
		"title": "The Dead 60s",
		"count": 1,
		"genre": "north-west"
	},
	{
		"year": "1996",
		"title": "The Killers",
		"count": 1,
		"genre": "north-west"
	},
	{
		"year": "1996",
		"title": "VHS or BETA",
		"count": 1,
		"genre": "north-west"
	},
	{
		"year": "1996",
		"title": "Weezer",
		"count": 1,
		"genre": "north-west"
	},
	{
		"year": "1996",
		"title": "DERRICK CARTER",
		"count": 1,
		"genre": "east"
	},
	{
		"year": "1996",
		"title": "Los Amigos Invisibles",
		"count": 1,
		"genre": "east"
	},
	{
		"year": "1996",
		"title": "MARK FARINA",
		"count": 1,
		"genre": "east"
	},
	{
		"year": "1996",
		"title": "Soulive",
		"count": 1,
		"genre": "south-east"
	},
	{
		"year": "1996",
		"title": "Z-Trip",
		"count": 1,
		"genre": "south-east"
	},
	{
		"year": "1996",
		"title": "...And You Will Know Us By The Trail Of Dead",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1996",
		"title": "Ambulance LTD",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1996",
		"title": "Arcade Fire",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1996",
		"title": "Blonde Redhead",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1996",
		"title": "Death Cab For Cutie",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1996",
		"title": "Dinosaur Jr.",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1996",
		"title": "Hard-Fi",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1996",
		"title": "Kaiser Chiefs",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1996",
		"title": "Kasabian",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1996",
		"title": "Louis XIV",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1996",
		"title": "M83",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1996",
		"title": "Pixies",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1996",
		"title": "Spoon",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1996",
		"title": "Tegan and Sara",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1996",
		"title": "The Black Keys",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1996",
		"title": "The Brian Jonestown Massacre",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1996",
		"title": "The Changes",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1996",
		"title": "The Ponys",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1996",
		"title": "The Redwalls",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1996",
		"title": "The Walkmen",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1996",
		"title": "The Warlocks",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1996",
		"title": "Candy Band",
		"count": 1,
		"genre": "south-west"
	},
	{
		"year": "1996",
		"title": "Daddy A Go-Go",
		"count": 1,
		"genre": "south-west"
	},
	{
		"year": "1996",
		"title": "DeSoL",
		"count": 1,
		"genre": "south-west"
	},
	{
		"year": "1996",
		"title": "Ella Jenkins",
		"count": 1,
		"genre": "south-west"
	},
	{
		"year": "1996",
		"title": "Gwendolyn and The Good Time Gang",
		"count": 1,
		"genre": "south-west"
	},
	{
		"year": "1996",
		"title": "John Yost’s Rhythm Revolution Drum Circle",
		"count": 1,
		"genre": "south-west"
	},
	{
		"year": "1996",
		"title": "Quest Theater Ensemble",
		"count": 1,
		"genre": "south-west"
	},
	{
		"year": "1996",
		"title": "Saul Williams",
		"count": 1,
		"genre": "south-west"
	},
	{
		"year": "1996",
		"title": "Blue Merle",
		"count": 1,
		"genre": "london"
	},
	{
		"year": "1996",
		"title": "Dashboard Confessional",
		"count": 1,
		"genre": "east-midlands"
	},
	{
		"year": "1996",
		"title": "The (International) Noise Conspiracy",
		"count": 1,
		"genre": "east-midlands"
	},
	{
		"year": "1996",
		"title": "DIGABLE PLANETS",
		"count": 1,
		"genre": "north-east"
	},
	{
		"year": "1996",
		"title": "DJ MUGGS (MASHUP CIRCUS)",
		"count": 1,
		"genre": "north-east"
	},
	{
		"year": "1996",
		"title": "Drive-By Truckers",
		"count": 1,
		"genre": "west"
	},
	{
		"year": "1996",
		"title": "G. Love &amp; Special Sauce",
		"count": 1,
		"genre": "west"
	},
	{
		"year": "1996",
		"title": "Ok Go",
		"count": 1,
		"genre": "west"
	},
	{
		"year": "1996",
		"title": "Peter Distefano &amp; Perry Farrell",
		"count": 1,
		"genre": "west"
	},
	{
		"year": "1996",
		"title": "STS9",
		"count": 1,
		"genre": "west"
	},
	{
		"year": "1996",
		"title": "Widespread Panic",
		"count": 1,
		"genre": "west"
	},
	{
		"year": "1997",
		"title": "Beast Patrol",
		"count": 1,
		"genre": "north-west"
	},
	{
		"year": "1997",
		"title": "Brick + Mortar",
		"count": 1,
		"genre": "north-west"
	},
	{
		"year": "1997",
		"title": "Cat Power",
		"count": 1,
		"genre": "north-west"
	},
	{
		"year": "1997",
		"title": "Foals",
		"count": 1,
		"genre": "north-west"
	},
	{
		"year": "1997",
		"title": "Guards",
		"count": 1,
		"genre": "north-west"
	},
	{
		"year": "1997",
		"title": "Machines Are People Too",
		"count": 1,
		"genre": "north-west"
	},
	{
		"year": "1997",
		"title": "Makeshift Prodigy",
		"count": 1,
		"genre": "north-west"
	},
	{
		"year": "1997",
		"title": "New Order",
		"count": 1,
		"genre": "north-west"
	},
	{
		"year": "1997",
		"title": "Nine Inch Nails",
		"count": 1,
		"genre": "north-west"
	},
	{
		"year": "1997",
		"title": "Queens Of The Stone Age",
		"count": 1,
		"genre": "north-west"
	},
	{
		"year": "1997",
		"title": "Reignwolf",
		"count": 1,
		"genre": "north-west"
	},
	{
		"year": "1997",
		"title": "Robert DeLong",
		"count": 1,
		"genre": "north-west"
	},
	{
		"year": "1997",
		"title": "The Cure",
		"count": 1,
		"genre": "north-west"
	},
	{
		"year": "1997",
		"title": "The Killers",
		"count": 1,
		"genre": "north-west"
	},
	{
		"year": "1997",
		"title": "The Postal Service",
		"count": 1,
		"genre": "north-west"
	},
	{
		"year": "1997",
		"title": "Twenty One Pilots",
		"count": 1,
		"genre": "north-west"
	},
	{
		"year": "1997",
		"title": "Two Door Cinema Club",
		"count": 1,
		"genre": "north-west"
	},
	{
		"year": "1997",
		"title": "Art Department",
		"count": 1,
		"genre": "east"
	},
	{
		"year": "1997",
		"title": "Cole Plante",
		"count": 1,
		"genre": "east"
	},
	{
		"year": "1997",
		"title": "Dada Life",
		"count": 1,
		"genre": "east"
	},
	{
		"year": "1997",
		"title": "Dillon Francis",
		"count": 1,
		"genre": "east"
	},
	{
		"year": "1997",
		"title": "Keys N Krates",
		"count": 1,
		"genre": "east"
	},
	{
		"year": "1997",
		"title": "RVSB",
		"count": 1,
		"genre": "east"
	},
	{
		"year": "1997",
		"title": "Steve Angello",
		"count": 1,
		"genre": "east"
	},
	{
		"year": "1997",
		"title": "Steve Aoki",
		"count": 1,
		"genre": "east"
	},
	{
		"year": "1997",
		"title": "Supreme Cuts",
		"count": 1,
		"genre": "east"
	},
	{
		"year": "1997",
		"title": "Adventure Club",
		"count": 1,
		"genre": "south-east"
	},
	{
		"year": "1997",
		"title": "Alex Clare",
		"count": 1,
		"genre": "south-east"
	},
	{
		"year": "1997",
		"title": "Alvin Risk",
		"count": 1,
		"genre": "south-east"
	},
	{
		"year": "1997",
		"title": "Baauer",
		"count": 1,
		"genre": "south-east"
	},
	{
		"year": "1997",
		"title": "Brite Lite Brite",
		"count": 1,
		"genre": "south-east"
	},
	{
		"year": "1997",
		"title": "Dog Blood",
		"count": 1,
		"genre": "south-east"
	},
	{
		"year": "1997",
		"title": "Ellie Goulding",
		"count": 1,
		"genre": "south-east"
	},
	{
		"year": "1997",
		"title": "Flux Pavilion",
		"count": 1,
		"genre": "south-east"
	},
	{
		"year": "1997",
		"title": "GriZ",
		"count": 1,
		"genre": "south-east"
	},
	{
		"year": "1997",
		"title": "Icona london",
		"count": 1,
		"genre": "south-east"
	},
	{
		"year": "1997",
		"title": "Jessie Ware",
		"count": 1,
		"genre": "south-east"
	},
	{
		"year": "1997",
		"title": "Kill the Noise",
		"count": 1,
		"genre": "south-east"
	},
	{
		"year": "1997",
		"title": "Knife Party",
		"count": 1,
		"genre": "south-east"
	},
	{
		"year": "1997",
		"title": "Lance Herbstrong",
		"count": 1,
		"genre": "south-east"
	},
	{
		"year": "1997",
		"title": "Major Lazer",
		"count": 1,
		"genre": "south-east"
	},
	{
		"year": "1997",
		"title": "Modestep",
		"count": 1,
		"genre": "south-east"
	},
	{
		"year": "1997",
		"title": "Stratus",
		"count": 1,
		"genre": "south-east"
	},
	{
		"year": "1997",
		"title": "Thievery Corporation",
		"count": 1,
		"genre": "south-east"
	},
	{
		"year": "1997",
		"title": "Alt-J",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1997",
		"title": "American Authors",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1997",
		"title": "Astro",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1997",
		"title": "Atlas Genius",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1997",
		"title": "Band Of Horses",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1997",
		"title": "Beach House",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1997",
		"title": "Bear Mountain",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1997",
		"title": "Ben Howard",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1997",
		"title": "Blondfire",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1997",
		"title": "Brooke Waggoner",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1997",
		"title": "Cherub",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1997",
		"title": "Crystal Castles",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1997",
		"title": "Deap Vally",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1997",
		"title": "DIIV",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1997",
		"title": "Drowners",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1997",
		"title": "Family of the Year",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1997",
		"title": "Father John Misty",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1997",
		"title": "Frightened Rabbit",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1997",
		"title": "Frontier Ruckus",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1997",
		"title": "Grizzly Bear",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1997",
		"title": "HAIM",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1997",
		"title": "Half Moon Run",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1997",
		"title": "Hey Marseilles",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1997",
		"title": "Hot Chip",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1997",
		"title": "IO Echo",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1997",
		"title": "Jake Bugg",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1997",
		"title": "Little Green Cars",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1997",
		"title": "Local Natives",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1997",
		"title": "Matt &amp; Kim",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1997",
		"title": "MS MR",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1997",
		"title": "Mumford &amp; Sons",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1997",
		"title": "Nightmare and the Cat",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1997",
		"title": "Pacific Air",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1997",
		"title": "Palma Violets",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1997",
		"title": "Phoenix",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1997",
		"title": "Pujol",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1997",
		"title": "San Cisco",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1997",
		"title": "Skaters",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1997",
		"title": "Smith Westerns",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1997",
		"title": "St. Lucia",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1997",
		"title": "Tegan and Sara",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1997",
		"title": "The Bright Light Social Hour",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1997",
		"title": "The Lumineers",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1997",
		"title": "The Mowglis",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1997",
		"title": "The National",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1997",
		"title": "The Neighbourhood",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1997",
		"title": "The Orwells",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1997",
		"title": "The Vaccines",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1997",
		"title": "Unknown Mortal Orchestra",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1997",
		"title": "Vampire Weekend",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1997",
		"title": "Wavves",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1997",
		"title": "Wild Belle",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1997",
		"title": "Wild Cub",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1997",
		"title": "Wild Nothing",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1997",
		"title": "Yawn",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1997",
		"title": "Baroness",
		"count": 1,
		"genre": "south-west"
	},
	{
		"year": "1997",
		"title": "Charles Bradley",
		"count": 1,
		"genre": "south-west"
	},
	{
		"year": "1997",
		"title": "Court Yard Hounds",
		"count": 1,
		"genre": "south-west"
	},
	{
		"year": "1997",
		"title": "Eric Church",
		"count": 1,
		"genre": "south-west"
	},
	{
		"year": "1997",
		"title": "Ghost B.C.",
		"count": 1,
		"genre": "south-west"
	},
	{
		"year": "1997",
		"title": "Houndmouth",
		"count": 1,
		"genre": "south-west"
	},
	{
		"year": "1997",
		"title": "Lianne La Havas",
		"count": 1,
		"genre": "south-west"
	},
	{
		"year": "1997",
		"title": "Shovels &amp; Rope",
		"count": 1,
		"genre": "south-west"
	},
	{
		"year": "1997",
		"title": "Wheeler Brsouth-wests",
		"count": 1,
		"genre": "south-west"
	},
	{
		"year": "1997",
		"title": "Emeli Sandé",
		"count": 1,
		"genre": "london"
	},
	{
		"year": "1997",
		"title": "Imagine Dragons",
		"count": 1,
		"genre": "london"
	},
	{
		"year": "1997",
		"title": "Lana Del Rey",
		"count": 1,
		"genre": "london"
	},
	{
		"year": "1997",
		"title": "Timeflies",
		"count": 1,
		"genre": "london"
	},
	{
		"year": "1997",
		"title": "Disclosure",
		"count": 1,
		"genre": "east-midlands"
	},
	{
		"year": "1997",
		"title": "O'Brsouth-west",
		"count": 1,
		"genre": "east-midlands"
	},
	{
		"year": "1997",
		"title": "360",
		"count": 1,
		"genre": "north-east"
	},
	{
		"year": "1997",
		"title": "2 Chainz",
		"count": 1,
		"genre": "north-east"
	},
	{
		"year": "1997",
		"title": "Angel Haze",
		"count": 1,
		"genre": "north-east"
	},
	{
		"year": "1997",
		"title": "Azealia Banks",
		"count": 1,
		"genre": "north-east"
	},
	{
		"year": "1997",
		"title": "Chance The Rapper",
		"count": 1,
		"genre": "north-east"
	},
	{
		"year": "1997",
		"title": "D-Pryde",
		"count": 1,
		"genre": "north-east"
	},
	{
		"year": "1997",
		"title": "Death Grips",
		"count": 1,
		"genre": "north-east"
	},
	{
		"year": "1997",
		"title": "Kendrick Lamar",
		"count": 1,
		"genre": "north-east"
	},
	{
		"year": "1997",
		"title": "Monsta",
		"count": 1,
		"genre": "north-east"
	},
	{
		"year": "1997",
		"title": "Planet Hemp",
		"count": 1,
		"genre": "north-east"
	},
	{
		"year": "1997",
		"title": "Rivals of the Peacemaker",
		"count": 1,
		"genre": "north-east"
	},
	{
		"year": "1997",
		"title": "Theophilus London",
		"count": 1,
		"genre": "north-east"
	},
	{
		"year": "1997",
		"title": "Badthings",
		"count": 1,
		"genre": "west"
	},
	{
		"year": "1997",
		"title": "Heartless Bastards",
		"count": 1,
		"genre": "west"
	},
	{
		"year": "1997",
		"title": "Lukas Nelson &amp; Promise Of The Real",
		"count": 1,
		"genre": "west"
	},
	{
		"year": "1997",
		"title": "The Dunwells",
		"count": 1,
		"genre": "west"
	},
	{
		"year": "1998",
		"title": "American Bang (fka Bang Bang Bang)",
		"count": 1,
		"genre": "north-west"
	},
	{
		"year": "1998",
		"title": "DEVO",
		"count": 1,
		"genre": "north-west"
	},
	{
		"year": "1998",
		"title": "Ed Kowalczyk",
		"count": 1,
		"genre": "north-west"
	},
	{
		"year": "1998",
		"title": "Hockey",
		"count": 1,
		"genre": "north-west"
	},
	{
		"year": "1998",
		"title": "Metric",
		"count": 1,
		"genre": "north-west"
	},
	{
		"year": "1998",
		"title": "My Dear Disco",
		"count": 1,
		"genre": "north-west"
	},
	{
		"year": "1998",
		"title": "Neon Trees",
		"count": 1,
		"genre": "north-west"
	},
	{
		"year": "1998",
		"title": "Perry Farrell",
		"count": 1,
		"genre": "north-west"
	},
	{
		"year": "1998",
		"title": "Slightly Stoopid",
		"count": 1,
		"genre": "north-west"
	},
	{
		"year": "1998",
		"title": "Soundgarden",
		"count": 1,
		"genre": "north-west"
	},
	{
		"year": "1998",
		"title": "Switchfoot",
		"count": 1,
		"genre": "north-west"
	},
	{
		"year": "1998",
		"title": "The Constellations",
		"count": 1,
		"genre": "north-west"
	},
	{
		"year": "1998",
		"title": "The Soft Pack",
		"count": 1,
		"genre": "north-west"
	},
	{
		"year": "1998",
		"title": "The Temper Trap",
		"count": 1,
		"genre": "north-west"
	},
	{
		"year": "1998",
		"title": "The Verve Pipe",
		"count": 1,
		"genre": "north-west"
	},
	{
		"year": "1998",
		"title": "Violent Soho",
		"count": 1,
		"genre": "north-west"
	},
	{
		"year": "1998",
		"title": "Vonnegutt",
		"count": 1,
		"genre": "north-west"
	},
	{
		"year": "1998",
		"title": "Wolfmsouth-west",
		"count": 1,
		"genre": "north-west"
	},
	{
		"year": "1998",
		"title": "Dani Deahl",
		"count": 1,
		"genre": "east"
	},
	{
		"year": "1998",
		"title": "Digitalism (DJ Set)",
		"count": 1,
		"genre": "east"
	},
	{
		"year": "1998",
		"title": "Dirty South",
		"count": 1,
		"genre": "east"
	},
	{
		"year": "1998",
		"title": "Felix Cartal",
		"count": 1,
		"genre": "east"
	},
	{
		"year": "1998",
		"title": "Felix Da Housecat",
		"count": 1,
		"genre": "east"
	},
	{
		"year": "1998",
		"title": "Joachim Garraud",
		"count": 1,
		"genre": "east"
	},
	{
		"year": "1998",
		"title": "Kaskade",
		"count": 1,
		"genre": "east"
	},
	{
		"year": "1998",
		"title": "Los Amigos Invisibles",
		"count": 1,
		"genre": "east"
	},
	{
		"year": "1998",
		"title": "Only Children",
		"count": 1,
		"genre": "east"
	},
	{
		"year": "1998",
		"title": "PerryEtty vs Chris Cox",
		"count": 1,
		"genre": "east"
	},
	{
		"year": "1998",
		"title": "Steve Porter",
		"count": 1,
		"genre": "east"
	},
	{
		"year": "1998",
		"title": "Wolfgang Gartner",
		"count": 1,
		"genre": "east"
	},
	{
		"year": "1998",
		"title": "2 Many DJ's",
		"count": 1,
		"genre": "south-east"
	},
	{
		"year": "1998",
		"title": "Ana Sia",
		"count": 1,
		"genre": "south-east"
	},
	{
		"year": "1998",
		"title": "Balkan Beat Box",
		"count": 1,
		"genre": "south-east"
	},
	{
		"year": "1998",
		"title": "Beats Antique",
		"count": 1,
		"genre": "south-east"
	},
	{
		"year": "1998",
		"title": "Caspa",
		"count": 1,
		"genre": "south-east"
	},
	{
		"year": "1998",
		"title": "Didi Gutman",
		"count": 1,
		"genre": "south-east"
	},
	{
		"year": "1998",
		"title": "Dragonette",
		"count": 1,
		"genre": "south-east"
	},
	{
		"year": "1998",
		"title": "Empire of the Sun",
		"count": 1,
		"genre": "south-east"
	},
	{
		"year": "1998",
		"title": "Erol Alkan",
		"count": 1,
		"genre": "south-east"
	},
	{
		"year": "1998",
		"title": "Lance Herbstrong",
		"count": 1,
		"genre": "south-east"
	},
	{
		"year": "1998",
		"title": "Mexican Institute of Sound",
		"count": 1,
		"genre": "south-east"
	},
	{
		"year": "1998",
		"title": "Rusko",
		"count": 1,
		"genre": "south-east"
	},
	{
		"year": "1998",
		"title": "Team Bayside High",
		"count": 1,
		"genre": "south-east"
	},
	{
		"year": "1998",
		"title": "Tiga",
		"count": 1,
		"genre": "south-east"
	},
	{
		"year": "1998",
		"title": "Arcade Fire",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1998",
		"title": "Blitzen Trapper",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1998",
		"title": "Chromeo",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1998",
		"title": "Cut / Copy",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1998",
		"title": "Cymbals Eat Guitars",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1998",
		"title": "Dan Black",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1998",
		"title": "Dawes",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1998",
		"title": "Deer Tick",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1998",
		"title": "Dirty Projectors",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1998",
		"title": "Edward Sharpe &amp; The Magnetic Zeros",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1998",
		"title": "F--- Buttons",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1998",
		"title": "Foxy Shazam",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1998",
		"title": "Frank Turner",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1998",
		"title": "Freelance Whales",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1998",
		"title": "Frightened Rabbit",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1998",
		"title": "Gogol Bordello",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1998",
		"title": "Grizzly Bear",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1998",
		"title": "Harlem",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1998",
		"title": "HEALTH",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1998",
		"title": "Hot Chip",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1998",
		"title": "Jamie Lidell",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1998",
		"title": "Javelin",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1998",
		"title": "Jukebox the Ghost",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1998",
		"title": "Matt &amp; Kim",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1998",
		"title": "MGMT",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1998",
		"title": "Mimicking Birds",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1998",
		"title": "Miniature Tigers",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1998",
		"title": "Minus the Bear",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1998",
		"title": "Mumford &amp; Sons",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1998",
		"title": "MyNameIsJohnMichael",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1998",
		"title": "Phoenix",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1998",
		"title": "Rogue Wave",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1998",
		"title": "Royal Bangs",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1998",
		"title": "Semi Precious Weapons",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1998",
		"title": "Skybox",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1998",
		"title": "Spoon",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1998",
		"title": "Stars",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1998",
		"title": "The Antlers",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1998",
		"title": "The Big Pink",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1998",
		"title": "The Black Keys",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1998",
		"title": "The Cribs",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1998",
		"title": "The Dodos",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1998",
		"title": "The Ettes",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1998",
		"title": "The Kissaway Trail",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1998",
		"title": "The Morning Benders",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1998",
		"title": "The National",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1998",
		"title": "The New Pornographers",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1998",
		"title": "The Strokes",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1998",
		"title": "The Walkmen",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1998",
		"title": "The xx",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1998",
		"title": "Thenewno2",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1998",
		"title": "These United States",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1998",
		"title": "Warpaint",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1998",
		"title": "Wavves",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1998",
		"title": "Wild Beasts",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1998",
		"title": "Yeasayer",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1998",
		"title": "Candy Band",
		"count": 1,
		"genre": "south-west"
	},
	{
		"year": "1998",
		"title": "Dan Zanes &amp; The Chicago Youth Symphony Orchestra",
		"count": 1,
		"genre": "south-west"
	},
	{
		"year": "1998",
		"title": "Erykah Badu",
		"count": 1,
		"genre": "south-west"
	},
	{
		"year": "1998",
		"title": "Jimmy Cliff",
		"count": 1,
		"genre": "south-west"
	},
	{
		"year": "1998",
		"title": "Mavis Staples",
		"count": 1,
		"genre": "south-west"
	},
	{
		"year": "1998",
		"title": "Raphael Saadiq",
		"count": 1,
		"genre": "south-west"
	},
	{
		"year": "1998",
		"title": "Rebelution",
		"count": 1,
		"genre": "south-west"
	},
	{
		"year": "1998",
		"title": "Recess Monkey",
		"count": 1,
		"genre": "south-west"
	},
	{
		"year": "1998",
		"title": "westnoceros",
		"count": 1,
		"genre": "south-west"
	},
	{
		"year": "1998",
		"title": "School Of west",
		"count": 1,
		"genre": "south-west"
	},
	{
		"year": "1998",
		"title": "The Happiness Club",
		"count": 1,
		"genre": "south-west"
	},
	{
		"year": "1998",
		"title": "Tim and the Space Cadets",
		"count": 1,
		"genre": "south-west"
	},
	{
		"year": "1998",
		"title": "X Japan",
		"count": 1,
		"genre": "south-west"
	},
	{
		"year": "1998",
		"title": "Lady Gaga",
		"count": 1,
		"genre": "london"
	},
	{
		"year": "1998",
		"title": "Neon Hitch",
		"count": 1,
		"genre": "london"
	},
	{
		"year": "1998",
		"title": "NERVO",
		"count": 1,
		"genre": "london"
	},
	{
		"year": "1998",
		"title": "Nneka",
		"count": 1,
		"genre": "london"
	},
	{
		"year": "1998",
		"title": "AFI",
		"count": 1,
		"genre": "east-midlands"
	},
	{
		"year": "1998",
		"title": "Green Day",
		"count": 1,
		"genre": "east-midlands"
	},
	{
		"year": "1998",
		"title": "Social Distortion",
		"count": 1,
		"genre": "east-midlands"
	},
	{
		"year": "1998",
		"title": "Ancient Astronauts",
		"count": 1,
		"genre": "north-east"
	},
	{
		"year": "1998",
		"title": "B.o.B",
		"count": 1,
		"genre": "north-east"
	},
	{
		"year": "1998",
		"title": "BBU",
		"count": 1,
		"genre": "north-east"
	},
	{
		"year": "1998",
		"title": "Chiddy Bang",
		"count": 1,
		"genre": "north-east"
	},
	{
		"year": "1998",
		"title": "Cypress Hill",
		"count": 1,
		"genre": "north-east"
	},
	{
		"year": "1998",
		"title": "DJ Mel",
		"count": 1,
		"genre": "north-east"
	},
	{
		"year": "1998",
		"title": "Flosstradamus",
		"count": 1,
		"genre": "north-east"
	},
	{
		"year": "1998",
		"title": "FreeSol",
		"count": 1,
		"genre": "north-east"
	},
	{
		"year": "1998",
		"title": "J. Cole",
		"count": 1,
		"genre": "north-east"
	},
	{
		"year": "1998",
		"title": "Peanut Butter Wolf",
		"count": 1,
		"genre": "north-east"
	},
	{
		"year": "1998",
		"title": "Q Brsouth-wests",
		"count": 1,
		"genre": "north-east"
	},
	{
		"year": "1998",
		"title": "Blues Traveler",
		"count": 1,
		"genre": "west"
	},
	{
		"year": "1998",
		"title": "Company Of Thieves",
		"count": 1,
		"genre": "west"
	},
	{
		"year": "1998",
		"title": "Drive-By Truckers",
		"count": 1,
		"genre": "west"
	},
	{
		"year": "1998",
		"title": "JP, Chrissie &amp; The Fairground Boys",
		"count": 1,
		"genre": "west"
	},
	{
		"year": "1998",
		"title": "Mutemath",
		"count": 1,
		"genre": "west"
	},
	{
		"year": "1998",
		"title": "Peter DiStefano &amp; Tor Hyams",
		"count": 1,
		"genre": "west"
	},
	{
		"year": "1998",
		"title": "Shawn Fisher",
		"count": 1,
		"genre": "west"
	},
	{
		"year": "1998",
		"title": "Son of a Bad Man",
		"count": 1,
		"genre": "west"
	},
	{
		"year": "1998",
		"title": "The Band of Heathens",
		"count": 1,
		"genre": "west"
	},
	{
		"year": "1998",
		"title": "The Ike Reilly Assassination",
		"count": 1,
		"genre": "west"
	},
	{
		"year": "1999",
		"title": "Fishbone",
		"count": 1,
		"genre": "north-west"
	},
	{
		"year": "1999",
		"title": "Jane's Addiction",
		"count": 1,
		"genre": "north-west"
	},
	{
		"year": "1999",
		"title": "Living Colour",
		"count": 1,
		"genre": "north-west"
	},
	{
		"year": "1999",
		"title": "Nine Inch Nails",
		"count": 1,
		"genre": "north-west"
	},
	{
		"year": "1999",
		"title": "Siouxsie &amp; The Banshees",
		"count": 1,
		"genre": "north-west"
	},
	{
		"year": "1999",
		"title": "Butthole Surfers",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1999",
		"title": "Violent Femmes",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "1999",
		"title": "Ice T &amp; Body Count",
		"count": 1,
		"genre": "south-west"
	},
	{
		"year": "1999",
		"title": "Rollins Band",
		"count": 1,
		"genre": "east-midlands"
	},
	{
		"year": "2000",
		"title": "L7",
		"count": 1,
		"genre": "north-west"
	},
	{
		"year": "2000",
		"title": "Luscious Jackson",
		"count": 1,
		"genre": "north-west"
	},
	{
		"year": "2000",
		"title": "Nick Cave &amp; The Bad Seeds",
		"count": 1,
		"genre": "north-west"
	},
	{
		"year": "2000",
		"title": "Smashing Pumpkins",
		"count": 1,
		"genre": "north-west"
	},
	{
		"year": "2000",
		"title": "Blast Off Country Style",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "2000",
		"title": "Boredoms",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "2000",
		"title": "Girls Against Boys",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "2000",
		"title": "Guided By Voices",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "2000",
		"title": "king kong",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "2000",
		"title": "Lambchop",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "2000",
		"title": "Palace Songs",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "2000",
		"title": "Rollerskate Skinny",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "2000",
		"title": "STEREOLAB",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "2000",
		"title": "The Boo Radleys",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "2000",
		"title": "The Breeders",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "2000",
		"title": "The Flaming Lips",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "2000",
		"title": "The Frogs",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "2000",
		"title": "The Verve",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "2000",
		"title": "Charlie Hunter Trio",
		"count": 1,
		"genre": "south-west"
	},
	{
		"year": "2000",
		"title": "George Clinton &amp; The P-Funk All Stars",
		"count": 1,
		"genre": "south-west"
	},
	{
		"year": "2000",
		"title": "Shonen Knife",
		"count": 1,
		"genre": "south-west"
	},
	{
		"year": "2000",
		"title": "The Last Poets",
		"count": 1,
		"genre": "south-west"
	},
	{
		"year": "2000",
		"title": "Green Day",
		"count": 1,
		"genre": "east-midlands"
	},
	{
		"year": "2000",
		"title": "Shudder to Think",
		"count": 1,
		"genre": "east-midlands"
	},
	{
		"year": "2000",
		"title": "A Tribe Called Quest",
		"count": 1,
		"genre": "north-east"
	},
	{
		"year": "2000",
		"title": "Beastie Boys",
		"count": 1,
		"genre": "north-east"
	},
	{
		"year": "2000",
		"title": "Cypress Hill",
		"count": 1,
		"genre": "north-east"
	},
	{
		"year": "2000",
		"title": "FU-Schnickens",
		"count": 1,
		"genre": "north-east"
	},
	{
		"year": "2000",
		"title": "Souls of Mischief",
		"count": 1,
		"genre": "north-east"
	},
	{
		"year": "2000",
		"title": "The Pharcyde",
		"count": 1,
		"genre": "north-east"
	},
	{
		"year": "2000",
		"title": "The Black Crowes",
		"count": 1,
		"genre": "west"
	},
	{
		"year": "2001",
		"title": "Arctic Monkeys",
		"count": 1,
		"genre": "north-west"
	},
	{
		"year": "2001",
		"title": "Crass Mammoth",
		"count": 1,
		"genre": "north-west"
	},
	{
		"year": "2001",
		"title": "Glen Hansard",
		"count": 1,
		"genre": "north-west"
	},
	{
		"year": "2001",
		"title": "Grouplove",
		"count": 1,
		"genre": "north-west"
	},
	{
		"year": "2001",
		"title": "Interpol",
		"count": 1,
		"genre": "north-west"
	},
	{
		"year": "2001",
		"title": "Joywave",
		"count": 1,
		"genre": "north-west"
	},
	{
		"year": "2001",
		"title": "Kings of Leon",
		"count": 1,
		"genre": "north-west"
	},
	{
		"year": "2001",
		"title": "Kongos",
		"count": 1,
		"genre": "north-west"
	},
	{
		"year": "2001",
		"title": "Meg Myers",
		"count": 1,
		"genre": "north-west"
	},
	{
		"year": "2001",
		"title": "Parquet Courts",
		"count": 1,
		"genre": "north-west"
	},
	{
		"year": "2001",
		"title": "Phantogram",
		"count": 1,
		"genre": "north-west"
	},
	{
		"year": "2001",
		"title": "The Temper Trap",
		"count": 1,
		"genre": "north-west"
	},
	{
		"year": "2001",
		"title": "Young The Giant",
		"count": 1,
		"genre": "north-west"
	},
	{
		"year": "2001",
		"title": "Anna Lunoe",
		"count": 1,
		"genre": "east"
	},
	{
		"year": "2001",
		"title": "Bagheera",
		"count": 1,
		"genre": "east"
	},
	{
		"year": "2001",
		"title": "Bomba Estéreo",
		"count": 1,
		"genre": "east"
	},
	{
		"year": "2001",
		"title": "Dimitri Vegas &amp; Like Mike",
		"count": 1,
		"genre": "east"
	},
	{
		"year": "2001",
		"title": "Duke Dumont",
		"count": 1,
		"genre": "east"
	},
	{
		"year": "2001",
		"title": "Flume",
		"count": 1,
		"genre": "east"
	},
	{
		"year": "2001",
		"title": "Gesaffelstein",
		"count": 1,
		"genre": "east"
	},
	{
		"year": "2001",
		"title": "Gta",
		"count": 1,
		"genre": "east"
	},
	{
		"year": "2001",
		"title": "Jacob Plant",
		"count": 1,
		"genre": "east"
	},
	{
		"year": "2001",
		"title": "Joachim Garraud",
		"count": 1,
		"genre": "east"
	},
	{
		"year": "2001",
		"title": "Martin Garrix",
		"count": 1,
		"genre": "east"
	},
	{
		"year": "2001",
		"title": "Oyinda",
		"count": 1,
		"genre": "east"
	},
	{
		"year": "2001",
		"title": "PerryEtty vs. Joachim Garraud",
		"count": 1,
		"genre": "east"
	},
	{
		"year": "2001",
		"title": "Rac",
		"count": 1,
		"genre": "east"
	},
	{
		"year": "2001",
		"title": "Sander Kleinenberg",
		"count": 1,
		"genre": "east"
	},
	{
		"year": "2001",
		"title": "Sebastian Ingrosso",
		"count": 1,
		"genre": "east"
	},
	{
		"year": "2001",
		"title": "Zedd",
		"count": 1,
		"genre": "east"
	},
	{
		"year": "2001",
		"title": "Above &amp; Beyond",
		"count": 1,
		"genre": "south-east"
	},
	{
		"year": "2001",
		"title": "Brillz",
		"count": 1,
		"genre": "south-east"
	},
	{
		"year": "2001",
		"title": "Cardiknox",
		"count": 1,
		"genre": "south-east"
	},
	{
		"year": "2001",
		"title": "Chase &amp; Status",
		"count": 1,
		"genre": "south-east"
	},
	{
		"year": "2001",
		"title": "Chvrches",
		"count": 1,
		"genre": "south-east"
	},
	{
		"year": "2001",
		"title": "Crizzly",
		"count": 1,
		"genre": "south-east"
	},
	{
		"year": "2001",
		"title": "Herobust",
		"count": 1,
		"genre": "south-east"
	},
	{
		"year": "2001",
		"title": "Krewella",
		"count": 1,
		"genre": "south-east"
	},
	{
		"year": "2001",
		"title": "Lindsay Lowend",
		"count": 1,
		"genre": "south-east"
	},
	{
		"year": "2001",
		"title": "Of Verona",
		"count": 1,
		"genre": "south-east"
	},
	{
		"year": "2001",
		"title": "Rudimental",
		"count": 1,
		"genre": "south-east"
	},
	{
		"year": "2001",
		"title": "Skrillex",
		"count": 1,
		"genre": "south-east"
	},
	{
		"year": "2001",
		"title": "The Glitch Mob",
		"count": 1,
		"genre": "south-east"
	},
	{
		"year": "2001",
		"title": "Z-Trip",
		"count": 1,
		"genre": "south-east"
	},
	{
		"year": "2001",
		"title": "Bear Hands",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "2001",
		"title": "Blood Orange",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "2001",
		"title": "Bombay Bicycle Club",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "2001",
		"title": "Broken Bells",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "2001",
		"title": "Bronze Radio Return",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "2001",
		"title": "Cage the Elephant",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "2001",
		"title": "Chromeo",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "2001",
		"title": "Courtney Barnett",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "2001",
		"title": "Cut / Copy",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "2001",
		"title": "Darkside",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "2001",
		"title": "Desert Noises",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "2001",
		"title": "Fly Golden Eagle",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "2001",
		"title": "Foster The People",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "2001",
		"title": "Gemini Club",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "2001",
		"title": "Highly Suspect",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "2001",
		"title": "J. Roddy Walston and The Business",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "2001",
		"title": "Jagwar Ma",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "2001",
		"title": "Jenny Lewis",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "2001",
		"title": "Jungle",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "2001",
		"title": "Kodaline",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "2001",
		"title": "London Grammar",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "2001",
		"title": "Lorde",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "2001",
		"title": "Lucius",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "2001",
		"title": "Lykke Li",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "2001",
		"title": "Manchester Orchestra",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "2001",
		"title": "NONONO",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "2001",
		"title": "Papa",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "2001",
		"title": "Phosphorescent",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "2001",
		"title": "Portugal. The Man",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "2001",
		"title": "Roadkill Ghost Choir",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "2001",
		"title": "Royal Blood",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "2001",
		"title": "San Fermin",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "2001",
		"title": "Smallpools",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "2001",
		"title": "Spoon",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "2001",
		"title": "Temples",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "2001",
		"title": "The 1975",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "2001",
		"title": "The Airborne Toxic Event",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "2001",
		"title": "The Districts",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "2001",
		"title": "The Head And The Heart",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "2001",
		"title": "The Kooks",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "2001",
		"title": "The Last Internationale",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "2001",
		"title": "Typhoon",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "2001",
		"title": "Warpaint",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "2001",
		"title": "White Denim",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "2001",
		"title": "Wildcat! Wildcat!",
		"count": 1,
		"genre": "yourkshire"
	},
	{
		"year": "2001",
		"title": "Delta Rae",
		"count": 1,
		"genre": "south-west"
	},
	{
		"year": "2001",
		"title": "Fitz &amp; The Tantrums",
		"count": 1,
		"genre": "south-west"
	},
	{
		"year": "2001",
		"title": "Francisca Valenzuela",
		"count": 1,
		"genre": "south-west"
	},
	{
		"year": "2001",
		"title": "Jambo",
		"count": 1,
		"genre": "south-west"
	},
	{
		"year": "2001",
		"title": "Jhené Aiko",
		"count": 1,
		"genre": "south-west"
	},
	{
		"year": "2001",
		"title": "Johnnyswim",
		"count": 1,
		"genre": "south-west"
	},
	{
		"year": "2001",
		"title": "Jon Batiste And Stay Human",
		"count": 1,
		"genre": "south-west"
	},
	{
		"year": "2001",
		"title": "Kausea",
		"count": 1,
		"genre": "south-west"
	},
	{
		"year": "2001",
		"title": "Kristian Bush",
		"count": 1,
		"genre": "south-west"
	},
	{
		"year": "2001",
		"title": "Laura Doherty &amp; The Heartbeats",
		"count": 1,
		"genre": "south-west"
	},
	{
		"year": "2001",
		"title": "Rebelution",
		"count": 1,
		"genre": "south-west"
	},
	{
		"year": "2001",
		"title": "Space Capone",
		"count": 1,
		"genre": "south-west"
	},
	{
		"year": "2001",
		"title": "The Avett Brsouth-wests",
		"count": 1,
		"genre": "south-west"
	},
	{
		"year": "2001",
		"title": "The Not-Its!",
		"count": 1,
		"genre": "south-west"
	},
	{
		"year": "2001",
		"title": "Trombone Shorty &amp; Orleans Avenue",
		"count": 1,
		"genre": "south-west"
	},
	{
		"year": "2001",
		"title": "Bebe Rexha",
		"count": 1,
		"genre": "london"
	},
	{
		"year": "2001",
		"title": "Betty Who",
		"count": 1,
		"genre": "london"
	},
	{
		"year": "2001",
		"title": "Bleachers",
		"count": 1,
		"genre": "london"
	},
	{
		"year": "2001",
		"title": "Calvin Harris",
		"count": 1,
		"genre": "london"
	},
	{
		"year": "2001",
		"title": "Cash Cash",
		"count": 1,
		"genre": "london"
	},
	{
		"year": "2001",
		"title": "Charlie Hirsch",
		"count": 1,
		"genre": "london"
	},
	{
		"year": "2001",
		"title": "Kate Nash",
		"count": 1,
		"genre": "london"
	},
	{
		"year": "2001",
		"title": "Vance Joy",
		"count": 1,
		"genre": "london"
	},
	{
		"year": "2001",
		"title": "AFI",
		"count": 1,
		"genre": "east-midlands"
	},
	{
		"year": "2001",
		"title": "Benjamin Booker",
		"count": 1,
		"genre": "east-midlands"
	},
	{
		"year": "2001",
		"title": "Into It. Over It.",
		"count": 1,
		"genre": "east-midlands"
	},
	{
		"year": "2001",
		"title": "Plastic Visions",
		"count": 1,
		"genre": "east-midlands"
	},
	{
		"year": "2001",
		"title": "The So So Glos",
		"count": 1,
		"genre": "east-midlands"
	},
	{
		"year": "2001",
		"title": "Chance The Rapper",
		"count": 1,
		"genre": "north-east"
	},
	{
		"year": "2001",
		"title": "Childish Gambino",
		"count": 1,
		"genre": "north-east"
	},
	{
		"year": "2001",
		"title": "Eminem",
		"count": 1,
		"genre": "north-east"
	},
	{
		"year": "2001",
		"title": "Flosstradamus",
		"count": 1,
		"genre": "north-east"
	},
	{
		"year": "2001",
		"title": "Gramatik",
		"count": 1,
		"genre": "north-east"
	},
	{
		"year": "2001",
		"title": "Iggy Azalea",
		"count": 1,
		"genre": "north-east"
	},
	{
		"year": "2001",
		"title": "Nas",
		"count": 1,
		"genre": "north-east"
	},
	{
		"year": "2001",
		"title": "Outkast",
		"count": 1,
		"genre": "north-east"
	},
	{
		"year": "2001",
		"title": "Ratking",
		"count": 1,
		"genre": "north-east"
	},
	{
		"year": "2001",
		"title": "Rich Homie Quan",
		"count": 1,
		"genre": "north-east"
	},
	{
		"year": "2001",
		"title": "westy Business",
		"count": 1,
		"genre": "north-east"
	},
	{
		"year": "2001",
		"title": "Run The Jewels",
		"count": 1,
		"genre": "north-east"
	},
	{
		"year": "2001",
		"title": "Vic Mensa",
		"count": 1,
		"genre": "north-east"
	},
	{
		"year": "2001",
		"title": "Wallpaper.",
		"count": 1,
		"genre": "north-east"
	},
	{
		"year": "2001",
		"title": "Dugas",
		"count": 1,
		"genre": "west"
	},
	{
		"year": "2001",
		"title": "John Butler Trio",
		"count": 1,
		"genre": "west"
	}
];

const case4_spec = {
	"original_artboard": {
		"name": "bookstores-desktop",
		"screen_type": "Desktop-Landscape",
		"artboard_width": 1024,
		"artboard_height": 600,
		"device_width": 1440,
		"device_height": 900,
		"ppi": 227
	},
	"artboard": {
		"name": "bookstores-desktop",
		"screen_type": "Desktop-Landscape",
		"artboard_width": 1024,
		"artboard_height": 600,
		"device_width": 1440,
		"device_height": 900,
		"ppi": 227
	},
	"fronto": {
		"data": [],
		"datatype": {},
		"name": "",
		"layout": {
			"width": 1024,
			"height": 600,
			"composition": "single",
			"column": [
				{
					"field": "year",
					"type": "nominal",
					"values": [
						1976,
						1977,
						1978,
						1979,
						1980,
						1981,
						1982,
						1988,
						1990,
						1991,
						1992,
						1993,
						1994,
						1995,
						1996,
						1997,
						1998,
						1999,
						2000,
						2001
					]
				}
			],
			"row": [
				{
					"field": "count",
					"type": "quantitative",
					"stack": "center"
				}
			],
			"haxis": {
				"domain": false
			}
		},
		"layer": [
			{
				"name": "layer_0",
				"mark": {
					"type": "bar",
					"fill": {
						"field": "genre",
						"scale": {
							"domain": [
								"north-west",
								"north-east",
								"yourkshire",
								"south-east",
								"east-midlands",
								"south-west",
								"east",
								"west",
								"london"
							],
							"range": [
								"rgba(247,180,10,1)",
								"rgba(155,204,57,1)",
								"rgba(50,184,85,1)",
								"rgba(23,138,134,1)",
								"rgba(67,91,163,1)",
								"rgba(105,44,158,1)",
								"rgba(172,72,64,1)",
								"rgba(230,44,12,1)",
								"rgba(94,94,94,1)"
							]
						}
					}
				},
				"text": [
					{
						"type": "on-axis",
						"field": "year",
						"items": [
							{
								"index": 0,
								"fontSize": 13,
								"fontWeight": "700",
								"align": "center"
							},
							{
								"fontSize": 12,
								"index": 1,
								"align": "center",
								"expression": "sum('count',true)"
							}
						],
						"orient": "top"
					},
					{
						"type": "legend",
						"field": "genre",
						"channel": "fill",
						"items": [
							{
								"index": 0,
								"custom": {
									"north-west": "North West",
									"north-east": "North East",
									"yourkshire": "Yorkshire/Humber",
									"south-east": "South East",
									"east-midlands": "East Midlands",
									"south-west": "South West",
									"east": "East of England",
									"west": "West Midlands",
									"london": "Greator London"
								}
							}
						],
						"orient": "top",
						"dx": null,
						"dy": null,
						"values": [
							"north-west",
							"north-east",
							"yourkshire",
							"south-east",
							"east-midlands",
							"south-west",
							"east",
							"west",
							"london"
						],
						"interactiveHighlight": "mouseover"
					}
				],
				"index": 0,
				"tooltip": {
					"visibility": "on-mark",
					"fields": [
						{
							"field": "year"
						},
						{
							"field": "genre"
						},
						{
							"field": "title"
						}
					]
				}
			}
		],
		"annotation": {
			"items": [
				{
					"type": "text",
					"text": [
						{
							"text": "The data do not include Wales, Northen Ireland, and Scotland.<br/>\nBookstore names may not be up-to-date.",
							"align": "left",
							"index": "0",
							"fontSize": 12
						}
					],
					"name": "annotation_0",
					"x": "25%",
					"y": "25%",
					"width": 200,
					"visibility": {
						"externalize": {
							"position": "bottom"
						}
					}
				}
			]
		},
		"title": {
			"items": [
				{
					"name": "title_0",
					"text": "How bookstores has changed",
					"fontWeight": "600",
					"fontSize": 36
				},
				{
					"name": "title_1",
					"text": "Over the past 25 years, the number of independent bookstores in England has been fluctuating from Yorkshire to London. These independent bookstores have served continuous demands for various genres of books that used to be not part of large book firms. We collected the data from the Independent Publication Association. Independent publishers use this data to make marketing and distribution plans according to different neighborhoods. Use this interactive chart to navigate bookstores in different regions and thier unique names.",
					"fontWeight": "400",
					"fontSize": 16
				}
			]
		}
	}
};

const case5_data = [
	{
		"y": 2,
		"category": "Redskins",
		"year": 1990
	},
	{
		"y": -2,
		"category": "Indians",
		"year": 1990
	},
	{
		"y": 2,
		"category": "Redskins",
		"year": 1992
	},
	{
		"y": 3,
		"category": "Redskins",
		"year": 1992
	},
	{
		"y": 2,
		"category": "Redskins",
		"year": 1993
	},
	{
		"y": 2,
		"category": "Redskins",
		"year": 1994
	},
	{
		"y": 2,
		"category": "Redskins",
		"year": 1995
	},
	{
		"y": -2,
		"category": "Indians",
		"year": 1996
	},
	{
		"y": 2,
		"category": "Redskins",
		"year": 1996
	},
	{
		"y": 2,
		"category": "Redskins",
		"year": 1997
	},
	{
		"y": 3,
		"category": "Redskins",
		"year": 1997
	},
	{
		"y": 2,
		"category": "Redskins",
		"year": 1998
	},
	{
		"y": 3,
		"category": "Redskins",
		"year": 1998
	},
	{
		"y": 4,
		"category": "Redskins",
		"year": 1998
	},
	{
		"y": 2,
		"category": "Redskins",
		"year": 1999
	},
	{
		"y": 3,
		"category": "Redskins",
		"year": 1999
	},
	{
		"y": 2,
		"category": "Redskins",
		"year": 2000
	},
	{
		"y": -2,
		"category": "Indians",
		"year": 2000
	},
	{
		"y": 2,
		"category": "Redskins",
		"year": 2001
	},
	{
		"y": 3,
		"category": "Redskins",
		"year": 2001
	},
	{
		"y": 4,
		"category": "Redskins",
		"year": 2001
	},
	{
		"y": 5,
		"category": "Redskins",
		"year": 2001
	},
	{
		"y": 6,
		"category": "Redskins",
		"year": 2001
	},
	{
		"y": -2,
		"category": "Indians",
		"year": 2001
	},
	{
		"y": -3,
		"category": "Indians",
		"year": 2001
	},
	{
		"y": -4,
		"category": "Indians",
		"year": 2001
	},
	{
		"y": 2,
		"category": "Redskins",
		"year": 2002
	},
	{
		"y": 3,
		"category": "Redskins",
		"year": 2002
	},
	{
		"y": 4,
		"category": "Redskins",
		"year": 2002
	},
	{
		"y": -2,
		"category": "Indians",
		"year": 2002
	},
	{
		"y": -2,
		"category": "Indians",
		"year": 2004
	},
	{
		"y": 2,
		"category": "Redskins",
		"year": 2005
	},
	{
		"y": -2,
		"category": "Indians",
		"year": 2005
	},
	{
		"y": -3,
		"category": "Indians",
		"year": 2005
	},
	{
		"y": 2,
		"category": "Redskins",
		"year": 2006
	},
	{
		"y": -2,
		"category": "Indians",
		"year": 2008
	},
	{
		"y": -2,
		"category": "Indians",
		"year": 2009
	},
	{
		"y": -3,
		"category": "Indians",
		"year": 2009
	},
	{
		"y": -2,
		"category": "Indians",
		"year": 2010
	},
	{
		"y": 2,
		"category": "Redskins",
		"year": 2011
	},
	{
		"y": -2,
		"category": "Indians",
		"year": 2011
	},
	{
		"y": 2,
		"category": "Redskins",
		"year": 2012
	},
	{
		"y": 3,
		"category": "Redskins",
		"year": 2012
	},
	{
		"y": 4,
		"category": "Redskins",
		"year": 2012
	},
	{
		"y": 2,
		"category": "Redskins",
		"year": 2013
	},
	{
		"y": 2,
		"category": "Redskins",
		"year": 2014
	},
	{
		"y": 3,
		"category": "Redskins",
		"year": 2014
	},
	{
		"y": -2,
		"category": "Indians",
		"year": 2015
	},
	{
		"y": 2,
		"category": "Redskins",
		"year": 2015
	},
	{
		"y": 3,
		"category": "Redskins",
		"year": 2015
	},
	{
		"y": 2,
		"category": "Redskins",
		"year": 2016
	},
	{
		"y": 3,
		"category": "Redskins",
		"year": 2016
	},
	{
		"y": 2,
		"category": "Redskins",
		"year": 2017
	},
	{
		"y": 2,
		"category": "Redskins",
		"year": 2019
	},
	{
		"y": -2,
		"category": "Indians",
		"year": 2019
	},
	{
		"y": -3,
		"category": "Indians",
		"year": 2019
	},
	{
		"y": -4,
		"category": "Indians",
		"year": 2019
	},
	{
		"y": -5,
		"category": "Indians",
		"year": 2019
	},
	{
		"y": 2,
		"category": "Redskins",
		"year": 2020
	},
	{
		"y": 3,
		"category": "Redskins",
		"year": 2020
	}
];

const case5_spec = {
	original_artboard: {
		"name": "server-breaks-desktop",
		"screen_type": "Desktop-Landscape",
		"artboard_width": 610,
		"artboard_height": 300,
		"device_width": 1440,
		"device_height": 901,
		"ppi": 227
	},
	artboard: {
		"name": "server-breaks-desktop",
		"screen_type": "Desktop-Landscape",
		"artboard_width": 610,
		"artboard_height": 300,
		"device_width": 1440,
		"device_height": 901,
		"ppi": 227
	},
	fronto: {
		"data": [],
		"datatype": {},
		"name": "",
		"layout": {
			"width": 610,
			"height": 300,
			"composition": "single",
			"column": [
				{
					"field": "year",
					"type": "quantitative",
					"values": [
						1990,
						1992,
						1993,
						1994,
						1995,
						1996,
						1997,
						1998,
						1999,
						2000,
						2001,
						2002,
						2004,
						2005,
						2006,
						2007,
						2009,
						2010,
						2011,
						2012,
						2013,
						2014,
						2015,
						2016,
						2017,
						2018,
						2020
					],
					"scale": {
						"domain": [
							1989.5,
							2020.5
						]
					}
				}
			],
			"row": [
				{
					"field": "y",
					"type": "quantitative"
				}
			],
			"vaxis": {
				"grid": false,
				"offset": 0
			},
			"padding": {
				"top": 50,
				"bottom": 100,
				"left": 90,
				"right": 70
			},
			"haxis": {
				"domain": true,
				"offset": -65,
				"domainColor": "rgba(158,158,158,1)",
				"domainWidth": 1
			}
		},
		"layer": [
			{
				"name": "layer_0",
				"mark": {
					"type": "circle",
					"size": {
						"value": 80
					},
					"fill": {
						"value": "rgba(69,140,119,1)"
					},
					"fillOpacity": {
						"value": 1
					},
					"opacity": {
						"value": 1
					}
				},
				"text": [
					{
						"type": "on-axis",
						"field": "year",
						"items": [
							{
								"index": 0,
								"expression": "\"'\"+(format(datum.value %100, '02'))",
								"fontSize": 16,
								"lineHeight": 100,
								"align": "center",
								"color": "rgba(158,158,158,1)",
								"fontWeight": "200",
								"fill": "rgba(255,255,255,1)",
								"width": 30
							}
						],
						"values": [
							1990,
							1995,
							2000,
							2005,
							2010,
							2015,
							2020
						],
						"padding": 3,
						"dx": "-2px",
						"dy": "-50%"
					}
				]
			}
		],
		"title": {
			"items": [
				{
					"name": "title_0",
					"text": "Fatal server breaks and congestion in North and South",
					"fontWeight": 700,
					"fontSize": 16
				}
			]
		},
		"annotation": {
			"items": [
				{
					"type": "text",
					"text": [
						{
							"text": "North$caret-right-fill$",
							"align": "right",
							"index": "0",
							"fontSize": 14,
							"fontWeight": "700"
						}
					],
					"name": "annotation_0",
					"x": "2%",
					"y": "33.5%",
					"width": 80,
					"axisAssist": true,
					"anchor": {
						"positionOrient": "top-left"
					}
				},
				{
					"type": "text",
					"text": [
						{
							"text": "South$caret-right-fill$",
							"align": "right",
							"index": "0",
							"fontWeight": "700",
							"fontSize": 14
						}
					],
					"name": "annotation_1",
					"x": "2%",
					"y": "45.5%",
					"width": 80,
					"axisAssist": true,
					"anchor": {
						"positionOrient": "top-left"
					}
				},
				{
					"type": "text",
					"text": [
						{
							"text": "1992",
							"align": "left",
							"index": "0",
							"fontSize": 14,
							"fontWeight": "700",
							"lineHeight": 110
						},
						{
							"text": "First unexpected malfunction observed",
							"align": "left",
							"index": "1",
							"fontSize": 14,
							"fontWeight": "400",
							"lineHeight": 110
						}
					],
					"name": "annotation_2",
					"x": "25%",
					"y": "25%",
					"width": 120,
					"anchor": {
						"dataItem": {
							"role": "circle",
							"datum": {
								"year": 1992,
								"y": 3
							}
						},
						"anchorAlign": "start",
						"to": {
							"dx": -11,
							"dy": -50
						},
						"positionOrient": "top-left",
						"callout": "yes",
						"cornering": "right-top",
						"from": {
							"dy": -10,
							"dx": 0
						},
						"textAnchor": true
					},
					"dx": -129,
					"dy": -80
				},
				{
					"type": "text",
					"text": [
						{
							"text": "1999",
							"align": "left",
							"index": "0",
							"fontSize": 14,
							"fontWeight": "700",
							"lineHeight": 110
						},
						{
							"text": "Malfunction occured, but did not impact many users",
							"align": "left",
							"index": "1",
							"fontSize": 14,
							"fontWeight": "400",
							"lineHeight": 110
						}
					],
					"name": "annotation_3",
					"x": "25%",
					"y": "25%",
					"width": 160,
					"anchor": {
						"dataItem": {
							"role": "circle",
							"datum": {
								"year": 1999,
								"y": 3
							}
						},
						"callout": "yes",
						"cornering": "left-top",
						"from": {
							"dx": 0,
							"dy": -10
						},
						"to": {
							"dx": 40,
							"dy": -75
						},
						"positionOrient": "top-left",
						"textAnchor": true,
						"anchorAlign": "start"
					},
					"dx": 49,
					"dy": -83
				},
				{
					"type": "text",
					"text": [
						{
							"text": "2014",
							"align": "left",
							"index": "0",
							"fontWeight": "700",
							"fontSize": 14,
							"lineHeight": 110
						},
						{
							"text": "First large-impact server break",
							"align": "left",
							"index": "1",
							"fontWeight": "400",
							"fontSize": 14,
							"lineHeight": 110
						}
					],
					"name": "annotation_4",
					"x": "25%",
					"y": "25%",
					"width": 130,
					"anchor": {
						"dataItem": {
							"role": "circle",
							"datum": {
								"year": 2014,
								"y": 3
							}
						},
						"callout": "yes",
						"from": {
							"dy": -10,
							"dx": 0
						},
						"to": {
							"dx": 24,
							"dy": -90
						},
						"cornering": "left-top",
						"positionOrient": "top-left",
						"textAnchor": true,
						"anchorAlign": "start"
					},
					"dx": 35,
					"dy": -96
				},
				{
					"type": "text",
					"text": [
						{
							"text": "2015",
							"align": "right",
							"index": "0",
							"fontSize": 14,
							"fontWeight": "700",
							"lineHeight": 110
						},
						{
							"text": "Personal data leak caused due to security breaks",
							"align": "right",
							"index": "1",
							"fontWeight": "400",
							"fontSize": 14,
							"lineHeight": 110
						}
					],
					"name": "annotation_5",
					"x": "25%",
					"y": "25%",
					"width": 190,
					"anchor": {
						"dataItem": {
							"role": "circle",
							"datum": {
								"year": 2015,
								"y": -2
							}
						},
						"callout": "yes",
						"to": {
							"dx": -29,
							"dy": 31
						},
						"from": {
							"dy": 0,
							"dx": -10
						},
						"cornering": "left-top",
						"positionOrient": "top-left",
						"textAnchor": true,
						"anchorAlign": "start"
					},
					"dx": -210,
					"dy": 42
				},
				{
					"type": "text",
					"text": [
						{
							"text": "2019",
							"align": "right",
							"index": "0",
							"fontSize": 14,
							"lineHeight": 110,
							"fontWeight": "700"
						},
						{
							"text": "First high-speed recovery applied to large-impact break",
							"align": "right",
							"index": "1",
							"fontSize": 14,
							"lineHeight": 110,
							"fontWeight": "400"
						}
					],
					"name": "annotation_6",
					"x": "25%",
					"y": "25%",
					"width": 200,
					"anchor": {
						"dataItem": {
							"role": "circle",
							"datum": {
								"year": 2019,
								"y": -2
							}
						},
						"callout": "yes",
						"to": {
							"dx": -25,
							"dy": 77
						},
						"from": {
							"dx": -10,
							"dy": 0
						},
						"cornering": "left-top",
						"positionOrient": "top-left",
						"textAnchor": true,
						"anchorAlign": "start"
					},
					"dx": -198,
					"dy": 86
				}
			]
		}
	}
};

const case6_data = [
	{
		"Period": "1990",
		"School": "Yale",
		"Self-efficacy Score": 48.3
	},
	{
		"Period": "1990",
		"School": "Dartmouth",
		"Self-efficacy Score": 26.2
	},
	{
		"Period": "1990",
		"School": "Brown",
		"Self-efficacy Score": 16.3
	},
	{
		"Period": "1990",
		"School": "Cornell",
		"Self-efficacy Score": 12.9
	},
	{
		"Period": "1990",
		"School": "Harvard",
		"Self-efficacy Score": 20.1
	},
	{
		"Period": "1990",
		"School": "MIT",
		"Self-efficacy Score": 6.8
	},
	{
		"Period": "2000",
		"School": "Yale",
		"Self-efficacy Score": 53.3
	},
	{
		"Period": "2000",
		"School": "Dartmouth",
		"Self-efficacy Score": 38.8
	},
	{
		"Period": "2000",
		"School": "Brown",
		"Self-efficacy Score": 37.2
	},
	{
		"Period": "2000",
		"School": "Cornell",
		"Self-efficacy Score": 24.1
	},
	{
		"Period": "2000",
		"School": "Harvard",
		"Self-efficacy Score": 23.9
	},
	{
		"Period": "2000",
		"School": "MIT",
		"Self-efficacy Score": 12.7
	},
	{
		"Period": "2010",
		"School": "Yale",
		"Self-efficacy Score": 70.8
	},
	{
		"Period": "2010",
		"School": "Dartmouth",
		"Self-efficacy Score": 36.2
	},
	{
		"Period": "2010",
		"School": "Brown",
		"Self-efficacy Score": 32.1
	},
	{
		"Period": "2010",
		"School": "Cornell",
		"Self-efficacy Score": 25.1
	},
	{
		"Period": "2010",
		"School": "Harvard",
		"Self-efficacy Score": 17.5
	},
	{
		"Period": "2010",
		"School": "MIT",
		"Self-efficacy Score": 14.2
	}
];

const case6_spec = {
	original_artboard: {
		"name": "efficacy-desktop",
		"screen_type": "Desktop-Landscape",
		"artboard_width": 620,
		"artboard_height": 380,
		"device_width": 1440,
		"device_height": 900,
		"ppi": 227
	},
	artboard: {
		"name": "efficacy-desktop",
		"screen_type": "Desktop-Landscape",
		"artboard_width": 620,
		"artboard_height": 380,
		"device_width": 1440,
		"device_height": 900,
		"ppi": 227
	},
	fronto: {
		"data": [],
		"datatype": {},
		"name": "",
		"layout": {
			"width": 620,
			"height": 380,
			"composition": "single",
			"column": [
				{
					"field": "Period",
					"type": "ordinal",
					"sort": "ascending"
				},
				{
					"field": "Self-efficacy Score",
					"type": "quantitative",
					"scale": {
						"domain": [
							0,
							80
						]
					}
				}
			],
			"row": [
				{
					"field": "School",
					"type": "nominal",
					"sort": {
						"order": [
							"Yale",
							"Dartmouth",
							"Brown",
							"Cornell",
							"Harvard",
							"MIT"
						]
					},
					"values": [
						"Yale",
						"Dartmouth",
						"Brown",
						"Cornell",
						"Harvard",
						"MIT"
					]
				}
			],
			"haxis": {
				"domain": true,
				"offset": 5,
				"domainWidth": 1.5
			},
			"vaxis": {
				"repeat": true
			}
		},
		"layer": [
			{
				"name": "layer_0",
				"mark": {
					"type": "bar",
					"fill": {
						"scale": {
							"domain": [
								"Yale",
								"Dartmouth",
								"Brown",
								"Cornell",
								"Harvard",
								"MIT"
							],
							"range": [
								"rgba(14,140,37,1)",
								"rgba(14,140,37,1)",
								"rgba(14,140,37,1)",
								"rgba(14,140,37,1)",
								"rgba(14,140,37,1)",
								"rgba(14,46,140,1)"
							]
						},
						"field": "School"
					}
				},
				"text": [
					{
						"type": "on-axis",
						"field": "Self-efficacy Score",
						"values": [0, 10, 30, 50, 70],
						"items": [
							{
								"fontSize": 16,
								"index": 0,
								"width": 20
							}
						],
						"tick": {
							"tickColor": "black",
							"width": 1.5,
							"tickValues": [0, 10, 20, 30, 40, 50, 60, 70, 80],
						},
						"padding": 5
					},
					{
						"type": "on-mark",
						"items": [
							{
								"index": 0,
								"textAlign": "right",
								"color": "$black-white",
								"fontWeight": "700",
								"fontSize": 15
							}
						],
						"field": "Self-efficacy Score",
						"name": "label_2",
						"orient": "middle-right",
						"anchorAlign": "end",
						"dx": -15,
						"dy": -8
					},
					{
						"type": "on-axis",
						"field": "School",
						"serial": true,
						"items": [
							{
								"fontSize": 16,
								"index": 0,
								"fontWeight": "400",
								"width": 60
							}
						],
						"dy": "0px"
					},
					{
						"type": "on-axis",
						"field": "Period",
						"items": [
							{
								"index": 0,
								"custom": {},
								"align": "left",
								"fontSize": 18,
								"fontWeight": "700",
								"lineHeight": 100
							}
						],
						"anchor": "start",
						"orient": "top",
						"offset": 0,
						"padding": 0,
						"dy": "0px"
					}
				],
				"tooltip": {
					"visibility": "on-mark",
					"fields": [
						{
							"field": "School"
						},
						{
							"field": "Self-efficacy Score"
						}
					]
				}
			}
		],
		"title": {
			"items": [
				{
					"name": "title_0",
					"text": "MIT students felt less confident than those in other comparative schools in U.S.",
					"fontWeight": 700,
					"fontSize": 26,
					"lineHeight": 110,
					"offset": 30
				}
			]
		},
		"annotation": {
			"items": [
				{
					"type": "text",
					"text": [
						{
							"text": "Source: University Eduacation Survey (in 1990, 2000, 2010)",
							"align": "left",
							"index": "0",
							"fontColor": "rgba(112,112,112,1)"
						}
					],
					"name": "annotation_0",
					"x": "25%",
					"y": "25%",
					"width": 200,
					"visibility": {
						"externalize": {
							"position": "bottom"
						}
					}
				}
			]
		}
	}
};


export {
	case1_data, case1_spec,
	case2_data, case2_spec,
	case3_data, case3_spec,
	case4_data, case4_spec,
	case5_data, case5_spec,
	case6_data, case6_spec
};